/** 
 * priority-js-api
 * @version v1.0.0
 * @date 2016-08-13T20:16:13.513Z
 * @license MIT
*/
(function () {
    'use strict';

    //var atob = require('atob');   // LEOR
    //var btoa = require('btoa');   // LEOR
    var base64 = require('base-64');
    var XMLHttpRequest = require('xhr2');
    try {
        var https = require('https');
        XMLHttpRequest.nodejsSet({'httpsAgent': new https.Agent({ keepAlive: true })});
    }
    catch {}
    var moment = require('moment-timezone');

    if(global.v8debug) {
      global.v8debug.Debug.setBreakOnException(); 
    }

    function btoa(str) {
        return base64.encode(str);
    }

    function atob(str) {
        return base64.decode(str);
    }

    function getExports($wnd) {

        var $doc = $wnd.document;
        var $gwt = {};
        var navigator = {
            userAgent: 'webkit'
        };

        function noop(){}

        var __gwtModuleFunction = noop;
        __gwtModuleFunction.__moduleStartupDone = noop;
        var $sendStats = noop;
        var $moduleName, $moduleBase;

        // Start GWT code
var $intern_0 = 2147483647, $intern_1 = {4:1, 11:1}, $intern_2 = {4:1, 6:1, 11:1}, $intern_3 = {4:1, 198:1}, $intern_4 = {31:1, 4:1, 6:1, 11:1}, $intern_5 = {4:1}, $intern_6 = 4194303, $intern_7 = 1048575, $intern_8 = 524288, $intern_9 = 4194304, $intern_10 = 17592186044416, $intern_11 = -9223372036854775808, $intern_12 = -2147483648, $intern_13 = {47:1}, $intern_14 = {18:1}, $intern_15 = {4:1, 27:1, 67:1};
var _, initFnList_0, prototypesByTypeId_0 = {}, permutationId = -1;
function typeMarkerFn(){
}

function portableObjCreate(obj){
  function F(){
  }

  ;
  F.prototype = obj || {};
  return new F;
}

function modernizeBrowser(){
  !Array.isArray && (Array.isArray = function(vArg){
    return Object.prototype.toString.call(vArg) === '[object Array]';
  }
  );
}

function maybeGetClassLiteralFromPlaceHolder_0(entry){
  return entry instanceof Array?entry[0]:null;
}

function emptyMethod(){
}

function defineClass(typeId, superTypeId, castableTypeMap){
  var prototypesByTypeId = prototypesByTypeId_0;
  var createSubclassPrototype = createSubclassPrototype_0;
  var maybeGetClassLiteralFromPlaceHolder = maybeGetClassLiteralFromPlaceHolder_0;
  var prototype_0 = prototypesByTypeId[typeId];
  var clazz = maybeGetClassLiteralFromPlaceHolder(prototype_0);
  if (prototype_0 && !clazz) {
    _ = prototype_0;
  }
   else {
    _ = prototypesByTypeId[typeId] = !superTypeId?{}:createSubclassPrototype(superTypeId);
    _.castableTypeMap$ = castableTypeMap;
    _.constructor = _;
    !superTypeId && (_.typeMarker$ = typeMarkerFn);
  }
  for (var i = 3; i < arguments.length; ++i) {
    arguments[i].prototype = _;
  }
  clazz && (_.___clazz$ = clazz);
}

function createSubclassPrototype_0(superTypeId){
  var prototypesByTypeId = prototypesByTypeId_0;
  return portableObjCreate(prototypesByTypeId[superTypeId]);
}

function setGwtProperty(propertyName, propertyValue){
  typeof window === 'object' && typeof window['$gwt'] === 'object' && (window['$gwt'][propertyName] = propertyValue);
}

function registerEntry(){
  return entry_0;
}

function gwtOnLoad_0(errFn, modName, modBase, softPermutationId){
  ensureModuleInit();
  var initFnList = initFnList_0;
  $moduleName = modName;
  $moduleBase = modBase;
  permutationId = softPermutationId;
  function initializeModules(){
    for (var i = 0; i < initFnList.length; i++) {
      initFnList[i]();
    }
  }

  if (errFn) {
    try {
      $entry(initializeModules)();
    }
     catch (e) {
      errFn(modName, e);
    }
  }
   else {
    $entry(initializeModules)();
  }
}

function ensureModuleInit(){
  initFnList_0 == null && (initFnList_0 = []);
}

function addInitFunctions(){
  ensureModuleInit();
  var initFnList = initFnList_0;
  for (var i = 0; i < arguments.length; i++) {
    initFnList.push(arguments[i]);
  }
}

function Object_0(){
}

function equals_Ljava_lang_Object__Z__devirtual$(this$static, other){
  return isJavaString(this$static)?$equals(this$static, other):hasJavaObjectVirtualDispatch(this$static)?this$static.equals$(other):isJavaArray(this$static)?this$static === other:this$static === other;
}

function getClass__Ljava_lang_Class___devirtual$(this$static){
  return isJavaString(this$static)?Ljava_lang_String_2_classLit:hasJavaObjectVirtualDispatch(this$static)?this$static.___clazz$:isJavaArray(this$static)?this$static.___clazz$:Lcom_google_gwt_core_client_JavaScriptObject_2_classLit;
}

function hashCode__I__devirtual$(this$static){
  return isJavaString(this$static)?getHashCode_0(this$static):hasJavaObjectVirtualDispatch(this$static)?this$static.hashCode$():isJavaArray(this$static)?getHashCode(this$static):getHashCode(this$static);
}

defineClass(1, null, {}, Object_0);
_.equals$ = function equals(other){
  return this === other;
}
;
_.getClass$ = function getClass_0(){
  return this.___clazz$;
}
;
_.hashCode$ = function hashCode_0(){
  return getHashCode(this);
}
;
_.toString$ = function toString_0(){
  return $getName(getClass__Ljava_lang_Class___devirtual$(this)) + '@' + toUnsignedRadixString(hashCode__I__devirtual$(this), 16);
}
;
_.toString = function(){
  return this.toString$();
}
;
stringCastMap = {4:1, 228:1, 25:1, 2:1};
modernizeBrowser();
function canCast(src_0, dstId){
  return isJavaString(src_0) && !!stringCastMap[dstId] || src_0.castableTypeMap$ && !!src_0.castableTypeMap$[dstId];
}

function charToString(x_0){
  return String.fromCharCode(x_0);
}

function dynamicCast(src_0, dstId){
  if (src_0 != null && !canCast(src_0, dstId)) {
    throw new ClassCastException;
  }
  return src_0;
}

function dynamicCastJso(src_0){
  if (src_0 != null && !(!isJavaString(src_0) && !hasTypeMarker(src_0))) {
    throw new ClassCastException;
  }
  return src_0;
}

function dynamicCastToString(src_0){
  if (src_0 != null && !isJavaString(src_0)) {
    throw new ClassCastException;
  }
  return src_0;
}

function hasJavaObjectVirtualDispatch(src_0){
  return !instanceofArray(src_0) && hasTypeMarker(src_0);
}

function instanceOf(src_0, dstId){
  return src_0 != null && canCast(src_0, dstId);
}

function instanceOfJso(src_0){
  return src_0 != null && !isJavaString(src_0) && !hasTypeMarker(src_0);
}

function instanceofArray(src_0){
  return Array.isArray(src_0);
}

function isJavaArray(src_0){
  return instanceofArray(src_0) && hasTypeMarker(src_0);
}

function isJavaString(src_0){
  return typeof src_0 === 'string';
}

function maskUndefined(src_0){
  return src_0 == null?null:src_0;
}

function round_int(x_0){
  return ~~Math.max(Math.min(x_0, $intern_0), -2147483648);
}

var stringCastMap;
function $ensureNamesAreInitialized(this$static){
  if (this$static.typeName != null) {
    return;
  }
  initializeNames(this$static);
}

function $getName(this$static){
  $ensureNamesAreInitialized(this$static);
  return this$static.typeName;
}

function Class(){
  ++nextSequentialId;
  this.typeName = null;
  this.simpleName = null;
  this.packageName = null;
  this.compoundName = null;
  this.canonicalName = null;
  this.typeId = null;
  this.arrayLiterals = null;
}

function createClassObject(packageName, compoundClassName){
  var clazz;
  clazz = new Class;
  clazz.packageName = packageName;
  clazz.compoundName = compoundClassName;
  return clazz;
}

function createForClass(packageName, compoundClassName, typeId){
  var clazz;
  clazz = createClassObject(packageName, compoundClassName);
  maybeSetClassLiteral(typeId, clazz);
  return clazz;
}

function createForEnum(packageName, compoundClassName, typeId, enumConstantsFunc){
  var clazz;
  clazz = createClassObject(packageName, compoundClassName);
  maybeSetClassLiteral(typeId, clazz);
  clazz.modifiers = enumConstantsFunc?8:0;
  return clazz;
}

function createForInterface(packageName, compoundClassName){
  var clazz;
  clazz = createClassObject(packageName, compoundClassName);
  clazz.modifiers = 2;
  return clazz;
}

function getClassLiteralForArray_0(leafClass, dimensions){
  var arrayLiterals = leafClass.arrayLiterals = leafClass.arrayLiterals || [];
  return arrayLiterals[dimensions] || (arrayLiterals[dimensions] = leafClass.createClassLiteralForArray(dimensions));
}

function getPrototypeForClass(clazz){
  if (clazz.isPrimitive()) {
    return null;
  }
  var typeId = clazz.typeId;
  var prototype_0 = prototypesByTypeId_0[typeId];
  return prototype_0;
}

function initializeNames(clazz){
  if (clazz.isArray_1()) {
    var componentType = clazz.componentType;
    componentType.isPrimitive()?(clazz.typeName = '[' + componentType.typeId):!componentType.isArray_1()?(clazz.typeName = '[L' + componentType.getName() + ';'):(clazz.typeName = '[' + componentType.getName());
    clazz.canonicalName = componentType.getCanonicalName() + '[]';
    clazz.simpleName = componentType.getSimpleName() + '[]';
    return;
  }
  var packageName = clazz.packageName;
  var compoundName = clazz.compoundName;
  compoundName = compoundName.split('/');
  clazz.typeName = join_0('.', [packageName, join_0('$', compoundName)]);
  clazz.canonicalName = join_0('.', [packageName, join_0('.', compoundName)]);
  clazz.simpleName = compoundName[compoundName.length - 1];
}

function join_0(separator, strings){
  var i = 0;
  while (!strings[i] || strings[i] == '') {
    i++;
  }
  var result = strings[i++];
  for (; i < strings.length; i++) {
    if (!strings[i] || strings[i] == '') {
      continue;
    }
    result += separator + strings[i];
  }
  return result;
}

function maybeSetClassLiteral(typeId, clazz){
  var proto;
  if (!typeId) {
    return;
  }
  clazz.typeId = typeId;
  var prototype_0 = getPrototypeForClass(clazz);
  if (!prototype_0) {
    prototypesByTypeId_0[typeId] = [clazz];
    return;
  }
  prototype_0.___clazz$ = clazz;
}

defineClass(68, 1, {}, Class);
_.createClassLiteralForArray = function createClassLiteralForArray(dimensions){
  var clazz;
  clazz = new Class;
  clazz.modifiers = 4;
  dimensions > 1?(clazz.componentType = getClassLiteralForArray_0(this, dimensions - 1)):(clazz.componentType = this);
  return clazz;
}
;
_.getCanonicalName = function getCanonicalName(){
  $ensureNamesAreInitialized(this);
  return this.canonicalName;
}
;
_.getName = function getName(){
  return $getName(this);
}
;
_.getSimpleName = function getSimpleName(){
  $ensureNamesAreInitialized(this);
  return this.simpleName;
}
;
_.isArray_1 = function isArray_1(){
  return (this.modifiers & 4) != 0;
}
;
_.isPrimitive = function isPrimitive(){
  return (this.modifiers & 1) != 0;
}
;
_.toString$ = function toString_13(){
  return ((this.modifiers & 2) != 0?'interface ':(this.modifiers & 1) != 0?'':'class ') + ($ensureNamesAreInitialized(this) , this.typeName);
}
;
_.modifiers = 0;
var nextSequentialId = 1;
var Ljava_lang_Object_2_classLit = createForClass('java.lang', 'Object', 1), Lcom_google_gwt_core_client_JavaScriptObject_2_classLit = createForClass('com.google.gwt.core.client', 'JavaScriptObject$', 0), Ljava_lang_Class_2_classLit = createForClass('java.lang', 'Class', 68);
function isScript(){
  return true;
}

function setUncaughtExceptionHandler(handler){
  uncaughtExceptionHandler = handler;
}

var uncaughtExceptionHandler = null;
function $fillInStackTrace(this$static){
  this$static.stackTrace = null;
  captureStackTrace(this$static, this$static.detailMessage);
  return this$static;
}

function $initCause(this$static, cause){
  checkState(!this$static.cause);
  checkCriticalArgument(cause != this$static, 'Self-causation not permitted');
  this$static.cause = cause;
  return this$static;
}

function $printStackTrace(this$static, out){
  var element, element$array, element$index, element$max, t, stackTrace;
  for (t = this$static; t; t = t.cause) {
    t != this$static && $append_0(out.builder, 'Caused by: ');
    $append_0(out.builder, '' + t);
    $append_0(out.builder, '\n');
    for (element$array = (t.stackTrace == null && (t.stackTrace = ($clinit_StackTraceCreator() , stackTrace = collector.getStackTrace(t) , dropInternalFrames(stackTrace))) , t.stackTrace) , element$index = 0 , element$max = element$array.length; element$index < element$max; ++element$index) {
      element = element$array[element$index];
      $append_0(out.builder, '\tat ' + element);
      $append_0(out.builder, '\n');
    }
  }
}

function $toString(this$static){
  var className, msg;
  className = $getName(this$static.___clazz$);
  msg = this$static.getMessage();
  return msg != null?className + ': ' + msg:className;
}

defineClass(11, 1, $intern_1);
_.getMessage = function getMessage(){
  return this.detailMessage;
}
;
_.toString$ = function toString_1(){
  return $toString(this);
}
;
var Ljava_lang_Throwable_2_classLit = createForClass('java.lang', 'Throwable', 11);
function Exception(message){
  this.detailMessage = message;
  $fillInStackTrace(this);
}

defineClass(6, 11, $intern_2);
var Ljava_lang_Exception_2_classLit = createForClass('java.lang', 'Exception', 6);
function RuntimeException(){
  $fillInStackTrace(this);
}

function RuntimeException_0(message){
  Exception.call(this, message);
}

defineClass(19, 6, $intern_2);
var Ljava_lang_RuntimeException_2_classLit = createForClass('java.lang', 'RuntimeException', 19);
defineClass(94, 19, $intern_2);
var Lcom_google_gwt_core_client_impl_JavaScriptExceptionBase_2_classLit = createForClass('com.google.gwt.core.client.impl', 'JavaScriptExceptionBase', 94);
function $clinit_JavaScriptException(){
  $clinit_JavaScriptException = emptyMethod;
  NOT_SET = new Object_0;
}

function $ensureInit(this$static){
  var exception;
  if (this$static.message_0 == null) {
    exception = maskUndefined(this$static.e) === maskUndefined(NOT_SET)?null:this$static.e;
    this$static.name_0 = exception == null?'null':instanceOfJso(exception)?getExceptionName0(dynamicCastJso(exception)):isJavaString(exception)?'String':$getName(getClass__Ljava_lang_Class___devirtual$(exception));
    this$static.description = this$static.description + ': ' + (instanceOfJso(exception)?getExceptionDescription0(dynamicCastJso(exception)):exception + '');
    this$static.message_0 = '(' + this$static.name_0 + ') ' + this$static.description;
  }
}

function JavaScriptException(e){
  $clinit_JavaScriptException();
  this.cause = null;
  this.detailMessage = null;
  this.description = '';
  this.e = e;
  this.description = '';
}

function getExceptionDescription0(e){
  return e == null?null:e.message;
}

function getExceptionName0(e){
  return e == null?null:e.name;
}

defineClass(23, 94, {23:1, 4:1, 6:1, 11:1}, JavaScriptException);
_.getMessage = function getMessage_0(){
  return $ensureInit(this) , this.message_0;
}
;
_.getThrown = function getThrown(){
  return maskUndefined(this.e) === maskUndefined(NOT_SET)?null:this.e;
}
;
var NOT_SET;
var Lcom_google_gwt_core_client_JavaScriptException_2_classLit = createForClass('com.google.gwt.core.client', 'JavaScriptException', 23);
function $setDate(this$static, dayOfMonth){
  this$static.setDate(dayOfMonth);
  return this$static.getTime();
}

function $setFullYear(this$static, year){
  this$static.setFullYear(year);
  return this$static.getTime();
}

function $setMonth(this$static, month){
  this$static.setMonth(month);
  return this$static.getTime();
}

function $setTime(this$static, milliseconds){
  this$static.setTime(milliseconds);
  return this$static.getTime();
}

function create(milliseconds){
  return new Date(milliseconds);
}

function create_0(year, month, dayOfMonth, hours, minutes, seconds, millis){
  return new Date(year, month, dayOfMonth, hours, minutes, seconds, millis);
}

function now_1(){
  if (Date.now) {
    return Date.now();
  }
  return (new Date).getTime();
}

function escapeChar(c, escapeTable){
  var lookedUp = escapeTable_0[c.charCodeAt(0)];
  return lookedUp == null?c:lookedUp;
}

function escapeJsonForEval(toEscape){
  var escapeTable = getEscapeTable();
  var s = toEscape.replace(/[\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb]/g, function(x_0){
    return escapeChar(x_0, escapeTable);
  }
  );
  return s;
}

function escapeValue(toEscape){
  var escapeTable = getEscapeTable();
  var s = toEscape.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(x_0){
    return escapeChar(x_0, escapeTable);
  }
  );
  return '"' + s + '"';
}

function getEscapeTable(){
  !escapeTable_0 && (escapeTable_0 = initEscapeTable());
  return escapeTable_0;
}

function initEscapeTable(){
  var out = ['\\u0000', '\\u0001', '\\u0002', '\\u0003', '\\u0004', '\\u0005', '\\u0006', '\\u0007', '\\b', '\\t', '\\n', '\\u000B', '\\f', '\\r', '\\u000E', '\\u000F', '\\u0010', '\\u0011', '\\u0012', '\\u0013', '\\u0014', '\\u0015', '\\u0016', '\\u0017', '\\u0018', '\\u0019', '\\u001A', '\\u001B', '\\u001C', '\\u001D', '\\u001E', '\\u001F'];
  out[34] = '\\"';
  out[92] = '\\\\';
  out[173] = '\\u00ad';
  out[1536] = '\\u0600';
  out[1537] = '\\u0601';
  out[1538] = '\\u0602';
  out[1539] = '\\u0603';
  out[1757] = '\\u06dd';
  out[1807] = '\\u070f';
  out[6068] = '\\u17b4';
  out[6069] = '\\u17b5';
  out[8203] = '\\u200b';
  out[8204] = '\\u200c';
  out[8205] = '\\u200d';
  out[8206] = '\\u200e';
  out[8207] = '\\u200f';
  out[8232] = '\\u2028';
  out[8233] = '\\u2029';
  out[8234] = '\\u202a';
  out[8235] = '\\u202b';
  out[8236] = '\\u202c';
  out[8237] = '\\u202d';
  out[8238] = '\\u202e';
  out[8288] = '\\u2060';
  out[8289] = '\\u2061';
  out[8290] = '\\u2062';
  out[8291] = '\\u2063';
  out[8292] = '\\u2064';
  out[8298] = '\\u206a';
  out[8299] = '\\u206b';
  out[8300] = '\\u206c';
  out[8301] = '\\u206d';
  out[8302] = '\\u206e';
  out[8303] = '\\u206f';
  out[65279] = '\\ufeff';
  out[65529] = '\\ufff9';
  out[65530] = '\\ufffa';
  out[65531] = '\\ufffb';
  return out;
}

function safeEval(json){
  try {
    return JSON.parse(json);
  }
   catch (e) {
    return throwIllegalArgumentException('Error parsing JSON: ' + e, json);
  }
}

function throwIllegalArgumentException(message, data_0){
  throw new IllegalArgumentException_0(message + '\n' + data_0);
}

var escapeTable_0;
defineClass(199, 1, {});
var Lcom_google_gwt_core_client_Scheduler_2_classLit = createForClass('com.google.gwt.core.client', 'Scheduler', 199);
function apply_0(jsFunction, thisObj, args){
  return jsFunction.apply(thisObj, args);
  var __0;
}

function enter(){
  var now_0;
  if (entryDepth != 0) {
    now_0 = now_1();
    if (now_0 - watchdogEntryDepthLastScheduled > 2000) {
      watchdogEntryDepthLastScheduled = now_0;
      watchdogEntryDepthTimerId = $wnd.setTimeout(watchdogEntryDepthRun, 10);
    }
  }
  if (entryDepth++ == 0) {
    $flushEntryCommands(($clinit_SchedulerImpl() , INSTANCE));
    return true;
  }
  return false;
}

function entry_0(jsFunction){
  return function(){
    if (isScript()) {
      return entry0(jsFunction, this, arguments);
    }
     else {
      var __0 = entry0(jsFunction, this, arguments);
      __0 != null && (__0 = __0.val);
      return __0;
    }
  }
  ;
}

function entry0(jsFunction, thisObj, args){
  var initialEntry, t;
  initialEntry = enter();
  try {
    if (uncaughtExceptionHandler) {
      try {
        return apply_0(jsFunction, thisObj, args);
      }
       catch ($e0) {
        $e0 = wrap($e0);
        if (instanceOf($e0, 11)) {
          t = $e0;
          reportUncaughtException(t);
          return undefined;
        }
         else 
          throw unwrap_5($e0);
      }
    }
     else {
      return apply_0(jsFunction, thisObj, args);
    }
  }
   finally {
    exit_0(initialEntry);
  }
}

function exit_0(initialEntry){
  initialEntry && $flushFinallyCommands(($clinit_SchedulerImpl() , INSTANCE));
  --entryDepth;
  if (initialEntry) {
    if (watchdogEntryDepthTimerId != -1) {
      watchdogEntryDepthCancel(watchdogEntryDepthTimerId);
      watchdogEntryDepthTimerId = -1;
    }
  }
}

function getHashCode(o){
  return o.$H || (o.$H = ++sNextHashId);
}

function reportToBrowser(e){
  $wnd.setTimeout(function(){
    throw e;
  }
  , 0);
}

function reportUncaughtException(e){
  var handler;
  handler = uncaughtExceptionHandler;
  if (handler) {
    if (handler == uncaughtExceptionHandlerForTest) {
      return;
    }
    $log_2(handler.val$log2, ($clinit_Level() , SEVERE), e.getMessage(), e);
    return;
  }
  reportToBrowser(instanceOf(e, 23)?dynamicCast(e, 23).getThrown():e);
}

function watchdogEntryDepthCancel(timerId){
  $wnd.clearTimeout(timerId);
}

function watchdogEntryDepthRun(){
  entryDepth != 0 && (entryDepth = 0);
  watchdogEntryDepthTimerId = -1;
}

var entryDepth = 0, sNextHashId = 0, uncaughtExceptionHandlerForTest, watchdogEntryDepthLastScheduled = 0, watchdogEntryDepthTimerId = -1;
function $clinit_SchedulerImpl(){
  $clinit_SchedulerImpl = emptyMethod;
  INSTANCE = new SchedulerImpl;
}

function $flushEntryCommands(this$static){
  var oldQueue, rescheduled;
  if (this$static.entryCommands) {
    rescheduled = null;
    do {
      oldQueue = this$static.entryCommands;
      this$static.entryCommands = null;
      rescheduled = runScheduledTasks(oldQueue, rescheduled);
    }
     while (this$static.entryCommands);
    this$static.entryCommands = rescheduled;
  }
}

function $flushFinallyCommands(this$static){
  var oldQueue, rescheduled;
  if (this$static.finallyCommands) {
    rescheduled = null;
    do {
      oldQueue = this$static.finallyCommands;
      this$static.finallyCommands = null;
      rescheduled = runScheduledTasks(oldQueue, rescheduled);
    }
     while (this$static.finallyCommands);
    this$static.finallyCommands = rescheduled;
  }
}

function SchedulerImpl(){
}

function execute(cmd){
  return cmd.execute();
}

function push_0(queue, task){
  !queue && (queue = []);
  queue[queue.length] = task;
  return queue;
}

function runScheduledTasks(tasks, rescheduled){
  var e, i, j, t;
  for (i = 0 , j = tasks.length; i < j; i++) {
    t = tasks[i];
    try {
      t[1]?t[0].execute() && (rescheduled = push_0(rescheduled, t)):t[0].nullMethod();
    }
     catch ($e0) {
      $e0 = wrap($e0);
      if (instanceOf($e0, 11)) {
        e = $e0;
        reportUncaughtException(e);
      }
       else 
        throw unwrap_5($e0);
    }
  }
  return rescheduled;
}

function scheduleFixedDelayImpl(cmd, delayMs){
  $clinit_SchedulerImpl();
  function callback(){
    var ret = $entry(execute)(cmd);
    !isScript() && (ret = ret == true);
    ret && $wnd.setTimeout(callback, delayMs);
  }

  $wnd.setTimeout(callback, delayMs);
}

defineClass(123, 199, {}, SchedulerImpl);
var INSTANCE;
var Lcom_google_gwt_core_client_impl_SchedulerImpl_2_classLit = createForClass('com.google.gwt.core.client.impl', 'SchedulerImpl', 123);
function $clinit_StackTraceCreator(){
  $clinit_StackTraceCreator = emptyMethod;
  var c, enforceLegacy;
  enforceLegacy = !(!!Error.stackTraceLimit || 'stack' in new Error);
  c = new StackTraceCreator$CollectorModernNoSourceMap;
  collector = enforceLegacy?new StackTraceCreator$CollectorLegacy:c;
}

function captureStackTrace(throwable, reference){
  $clinit_StackTraceCreator();
  collector.collect(throwable, reference);
}

function dropInternalFrames(stackTrace){
  var dropFrameUntilFnName, i, numberOfFrameToSearch;
  dropFrameUntilFnName = 'captureStackTrace';
  numberOfFrameToSearch = min_0(stackTrace.length);
  for (i = 0; i < numberOfFrameToSearch; i++) {
    if ($equals(stackTrace[i].methodName, dropFrameUntilFnName)) {
      return dynamicCast((stackTrace.length >= i + 1 && stackTrace.splice(0, i + 1) , stackTrace), 198);
    }
  }
  return stackTrace;
}

function extractFunctionName(fnName){
  var fnRE = /function(?:\s+([\w$]+))?\s*\(/;
  var match_0 = fnRE.exec(fnName);
  return match_0 && match_0[1] || 'anonymous';
}

function parseInt_0(number){
  $clinit_StackTraceCreator();
  return parseInt(number) || -1;
}

var collector;
defineClass(210, 1, {});
var Lcom_google_gwt_core_client_impl_StackTraceCreator$Collector_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/Collector', 210);
function StackTraceCreator$CollectorLegacy(){
}

defineClass(95, 210, {}, StackTraceCreator$CollectorLegacy);
_.collect = function collect(t, thrownIgnored){
  var seen = {}, name_1;
  t.fnStack = [];
  var callee = arguments.callee.caller;
  while (callee) {
    var name_0 = ($clinit_StackTraceCreator() , callee.name || (callee.name = extractFunctionName(callee.toString())));
    t.fnStack.push(name_0);
    var keyName = ':' + name_0;
    var withThisName = seen[keyName];
    if (withThisName) {
      var i, j;
      for (i = 0 , j = withThisName.length; i < j; i++) {
        if (withThisName[i] === callee) {
          return;
        }
      }
    }
    (withThisName || (seen[keyName] = [])).push(callee);
    callee = callee.caller;
  }
}
;
_.getStackTrace = function getStackTrace(t){
  var i, length_0, stack_0, stackTrace;
  stack_0 = ($clinit_StackTraceCreator() , t && t.fnStack && t.fnStack instanceof Array?t.fnStack:[]);
  length_0 = stack_0.length;
  stackTrace = initDim(Ljava_lang_StackTraceElement_2_classLit, $intern_3, 32, length_0, 0, 1);
  for (i = 0; i < length_0; i++) {
    stackTrace[i] = new StackTraceElement(stack_0[i], null, -1);
  }
  return stackTrace;
}
;
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorLegacy_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorLegacy', 95);
function $clinit_StackTraceCreator$CollectorModern(){
  $clinit_StackTraceCreator$CollectorModern = emptyMethod;
  Error.stackTraceLimit = 64;
}

function $parse(this$static, stString){
  var closeParen, col, endFileUrlIndex, fileName, index_0, lastColonIndex, line, location_0, toReturn;
  if (!stString.length) {
    return this$static.createSte('Unknown', 'anonymous', -1, -1);
  }
  toReturn = $trim(stString);
  $equals(toReturn.substr(0, 3), 'at ') && (toReturn = __substr(toReturn, 3, toReturn.length - 3));
  toReturn = toReturn.replace(/\[.*?\]/g, '');
  index_0 = toReturn.indexOf('(');
  if (index_0 == -1) {
    index_0 = toReturn.indexOf('@');
    if (index_0 == -1) {
      location_0 = toReturn;
      toReturn = '';
    }
     else {
      location_0 = $trim(__substr(toReturn, index_0 + 1, toReturn.length - (index_0 + 1)));
      toReturn = $trim(toReturn.substr(0, index_0));
    }
  }
   else {
    closeParen = toReturn.indexOf(')', index_0);
    location_0 = toReturn.substr(index_0 + 1, closeParen - (index_0 + 1));
    toReturn = $trim(toReturn.substr(0, index_0));
  }
  index_0 = $indexOf(toReturn, fromCodePoint(46));
  index_0 != -1 && (toReturn = __substr(toReturn, index_0 + 1, toReturn.length - (index_0 + 1)));
  (!toReturn.length || $equals(toReturn, 'Anonymous function')) && (toReturn = 'anonymous');
  lastColonIndex = $lastIndexOf(location_0, fromCodePoint(58));
  endFileUrlIndex = $lastIndexOf_0(location_0, fromCodePoint(58), lastColonIndex - 1);
  line = -1;
  col = -1;
  fileName = 'Unknown';
  if (lastColonIndex != -1 && endFileUrlIndex != -1) {
    fileName = location_0.substr(0, endFileUrlIndex);
    line = parseInt_0(location_0.substr(endFileUrlIndex + 1, lastColonIndex - (endFileUrlIndex + 1)));
    col = parseInt_0(__substr(location_0, lastColonIndex + 1, location_0.length - (lastColonIndex + 1)));
  }
  return this$static.createSte(fileName, toReturn, line, col);
}

defineClass(211, 210, {});
_.collect = function collect_0(t, jsThrown){
  function fixIE(e){
    if (!('stack' in e)) {
      try {
        throw e;
      }
       catch (ignored) {
      }
    }
    return e;
  }

  var backingJsError;
  typeof jsThrown == 'string'?(backingJsError = fixIE(new Error(jsThrown))):jsThrown instanceof Object && 'stack' in jsThrown?(backingJsError = jsThrown):(backingJsError = fixIE(new Error));
  t.__gwt$backingJsError = backingJsError;
}
;
_.createSte = function createSte(fileName, method, line, col){
  return new StackTraceElement(method, fileName + '@' + col, line < 0?-1:line);
}
;
_.getStackTrace = function getStackTrace_0(t){
  var addIndex, i, length_0, stack_0, stackTrace, ste, e;
  stack_0 = ($clinit_StackTraceCreator() , e = t.__gwt$backingJsError , e && e.stack?e.stack.split('\n'):[]);
  stackTrace = initDim(Ljava_lang_StackTraceElement_2_classLit, $intern_3, 32, 0, 0, 1);
  addIndex = 0;
  length_0 = stack_0.length;
  if (length_0 == 0) {
    return stackTrace;
  }
  ste = $parse(this, stack_0[0]);
  $equals(ste.methodName, 'anonymous') || (stackTrace[addIndex++] = ste);
  for (i = 1; i < length_0; i++) {
    stackTrace[addIndex++] = $parse(this, stack_0[i]);
  }
  return stackTrace;
}
;
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorModern_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorModern', 211);
function StackTraceCreator$CollectorModernNoSourceMap(){
  $clinit_StackTraceCreator$CollectorModern();
}

defineClass(96, 211, {}, StackTraceCreator$CollectorModernNoSourceMap);
_.createSte = function createSte_0(fileName, method, line, col){
  return new StackTraceElement(method, fileName, -1);
}
;
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorModernNoSourceMap_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorModernNoSourceMap', 96);
function checkCriticalArgument(expression, errorMessage){
  if (!expression) {
    throw new IllegalArgumentException_0('' + errorMessage);
  }
}

function checkCriticalElement(expression){
  if (!expression) {
    throw new NoSuchElementException;
  }
}

function checkElementIndex(index_0, size_0){
  if (index_0 < 0 || index_0 >= size_0) {
    throw new IndexOutOfBoundsException('Index: ' + index_0 + ', Size: ' + size_0);
  }
}

function checkNotNull(reference){
  if (!reference) {
    throw new NullPointerException;
  }
  return reference;
}

function checkPositionIndex(index_0, size_0){
  if (index_0 < 0 || index_0 > size_0) {
    throw new IndexOutOfBoundsException('Index: ' + index_0 + ', Size: ' + size_0);
  }
}

function checkState(expression){
  if (!expression) {
    throw new IllegalStateException;
  }
}

function $cancel(this$static){
  var xhr;
  if (!this$static.xmlHttpRequest) {
    return;
  }
  $cancel_0(this$static.timer);
  xhr = this$static.xmlHttpRequest;
  this$static.xmlHttpRequest = null;
  $clearOnReadyStateChange(xhr);
  xhr.abort();
}

function $fireOnResponseReceived(this$static, callback){
  var response, xhr;
  if (!this$static.xmlHttpRequest) {
    return;
  }
  $cancel_0(this$static.timer);
  xhr = this$static.xmlHttpRequest;
  this$static.xmlHttpRequest = null;
  response = new ResponseImpl(xhr);
  $onResponseReceived(callback, response);
}

function $fireOnTimeout(this$static){
  if (!this$static.xmlHttpRequest) {
    return;
  }
  $cancel(this$static);
  new RequestTimeoutException(this$static.timeoutMillis);
}

function Request(xmlHttpRequest, timeoutMillis, callback){
  this.timer = new Request$1(this);
  if (!xmlHttpRequest) {
    throw new NullPointerException;
  }
  if (!callback) {
    throw new NullPointerException;
  }
  if (timeoutMillis < 0) {
    throw new IllegalArgumentException;
  }
  this.timeoutMillis = timeoutMillis;
  this.xmlHttpRequest = xmlHttpRequest;
  timeoutMillis > 0 && $schedule(this.timer, timeoutMillis);
}

defineClass(187, 1, {}, Request);
_.timeoutMillis = 0;
var Lcom_google_gwt_http_client_Request_2_classLit = createForClass('com.google.gwt.http.client', 'Request', 187);
function $cancel_0(this$static){
  if (!this$static.timerId) {
    return;
  }
  ++this$static.cancelCounter;
  this$static.isRepeating?clearInterval_0(this$static.timerId.value_0):clearTimeout_0(this$static.timerId.value_0);
  this$static.timerId = null;
}

function $schedule(this$static, delayMillis){
  if (delayMillis < 0) {
    throw new IllegalArgumentException_0('must be non-negative');
  }
  !!this$static.timerId && $cancel_0(this$static);
  this$static.isRepeating = false;
  this$static.timerId = valueOf(setTimeout_0(createCallback(this$static, this$static.cancelCounter), delayMillis));
}

function clearInterval_0(timerId){
  $wnd.clearInterval(timerId);
}

function clearTimeout_0(timerId){
  $wnd.clearTimeout(timerId);
}

function createCallback(timer, cancelCounter){
  return $entry(function(){
    timer.fire(cancelCounter);
  }
  );
}

function setTimeout_0(func, time){
  return $wnd.setTimeout(func, time);
}

defineClass(188, 1, {});
_.fire = function fire(scheduleCancelCounter){
  if (scheduleCancelCounter != this.cancelCounter) {
    return;
  }
  this.isRepeating || (this.timerId = null);
  $fireOnTimeout(this.this$01);
}
;
_.cancelCounter = 0;
_.isRepeating = false;
_.timerId = null;
var Lcom_google_gwt_user_client_Timer_2_classLit = createForClass('com.google.gwt.user.client', 'Timer', 188);
function Request$1(this$0){
  this.this$01 = this$0;
}

defineClass(189, 188, {}, Request$1);
var Lcom_google_gwt_http_client_Request$1_2_classLit = createForClass('com.google.gwt.http.client', 'Request/1', 189);
function $clinit_RequestBuilder(){
  $clinit_RequestBuilder = emptyMethod;
  new RequestBuilder$Method('DELETE');
  new RequestBuilder$Method('GET');
  new RequestBuilder$Method('HEAD');
  POST = new RequestBuilder$Method('POST');
  new RequestBuilder$Method('PUT');
}

function $doSend(this$static, requestData, callback){
  var e, request, requestPermissionException, xmlHttpRequest;
  xmlHttpRequest = new XMLHttpRequest;
  try {
    $open(xmlHttpRequest, this$static.httpMethod, this$static.url_0);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 23)) {
      e = $e0;
      requestPermissionException = new RequestPermissionException(this$static.url_0);
      $initCause(requestPermissionException, new RequestException(e.getMessage()));
      throw requestPermissionException;
    }
     else 
      throw unwrap_5($e0);
  }
  $setHeaders(this$static, xmlHttpRequest);
  this$static.includeCredentials && (xmlHttpRequest.withCredentials = true , undefined);
  request = new Request(xmlHttpRequest, this$static.timeoutMillis, callback);
  $setOnReadyStateChange(xmlHttpRequest, new RequestBuilder$1(request, callback));
  try {
    xmlHttpRequest.send(requestData);
  }
   catch ($e1) {
    $e1 = wrap($e1);
    if (instanceOf($e1, 23)) {
      e = $e1;
      throw new RequestException(e.getMessage());
    }
     else 
      throw unwrap_5($e1);
  }
  return request;
}

function $setHeader(this$static, header, value_0){
  throwIfEmptyOrNull('header', header);
  throwIfEmptyOrNull('value', value_0);
  !this$static.headers && (this$static.headers = new HashMap);
  $putStringValue(this$static.headers, header, value_0);
}

function $setHeaders(this$static, xmlHttpRequest){
  var e, header, header$iterator;
  if (!!this$static.headers && this$static.headers.size_0 > 0) {
    for (header$iterator = new AbstractHashMap$EntrySetIterator((new AbstractHashMap$EntrySet(this$static.headers)).this$01); $hasNext(header$iterator);) {
      header = (checkStructuralChange(header$iterator.this$01, header$iterator) , checkCriticalElement($hasNext(header$iterator)) , dynamicCast(header$iterator.current.next_0(), 18));
      try {
        $setRequestHeader(xmlHttpRequest, dynamicCastToString(header.getKey()), dynamicCastToString(header.getValue()));
      }
       catch ($e0) {
        $e0 = wrap($e0);
        if (instanceOf($e0, 23)) {
          e = $e0;
          throw new RequestException(e.getMessage());
        }
         else 
          throw unwrap_5($e0);
      }
    }
  }
   else {
    $setRequestHeader(xmlHttpRequest, 'Content-Type', 'text/plain; charset=utf-8');
  }
}

function RequestBuilder(httpMethod, url_0){
  RequestBuilder_0.call(this, !httpMethod?null:httpMethod.name_0, url_0);
}

function RequestBuilder_0(httpMethod, url_0){
  throwIfEmptyOrNull('httpMethod', httpMethod);
  throwIfEmptyOrNull('url', url_0);
  this.httpMethod = httpMethod;
  this.url_0 = url_0;
}

defineClass(70, 1, {});
_.includeCredentials = false;
_.timeoutMillis = 0;
var POST;
var Lcom_google_gwt_http_client_RequestBuilder_2_classLit = createForClass('com.google.gwt.http.client', 'RequestBuilder', 70);
function RequestBuilder$1(val$request, val$callback){
  this.val$request2 = val$request;
  this.val$callback3 = val$callback;
}

defineClass(104, 1, {}, RequestBuilder$1);
_.onReadyStateChange = function onReadyStateChange(xhr){
  if (xhr.readyState == 4) {
    $clearOnReadyStateChange(xhr);
    $fireOnResponseReceived(this.val$request2, this.val$callback3);
  }
}
;
var Lcom_google_gwt_http_client_RequestBuilder$1_2_classLit = createForClass('com.google.gwt.http.client', 'RequestBuilder/1', 104);
function RequestBuilder$Method(name_0){
  this.name_0 = name_0;
}

defineClass(43, 1, {}, RequestBuilder$Method);
_.toString$ = function toString_2(){
  return this.name_0;
}
;
var Lcom_google_gwt_http_client_RequestBuilder$Method_2_classLit = createForClass('com.google.gwt.http.client', 'RequestBuilder/Method', 43);
function RequestException(message){
  Exception.call(this, message);
}

defineClass(31, 6, $intern_4, RequestException);
var Lcom_google_gwt_http_client_RequestException_2_classLit = createForClass('com.google.gwt.http.client', 'RequestException', 31);
function RequestPermissionException(url_0){
  RequestException.call(this, 'The URL ' + url_0 + ' is invalid or violates the same-origin security restriction');
}

defineClass(195, 31, $intern_4, RequestPermissionException);
var Lcom_google_gwt_http_client_RequestPermissionException_2_classLit = createForClass('com.google.gwt.http.client', 'RequestPermissionException', 195);
function RequestTimeoutException(timeoutMillis){
  RequestException.call(this, 'A request timeout has expired after ' + timeoutMillis + ' ms');
}

defineClass(197, 31, $intern_4, RequestTimeoutException);
var Lcom_google_gwt_http_client_RequestTimeoutException_2_classLit = createForClass('com.google.gwt.http.client', 'RequestTimeoutException', 197);
defineClass(226, 1, {});
var Lcom_google_gwt_http_client_Response_2_classLit = createForClass('com.google.gwt.http.client', 'Response', 226);
function ResponseImpl(xmlHttpRequest){
  this.xmlHttpRequest = xmlHttpRequest;
}

defineClass(190, 226, {}, ResponseImpl);
var Lcom_google_gwt_http_client_ResponseImpl_2_classLit = createForClass('com.google.gwt.http.client', 'ResponseImpl', 190);
function throwIfEmptyOrNull(name_0, value_0){
  throwIfNull(name_0, value_0);
  if (0 == $trim(value_0).length) {
    throw new IllegalArgumentException_0(name_0 + ' cannot be empty');
  }
}

function throwIfNull(name_0, value_0){
  if (null == value_0) {
    throw new NullPointerException_0(name_0 + ' cannot be null');
  }
}

defineClass(224, 1, {});
var Lcom_google_gwt_i18n_shared_DefaultDateTimeFormatInfo_2_classLit = createForClass('com.google.gwt.i18n.shared', 'DefaultDateTimeFormatInfo', 224);
defineClass(225, 224, {});
var Lcom_google_gwt_i18n_client_DefaultDateTimeFormatInfo_2_classLit = createForClass('com.google.gwt.i18n.client', 'DefaultDateTimeFormatInfo', 225);
function $clinit_LocaleInfo(){
  $clinit_LocaleInfo = emptyMethod;
  instance = new LocaleInfo;
}

function $getDateTimeFormatInfo(this$static){
  !this$static.dateTimeFormatInfo && (this$static.dateTimeFormatInfo = new DateTimeFormatInfoImpl);
  return this$static.dateTimeFormatInfo;
}

function LocaleInfo(){
}

defineClass(133, 1, {}, LocaleInfo);
var instance;
var Lcom_google_gwt_i18n_client_LocaleInfo_2_classLit = createForClass('com.google.gwt.i18n.client', 'LocaleInfo', 133);
function DateTimeFormatInfoImpl(){
}

defineClass(184, 225, {}, DateTimeFormatInfoImpl);
var Lcom_google_gwt_i18n_client_impl_cldr_DateTimeFormatInfoImpl_2_classLit = createForClass('com.google.gwt.i18n.client.impl.cldr', 'DateTimeFormatInfoImpl', 184);
defineClass(215, 1, {});
_.isArray_0 = function isArray(){
  return null;
}
;
_.isNumber = function isNumber(){
  return null;
}
;
_.isObject = function isObject(){
  return null;
}
;
_.isString = function isString(){
  return null;
}
;
var Lcom_google_gwt_json_client_JSONValue_2_classLit = createForClass('com.google.gwt.json.client', 'JSONValue', 215);
function $get(this$static, index_0){
  var v = this$static.jsArray[index_0];
  var func = ($clinit_JSONParser() , typeMap)[typeof v];
  return func?func(v):throwUnknownTypeException(typeof v);
}

function $set(this$static, index_0, value_0){
  var previous;
  previous = $get(this$static, index_0);
  $set0(this$static, index_0, value_0);
  return previous;
}

function $set0(this$static, index_0, value_0){
  if (value_0) {
    var func = value_0.getUnwrapper();
    value_0 = func(value_0);
  }
   else {
    value_0 = undefined;
  }
  this$static.jsArray[index_0] = value_0;
}

function JSONArray(){
  this.jsArray = [];
}

function JSONArray_0(arr){
  this.jsArray = arr;
}

function unwrap(value_0){
  return value_0.jsArray;
}

defineClass(7, 215, {7:1}, JSONArray, JSONArray_0);
_.equals$ = function equals_0(other){
  if (!instanceOf(other, 7)) {
    return false;
  }
  return this.jsArray == dynamicCast(other, 7).jsArray;
}
;
_.getUnwrapper = function getUnwrapper(){
  return unwrap;
}
;
_.hashCode$ = function hashCode_1(){
  return getHashCode(this.jsArray);
}
;
_.isArray_0 = function isArray_0(){
  return this;
}
;
_.toString$ = function toString_3(){
  var c, i, sb;
  sb = new StringBuilder_0('[');
  for (i = 0 , c = this.jsArray.length; i < c; i++) {
    i > 0 && (sb.string += ',' , sb);
    $append(sb, $get(this, i));
  }
  sb.string += ']';
  return sb.string;
}
;
var Lcom_google_gwt_json_client_JSONArray_2_classLit = createForClass('com.google.gwt.json.client', 'JSONArray', 7);
function $clinit_JSONBoolean(){
  $clinit_JSONBoolean = emptyMethod;
  FALSE = new JSONBoolean(false);
  TRUE = new JSONBoolean(true);
}

function JSONBoolean(value_0){
  this.value_0 = value_0;
}

function unwrap_0(value_0){
  return value_0.value_0;
}

defineClass(80, 215, {}, JSONBoolean);
_.getUnwrapper = function getUnwrapper_0(){
  return unwrap_0;
}
;
_.toString$ = function toString_4(){
  return $clinit_Boolean() , '' + this.value_0;
}
;
_.value_0 = false;
var FALSE, TRUE;
var Lcom_google_gwt_json_client_JSONBoolean_2_classLit = createForClass('com.google.gwt.json.client', 'JSONBoolean', 80);
function JSONException(message){
  RuntimeException_0.call(this, message);
}

function JSONException_0(cause){
  this.detailMessage = !cause?null:$toString(cause);
  this.cause = cause;
  $fillInStackTrace(this);
}

defineClass(64, 19, $intern_2, JSONException, JSONException_0);
var Lcom_google_gwt_json_client_JSONException_2_classLit = createForClass('com.google.gwt.json.client', 'JSONException', 64);
function $clinit_JSONNull(){
  $clinit_JSONNull = emptyMethod;
  instance_0 = new JSONNull;
}

function JSONNull(){
}

function unwrap_1(){
  return null;
}

defineClass(196, 215, {}, JSONNull);
_.getUnwrapper = function getUnwrapper_1(){
  return unwrap_1;
}
;
_.toString$ = function toString_5(){
  return 'null';
}
;
var instance_0;
var Lcom_google_gwt_json_client_JSONNull_2_classLit = createForClass('com.google.gwt.json.client', 'JSONNull', 196);
function JSONNumber(value_0){
  this.value_0 = value_0;
}

function unwrap_2(value_0){
  return value_0.value_0;
}

defineClass(26, 215, {26:1}, JSONNumber);
_.equals$ = function equals_1(other){
  if (!instanceOf(other, 26)) {
    return false;
  }
  return this.value_0 == dynamicCast(other, 26).value_0;
}
;
_.getUnwrapper = function getUnwrapper_2(){
  return unwrap_2;
}
;
_.hashCode$ = function hashCode_2(){
  return round_int((new Double(this.value_0)).value_0);
}
;
_.isNumber = function isNumber_0(){
  return this;
}
;
_.toString$ = function toString_6(){
  return this.value_0 + '';
}
;
_.value_0 = 0;
var Lcom_google_gwt_json_client_JSONNumber_2_classLit = createForClass('com.google.gwt.json.client', 'JSONNumber', 26);
function $computeKeys0(this$static, result){
  var jsObject = this$static.jsObject;
  var i = 0;
  for (var key in jsObject) {
    jsObject.hasOwnProperty(key) && (result[i++] = key);
  }
  return result;
}

function $get_0(this$static, key){
  if (key == null) {
    throw new NullPointerException;
  }
  return $get0(this$static, key);
}

function $get0(this$static, key){
  var jsObject = this$static.jsObject;
  var v;
  key = String(key);
  jsObject.hasOwnProperty(key) && (v = jsObject[key]);
  var func = ($clinit_JSONParser() , typeMap)[typeof v];
  var ret = func?func(v):throwUnknownTypeException(typeof v);
  return ret;
}

function $put(this$static, key, jsonValue){
  var previous;
  previous = $get_0(this$static, key);
  $put0(this$static, key, jsonValue);
  return previous;
}

function $put0(this$static, key, value_0){
  if (value_0) {
    var func = value_0.getUnwrapper();
    this$static.jsObject[key] = func(value_0);
  }
   else {
    delete this$static.jsObject[key];
  }
}

function $toString_0(this$static){
  var first, key, key$index, key$max, keys_0, sb;
  sb = new StringBuilder_0('{');
  first = true;
  keys_0 = $computeKeys0(this$static, initDim(Ljava_lang_String_2_classLit, $intern_5, 2, 0, 4, 1));
  for (key$index = 0 , key$max = keys_0.length; key$index < key$max; ++key$index) {
    key = keys_0[key$index];
    first?(first = false):(sb.string += ', ' , sb);
    $append_0(sb, escapeValue(key));
    sb.string += ':';
    $append(sb, $get_0(this$static, key));
  }
  sb.string += '}';
  return sb.string;
}

function JSONObject(){
  JSONObject_0.call(this, {});
}

function JSONObject_0(jsValue){
  this.jsObject = jsValue;
}

function unwrap_3(value_0){
  return value_0.jsObject;
}

defineClass(5, 215, {5:1}, JSONObject, JSONObject_0);
_.equals$ = function equals_2(other){
  if (!instanceOf(other, 5)) {
    return false;
  }
  return this.jsObject == dynamicCast(other, 5).jsObject;
}
;
_.getUnwrapper = function getUnwrapper_3(){
  return unwrap_3;
}
;
_.hashCode$ = function hashCode_3(){
  return getHashCode(this.jsObject);
}
;
_.isObject = function isObject_0(){
  return this;
}
;
_.toString$ = function toString_7(){
  return $toString_0(this);
}
;
var Lcom_google_gwt_json_client_JSONObject_2_classLit = createForClass('com.google.gwt.json.client', 'JSONObject', 5);
function $clinit_JSONParser(){
  $clinit_JSONParser = emptyMethod;
  typeMap = {'boolean':createBoolean, number:createNumber, string:createString, object:createObject, 'function':createObject, undefined:createUndefined};
}

function createBoolean(v){
  return $clinit_JSONBoolean() , v?TRUE:FALSE;
}

function createNumber(v){
  return new JSONNumber(v);
}

function createObject(o){
  if (!o) {
    return $clinit_JSONNull() , instance_0;
  }
  var v = o.valueOf?o.valueOf():o;
  if (v !== o) {
    var func = typeMap[typeof v];
    return func?func(v):throwUnknownTypeException(typeof v);
  }
   else if (o instanceof Array || o instanceof $wnd.Array) {
    return new JSONArray_0(o);
  }
   else {
    return new JSONObject_0(o);
  }
}

function createString(v){
  return new JSONString(v);
}

function createUndefined(){
  return null;
}

function evaluate(json, strict){
  var v;
  if (strict) {
    try {
      v = JSON.parse(json);
    }
     catch (e) {
      return throwJSONException('Error parsing JSON: ' + e);
    }
  }
   else {
    json = escapeJsonForEval(json);
    try {
      v = eval('(' + json + ')');
    }
     catch (e) {
      return throwJSONException('Error parsing JSON: ' + e);
    }
  }
  var func = typeMap[typeof v];
  return func?func(v):throwUnknownTypeException(typeof v);
}

function parse_0(jsonString){
  $clinit_JSONParser();
  var ex;
  if (jsonString == null) {
    throw new NullPointerException;
  }
  if (jsonString.length == 0) {
    throw new IllegalArgumentException_0('empty argument');
  }
  try {
    return evaluate(jsonString, true);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 23)) {
      ex = $e0;
      throw new JSONException_0(ex);
    }
     else 
      throw unwrap_5($e0);
  }
}

function throwJSONException(message){
  throw new JSONException(message);
}

function throwUnknownTypeException(typeString){
  $clinit_JSONParser();
  throw new JSONException("Unexpected typeof result '" + typeString + "'; please report this bug to the GWT team");
}

var typeMap;
function JSONString(value_0){
  if (value_0 == null) {
    throw new NullPointerException;
  }
  this.value_0 = value_0;
}

function unwrap_4(value_0){
  return value_0.value_0;
}

defineClass(10, 215, {10:1}, JSONString);
_.equals$ = function equals_3(other){
  if (!instanceOf(other, 10)) {
    return false;
  }
  return $equals(this.value_0, dynamicCast(other, 10).value_0);
}
;
_.getUnwrapper = function getUnwrapper_4(){
  return unwrap_4;
}
;
_.hashCode$ = function hashCode_4(){
  return getHashCode_0(this.value_0);
}
;
_.isString = function isString_0(){
  return this;
}
;
_.toString$ = function toString_8(){
  return escapeValue(this.value_0);
}
;
var Lcom_google_gwt_json_client_JSONString_2_classLit = createForClass('com.google.gwt.json.client', 'JSONString', 10);
function getClassLiteralForArray(clazz, dimensions){
  return getClassLiteralForArray_0(clazz, dimensions);
}

function initDim(leafClassLiteral, castableTypeMap, elementTypeId, length_0, elementTypeCategory, dimensions){
  var result;
  result = initializeArrayElementsWithDefaults(elementTypeCategory, length_0);
  initValues(getClassLiteralForArray(leafClassLiteral, dimensions), castableTypeMap, elementTypeId, elementTypeCategory, result);
  return result;
}

function initValues(arrayClass, castableTypeMap, elementTypeId, elementTypeCategory, array){
  array.___clazz$ = arrayClass;
  array.castableTypeMap$ = castableTypeMap;
  array.typeMarker$ = typeMarkerFn;
  array.__elementTypeId$ = elementTypeId;
  array.__elementTypeCategory$ = elementTypeCategory;
  return array;
}

function initializeArrayElementsWithDefaults(elementTypeCategory, length_0){
  var array = new Array(length_0);
  var initValue;
  switch (elementTypeCategory) {
    case 6:
      initValue = {l:0, m:0, h:0};
      break;
    case 7:
      initValue = 0;
      break;
    case 8:
      initValue = false;
      break;
    default:return array;
  }
  for (var i = 0; i < length_0; ++i) {
    array[i] = initValue;
  }
  return array;
}

function setCheck(array, index_0, value_0){
  var elementTypeId;
  if (value_0 != null) {
    switch (array.__elementTypeCategory$) {
      case 4:
        if (!isJavaString(value_0)) {
          throw new ArrayStoreException;
        }

        break;
      case 0:
        {
          elementTypeId = array.__elementTypeId$;
          if (!canCast(value_0, elementTypeId)) {
            throw new ArrayStoreException;
          }
          break;
        }

      case 2:
        if (!(!isJavaString(value_0) && !hasTypeMarker(value_0))) {
          throw new ArrayStoreException;
        }

        break;
      case 1:
        {
          elementTypeId = array.__elementTypeId$;
          if (!(!isJavaString(value_0) && !hasTypeMarker(value_0)) && !canCast(value_0, elementTypeId)) {
            throw new ArrayStoreException;
          }
          break;
        }

    }
  }
  return array[index_0] = value_0;
}

function cacheJavaScriptException(e, jse){
  if (e && typeof e == 'object') {
    try {
      e.__gwt$exception = jse;
    }
     catch (ignored) {
    }
  }
}

function unwrap_5(e){
  var jse;
  if (instanceOf(e, 23)) {
    jse = dynamicCast(e, 23);
    if (maskUndefined(jse.e) !== maskUndefined(($clinit_JavaScriptException() , NOT_SET))) {
      return maskUndefined(jse.e) === maskUndefined(NOT_SET)?null:jse.e;
    }
  }
  return e;
}

function wrap(e){
  var jse;
  if (instanceOf(e, 11)) {
    return e;
  }
  jse = e && e.__gwt$exception;
  if (!jse) {
    jse = new JavaScriptException(e);
    captureStackTrace(jse, e);
    cacheJavaScriptException(e, jse);
  }
  return jse;
}

function create_1(value_0){
  var a0, a1, a2;
  a0 = value_0 & $intern_6;
  a1 = value_0 >> 22 & $intern_6;
  a2 = value_0 < 0?$intern_7:0;
  return create0(a0, a1, a2);
}

function create_2(a){
  return create0(a.l, a.m, a.h);
}

function create0(l, m, h){
  return {l:l, m:m, h:h};
}

function divMod(a, b, computeRemainder){
  var aIsCopy, aIsMinValue, aIsNegative, bpower, c, negative;
  if (b.l == 0 && b.m == 0 && b.h == 0) {
    throw new ArithmeticException;
  }
  if (a.l == 0 && a.m == 0 && a.h == 0) {
    computeRemainder && (remainder = create0(0, 0, 0));
    return create0(0, 0, 0);
  }
  if (b.h == $intern_8 && b.m == 0 && b.l == 0) {
    return divModByMinValue(a, computeRemainder);
  }
  negative = false;
  if (b.h >> 19 != 0) {
    b = neg(b);
    negative = true;
  }
  bpower = powerOfTwo(b);
  aIsNegative = false;
  aIsMinValue = false;
  aIsCopy = false;
  if (a.h == $intern_8 && a.m == 0 && a.l == 0) {
    aIsMinValue = true;
    aIsNegative = true;
    if (bpower == -1) {
      a = create_2(($clinit_LongLib$Const() , MAX_VALUE));
      aIsCopy = true;
      negative = !negative;
    }
     else {
      c = shr(a, bpower);
      negative && negate(c);
      computeRemainder && (remainder = create0(0, 0, 0));
      return c;
    }
  }
   else if (a.h >> 19 != 0) {
    aIsNegative = true;
    a = neg(a);
    aIsCopy = true;
    negative = !negative;
  }
  if (bpower != -1) {
    return divModByShift(a, bpower, negative, aIsNegative, computeRemainder);
  }
  if (!gte_0(a, b)) {
    computeRemainder && (aIsNegative?(remainder = neg(a)):(remainder = create0(a.l, a.m, a.h)));
    return create0(0, 0, 0);
  }
  return divModHelper(aIsCopy?a:create0(a.l, a.m, a.h), b, negative, aIsNegative, aIsMinValue, computeRemainder);
}

function divModByMinValue(a, computeRemainder){
  if (a.h == $intern_8 && a.m == 0 && a.l == 0) {
    computeRemainder && (remainder = create0(0, 0, 0));
    return create_2(($clinit_LongLib$Const() , ONE));
  }
  computeRemainder && (remainder = create0(a.l, a.m, a.h));
  return create0(0, 0, 0);
}

function divModByShift(a, bpower, negative, aIsNegative, computeRemainder){
  var c;
  c = shr(a, bpower);
  negative && negate(c);
  if (computeRemainder) {
    a = maskRight(a, bpower);
    aIsNegative?(remainder = neg(a)):(remainder = create0(a.l, a.m, a.h));
  }
  return c;
}

function divModHelper(a, b, negative, aIsNegative, aIsMinValue, computeRemainder){
  var bshift, gte, quotient, shift_0, a1, a2, a0;
  shift_0 = numberOfLeadingZeros(b) - numberOfLeadingZeros(a);
  bshift = shl(b, shift_0);
  quotient = create0(0, 0, 0);
  while (shift_0 >= 0) {
    gte = trialSubtract(a, bshift);
    if (gte) {
      shift_0 < 22?(quotient.l |= 1 << shift_0 , undefined):shift_0 < 44?(quotient.m |= 1 << shift_0 - 22 , undefined):(quotient.h |= 1 << shift_0 - 44 , undefined);
      if (a.l == 0 && a.m == 0 && a.h == 0) {
        break;
      }
    }
    a1 = bshift.m;
    a2 = bshift.h;
    a0 = bshift.l;
    setH(bshift, a2 >>> 1);
    bshift.m = a1 >>> 1 | (a2 & 1) << 21;
    bshift.l = a0 >>> 1 | (a1 & 1) << 21;
    --shift_0;
  }
  negative && negate(quotient);
  if (computeRemainder) {
    if (aIsNegative) {
      remainder = neg(a);
      aIsMinValue && (remainder = sub_0(remainder, ($clinit_LongLib$Const() , ONE)));
    }
     else {
      remainder = create0(a.l, a.m, a.h);
    }
  }
  return quotient;
}

function maskRight(a, bits){
  var b0, b1, b2;
  if (bits <= 22) {
    b0 = a.l & (1 << bits) - 1;
    b1 = b2 = 0;
  }
   else if (bits <= 44) {
    b0 = a.l;
    b1 = a.m & (1 << bits - 22) - 1;
    b2 = 0;
  }
   else {
    b0 = a.l;
    b1 = a.m;
    b2 = a.h & (1 << bits - 44) - 1;
  }
  return create0(b0, b1, b2);
}

function negate(a){
  var neg0, neg1, neg2;
  neg0 = ~a.l + 1 & $intern_6;
  neg1 = ~a.m + (neg0 == 0?1:0) & $intern_6;
  neg2 = ~a.h + (neg0 == 0 && neg1 == 0?1:0) & $intern_7;
  setL(a, neg0);
  setM(a, neg1);
  setH(a, neg2);
}

function numberOfLeadingZeros(a){
  var b1, b2;
  b2 = numberOfLeadingZeros_0(a.h);
  if (b2 == 32) {
    b1 = numberOfLeadingZeros_0(a.m);
    return b1 == 32?numberOfLeadingZeros_0(a.l) + 32:b1 + 20 - 10;
  }
   else {
    return b2 - 12;
  }
}

function powerOfTwo(a){
  var h, l, m;
  l = a.l;
  if ((l & l - 1) != 0) {
    return -1;
  }
  m = a.m;
  if ((m & m - 1) != 0) {
    return -1;
  }
  h = a.h;
  if ((h & h - 1) != 0) {
    return -1;
  }
  if (h == 0 && m == 0 && l == 0) {
    return -1;
  }
  if (h == 0 && m == 0 && l != 0) {
    return numberOfTrailingZeros(l);
  }
  if (h == 0 && m != 0 && l == 0) {
    return numberOfTrailingZeros(m) + 22;
  }
  if (h != 0 && m == 0 && l == 0) {
    return numberOfTrailingZeros(h) + 44;
  }
  return -1;
}

function setH(a, x_0){
  a.h = x_0;
}

function setL(a, x_0){
  a.l = x_0;
}

function setM(a, x_0){
  a.m = x_0;
}

function toDoubleHelper(a){
  return a.l + a.m * $intern_9 + a.h * $intern_10;
}

function trialSubtract(a, b){
  var sum0, sum1, sum2;
  sum2 = a.h - b.h;
  if (sum2 < 0) {
    return false;
  }
  sum0 = a.l - b.l;
  sum1 = a.m - b.m + (sum0 >> 22);
  sum2 += sum1 >> 22;
  if (sum2 < 0) {
    return false;
  }
  setL(a, sum0 & $intern_6);
  setM(a, sum1 & $intern_6);
  setH(a, sum2 & $intern_7);
  return true;
}

var remainder;
function eq(a, b){
  return a.l == b.l && a.m == b.m && a.h == b.h;
}

function fromDouble(value_0){
  var a0, a1, a2, negative, result;
  if (isNaN(value_0)) {
    return $clinit_LongLib$Const() , ZERO;
  }
  if (value_0 < $intern_11) {
    return $clinit_LongLib$Const() , MIN_VALUE;
  }
  if (value_0 >= 9223372036854775807) {
    return $clinit_LongLib$Const() , MAX_VALUE;
  }
  negative = false;
  if (value_0 < 0) {
    negative = true;
    value_0 = -value_0;
  }
  a2 = 0;
  if (value_0 >= $intern_10) {
    a2 = round_int(value_0 / $intern_10);
    value_0 -= a2 * $intern_10;
  }
  a1 = 0;
  if (value_0 >= $intern_9) {
    a1 = round_int(value_0 / $intern_9);
    value_0 -= a1 * $intern_9;
  }
  a0 = round_int(value_0);
  result = create0(a0, a1, a2);
  negative && negate(result);
  return result;
}

function fromInt(value_0){
  var rebase, result;
  if (value_0 > -129 && value_0 < 128) {
    rebase = value_0 + 128;
    boxedValues == null && (boxedValues = initDim(Lcom_google_gwt_lang_LongLibBase$LongEmul_2_classLit, $intern_5, 232, 256, 0, 1));
    result = boxedValues[rebase];
    !result && (result = boxedValues[rebase] = create_1(value_0));
    return result;
  }
  return create_1(value_0);
}

function gte_0(a, b){
  var signa, signb;
  signa = a.h >> 19;
  signb = b.h >> 19;
  return signa == 0?signb != 0 || a.h > b.h || a.h == b.h && a.m > b.m || a.h == b.h && a.m == b.m && a.l >= b.l:!(signb == 0 || a.h < b.h || a.h == b.h && a.m < b.m || a.h == b.h && a.m == b.m && a.l < b.l);
}

function neg(a){
  var neg0, neg1, neg2;
  neg0 = ~a.l + 1 & $intern_6;
  neg1 = ~a.m + (neg0 == 0?1:0) & $intern_6;
  neg2 = ~a.h + (neg0 == 0 && neg1 == 0?1:0) & $intern_7;
  return create0(neg0, neg1, neg2);
}

function shl(a, n){
  var res0, res1, res2;
  n &= 63;
  if (n < 22) {
    res0 = a.l << n;
    res1 = a.m << n | a.l >> 22 - n;
    res2 = a.h << n | a.m >> 22 - n;
  }
   else if (n < 44) {
    res0 = 0;
    res1 = a.l << n - 22;
    res2 = a.m << n - 22 | a.l >> 44 - n;
  }
   else {
    res0 = 0;
    res1 = 0;
    res2 = a.l << n - 44;
  }
  return {l:res0 & $intern_6, m:res1 & $intern_6, h:res2 & $intern_7};
}

function shr(a, n){
  var a2, negative, res0, res1, res2;
  n &= 63;
  a2 = a.h;
  negative = (a2 & $intern_8) != 0;
  negative && (a2 |= -1048576);
  if (n < 22) {
    res2 = a2 >> n;
    res1 = a.m >> n | a2 << 22 - n;
    res0 = a.l >> n | a.m << 22 - n;
  }
   else if (n < 44) {
    res2 = negative?$intern_7:0;
    res1 = a2 >> n - 22;
    res0 = a.m >> n - 22 | a2 << 44 - n;
  }
   else {
    res2 = negative?$intern_7:0;
    res1 = negative?$intern_6:0;
    res0 = a2 >> n - 44;
  }
  return {l:res0 & $intern_6, m:res1 & $intern_6, h:res2 & $intern_7};
}

function shru(a, n){
  var a2, res0, res1, res2;
  n &= 63;
  a2 = a.h & $intern_7;
  if (n < 22) {
    res2 = a2 >>> n;
    res1 = a.m >> n | a2 << 22 - n;
    res0 = a.l >> n | a.m << 22 - n;
  }
   else if (n < 44) {
    res2 = 0;
    res1 = a2 >>> n - 22;
    res0 = a.m >> n - 22 | a.h << 44 - n;
  }
   else {
    res2 = 0;
    res1 = 0;
    res0 = a2 >>> n - 44;
  }
  return {l:res0 & $intern_6, m:res1 & $intern_6, h:res2 & $intern_7};
}

function sub_0(a, b){
  var sum0, sum1, sum2;
  sum0 = a.l - b.l;
  sum1 = a.m - b.m + (sum0 >> 22);
  sum2 = a.h - b.h + (sum1 >> 22);
  return {l:sum0 & $intern_6, m:sum1 & $intern_6, h:sum2 & $intern_7};
}

function toDouble(a){
  if (eq(a, ($clinit_LongLib$Const() , MIN_VALUE))) {
    return $intern_11;
  }
  if (!gte_0(a, ZERO)) {
    return -toDoubleHelper(neg(a));
  }
  return a.l + a.m * $intern_9 + a.h * $intern_10;
}

function toInt(a){
  return a.l | a.m << 22;
}

function toString_9(a){
  var digits, rem, res, tenPowerLong, zeroesNeeded;
  if (a.l == 0 && a.m == 0 && a.h == 0) {
    return '0';
  }
  if (a.h == $intern_8 && a.m == 0 && a.l == 0) {
    return '-9223372036854775808';
  }
  if (a.h >> 19 != 0) {
    return '-' + toString_9(neg(a));
  }
  rem = a;
  res = '';
  while (!(rem.l == 0 && rem.m == 0 && rem.h == 0)) {
    tenPowerLong = fromInt(1000000000);
    rem = divMod(rem, tenPowerLong, true);
    digits = '' + toInt(remainder);
    if (!(rem.l == 0 && rem.m == 0 && rem.h == 0)) {
      zeroesNeeded = 9 - digits.length;
      for (; zeroesNeeded > 0; zeroesNeeded--) {
        digits = '0' + digits;
      }
    }
    res = digits + res;
  }
  return res;
}

function xor(a, b){
  return {l:a.l ^ b.l, m:a.m ^ b.m, h:a.h ^ b.h};
}

var boxedValues;
function $clinit_LongLib$Const(){
  $clinit_LongLib$Const = emptyMethod;
  MAX_VALUE = create0($intern_6, $intern_6, 524287);
  MIN_VALUE = create0(0, 0, $intern_8);
  ONE = fromInt(1);
  fromInt(2);
  ZERO = fromInt(0);
}

var MAX_VALUE, MIN_VALUE, ONE, ZERO;
function hasTypeMarker(o){
  return o.typeMarker$ === typeMarkerFn;
}

function init(){
  $wnd.setTimeout($entry(assertCompileTimeUserAgent));
  $onModuleLoad_0();
  $onModuleLoad($clinit_LogConfiguration());
  $onModuleLoad_1(new PriorityApp);
}

function $getLevel(this$static){
  if (this$static.level_0) {
    return this$static.level_0;
  }
  return $clinit_Level() , ALL;
}

function $setFormatter(this$static, newFormatter){
  this$static.formatter = newFormatter;
}

function $setLevel(this$static, newLevel){
  this$static.level_0 = newLevel;
}

defineClass(45, 1, {45:1});
var Ljava_util_logging_Handler_2_classLit = createForClass('java.util.logging', 'Handler', 45);
function ConsoleLogHandler(){
  $setFormatter(this, new TextLogFormatter(true));
  $setLevel(this, ($clinit_Level() , ALL));
}

defineClass(147, 45, {45:1}, ConsoleLogHandler);
_.publish = function publish(record){
                        return;
  var msg, val;
  if (!window.console || ($getLevel(this) , $intern_12 > record.level_0.intValue_0())) {
    return;
  }
  msg = $format(this.formatter, record);
  val = record.level_0.intValue_0();
  val >= ($clinit_Level() , 1000)?(window.console.error(msg) , undefined):val >= 900?(window.console.warn(msg) , undefined):val >= 800?(window.console.info(msg) , undefined):(window.console.log(msg) , undefined);
}
;
var Lcom_google_gwt_logging_client_ConsoleLogHandler_2_classLit = createForClass('com.google.gwt.logging.client', 'ConsoleLogHandler', 147);
function DevelopmentModeLogHandler(){
  $setFormatter(this, new TextLogFormatter(false));
  $setLevel(this, ($clinit_Level() , ALL));
}

defineClass(148, 45, {45:1}, DevelopmentModeLogHandler);
_.publish = function publish_0(record){
  return;
}
;
var Lcom_google_gwt_logging_client_DevelopmentModeLogHandler_2_classLit = createForClass('com.google.gwt.logging.client', 'DevelopmentModeLogHandler', 148);
function $clinit_LogConfiguration(){
  $clinit_LogConfiguration = emptyMethod;
  impl = new LogConfiguration$LogConfigurationImplRegular;
}

function $onModuleLoad(){
  var log_0;
  $configureClientSideLogging(impl);
  if (!uncaughtExceptionHandler) {
    log_0 = getLogger(($ensureNamesAreInitialized(Lcom_google_gwt_logging_client_LogConfiguration_2_classLit) , Lcom_google_gwt_logging_client_LogConfiguration_2_classLit.typeName));
    setUncaughtExceptionHandler(new LogConfiguration$1(log_0));
  }
}

var impl;
var Lcom_google_gwt_logging_client_LogConfiguration_2_classLit = createForClass('com.google.gwt.logging.client', 'LogConfiguration', null);
function LogConfiguration$1(val$log){
  this.val$log2 = val$log;
}

defineClass(83, 1, {}, LogConfiguration$1);
var Lcom_google_gwt_logging_client_LogConfiguration$1_2_classLit = createForClass('com.google.gwt.logging.client', 'LogConfiguration/1', 83);
function $configureClientSideLogging(this$static){
  this$static.root = (new LoggerImplRegular , $ensureLogger(getLogManager(), ''));
  this$static.root.impl.useParentHandlers = false;
  $setLevels(this$static.root);
  $setDefaultHandlers(this$static.root);
}

function $setDefaultHandlers(l){
  var console_0, dev;
  console_0 = new ConsoleLogHandler;
  $addHandler(l.impl, console_0);
  dev = new DevelopmentModeLogHandler;
  $addHandler(l.impl, dev);
}

function $setLevels(l){
  var level, levelParam, paramsForName;
  levelParam = (ensureListParameterMap() , paramsForName = dynamicCast(listParamMap.get_0('logLevel'), 27) , !paramsForName?null:dynamicCastToString(paramsForName.get_1(paramsForName.size_1() - 1)));
  level = levelParam == null?null:($clinit_Level() , $parse_0(levelParam));
  level?$setLevel_0(l.impl, level):$setLevel_1(l, ($clinit_Level() , ALL));
}

function LogConfiguration$LogConfigurationImplRegular(){
}

defineClass(82, 1, {}, LogConfiguration$LogConfigurationImplRegular);
var Lcom_google_gwt_logging_client_LogConfiguration$LogConfigurationImplRegular_2_classLit = createForClass('com.google.gwt.logging.client', 'LogConfiguration/LogConfigurationImplRegular', 82);
defineClass(222, 1, {});
var Ljava_util_logging_Formatter_2_classLit = createForClass('java.util.logging', 'Formatter', 222);
defineClass(223, 222, {});
var Lcom_google_gwt_logging_impl_FormatterImpl_2_classLit = createForClass('com.google.gwt.logging.impl', 'FormatterImpl', 223);
function $format(this$static, event_0){
  var message, date, s;
  message = new StringBuilder;
  $append_0(message, (date = new Date_1(event_0.millis) , s = new StringBuilder , $append_0(s, $toString_3(date)) , s.string += ' ' , $append_0(s, event_0.loggerName) , s.string += '\n' , $append_0(s, event_0.level_0.getName()) , s.string += ': ' , s.string));
  $append_0(message, event_0.msg);
  this$static.showStackTraces && !!event_0.thrown && $printStackTrace(event_0.thrown, new StackTracePrintStream(message));
  return message.string;
}

function TextLogFormatter(showStackTraces){
  this.showStackTraces = showStackTraces;
}

defineClass(78, 223, {}, TextLogFormatter);
_.showStackTraces = false;
var Lcom_google_gwt_logging_client_TextLogFormatter_2_classLit = createForClass('com.google.gwt.logging.client', 'TextLogFormatter', 78);
function $parse_0(name_0){
  name_0 = name_0.toUpperCase();
  if ($equals(name_0, 'ALL')) {
    return $clinit_Level() , ALL;
  }
   else if ($equals(name_0, 'CONFIG')) {
    return $clinit_Level() , CONFIG;
  }
   else if ($equals(name_0, 'FINE')) {
    return $clinit_Level() , FINE;
  }
   else if ($equals(name_0, 'FINER')) {
    return $clinit_Level() , FINER;
  }
   else if ($equals(name_0, 'FINEST')) {
    return $clinit_Level() , FINEST;
  }
   else if ($equals(name_0, 'INFO')) {
    return $clinit_Level() , INFO;
  }
   else if ($equals(name_0, 'OFF')) {
    return $clinit_Level() , OFF;
  }
   else if ($equals(name_0, 'SEVERE')) {
    return $clinit_Level() , SEVERE;
  }
   else if ($equals(name_0, 'WARNING')) {
    return $clinit_Level() , WARNING;
  }
  throw new IllegalArgumentException_0('Invalid level "' + name_0 + '"');
}

function $addHandler(this$static, handler){
  $add(this$static.handlers, handler);
}

function $getEffectiveLevel(this$static){
  var effectiveLevel, logger;
  if (this$static.level_0) {
    return this$static.level_0;
  }
  logger = this$static.parent_0;
  while (logger) {
    effectiveLevel = logger.impl.level_0;
    if (effectiveLevel) {
      return effectiveLevel;
    }
    logger = logger.impl.parent_0;
  }
  return $clinit_Level() , INFO;
}

function $getHandlers(this$static){
  return dynamicCast($toArray(this$static.handlers, initDim(Ljava_util_logging_Handler_2_classLit, {4:1, 81:1}, 45, this$static.handlers.array.length, 0, 1)), 81);
}

function $isLoggable(this$static, messageLevel){
  return $getEffectiveLevel(this$static).intValue_0() <= messageLevel.intValue_0();
}

function $log(this$static, level, msg, thrown){
  var record;
  if ($getEffectiveLevel(this$static).intValue_0() <= level.intValue_0()) {
    record = new LogRecord(level, msg);
    record.thrown = thrown;
    $setLoggerName(record, this$static.name_0);
    $log_0(this$static, record);
  }
}

function $log_0(this$static, record){
  var handler, handler$array, handler$array0, handler$index, handler$index0, handler$max, handler$max0, logger;
  if ($isLoggable(this$static, record.level_0)) {
    for (handler$array0 = dynamicCast($toArray(this$static.handlers, initDim(Ljava_util_logging_Handler_2_classLit, {4:1, 81:1}, 45, this$static.handlers.array.length, 0, 1)), 81) , handler$index0 = 0 , handler$max0 = handler$array0.length; handler$index0 < handler$max0; ++handler$index0) {
      handler = handler$array0[handler$index0];
      handler.publish(record);
    }
    logger = this$static.useParentHandlers?this$static.parent_0:null;
    while (logger) {
      for (handler$array = $getHandlers(logger.impl) , handler$index = 0 , handler$max = handler$array.length; handler$index < handler$max; ++handler$index) {
        handler = handler$array[handler$index];
        handler.publish(record);
      }
      logger = logger.impl.useParentHandlers?logger.impl.parent_0:null;
    }
  }
}

function $setLevel_0(this$static, newLevel){
  this$static.level_0 = newLevel;
}

function $setName(this$static, newName){
  this$static.name_0 = newName;
}

function $setParent(this$static, newParent){
  !!newParent && (this$static.parent_0 = newParent);
}

function LoggerImplRegular(){
  this.useParentHandlers = true;
  this.handlers = new ArrayList;
}

defineClass(51, 1, {}, LoggerImplRegular);
_.level_0 = null;
_.useParentHandlers = false;
var Lcom_google_gwt_logging_impl_LoggerImplRegular_2_classLit = createForClass('com.google.gwt.logging.impl', 'LoggerImplRegular', 51);
defineClass(218, 1, {});
var Ljava_io_OutputStream_2_classLit = createForClass('java.io', 'OutputStream', 218);
defineClass(219, 218, {});
var Ljava_io_FilterOutputStream_2_classLit = createForClass('java.io', 'FilterOutputStream', 219);
defineClass(220, 219, {});
var Ljava_io_PrintStream_2_classLit = createForClass('java.io', 'PrintStream', 220);
function StackTracePrintStream(builder){
  this.builder = builder;
}

defineClass(183, 220, {}, StackTracePrintStream);
var Lcom_google_gwt_logging_impl_StackTracePrintStream_2_classLit = createForClass('com.google.gwt.logging.impl', 'StackTracePrintStream', 183);
function isValidCookieValue(value_0){
  if (uriEncoding) {
    return true;
  }
  return !(value_0.indexOf('=') != -1 || value_0.indexOf(';') != -1);
}

function setCookie(name_0, value_0, expires, path){
  if (uriEncoding) {
    name_0 = encodeURIComponent(name_0);
    value_0 = encodeURIComponent(value_0);
  }
   else if (uriEncoding || !(name_0.indexOf('=') != -1 || name_0.indexOf(';') != -1 || name_0.indexOf(',') != -1 || $equals(name_0.substr(0, 1), '$') || (new RegExp('^(.*\\s+.*)$')).test(name_0))) {
    if (!isValidCookieValue(value_0)) {
      throw new IllegalArgumentException_0('Illegal cookie format: ' + value_0 + ' is not a valid cookie value.');
    }
  }
   else {
    throw new IllegalArgumentException_0('Illegal cookie format: ' + name_0 + ' is not a valid cookie name.');
  }
  setCookieImpl(name_0, value_0, toDouble(!expires?{l:0, m:0, h:0}:fromDouble(expires.jsdate.getTime())), '', path, false);
}

function setCookieImpl(name_0, value_0, expires, domain, path, secure){
  var c = name_0 + '=' + value_0;
  expires && (c += ';expires=' + (new Date(expires)).toGMTString());
  domain && (c += ';domain=' + domain);
  path && (c += ';path=' + path);
  secure && (c += ';secure');
  $doc.cookie = c;
}

var uriEncoding = true;
function $onModuleLoad_0(){
  var allowedModes, currentMode, i;
  currentMode = $doc.compatMode;
  allowedModes = initValues(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_5, 2, 4, ['CSS1Compat']);
  for (i = 0; i < allowedModes.length; i++) {
    if ($equals(allowedModes[i], currentMode)) {
      return;
    }
  }
  allowedModes.length == 1 && $equals('CSS1Compat', allowedModes[0]) && $equals('BackCompat', currentMode)?"GWT no longer supports Quirks Mode (document.compatMode=' BackCompat').<br>Make sure your application's host HTML page has a Standards Mode (document.compatMode=' CSS1Compat') doctype,<br>e.g. by using &lt;!doctype html&gt; at the start of your application's HTML page.<br><br>To continue using this unsupported rendering mode and risk layout problems, suppress this message by adding<br>the following line to your*.gwt.xml module file:<br>&nbsp;&nbsp;&lt;extend-configuration-property name=\"document.compatMode\" value=\"" + currentMode + '"/&gt;':"Your *.gwt.xml module configuration prohibits the use of the current document rendering mode (document.compatMode=' " + currentMode + "').<br>Modify your application's host HTML page doctype, or update your custom " + "'document.compatMode' configuration property settings.";
}

function buildListParamMap(queryString){
  var entry, entry$iterator, key, kv, kvPair, kvPair$array, kvPair$index, kvPair$max, out, qs, val, values, regexp;
  out = new HashMap;
  if (queryString != null && queryString.length > 1) {
    qs = __substr(queryString, 1, queryString.length - 1);
    for (kvPair$array = $split(qs, '&', 0) , kvPair$index = 0 , kvPair$max = kvPair$array.length; kvPair$index < kvPair$max; ++kvPair$index) {
      kvPair = kvPair$array[kvPair$index];
      kv = $split(kvPair, '=', 2);
      key = kv[0];
      if (!key.length) {
        continue;
      }
      val = kv.length > 1?kv[1]:'';
      try {
        val = (throwIfNull('encodedURLComponent', val) , regexp = /\+/g , decodeURIComponent(val.replace(regexp, '%20')));
      }
       catch ($e0) {
        $e0 = wrap($e0);
        if (!instanceOf($e0, 23))
          throw unwrap_5($e0);
      }
      values = dynamicCast(out.get_0(key), 27);
      if (!values) {
        values = new ArrayList;
        out.put(key, values);
      }
      values.add_1(val);
    }
  }
  for (entry$iterator = out.entrySet_0().iterator(); entry$iterator.hasNext();) {
    entry = dynamicCast(entry$iterator.next_0(), 18);
    entry.setValue(unmodifiableList(dynamicCast(entry.getValue(), 27)));
  }
  out = new Collections$UnmodifiableMap(out);
  return out;
}

function ensureListParameterMap(){
  var currentQueryString;$wnd.location = {};
  currentQueryString = $wnd.location.search;
  if (!listParamMap || !$equals(cachedQueryString, currentQueryString)) {
    listParamMap = buildListParamMap(currentQueryString);
    cachedQueryString = currentQueryString;
  }
}

var cachedQueryString = '', listParamMap;
function $clinit_CalendarUtil(){
  $clinit_CalendarUtil = emptyMethod;
  $getDateTimeFormatInfo(($clinit_LocaleInfo() , $clinit_LocaleInfo() , instance));
}

function assertCompileTimeUserAgent(){
  var runtimeValue;
  runtimeValue = $getRuntimeValue();
  if (!$equals('safari', runtimeValue)) {
    throw new UserAgentAsserter$UserAgentAssertionError(runtimeValue);
  }
}

function Error_0(message, cause){
  this.cause = cause;
  this.detailMessage = message;
  $fillInStackTrace(this);
}

defineClass(58, 11, $intern_1);
var Ljava_lang_Error_2_classLit = createForClass('java.lang', 'Error', 58);
defineClass(22, 58, $intern_1);
var Ljava_lang_AssertionError_2_classLit = createForClass('java.lang', 'AssertionError', 22);
function UserAgentAsserter$UserAgentAssertionError(runtimeValue){
  Error_0.call(this, '' + ('Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value (' + runtimeValue + ').\n' + 'Expect more errors.'), instanceOf('Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value (' + runtimeValue + ').\n' + 'Expect more errors.', 11)?dynamicCast('Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value (' + runtimeValue + ').\n' + 'Expect more errors.', 11):null);
}

defineClass(84, 22, $intern_1, UserAgentAsserter$UserAgentAssertionError);
var Lcom_google_gwt_useragent_client_UserAgentAsserter$UserAgentAssertionError_2_classLit = createForClass('com.google.gwt.useragent.client', 'UserAgentAsserter/UserAgentAssertionError', 84);
function $getRuntimeValue(){
  var ua = navigator.userAgent.toLowerCase();
  var docMode = $doc.documentMode;
  if (function(){
    return ua.indexOf('webkit') != -1;
  }
  ())
    return 'safari';
  if (function(){
    return ua.indexOf('msie') != -1 && docMode >= 10 && docMode < 11;
  }
  ())
    return 'ie10';
  if (function(){
    return ua.indexOf('msie') != -1 && docMode >= 9 && docMode < 11;
  }
  ())
    return 'ie9';
  if (function(){
    return ua.indexOf('msie') != -1 && docMode >= 8 && docMode < 11;
  }
  ())
    return 'ie8';
  if (function(){
    return ua.indexOf('gecko') != -1 || docMode >= 11;
  }
  ())
    return 'gecko1_8';
  return 'unknown';
}

function $clearOnReadyStateChange(this$static){
  this$static.onreadystatechange = function(){
  }
  ;
}

function $open(this$static, httpMethod, url_0){
  this$static.open(httpMethod, url_0, true);
}

function $setOnReadyStateChange(this$static, handler){
  var _this = this$static;
  this$static.onreadystatechange = $entry(function(){
    handler.onReadyStateChange(_this);
  }
  );
}

function $setRequestHeader(this$static, header, value_0){
  this$static.setRequestHeader(header, value_0);
}

function $name(this$static){
  return this$static.name_0 != null?this$static.name_0:'' + this$static.ordinal;
}

function $toString_1(this$static){
  return this$static.name_0 != null?this$static.name_0:'' + this$static.ordinal;
}

function Enum(name_0, ordinal){
  this.name_0 = name_0;
  this.ordinal = ordinal;
}

defineClass(20, 1, {4:1, 25:1, 20:1});
_.equals$ = function equals_4(other){
  return this === other;
}
;
_.hashCode$ = function hashCode_5(){
  return getHashCode(this);
}
;
_.toString$ = function toString_10(){
  return $toString_1(this);
}
;
_.ordinal = 0;
var Ljava_lang_Enum_2_classLit = createForClass('java.lang', 'Enum', 20);
function $clinit_ColumnTypes(){
  $clinit_ColumnTypes = emptyMethod;
  None = new ColumnTypes('None', 0, 0, 'text');
  Char = new ColumnTypes('Char', 1, 99, 'text');
  Str = new ColumnTypes('Str', 2, 115, 'text');
  Rstr = new ColumnTypes('Rstr', 3, 83, 'text');
  Bool = new ColumnTypes('Bool', 4, 98, 'bool');
  Real = new ColumnTypes('Real', 5, 114, 'number');
  Int = new ColumnTypes('Int', 6, 105, 'number');
  Date8 = new ColumnTypes('Date8', 7, 100, 'date');
  Date10 = new ColumnTypes('Date10', 8, 101, 'date');
  Date14 = new ColumnTypes('Date14', 9, 68, 'date');
  Time5 = new ColumnTypes('Time5', 10, 116, 'time');
  Time6 = new ColumnTypes('Time6', 11, 84, 'time');
  Day = new ColumnTypes('Day', 12, 121, 'text');
  Unsigned = new ColumnTypes('Unsigned', 13, 117, 'number');
  Operator = new ColumnTypes('Operator', 14, 111, 'text');
}

function $getFormat(this$static){
  switch (this$static.ordinal) {
    case 7:
      return Lang == 3?'MM/DD/YY':'DD/MM/YY';
    case 8:
      return Lang == 3?'MM/DD/YYYY':'DD/MM/YYYY';
    case 9:
      return Lang == 3?'MM/DD/YY HH:mm':'DD/MM/YY HH:mm';
    case 10:
    case 11:
      return 'HH:mm';
  }
  return '';
}

function ColumnTypes(enum$name, enum$ordinal, value_0, inputType){
  Enum.call(this, enum$name, enum$ordinal);
  this.inputType = inputType;
  $put_0((!mappings && !mappings && (mappings = new HashMap) , mappings), valueOf(value_0), this);
}

function forValue(value_0){
  $clinit_ColumnTypes();
  return dynamicCast($get_1((!mappings && !mappings && (mappings = new HashMap) , mappings), valueOf(value_0)), 16);
}

function values_0(){
  $clinit_ColumnTypes();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_ColumnTypes_2_classLit, 1), $intern_5, 16, 0, [None, Char, Str, Rstr, Bool, Real, Int, Date8, Date10, Date14, Time5, Time6, Day, Unsigned, Operator]);
}

defineClass(16, 20, {16:1, 4:1, 25:1, 20:1}, ColumnTypes);
var Bool, Char, Date10, Date14, Date8, Day, Int, None, Operator, Real, Rstr, Str, Time5, Time6, Unsigned, mappings;
var Lcom_priority_app_common_ColumnTypes_2_classLit = createForEnum('com.priority.app.common', 'ColumnTypes', 16, values_0);
function $clinit_EntityTypes(){
  $clinit_EntityTypes = emptyMethod;
  None_0 = new EntityTypes('None', 0, 0);
  Form_0 = new EntityTypes('Form', 1, 70);
  Report = new EntityTypes('Report', 2, 82);
  Wizard = new EntityTypes('Wizard', 3, 87);
  Html = new EntityTypes('Html', 4, 72);
  Movie = new EntityTypes('Movie', 5, 109);
  Gantt = new EntityTypes('Gantt', 6, 71);
  Explorer = new EntityTypes('Explorer', 7, 69);
  Dashboard = new EntityTypes('Dashboard', 8, 68);
  Olap = new EntityTypes('Olap', 9, 79);
  Procedure = new EntityTypes('Procedure', 10, 80);
  Menu = new EntityTypes('Menu', 11, 77);
  WizardMenu = new EntityTypes('WizardMenu', 12, 119);
  BPM = new EntityTypes('BPM', 13, 98);
  Generators = new EntityTypes('Generators', 14, 103);
  CompliedProg = new EntityTypes('CompliedProg', 15, 67);
  Load = new EntityTypes('Load', 16, 76);
  Interface = new EntityTypes('Interface', 17, 73);
  ExtDoc = new EntityTypes('ExtDoc', 18, 102);
  Message = new EntityTypes('Message', 19, 40);
  Frame_0 = new EntityTypes('Frame', 20, 35);
}

function EntityTypes(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  $put_0((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(value_0), this);
}

function getEntChar(type_0){
  $clinit_EntityTypes();
  var k, k$iterator;
  for (k$iterator = (!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , $iterator(new AbstractMap$1(mappings_0))); $hasNext(k$iterator.val$outerIter2);) {
    k = dynamicCast($next_0(k$iterator), 15).value_0;
    if (maskUndefined($get_1((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(k))) === maskUndefined(type_0)) {
      return k & 65535;
    }
  }
  return 0;
}

function values_1(){
  $clinit_EntityTypes();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_EntityTypes_2_classLit, 1), $intern_5, 14, 0, [None_0, Form_0, Report, Wizard, Html, Movie, Gantt, Explorer, Dashboard, Olap, Procedure, Menu, WizardMenu, BPM, Generators, CompliedProg, Load, Interface, ExtDoc, Message, Frame_0]);
}

defineClass(14, 20, {14:1, 4:1, 25:1, 20:1}, EntityTypes);
var BPM, CompliedProg, Dashboard, Explorer, ExtDoc, Form_0, Frame_0, Gantt, Generators, Html, Interface, Load, Menu, Message, Movie, None_0, Olap, Procedure, Report, Wizard, WizardMenu, mappings_0;
var Lcom_priority_app_common_EntityTypes_2_classLit = createForEnum('com.priority.app.common', 'EntityTypes', 14, values_1);
function $UploadFile(this$static, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, userState){
  var b64, base64FileSize, finished, macFileTransfer, uploadmode;
  uploadmode = 0;
  if (uploadFileSection == 0) {
    b64 = fileContents.indexOf('base64,', 0);
    b64 >= 0 && (fileContents = __substr(fileContents, b64 + 7, fileContents.length - (b64 + 7)));
  }
   else {
    uploadmode = 1;
  }
  if (this$static.holder.isCancelFileUpload_0()) {
    this$static.holder.setCancelFileUpload(false);
    this$static.UploadCancel(onSuccess, onError);
    return;
  }
  finished = false;
  macFileTransfer = null;
  base64FileSize = $getBase64FileSize();
  $clinit_PriCommon();
  fileContents == null || fileContents.length == 0?(finished = true):uploadFileSection * base64FileSize >= fileContents.length?(finished = true):(macFileTransfer = fileContents.substr(uploadFileSection * base64FileSize, (uploadFileSection + 1) * base64FileSize - uploadFileSection * base64FileSize));
  this$static.ServerUpload(uploadmode, finished, b64encode(macFileTransfer), fileName, uploadFileSection, false, fileContents, onProgress, onSuccess, onError, userState);
}

function $getBase64FileSize(){
  var base64FileSize;
  base64FileSize = 19456;
  (($clinit_PriCommon() , MajorVersion) > 18 || MajorVersion == 18 && MinorVersion >= 4) && (base64FileSize = 191488);
  return base64FileSize;
}

function $getProgress(uploadFileSection, contents){
  var base64FileSize, progress;
  base64FileSize = $getBase64FileSize();
  progress = round_int((uploadFileSection + 1) * base64FileSize / contents.length * 100);
  progress > 100 && (progress = 100);
  return progress;
}

function FileUploader(holder){
  this.holder = holder;
}

defineClass(77, 1, {});
var Lcom_priority_app_common_FileUploader_2_classLit = createForClass('com.priority.app.common', 'FileUploader', 77);
function $clinit_PriCommon(){
  var month, year, resultMonthCount, resultYear, resultMonth, hours, hours_0;
  $clinit_PriCommon = emptyMethod;
  var d, formFuncs, mainFuncs, procFuncs;
  HasFiltersFeature = ($clinit_Boolean() , $clinit_Boolean() , FALSE_0);
  HasFormAlertChooseFeature = (null , FALSE_0);
  HasUserValuesFeature = (null , FALSE_0);
  NotSupportedFunctions = new HashMap;
  mainFuncs = new HashMap;
  $putStringValue(mainFuncs, 'companies', valueOf(1));
  $putStringValue(mainFuncs, 'entMessages', valueOf(1));
  $putStringValue(mainFuncs, 'languages', valueOf(2));
  $putStringValue(mainFuncs, 'isUserConsent', valueOf(4));
  formFuncs = new HashMap;
  $putStringValue(formFuncs, 'filterChoose', valueOf(4));
  $putStringValue(formFuncs, 'filterSearchAction', valueOf(4));
  $putStringValue(formFuncs, 'setSearchFilter', valueOf(5));
  $putStringValue(formFuncs, 'getFilters', valueOf(7));
  $putStringValue(formFuncs, 'saveFilter', valueOf(7));
  $putStringValue(formFuncs, 'deleteFilter', valueOf(7));
  procFuncs = new HashMap;
  $putStringValue(procFuncs, 'uploadFile', valueOf(4));
  $putStringValue(procFuncs, 'uploadDataUrl', valueOf(4));
  $put_0(NotSupportedFunctions, valueOf(1), mainFuncs);
  $put_0(NotSupportedFunctions, valueOf(2), formFuncs);
  $put_0(NotSupportedFunctions, valueOf(3), procFuncs);
  logger_0 = (new LoggerImplRegular , $ensureLogger(getLogManager(), 'Pri'));
  d = new Date_0;
  $clinit_CalendarUtil();
  month = d.jsdate.getMonth();
  year = d.jsdate.getFullYear() - 1900;
  resultMonthCount = year * 12 + month + 120;
  resultYear = round_int(Math.floor(resultMonthCount / 12));
  resultMonth = resultMonthCount - resultYear * 12;
  hours = d.jsdate.getHours();
  $setMonth(d.jsdate, resultMonth);
  $fixDaylightSavings(d, hours);
  hours_0 = d.jsdate.getHours();
  $setFullYear(d.jsdate, resultYear + 1900);
  $fixDaylightSavings(d, hours_0);
  tenYearsFromNow = d;
}

function FuncSupportedFromVersion(type_0, funcname){
  $clinit_PriCommon();
  var funcs;
  if ((funcname == 'userValuesGet' || funcname == 'userValuesSet') && HasUserValuesFeature.value_0)
    return 0;
  if (funcname == 'getFilters' || funcname == 'saveFilter' || funcname == 'deleteFilter') {
    if (HasFiltersFeature.value_0)
      return 0;
  }
  funcs = dynamicCast($get_1(NotSupportedFunctions, valueOf(type_0)), 9);
  if (!!funcs && (funcname == null?!!$getEntry(funcs.hashCodeMap, null):!(funcs.stringMap.get_2(funcname) === undefined)) && dynamicCast(funcname == null?getEntryValueOrNull($getEntry(funcs.hashCodeMap, null)):funcs.stringMap.get_2(funcname), 15).value_0 > BuildVersion)
    return dynamicCast(funcname == null?getEntryValueOrNull($getEntry(funcs.hashCodeMap, null)):funcs.stringMap.get_2(funcname), 15).value_0;
  return 0;
}

function GetDName(dn){
  $clinit_PriCommon();
  if (dn == null || !dn)
    return null;
  if (typeof dn === 'string' || dn instanceof String)
    return dn;
  if (dn.company && dn.company != null) {
    if (dn.group && dn.group != null)
      return dn.company + ':' + dn.group;
    return dn.company;
  }
  return null;
}

function GetIPMessage(msg){
  $clinit_PriCommon();
  var message;
  message = IPMessage;
  (message == null || message.length == 0) && (message = 'This user is currently working in the system at another workstation.');
  message += '(' + msg + ')';
  return message;
}

function IsNullOrEmpty(str){
  $clinit_PriCommon();
  return str == null || str.length == 0;
}

function JsonToString(json){
  $clinit_PriCommon();
  return JSON.stringify(json);
}

function Printlog(message){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), message);
}

function SetMailDirPath(path){
  $clinit_PriCommon();
  var systemimages, systemmail, tenlen;
  tenlen = TenantID.length;
  systemmail = '../../system/mail';
  systemimages = '../../system/images';
  if (tenlen > 0) {
    systemmail += '/' + TenantID;
    systemimages += '/' + TenantID;
  }
  return $startsWith($replace(path.toLowerCase(), 92, 47), systemmail)?SystemMailDir + '/' + $replace($substring(path, systemmail.length + 1), 92, 47):$startsWith($replace(path.toLowerCase(), 92, 47), systemimages)?SystemImagesDir + '/' + $replace($substring(path, systemimages.length + 1), 92, 47):$startsWith(path.toLowerCase(), 'file:///')?path.substr(0, 0) + __substr(path, 8, path.length - 8):path;
}

function TimeZoneName(){
  var _myintl_, _mymoment_, tz;
  $clinit_PriCommon();
  timeZoneName != null && $equals(timeZoneName, '@@@@@@') && (timeZoneName = (_mymoment_ = moment , _myintl_ = null , $wnd.hasOwnProperty('Intl') && (_myintl_ = Intl) , tz = null , _mymoment_ && _mymoment_.tz && (tz = _mymoment_.tz.guess()) , _myintl_ && _myintl_ != null && (tz == null || !tz || tz.length <= 0) && (tz = _myintl_.DateTimeFormat().resolvedOptions().timeZone) , tz));
  if (timeZoneName != null && timeZoneName.length > 0)
    return timeZoneName;
  return '';
}

function b64encode(str){
  $clinit_PriCommon();
  return btoa(unescape(encodeURIComponent(str)));
}

function getHyperLink(obj){
  $clinit_PriCommon();
  var h, hyperlinks, jo;
  hyperlinks = null;
  h = dynamicCast($get_0(obj, 'HyperLinkedText'), 7);
  if (!!h && h.jsArray.length > 0) {
    jo = dynamicCast($get(h, 0), 5);
    'HyperLinks' in jo.jsObject && (hyperlinks = dynamicCast($get_0(jo, 'HyperLinks'), 7));
  }
  if (hyperlinks) {
    return hyperlinks.jsArray;
  }
  return null;
}

function getHyperLinkedText(obj, propertyName){
  $clinit_PriCommon();
  var h, jo, jstr, msgtext;
  msgtext = '';
  h = dynamicCast($get_0(obj, 'HyperLinkedText'), 7);
  if (!!h && h.jsArray.length > 0) {
    jo = dynamicCast($get(h, 0), 5);
    if ('text' in jo.jsObject) {
      jstr = $get_0(jo, 'text').isString();
      !!jstr && (msgtext = jstr.value_0);
    }
  }
  if (msgtext == null || msgtext.length == 0) {
    if (propertyName in obj.jsObject) {
      jstr = $get_0(obj, propertyName).isString();
      !!jstr && (msgtext = jstr.value_0);
    }
  }
  return msgtext;
}

function getJSONNumberProperty(obj, propertyName){
  $clinit_PriCommon();
  var js;
  js = dynamicCast($get_0(obj, propertyName), 26);
  if (!js)
    return 0;
  return js.value_0;
}

function getJSONStringProperty(obj, propertyName){
  $clinit_PriCommon();
  var js;
  js = dynamicCast($get_0(obj, propertyName), 10);
  if (!js)
    return '';
  return js.value_0;
}

function getPriorityVersion(){
  $clinit_PriCommon();
  return MajorVersion + '.' + MinorVersion + '.' + BuildVersion;
}

function split_0(str, delim){
  $clinit_PriCommon();
  var i, jo, len, ret;
  jo = str.split(delim);
  if (jo) {
    len = jo.length;
    if (len >= 0) {
      ret = initDim(Ljava_lang_String_2_classLit, $intern_5, 2, len, 4, 1);
      for (i = 0; i < len; i++)
        ret[i] = jo[i];
      return ret;
    }
  }
  return initDim(Ljava_lang_String_2_classLit, $intern_5, 2, 0, 4, 1);
}

var APIVersion = '2.2.7', AppMain, BuildVersion = 0, HasFiltersFeature, HasFormAlertChooseFeature, HasUserValuesFeature, HtmlSvcCookie = '', IPMessage = '', LabelsPrint = '__LABELS__PRINT__', LangFormat = 0, MGCookie = '', MajorVersion = 0, MinorVersion = 0, NotSupportedFunctions, SystemImagesDir = '', SystemMailDir = '', TenantID = '', isDebugging = true, logger_0, tenYearsFromNow, timeZoneName = '@@@@@@';
function $clinit_PriCommon$ChooseTypes(){
  $clinit_PriCommon$ChooseTypes = emptyMethod;
  Normal = new PriCommon$ChooseTypes('Normal', 0, -18);
  Zoom = new PriCommon$ChooseTypes('Zoom', 1, 0);
  Full = new PriCommon$ChooseTypes('Full', 2, 38);
  Alternate = new PriCommon$ChooseTypes('Alternate', 3, 39);
}

function PriCommon$ChooseTypes(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  this.intValue = value_0;
  $put_0((!mappings_1 && !mappings_1 && (mappings_1 = new HashMap) , mappings_1), valueOf(value_0), this);
}

function values_2(){
  $clinit_PriCommon$ChooseTypes();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_PriCommon$ChooseTypes_2_classLit, 1), $intern_5, 39, 0, [Normal, Zoom, Full, Alternate]);
}

defineClass(39, 20, {39:1, 4:1, 25:1, 20:1}, PriCommon$ChooseTypes);
_.intValue = 0;
var Alternate, Full, Normal, Zoom, mappings_1;
var Lcom_priority_app_common_PriCommon$ChooseTypes_2_classLit = createForEnum('com.priority.app.common', 'PriCommon/ChooseTypes', 39, values_2);
function $clinit_PriCommon$PriMessageType(){
  $clinit_PriCommon$PriMessageType = emptyMethod;
  Ok = new PriCommon$PriMessageType('Ok', 0);
  OkCancel = new PriCommon$PriMessageType('OkCancel', 1);
  None_1 = new PriCommon$PriMessageType('None', 2);
  Cancel = new PriCommon$PriMessageType('Cancel', 3);
  YesNo = new PriCommon$PriMessageType('YesNo', 4);
  YesNoCancel = new PriCommon$PriMessageType('YesNoCancel', 5);
  ReadWriteCancel = new PriCommon$PriMessageType('ReadWriteCancel', 6);
  IPWarning = new PriCommon$PriMessageType('IPWarning', 7);
}

function PriCommon$PriMessageType(enum$name, enum$ordinal){
  Enum.call(this, enum$name, enum$ordinal);
}

function values_3(){
  $clinit_PriCommon$PriMessageType();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_PriCommon$PriMessageType_2_classLit, 1), $intern_5, 28, 0, [Ok, OkCancel, None_1, Cancel, YesNo, YesNoCancel, ReadWriteCancel, IPWarning]);
}

defineClass(28, 20, {28:1, 4:1, 25:1, 20:1}, PriCommon$PriMessageType);
var Cancel, IPWarning, None_1, Ok, OkCancel, ReadWriteCancel, YesNo, YesNoCancel;
var Lcom_priority_app_common_PriCommon$PriMessageType_2_classLit = createForEnum('com.priority.app.common', 'PriCommon/PriMessageType', 28, values_3);
function $clinit_SearchActions(){
  $clinit_SearchActions = emptyMethod;
  None_2 = new SearchActions('None', 0, -1);
  Start = new SearchActions('Start', 1, 0);
  Next = new SearchActions('Next', 2, 1);
  Prev = new SearchActions('Prev', 3, 2);
  TypeChange = new SearchActions('TypeChange', 4, 3);
  TextChange = new SearchActions('TextChange', 5, 4);
  StartChange = new SearchActions('StartChange', 6, 5);
  IgnoreCaseChanged = new SearchActions('IgnoreCaseChanged', 7, 6);
}

function SearchActions(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  this.intValue = value_0;
  $put_0((!mappings_2 && !mappings_2 && (mappings_2 = new HashMap) , mappings_2), valueOf(value_0), this);
}

function values_4(){
  $clinit_SearchActions();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_SearchActions_2_classLit, 1), $intern_5, 30, 0, [None_2, Start, Next, Prev, TypeChange, TextChange, StartChange, IgnoreCaseChanged]);
}

defineClass(30, 20, {30:1, 4:1, 25:1, 20:1}, SearchActions);
_.intValue = 0;
var IgnoreCaseChanged, Next, None_2, Prev, Start, StartChange, TextChange, TypeChange, mappings_2;
var Lcom_priority_app_common_SearchActions_2_classLit = createForEnum('com.priority.app.common', 'SearchActions', 30, values_4);
function $onResponseReceived(this$static, response){
  var e, res;
  try {
    !!this$static.myWcf && !!this$static.myWcf.conHolder && this$static.myWcf.conHolder.ServerTripCompleted(this$static.myWcf, this$static);
    if (response.xmlHttpRequest.status != 200) {
      response.xmlHttpRequest.status == 0?(this$static.error_0 = '@@@The server has failed to respond due to a communication error. Please try again later.\nIf this problem persists, please check your network/internet connection, and notify your system manager.\n'):(this$static.error_0 = "@@@Can't connect to server. HTTP Response: " + response.xmlHttpRequest.status + ', ' + response.xmlHttpRequest.statusText + '\ndetails: ' + response.xmlHttpRequest.responseText);
      this$static.OnPriError(this$static.error_0, false);
    }
     else {
      res = $ResponseResult(response, this$static.op_0);
      this$static.OnPriResponse(($clinit_PriCommon() , decodeURIComponent(escape(atob(res)))));
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      !!this$static.myWcf && !!this$static.myWcf.conHolder && this$static.myWcf.conHolder.ServerTripCompleted(this$static.myWcf, this$static);
      this$static.error_0 = $toString(e);
      this$static.OnPriError(this$static.error_0, false);
    }
     else 
      throw unwrap_5($e0);
  }
}

function WCFResponse(con){
  this.myWcf = con;
}

defineClass(8, 1, {});
_.OnPriError = function OnPriError(error, isOnServer){
}
;
_.OnPriResponse = function OnPriResponse(response){
}
;
var Lcom_priority_app_common_WCFResponse_2_classLit = createForClass('com.priority.app.common', 'WCFResponse', 8);
function $CallApiKeyFunc(svc, requestData, callback, func){
  func().then(function(result){
    svc.PriSendRequest(requestData, callback, result);
  }
  );
}

function $EnvelopeStart(this$static, apiKey, curop){
  var appid, appkey, debugserver;
  return '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Header><Language xmlns="PriorityNS">' + ('' + this$static.Userlang) + '<\/Language><Hostname xmlns="PriorityNS">' + (this$static.Compname == null?'':this$static.Compname) + '<\/Hostname><WinUser xmlns="PriorityNS">' + (this$static.WindowsUser == null?'':this$static.WindowsUser) + '<\/WinUser><UtcOffset xmlns="PriorityNS">' + MobGetTimeAndPlace(GPSLocation, TimeZoneName()) + '<\/UtcOffset><Environment xmlns="PriorityNS">' + (!!this$static.conHolder && this$static.conHolder.getDname() != null?this$static.conHolder.getDname():this$static.Dname == null?'':this$static.Dname) + '<\/Environment><SilverLight xmlns="PriorityNS">2' + '<\/SilverLight>' + (appid = '' , appkey = '' , debugserver = '' , IsNullOrEmpty(AppId) || (appid = 'appid_' + AppId + ',') , $clinit_PriCommon() , apiKey == null || apiKey.length == 0 || (appkey = 'appkey_' + apiKey + ',') , DebugServer == 1 && (debugserver = 'debug,') , '<OtherInfo xmlns="PriorityNS">app_' + AppName + ',' + appid + appkey + debugserver + '<\/OtherInfo>') + '<Security s:mustUnderstand="1" xmlns:u="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" xmlns="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"> <u:Timestamp u:Id="_0">' + $wnd.GMTDates() + '<\/u:Timestamp> <UsernameToken><Username>' + this$static.Username + '<\/Username><Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText">' + this$static.Password + '<\/Password><\/UsernameToken><\/Security><\/s:Header><s:Body><' + curop + ' xmlns="http://tempuri.org/">';
}

function $FormActivateMobAsync(this$static, statexml, before, callback){
  var data_0;
  callback.op_0 = 'FormActivateMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormActivateMob');
  data_0 = $OneParameter_0('statexml', statexml) + $OneParameter('before', ($clinit_Boolean() , before?TRUE_0:FALSE_0)) + '<\/FormActivateMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormAlertChooseMobAsync(this$static, statexml, mode, editvalue, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_7(callback, null);
    return;
  }
  callback.op_0 = 'FormAlertChooseMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormAlertChooseMob');
  data_0 = $OneParameter_0('statexml', statexml) + '<id>-1<\/id>' + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormAlertChooseMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormAlertSearchMobAsync(this$static, statexml, id_0, mode, editvalue, callback){
  var data_0;
  callback.op_0 = 'FormAlertSearchMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormAlertSearchMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<id>' + ('' + toString_9(id_0)) + '<\/' + 'id' + '>') + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormAlertSearchMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormAlertSearchPageMobAsync(this$static, statexml, id_0, page, editvalue, callback){
  var data_0;
  callback.op_0 = 'FormAlertSearchPageMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormAlertSearchPageMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<id>' + ('' + toString_9(id_0)) + '<\/' + 'id' + '>') + ('<page>' + ('' + toString_9(page)) + '<\/' + 'page' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormAlertSearchPageMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormExitFormMobAsync(this$static, statexml, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError(callback, null);
    return;
  }
  callback.op_0 = 'FormExitFormMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormExitFormMob');
  data_0 = $OneParameter_0('statexml', statexml) + '<\/FormExitFormMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormGenerateLabelsMobAsync(this$static, statexml, label_0, lines, clean, print_0, callback){
  var data_0;
  callback.op_0 = 'FormGenerateLabelsMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormGenerateLabelsMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<label>' + ('' + toString_9(label_0)) + '<\/' + 'label' + '>') + $OneParameter('lines', ($clinit_Boolean() , lines?TRUE_0:FALSE_0)) + $OneParameter('clean', clean?TRUE_0:FALSE_0) + $OneParameter('print', print_0?TRUE_0:FALSE_0) + '<\/FormGenerateLabelsMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormHtmlMobAsync(this$static, statexml, tstext, tsline, modified, html, key, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    callback.OnPriError(null, true);
    return;
  }
  callback.op_0 = 'FormHtmlMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormHtmlMob');
  data_0 = $OneParameter_0('statexml', statexml) + $OneParameter_0('tstext', tstext) + ('<tsline>' + ('' + toString_9(tsline)) + '<\/' + 'tsline' + '>') + ('<modified>' + ('' + toString_9(modified)) + '<\/' + 'modified' + '>') + $OneParameter_0('html', html) + $OneParameter_0('comment', '') + ('<key>' + ('' + toString_9(key)) + '<\/' + 'key' + '>') + '<param1>0<\/param1>' + '<param2>0<\/param2>' + '<param3>0<\/param3>' + '<\/FormHtmlMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormIsAliveMobAsync(this$static, statexml, callback){
  var data_0;
  callback.op_0 = 'FormIsAliveMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormIsAliveMob');
  data_0 = $OneParameter_0('statexml', statexml) + '<\/FormIsAliveMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormJumpLineMobAsync(this$static, statexml, line, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_0(callback, null);
    return;
  }
  callback.op_0 = 'FormJumpLineMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormJumpLineMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<line>' + ('' + toString_9(line)) + '<\/' + 'line' + '>') + '<\/FormJumpLineMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormKeyMobAsync(this$static, statexml, key, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    callback.OnPriError(null, true);
    return;
  }
  callback.op_0 = 'FormKeyMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormKeyMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<key>' + ('' + toString_9(key)) + '<\/' + 'key' + '>') + '<\/FormKeyMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormQueryDlgChooseMobAsync(this$static, statexml, field, mode, editvalue, callback){
  var data_0;
  callback.op_0 = 'FormQueryDlgChooseMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormQueryDlgChooseMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormQueryDlgChooseMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormQueryDlgDeleteMobAsync(this$static, statexml, query, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_4(callback, null);
    return;
  }
  callback.op_0 = 'FormQueryDlgDeleteMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormQueryDlgDeleteMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<query>' + ('' + toString_9(query)) + '<\/' + 'query' + '>') + '<\/FormQueryDlgDeleteMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormQueryDlgExecuteMobAsync(this$static, statexml, add_0, xml, top_0, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    callback.OnPriError(null, true);
    return;
  }
  callback.op_0 = 'FormQueryDlgExecuteMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormQueryDlgExecuteMob');
  data_0 = $OneParameter_0('statexml', statexml) + $OneParameter('add', ($clinit_Boolean() , add_0?TRUE_0:FALSE_0)) + $OneParameter_0('xml', xml) + $OneParameter('ic', (null , TRUE_0)) + $OneParameter_0('queryname', '') + ('<top>' + ('' + toString_9(top_0)) + '<\/' + 'top' + '>') + '<\/FormQueryDlgExecuteMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormQueryDlgSaveMobAsync(this$static, statexml, query, xml, queryname, isdefault, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_2(callback, null);
    return;
  }
  callback.op_0 = 'FormQueryDlgSaveMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormQueryDlgSaveMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<query>' + ('' + toString_9(query)) + '<\/' + 'query' + '>') + $OneParameter_0('xml', xml) + $OneParameter_0('queryname', queryname) + ('<isdefault>' + ('' + toString_9(isdefault)) + '<\/' + 'isdefault' + '>') + '<\/FormQueryDlgSaveMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormQueryDlgStartMobAsync(this$static, statexml, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_5(callback, null);
    return;
  }
  callback.op_0 = 'FormQueryDlgStartMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormQueryDlgStartMob');
  data_0 = $OneParameter_0('statexml', statexml) + '<\/FormQueryDlgStartMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSaveMobAsync(this$static, statexml, link_0, thisline, callback){
  var data_0;
  callback.op_0 = 'FormSaveMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSaveMob');
  data_0 = $OneParameter_0('statexml', statexml) + $OneParameter_0('link', link_0) + $OneParameter('thisline', ($clinit_Boolean() , thisline?TRUE_0:FALSE_0)) + '<\/FormSaveMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSearchMobAsync(this$static, statexml, mode, editvalue, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_6(callback, null);
    return;
  }
  callback.op_0 = 'FormSearchMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSearchMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormSearchMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSearchPageMobAsync(this$static, statexml, page, editvalue, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_6(callback, null);
    return;
  }
  callback.op_0 = 'FormSearchPageMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSearchPageMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<page>' + ('' + toString_9(page)) + '<\/' + 'page' + '>') + $OneParameter_0('editvalue', editvalue) + '<\/FormSearchPageMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSearchSetDirtyMobAsync(this$static, statexml, callback){
  var data_0;
  callback.op_0 = 'FormSearchSetDirtyMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSearchSetDirtyMob');
  data_0 = $OneParameter_0('statexml', statexml) + '<\/FormSearchSetDirtyMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormStartExMobAsync(this$static, form_0, link_0, linkid, zoomname, debug, zoomvalue, appParams, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    InvokeFormStartCallback(null, 0, null, null, null, 'exception', callback.val$onSuccess4, callback.val$onError5);
    return;
  }
  callback.op_0 = 'FormStartExMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormStartExMob');
  data_0 = $OneParameter_0('form', form_0) + '<scrwidth>-1<\/scrwidth>' + $OneParameter_0('link', link_0) + $OneParameter_0('linkid', linkid) + '<zoomcolumn>0<\/zoomcolumn>' + $OneParameter_0('zoomname', zoomname) + $OneParameter('debug', ($clinit_Boolean() , debug?TRUE_0:FALSE_0)) + $OneParameter('sendtitles', (null , FALSE_0)) + $OneParameter_0('zoomvalue', zoomvalue) + $OneParameter_0('appParams', appParams) + '<\/FormStartExMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormStartMobAsync(this$static, form_0, scrwidth, link_0, linkid, zoomname, debug, zoomvalue, autoRetrieveFirstRows, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    InvokeFormStartCallback(null, 0, null, null, null, 'exception', callback.val$onSuccess4, callback.val$onError5);
    return;
  }
  callback.op_0 = 'FormStartMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormStartMob');
  data_0 = $OneParameter_0('form', form_0) + ('<scrwidth>' + ('' + toString_9(scrwidth)) + '<\/' + 'scrwidth' + '>') + $OneParameter_0('link', link_0) + $OneParameter_0('linkid', linkid) + '<zoomcolumn>0<\/zoomcolumn>' + $OneParameter_0('zoomname', zoomname) + $OneParameter('debug', ($clinit_Boolean() , debug?TRUE_0:FALSE_0)) + $OneParameter('sendtitles', (null , FALSE_0)) + $OneParameter_0('zoomvalue', zoomvalue) + $OneParameter('autoRetrieveFirstRows', autoRetrieveFirstRows?TRUE_0:FALSE_0) + '<\/FormStartMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSubFormExMobAsync(this$static, statexml, self_0, appParams, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_1(callback, null);
    return;
  }
  callback.op_0 = 'FormSubFormExMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSubFormExMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<self>' + ('' + toString_9(self_0)) + '<\/' + 'self' + '>') + $OneParameter('empty', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + $OneParameter_0('appParams', appParams) + '<\/FormSubFormExMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormSubFormMobAsync(this$static, statexml, self_0, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_1(callback, null);
    return;
  }
  callback.op_0 = 'FormSubFormMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormSubFormMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<self>' + ('' + toString_9(self_0)) + '<\/' + 'self' + '>') + $OneParameter('empty', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + '<\/FormSubFormMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormUploadFileAsyncMob(this$static, statexml, mode, file, base64, callback){
  var data_0;
  callback.op_0 = 'FormUploadFileMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormUploadFileMob');
  data_0 = $OneParameter_0('statexml', statexml) + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('file', file) + $OneParameter_0('base64', base64) + '<\/FormUploadFileMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $FormWarningMobAsync(this$static, statexml, wsql, wval, wline, wkey, wstep, callback){
  var data_0;
  if (!!this$static.conHolder && !this$static.conHolder.SetIsGoneToServer(callback)) {
    $OnPriError_3(callback, null);
    return;
  }
  callback.op_0 = 'FormWarningMob';
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/FormWarningMob');
  data_0 = $OneParameter_0('statexml', statexml) + $OneParameter_0('wsql', wsql) + ('<wval>' + ('' + toString_9(wval)) + '<\/' + 'wval' + '>') + ('<wline>' + ('' + toString_9(wline)) + '<\/' + 'wline' + '>') + ('<wkey>' + ('' + toString_9(wkey)) + '<\/' + 'wkey' + '>') + ('<wstep>' + ('' + toString_9(wstep)) + '<\/' + 'wstep' + '>') + '<\/FormWarningMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GeneralAttachmentToDataUriMob(this$static, filename, callback){
  var data_0;
  callback.op_0 = 'GeneralAttachmentToDataUriMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralAttachmentToDataUriMob');
  data_0 = $OneParameter_0('filename', filename) + '<\/GeneralAttachmentToDataUriMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GeneralCompaniesMobAsync(this$static, callback){
  callback.op_0 = 'GeneralCompaniesMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralCompaniesMob');
  AppKeyFunction?$CallApiKeyFunc(this$static, '<\/GeneralCompaniesMob><\/s:Body><\/s:Envelope>', callback, AppKeyFunction):$PriSendRequest(this$static, '<\/GeneralCompaniesMob><\/s:Body><\/s:Envelope>', callback, AppKey);
}

function $GeneralExtMessagesRangeMobAsync(this$static, ename, type_0, from, to, callback){
  var data_0;
  callback.op_0 = 'GeneralExtMessagesRangeMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralExtMessagesRangeMob');
  data_0 = $OneParameter_0('ename', ename) + $OneParameter_0('type', type_0) + ('<from>' + ('' + toString_9(from)) + '<\/' + 'from' + '>') + ('<to>' + ('' + toString_9(to)) + '<\/' + 'to' + '>') + '<\/GeneralExtMessagesRangeMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GeneralLanguagesMobAsync(this$static, callback){
  callback.op_0 = 'GeneralLanguagesMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralLanguagesMob');
  AppKeyFunction?$CallApiKeyFunc(this$static, '<\/GeneralLanguagesMob><\/s:Body><\/s:Envelope>', callback, AppKeyFunction):$PriSendRequest(this$static, '<\/GeneralLanguagesMob><\/s:Body><\/s:Envelope>', callback, AppKey);
}

function $GeneralUserConsentMobAsync(this$static, callback){
  callback.op_0 = 'GeneralUserConsentMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralUserConsentMob');
  AppKeyFunction?$CallApiKeyFunc(this$static, '<\/GeneralUserConsentMob><\/s:Body><\/s:Envelope>', callback, AppKeyFunction):$PriSendRequest(this$static, '<\/GeneralUserConsentMob><\/s:Body><\/s:Envelope>', callback, AppKey);
}

function $GeneralUserValuesGetMobAsync(this$static, json, callback){
  var data_0;
  callback.op_0 = 'GeneralUserValuesGetMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralUserValuesGetMob');
  data_0 = $OneParameter_0('data', json) + '<\/GeneralUserValuesGetMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GeneralUserValuesSetMobAsync(this$static, json, callback){
  var data_0;
  callback.op_0 = 'GeneralUserValuesSetMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralUserValuesSetMob');
  data_0 = $OneParameter_0('data', json) + '<\/GeneralUserValuesSetMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GeneralValidPasswordMobAsync(this$static, password, callback){
  var data_0;
  callback.op_0 = 'GeneralValidPasswordMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GeneralValidPasswordMob');
  data_0 = $OneParameter_0('password', password) + '<\/GeneralValidPasswordMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $GetFileVersion(this$static, callback){
  callback.op_0 = 'GetFileVersion';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/GetFileVersion');
  AppKeyFunction?$CallApiKeyFunc(this$static, '<\/GetFileVersion><\/s:Body><\/s:Envelope>', callback, AppKeyFunction):$PriSendRequest(this$static, '<\/GetFileVersion><\/s:Body><\/s:Envelope>', callback, AppKey);
}

function $OneParameter(name_0, value_0){
  return '<' + name_0 + '>' + (value_0.value_0?'true':'false') + '<\/' + name_0 + '>';
}

function $OneParameter_0(name_0, value_0){
  if (value_0 == null)
    return '';
  return '<' + name_0 + '>' + escapeString(value_0) + '<\/' + name_0 + '>';
}

function $PriSendRequest(this$static, requestData, callback, apiKey){
  requestData = $EnvelopeStart(this$static, apiKey, callback.op_0) + requestData;
  try {
    throwIfNull('callback', callback);
    $doSend(this$static, requestData, callback);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (!instanceOf($e0, 31))
      throw unwrap_5($e0);
  }
}

function $ProcAskPrintOKMobAsync(this$static, session, mode, format, pdf, callback){
  var data_0;
  callback.op_0 = 'ProcAskPrintOKMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcAskPrintOKMob');
  data_0 = $OneParameter_0('session', session) + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + ('<format>' + ('' + toString_9(format)) + '<\/' + 'format' + '>') + $OneParameter('sendattach', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + '<copies>1<\/copies>' + $OneParameter('pdf', pdf?TRUE_0:FALSE_0) + $OneParameter('sign', (null , FALSE_0)) + $OneParameter('quick', (null , FALSE_0)) + '<\/ProcAskPrintOKMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcCheckExecutionMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcCheckExecutionMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcCheckExecutionMob');
  data_0 = $OneParameter_0('session', session) + '<\/ProcCheckExecutionMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcChooseFieldsOKMobAsync(this$static, session, field, callback){
  var data_0;
  callback.op_0 = 'ProcChooseFieldsOKMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcChooseFieldsOKMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + '<\/ProcChooseFieldsOKMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcClientContinueMobAsync(this$static, session, clientData, callback){
  var data_0;
  callback.op_0 = 'ProcClientContinueMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcClientContinueMob');
  data_0 = $OneParameter_0('session', session) + $OneParameter_0('data', clientData) + '<\/ProcClientContinueMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcContinueMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcContinueMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcContinueMob');
  data_0 = $OneParameter_0('session', session) + '<\/ProcContinueMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcCreateSpreadsheetMobAsync(this$static, type_0, ename, template, sourceDataFile, callback){
  var data_0;
  callback.op_0 = 'ProcCreateSpreadsheetMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcCreateSpreadsheetMob');
  data_0 = $OneParameter_0('type', type_0) + $OneParameter_0('ename', ename) + ('<template>' + ('' + toString_9(template)) + '<\/' + 'template' + '>') + $OneParameter_0('sourcedatafile', sourceDataFile) + '<\/ProcCreateSpreadsheetMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcEditFieldsOKMobAsync(this$static, session, xml, callback){
  var data_0;
  callback.op_0 = 'ProcEditFieldsOKMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcEditFieldsOKMob');
  data_0 = $OneParameter_0('session', session) + $OneParameter('save', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + $OneParameter_0('xml', xml) + '<\/ProcEditFieldsOKMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcEndMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcEndMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcEndMob');
  data_0 = $OneParameter_0('session', session) + '<\/ProcEndMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcKillExecutionMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcKillExecutionMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcKillExecutionMob');
  data_0 = $OneParameter_0('session', session) + '<\/ProcKillExecutionMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcKillProcessMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcKillProcessMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcKillProcessMob');
  data_0 = $OneParameter_0('session', session) + '<\/ProcKillProcessMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcNewReportMobAsync(this$static, type_0, ename, mode, format, callback){
  var data_0;
  callback.op_0 = 'ProcNewReportMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcNewReportMob');
  data_0 = $OneParameter_0('type', type_0) + $OneParameter_0('ename', ename) + $OneParameter('debug', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + $OneParameter_0('mode', mode) + ('<format>' + ('' + toString_9(format)) + '<\/' + 'format' + '>') + $OneParameter_0('zoomvalue', '') + '<\/ProcNewReportMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcParamChooseMobAsync(this$static, session, field, xml, callback){
  var data_0;
  callback.op_0 = 'ProcParamChooseMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcParamChooseMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + $OneParameter_0('xml', xml) + '<\/ProcParamChooseMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcParamSearchMobAsync(this$static, session, field, mode, cursor, start_0, last, editvalue, xml, callback){
  var data_0;
  callback.op_0 = 'ProcParamSearchMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcParamSearchMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + ('<cursor>' + ('' + toString_9(cursor)) + '<\/' + 'cursor' + '>') + ('<start>' + ('' + toString_9(start_0)) + '<\/' + 'start' + '>') + $OneParameter_0('last', last) + $OneParameter_0('editvalue', editvalue) + $OneParameter_0('xml', xml) + '<\/ProcParamSearchMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcParamSearchPageMobAsync(this$static, session, field, page, cursor, start_0, last, editvalue, callback){
  var data_0;
  callback.op_0 = 'ProcParamSearchPageMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcParamSearchPageMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + ('<page>' + ('' + toString_9(page)) + '<\/' + 'page' + '>') + ('<cursor>' + ('' + toString_9(cursor)) + '<\/' + 'cursor' + '>') + ('<start>' + ('' + toString_9(start_0)) + '<\/' + 'start' + '>') + $OneParameter_0('last', last) + $OneParameter_0('editvalue', editvalue) + $OneParameter_0('xml', null) + '<\/ProcParamSearchPageMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcParamZoomMobAsync(this$static, session, field, callback){
  var data_0;
  callback.op_0 = 'ProcParamZoomMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcParamZoomMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + '<\/ProcParamZoomMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcParamZoomValueMobAsync(this$static, session, field, link_0, callback){
  var data_0;
  callback.op_0 = 'ProcParamZoomValueMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcParamZoomValueMob');
  data_0 = $OneParameter_0('session', session) + ('<field>' + ('' + toString_9(field)) + '<\/' + 'field' + '>') + $OneParameter_0('link', link_0) + '<\/ProcParamZoomValueMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcStartActivateMobAsync(this$static, type_0, ename, table, link_0, linkid, avoidmessages, callback){
  var data_0;
  callback.op_0 = 'ProcStartActivateMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcStartActivateMob');
  data_0 = $OneParameter_0('type', type_0) + $OneParameter_0('ename', ename) + $OneParameter_0('table', table) + $OneParameter_0('link', link_0) + $OneParameter_0('linkid', linkid) + $OneParameter('avoidmessages', ($clinit_Boolean() , avoidmessages?TRUE_0:FALSE_0)) + '<\/ProcStartActivateMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcStartMobAsync(this$static, type_0, ename, avoidmessages, callback){
  var data_0;
  callback.op_0 = 'ProcStartMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcStartMob');
  data_0 = $OneParameter_0('type', type_0) + $OneParameter_0('ename', ename) + $OneParameter('debug', ($clinit_Boolean() , $clinit_Boolean() , FALSE_0)) + '<repexec>0<\/repexec>' + $OneParameter('avoidmessages', avoidmessages?TRUE_0:FALSE_0) + '<\/ProcStartMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcUploadFileMobAsync(this$static, session, mode, base64, callback){
  var data_0;
  callback.op_0 = 'ProcUploadFileMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcUploadFileMob');
  data_0 = $OneParameter_0('session', session) + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('base64', base64) + '<\/ProcUploadFileMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcUploadFileParamMobAsync(this$static, session, mode, base64, file, callback){
  var data_0;
  callback.op_0 = 'ProcUploadFileParamMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcUploadFileParamMob');
  data_0 = $OneParameter_0('session', session) + ('<mode>' + ('' + toString_9(mode)) + '<\/' + 'mode' + '>') + $OneParameter_0('base64', base64) + $OneParameter_0('file', file) + '<\/ProcUploadFileParamMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ProcWarningOKMobAsync(this$static, session, callback){
  var data_0;
  callback.op_0 = 'ProcWarningOKMob';
  !!this$static.conHolder && this$static.conHolder.SetIsGoneToServer(callback);
  $setHeader(this$static, 'SOAPAction', 'http://tempuri.org/IWCFService/ProcWarningOKMob');
  data_0 = $OneParameter_0('session', session) + '<warnings>0<\/warnings>' + '<\/ProcWarningOKMob><\/s:Body><\/s:Envelope>';
  AppKeyFunction?$CallApiKeyFunc(this$static, data_0, callback, AppKeyFunction):$PriSendRequest(this$static, data_0, callback, AppKey);
}

function $ResponseResult(r, curop){
  var a;
  a = split_0(r.xmlHttpRequest.responseText, curop + 'Result>');
  if (a.length < 2 || a[1].length <= 2)
    return '';
  return $substring_0(a[1], 0, a[1].length - 2);
}

function $SetComputerName(this$static, name_0){
  this$static.Compname = name_0 == null?'':name_0;
}

function $SetUsernamePassword(this$static, app, username, password, activeDirectory, authAudience){
  this$static.Username = username + '\t' + app;
  $clinit_PriCommon();
  authAudience == null || authAudience.length == 0 || (this$static.Username += '\t' + authAudience);
  this$static.Password = password;
  activeDirectory == 1?(this$static.Username = '$AppAd$' + this$static.Username):activeDirectory == 2 && (this$static.Username = '$AppAdEnc$' + this$static.Username);
}

function $SetWindowsUser(this$static, name_0){
  this$static.WindowsUser = name_0 == null?'':name_0;
}

function MobGetTimeAndPlace(loc, tz){
  var offset = -(new Date).getTimezoneOffset();
  moment && moment.tz && tz && tz != '' && (offset = moment.tz(tz).utcOffset());
  return offset + (loc?loc:'') + (tz && tz != ''?'@TZ@' + tz:'');
}

function WCFService(url_0, holder){
  $clinit_RequestBuilder();
  RequestBuilder.call(this, POST, url_0);
  $setHeader(this, 'content-type', 'text/xml; charset=utf-8');
  this.conHolder = holder;
}

function escapeString(str){
  str = str.indexOf('&') >= 0?str.replace(/&/g, '&amp;'):str;
  str = str.indexOf('<') >= 0?str.replace(/</g, '&lt;'):str;
  str = str.indexOf('>') >= 0?str.replace(/>/g, '&gt;'):str;
  return str;
}

defineClass(103, 70, {}, WCFService);
_.PriSendRequest = function PriSendRequest(requestData, callback, apiKey){
  $PriSendRequest(this, requestData, callback, apiKey);
}
;
_.Userlang = 0;
var Lcom_priority_app_common_WCFService_2_classLit = createForClass('com.priority.app.common', 'WCFService', 103);
function CheckWCFVersion(){
  if (WCFVersion) {
    if (WCFVersion.major > 1)
      return true;
    if (WCFVersion.minor > 0)
      return true;
    if (WCFVersion.build > 9)
      return true;
  }
  return false;
}

function GetWCFServiceClient(conHolder){
  var con;
  con = new WCFService(Host, conHolder);
  $SetUsernamePassword(con, App, Login, Pwd, ActiveDirectory, AuthAudience);
  $SetComputerName(con, ComputerName);
  $SetWindowsUser(con, WindowsUser);
  con.Userlang = Lang;
  con.Dname = DName;
  return con;
}

function SetWCFServiceClientParams(login, pwd, accessToken, computerName, windowsUser, authAudience){
  $clinit_PriCommon();
  if (accessToken == null || accessToken.length == 0) {
    Login = login;
    Pwd = pwd;
  }
   else {
    Login = 'oidc_jwt';
    Pwd = accessToken;
  }
  ComputerName = computerName;
  WindowsUser = windowsUser;
  AuthAudience = authAudience;
}

function SetWCFServiceParams(host, app, lang_0, dname, appname, activeDirectory, appid, appkey, debugserver, timezoneName){
  Host = host;
  App = app;
  Lang = lang_0;
  DName = dname;
  AppName = appname;
  ActiveDirectory = activeDirectory;
  AppId = appid;
  DebugServer = debugserver;
  setAppKey(appkey);
  $clinit_PriCommon();
  timezoneName == null || timezoneName.length == 0 || (null , timeZoneName = timezoneName);
}

function SetWCFVersion(version){
  var parts;
  $clinit_PriCommon();
  if (!(version == null || version.length == 0)) {
    parts = $split(version, '\\.', 0);
    parts != null && parts.length >= 3 && (WCFVersion = new WCFUtil$WCFVersion(__parseAndValidateInt(parts[0]), __parseAndValidateInt(parts[1]), __parseAndValidateInt(parts[2])));
  }
}

function setAppKey(appKey){
  if (appKey == null || !appKey)
    return;
  typeof appKey === 'string' || appKey instanceof String?(AppKey = appKey):typeof appKey === 'function' && (AppKeyFunction = appKey);
}

var ActiveDirectory = 0, App, AppId, AppKey, AppKeyFunction = null, AppName, AuthAudience = null, ComputerName, DName, DebugServer = 0, GPSLocation, Host, Lang = 0, Login, Pwd, WCFVersion = null, WindowsUser;
function WCFUtil$WCFVersion(major, minor, build){
  this.major = major;
  this.minor = minor;
  this.build = build;
}

defineClass(146, 1, {}, WCFUtil$WCFVersion);
_.build = 0;
_.major = 0;
_.minor = 0;
var Lcom_priority_app_common_WCFUtil$WCFVersion_2_classLit = createForClass('com.priority.app.common', 'WCFUtil/WCFVersion', 146);
function $clinit_ZoomTypes(){
  $clinit_ZoomTypes = emptyMethod;
  None_3 = new ZoomTypes('None', 0, 0);
  Attach = new ZoomTypes('Attach', 1, 1);
  Search = new ZoomTypes('Search', 2, 2);
  Choose = new ZoomTypes('Choose', 3, 3);
  Zoom_0 = new ZoomTypes('Zoom', 4, 4);
  Date14_0 = new ZoomTypes('Date14', 5, 5);
  Date8_0 = new ZoomTypes('Date8', 6, 6);
  Date10_0 = new ZoomTypes('Date10', 7, 7);
  EMail = new ZoomTypes('EMail', 8, 8);
  URL_0 = new ZoomTypes('URL', 9, 9);
  HiddenZoom = new ZoomTypes('HiddenZoom', 10, 10);
  LinkFile = new ZoomTypes('LinkFile', 11, 11);
  QEdit = new ZoomTypes('QEdit', 12, 12);
  RelSearch = new ZoomTypes('RelSearch', 13, 13);
  SpecialAttach = new ZoomTypes('SpecialAttach', 14, 99);
}

function ZoomTypes(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  $put_0((!mappings_3 && !mappings_3 && (mappings_3 = new HashMap) , mappings_3), valueOf(value_0), this);
}

function forValue_0(value_0){
  $clinit_ZoomTypes();
  return dynamicCast($get_1((!mappings_3 && !mappings_3 && (mappings_3 = new HashMap) , mappings_3), valueOf(value_0)), 17);
}

function values_5(){
  $clinit_ZoomTypes();
  return initValues(getClassLiteralForArray(Lcom_priority_app_common_ZoomTypes_2_classLit, 1), $intern_5, 17, 0, [None_3, Attach, Search, Choose, Zoom_0, Date14_0, Date8_0, Date10_0, EMail, URL_0, HiddenZoom, LinkFile, QEdit, RelSearch, SpecialAttach]);
}

defineClass(17, 20, {17:1, 4:1, 25:1, 20:1}, ZoomTypes);
var Attach, Choose, Date10_0, Date14_0, Date8_0, EMail, HiddenZoom, LinkFile, None_3, QEdit, RelSearch, Search, SpecialAttach, URL_0, Zoom_0, mappings_3;
var Lcom_priority_app_common_ZoomTypes_2_classLit = createForEnum('com.priority.app.common', 'ZoomTypes', 17, values_5);
function DirectAct(title_0){
  this.title_0 = title_0;
}

defineClass(66, 1, {66:1}, DirectAct);
var Lcom_priority_app_form_DirectAct_2_classLit = createForClass('com.priority.app.form', 'DirectAct', 66);
function $clinit_Form(){
  $clinit_Form = emptyMethod;
  LabelsMessages = new HashMap;
  fieldColors = new HashMap;
}

function $Activate(this$static, start_0, onSuccess, onError, ename, type_0, onProgress){
  var memento;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  if (ename == ($clinit_PriCommon() , LabelsPrint)) {
    if (start_0) {
      $LabelsStart(this$static, onSuccess, onError, onProgress);
      $ExecuteNextRequest(this$static.RequestsQueue);
    }
     else {
      onSrvSuccess_0(this$static, new JSONObject, onSuccess, onError, null, null, 0);
    }
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  $FormActivateMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), start_0, new Form$12(this$static, $GetConnection(this$static), this$static, start_0, ename, type_0, onProgress, onSuccess, onError));
}

function $ActivateStart(this$static, onSuccess, onError, ename, type_0, onProgress, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In ActivateStart: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , ActivateStart_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError, ename, type_0, onProgress])), executeNow))
    return;
  $Activate(this$static, true, onSuccess, onError, ename, type_0, onProgress);
}

function $AddCurrentRow(row, retObj){
  retObj.NewRow = {};
  retObj.NewRow.rowindex = row;
}

function $AddHtmlToResponseObject(this$static, retObj, isGetRows){
  var ind, styleEnd, styleStart, text_0;
  text_0 = this$static.curTab.htmltext;
  if (text_0 != null && text_0.length > 0) {
    styleStart = text_0.indexOf('<style>');
    styleEnd = text_0.indexOf('<\/style>');
    styleStart == 0 && styleEnd > 0 && (text_0 = $trim(__substr(text_0, styleEnd + 8, text_0.length - (styleEnd + 8))));
    if ($endsWith(text_0, '&nbsp;<\/P>'))
      text_0 = $substring_0(text_0, 0, text_0.length - 10) + '<\/P>';
    else {
      ind = text_0.indexOf('&nbsp;<\/P><timestamp:');
      ind >= 0 && (text_0 = text_0.substr(0, ind) + $substring_0(text_0, ind + 6, text_0.length));
    }
  }
  $FormHtmlRetobj(retObj, text_0, isGetRows, this$static.curTab.table_0, this$static);
}

function $AddText(this$static, text_0, addFlag, commentFlag, lang2Flag, onSuccess, onError, executeNow){
  var error, errorType, memento, newtext;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In AddText: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , AddText_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [text_0, valueOf(addFlag), valueOf(commentFlag), valueOf(lang2Flag), onSuccess, onError])), executeNow))
    return;
  memento = $CreateMemento(this$static.curTab);
  error = null;
  errorType = null;
  newtext = null;
  if (this$static.curTab.ishtml_0 == 0) {
    error = 'Not an Html form.';
    errorType = 'noHtml';
  }
   else if (this$static.curTab.isEdit == 0) {
    error = 'This form is readonly.';
    errorType = 'readOnlyForm';
  }
   else {
    newtext = $ComposeText(this$static.curTab, this$static.curTab.htmltext, text_0, addFlag == 1, commentFlag == 1, lang2Flag == 1);
  }
  if (newtext != null && newtext.length >= 190000) {
    error = 'Text is too long (limited to 190000 Characters).';
    errorType = 'textTooLong';
  }
  if (error != null) {
    InvokeCallback(this$static, null, null, error, errorType, onSuccess, onError);
    return;
  }
  newtext.length < 190000 && $FormHtmlMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), this$static.curTab.tstext_0, fromInt(this$static.curTab.tsline_0), {l:1, m:0, h:0}, b64encode(newtext), fromInt(-($clinit_PriKeys() , SaveHtml).intValue), new Form$23(this$static, $GetConnection(this$static), this$static, onSuccess, onError));
}

function $ClearRows(this$static, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In ClearRows: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , ClearRows_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  $setAdd(this$static.curTab, false);
  $FormKey(this$static, ($clinit_PriKeys() , Clntb), onSuccess, onError);
}

function $ClearSearchFilter(this$static, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In ClearSearchFilter: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , ClearSearchFilter_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  $ClearSearchFilter_0(this$static.curTab, onSuccess);
}

function $Con_FormUploadFileCompleted(this$static, jo, retObj, fileName, userState, uploadFileSection, isLast, fileContents, onProgress, onSuccess, onError){
  var fn, progress, ret;
  try {
    fn = retObj.UploadFile.file;
    fn != null && fn.length > 0 && (fileName = fn);
    if (isLast) {
      ret = new JSONObject;
      PrepareRetObj(ret, 100, true, fileName);
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, upload last (success)');
      InvokeCallback(this$static, jo, ret, null, null, onSuccess, onError);
    }
     else {
      progress = $getProgress(uploadFileSection, fileContents);
      ret = new JSONObject;
      PrepareRetObj(ret, progress, false, fileName);
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeSuccessNow, upload not last (success)');
      onProgress(ret);
      $UploadFile_0(this$static, uploadFileSection + 1, fileName, fileContents, onProgress, onSuccess, onError, userState);
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      return;
    }
     else 
      throw unwrap_5($e0);
  }
}

function $DelRow(this$static, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In DelRow: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , DelRow_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  $FormKey(this$static, ($clinit_PriKeys() , Del), onSuccess, onError);
}

function $DeleteFilter(this$static, filterNum, onSuccess, onError, executeNow){
  var memento;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'DeleteFilter: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , DeleteFilter_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(filterNum), onSuccess, onError])), executeNow))
    return;
  memento = $CreateMemento(this$static.curTab);
  $FormQueryDlgDeleteMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(filterNum), new Form$20($GetConnection(this$static), this$static, onSuccess, onError));
}

function $EndCurrentForm(this$static, returnJustThisRow, onSuccess, onError, executeNow){
  var memento, zoom;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In EndCurrentForm: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , EndCurrentForm_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [($clinit_Boolean() , returnJustThisRow?TRUE_0:FALSE_0), onSuccess, onError])), executeNow))
    return;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  if (this$static.curTab.ishtml_0 == 1 && this$static.curTab.isEdit == 1) {
    memento = $CreateMemento(this$static.curTab);
    $FormHtmlMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), this$static.curTab.tstext_0, fromInt(this$static.curTab.tsline_0), {l:0, m:0, h:0}, b64encode(''), fromInt(-($clinit_PriKeys() , Tab).intValue), new Form$14($GetConnection(this$static), this$static, onSuccess, onError));
  }
   else if (this$static.curTab.level_0 == 0) {
    zoom = this$static.formzoom;
    if (!!zoom && zoom.nativeZoom.link != null && zoom.nativeZoom.link.length > 0 && this$static.privateSession != null) {
      memento = $CreateMemento(this$static.curTab);
      $FormSaveMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), zoom.nativeZoom.link, returnJustThisRow, new Form$15(this$static, $GetConnection(this$static), this$static, onSuccess, onError));
    }
     else {
      $FormExitForm(this$static, onSuccess, onError);
    }
  }
   else {
    $SaveCurrentRow(this$static, 1, onSuccess, onError, 1);
  }
}

function $FormCheckSupported(this$static, funcname, onError){
  var ver;
  ver = FuncSupportedFromVersion(2, funcname);
  if (ver == 0)
    return true;
  !!onError && onSrvError(this$static, onError, ($clinit_PriCommon() , 'This feature is supported from web-sdk patch version ' + ver), 0, 'notSupportedInThisPriorityVersion');
  return false;
}

function $FormChoose(this$static, fieldName, fieldValue, mode, onSuccess, onError, executeNow){
  var col, md, memento;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormChoose: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , Choose_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [fieldName, fieldValue, valueOf(mode), onSuccess, onError])), executeNow))
    return;
  col = $getCol_0(this$static.curTab, fieldName);
  if (!col) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, FormChoose can't find column (error)");
    InvokeFormChooseCallback(this$static, null, null, "Can't find column: " + fieldName, 'noSuchColumn', onSuccess, onError);
    return;
  }
  $SetField(this$static.curTab, col.field_0, fieldValue);
  memento = $CreateMemento(this$static.curTab);
  md = ($clinit_PriCommon$ChooseTypes() , Normal);
  mode == 1 && (md = Full);
  $FormKeyMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(md.intValue), new Form$28($GetConnection(this$static), this$static, onSuccess, onError));
}

function $FormExitForm(this$static, onSuccess, onError){
  var memento;
  memento = $CreateMemento(this$static.curTab);
  $FormExitFormMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), new Form$13($GetConnection(this$static), this$static, onSuccess, onError));
}

function $FormFieldUpdate(this$static, fieldName, value_0, onSuccess, onError, executeNow){
  var col, err, valueSave;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormFieldUpdate: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , FieldUpdate), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [fieldName, value_0, onSuccess, onError])), executeNow))
    return;
  col = $getCol_0(this$static.curTab, fieldName);
  if (!col) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, FormFieldUpdate can't find column (error)");
    InvokeCallback(this$static, null, null, "Can't find column: " + fieldName, 'noSuchColumn', onSuccess, onError);
    return;
  }
  if (col.hidden_0 == 1) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, FormFieldUpdate can't update hidden column (error)");
    InvokeCallback(this$static, null, null, "Can't update hidden column: " + fieldName, 'cantUpdateHiddenColumn', onSuccess, onError);
    return;
  }
  if (col.multienv_0 == 1 && this$static.position_0.isappend_0 == 0) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, FormFieldUpdate can't update multienv column (error)");
    InvokeCallback(this$static, null, null, "Can't update multi-env column in an existing row: " + fieldName, 'cantUpdateMultienvColumn', onSuccess, onError);
    return;
  }
  valueSave = value_0;
  if (col.type_0 == 'date') {
    value_0 = ISOToDate(col.width_0, value_0);
    err = ISOToDateErr(value_0);
    if (err != null) {
      InvokeCallback(this$static, null, null, 'badDateFormat: ' + valueSave, err, onSuccess, onError);
      return;
    }
  }
   else 
    col.type_0 == 'bool' && (value_0 == 'N' || value_0 == 'n') && (value_0 = '');
  $SetField(this$static.curTab, col.field_0, value_0);
  $FormKey(this$static, ($clinit_PriKeys() , Return), onSuccess, onError);
}

function $FormFilterChoose(this$static, fieldName, fieldValue, onSuccess, onError, executeNow){
  var col, memento;
  if (!$FormCheckSupported(this$static, 'filterChoose', onError))
    return;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormChoose: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , FilterChoose), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [fieldName, fieldValue, onSuccess, onError])), executeNow))
    return;
  col = $getCol_0(this$static.curTab, fieldName);
  if (!col) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, FormChoose can't find column (error)");
    InvokeFormChooseCallback(this$static, null, null, "Can't find column: " + fieldName, 'noSuchColumn', onSuccess, onError);
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  col.type_0 == 'date' && HasFormAlertChooseFeature.value_0?$FormAlertChooseMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(($clinit_PriCommon$ChooseTypes() , Zoom).intValue), fieldValue, new Form$26(this$static, $GetConnection(this$static), col, this$static, onSuccess, onError)):$FormQueryDlgChooseMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(col.field_0), fromInt(($clinit_PriCommon$ChooseTypes() , Zoom).intValue), fieldValue, new Form$27(this$static, $GetConnection(this$static), col, this$static, onSuccess, onError));
}

function $FormFilterSearchAction(this$static, action, searchText, onSuccess, onError, executeNow){
  var field, resp;
  if (!$FormCheckSupported(this$static, 'filterSearchAction', onError))
    return;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormFilterSearchAction: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , FilterSearchAction), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(action), searchText, onSuccess, onError])), executeNow))
    return;
  resp = new Form$24($GetConnection(this$static), this$static, onSuccess, onError);
  field = this$static.curTab.self_0 << 16 | this$static.formFilterChooseLastField;
  if (action == ($clinit_SearchActions() , Next).intValue && 6 <= BuildVersion) {
    ++this$static.SearchLastPage;
    $FormAlertSearchPageMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), fromInt(field), fromInt(this$static.SearchLastPage), searchText, resp);
  }
   else {
    this$static.SearchLastPage = 0;
    $FormAlertSearchMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), fromInt(field), fromInt(action), searchText, resp);
  }
}

function $FormGoto(this$static, row, getData, onSuccess, onError){
  var firstrow, hasData, jo, lastrow, memento, retObj;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  firstrow = this$static.curTab.line_0;
  lastrow = this$static.curTab.line_0 + this$static.curTab.rowcount;
  if (row >= firstrow && row <= lastrow + 1) {
    hasData = true;
    retObj = new JSONObject;
    getData?(hasData = $GetRowsData(this$static.curTab.table_0, row, retObj, this$static)):$AddCurrentRow(row, retObj);
    if (hasData) {
      $SetRowClient(this$static, row);
      jo = {};
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormGoto hasData=true (success)');
      InvokeCallback(this$static, jo, retObj, null, null, onSuccess, onError);
      return;
    }
  }
  memento = $CreateMemento(this$static.curTab);
  $FormJumpLineMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(row), new Form$16($GetConnection(this$static), this$static, getData, row, onSuccess, onError));
}

function $FormHtmlRetobj(retObj, htmltext, isGetRows, table, that){
  var gform = that.GetJsTableObject(table);
  if (isGetRows) {
    retObj.RowsData = {};
    retObj.RowsData[gform.name] = {};
    retObj.RowsData[gform.name][1] = {};
    retObj.RowsData[gform.name][1]['htmltext'] = htmltext;
  }
   else {
    !retObj.ReplaceText && (retObj.ReplaceText = {});
    retObj.ReplaceText[gform.name] = {};
    retObj.ReplaceText[gform.name][1] = {};
    retObj.ReplaceText[gform.name][1]['htmltext'] = htmltext;
  }
}

function $FormKey(this$static, key, onSuccess, onError){
  var memento;
  memento = $CreateMemento(this$static.curTab);
  $FormKeyMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(-key.intValue), new Form$5($GetConnection(this$static), this$static, key, onSuccess, onError));
}

function $FormQuery(this$static, filter, fromRow, onSuccess, onError){
  var memento, xml;
  if (this$static.started == 1 && !filter && fromRow <= 1) {
    $setAdd(this$static.curTab, true);
    $FormGoto(this$static, 1, true, onSuccess, onError);
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  xml = null;
  !!filter && (xml = b64encode(JsonToString(filter)));
  $FormQueryDlgExecuteMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), this$static.curTab.isAdd, xml, fromInt(fromRow + this$static.curTab.rowcount - 2), new Form$4(this$static, $GetConnection(this$static), this$static, onSuccess, onError, fromRow));
}

function $FormSearchAction(this$static, action, searchText, onSuccess, onError, executeNow){
  var resp;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormSearchAction: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SearchAction), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(action), searchText, onSuccess, onError])), executeNow))
    return;
  resp = new Form$25($GetConnection(this$static), this$static, onSuccess, onError);
  if (action == ($clinit_SearchActions() , Next).intValue && 6 <= BuildVersion) {
    ++this$static.SearchLastPage;
    $FormSearchPageMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), fromInt(this$static.SearchLastPage), searchText, resp);
  }
   else {
    this$static.SearchLastPage = 0;
    $FormSearchMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), fromInt(action), searchText, resp);
  }
}

function $FormStartZoom(this$static, name_0, autoRetrieveFirstRows, onSuccess, onError, params, zoom){
  var appParams, debug, hiddenFields, link_0, linkid, rsp, zoomname, zoomvalue;
  link_0 = '';
  linkid = '';
  if (zoom) {
    link_0 = zoom.nativeZoom.link;
    linkid = zoom.nativeZoom.linkid;
  }
  zoomname = '';
  debug = false;
  zoomvalue = '';
  autoRetrieveFirstRows > 2?(autoRetrieveFirstRows = 2):autoRetrieveFirstRows < 0 && (autoRetrieveFirstRows = 0);
  rsp = new Form$1(this$static, $GetConnection(this$static), this$static, onSuccess, onError);
  hiddenFields = null;
  if (params) {
    hiddenFields = GetHiddenFields(params);
    zoomvalue = GetZoomValue(params);
    zoomname = GetZoomName(params);
    debug = GetDebug(params);
  }
  $clinit_PriCommon();
  if (3 <= BuildVersion) {
    appParams = autoRetrieveFirstRows + (hiddenFields != null && hiddenFields.length > 0?'@P@' + hiddenFields:'');
    $FormStartExMobAsync($GetConnection(this$static), name_0, link_0, linkid, zoomname, debug, zoomvalue, appParams, rsp);
  }
   else {
    $FormStartMobAsync($GetConnection(this$static), name_0, fromInt(DebugServer == 1?-2:-1), link_0, linkid, zoomname, debug, zoomvalue, autoRetrieveFirstRows > 0, rsp);
  }
}

function $FormWarning(this$static, ok, executeNow){
  var onError, onSuccess, table;
  onSuccess = this$static.onSuccess;
  onError = this$static.onError;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In FormWarning: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , WarningApproved), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(ok), onError])), executeNow))
    return;
  if (ok == 0 && this$static.warningData.readWrite == 0) {
    $HandleError(this$static.RequestsQueue);
    sendMessage(this$static, onError, '', 'apiError', 'warningCancel', 0, 0, 1, 1);
    return;
  }
  if (this$static.isWaitingInfoApprove) {
    this$static.isWaitingInfoApprove = false;
    if (this$static.fromStartForm == 1) {
      table = this$static.curTab?this$static.curTab.table_0:0;
      InvokeSubFormStartCallback(this$static, table, {}, this$static.lastRetObj, null, null, onSuccess, onError);
    }
     else {
      onSrvSuccess_0(this$static, this$static.lastRetObj, onSuccess, onError, this$static.lastPar1, this$static.lastPar2, 0);
    }
    return;
  }
  $FormWarningMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, $CreateMemento(this$static.curTab))), this$static.warningData.wsql, this$static.warningData.wval, this$static.warningData.readWrite == 0?this$static.warningData.wline:fromInt(ok), this$static.warningData.wkey, this$static.warningData.wstep, new Form$2(this$static, $GetConnection(this$static), this$static, onSuccess, onError));
}

function $GetConnection(this$static){
  if (!!this$static.con && $equals(this$static.con.Password, Pwd))
    return this$static.con;
  this$static.con = GetWCFServiceClient(this$static);
  return this$static.con;
}

function $GetFileContent(this$static, filename, onSuccess, onError, executeNow){
  var con;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In GetFileContent: executeNow=' + executeNow);
  con = $GetConnection_0(AppMain);
  $GeneralAttachmentToDataUriMob(con, filename, new Form$6(con, this$static, onSuccess, onError));
}

function $GetFilters(this$static, onSuccess, onError, executeNow){
  var memento;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'GetFilters: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , GetFilters_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  memento = $CreateMemento(this$static.curTab);
  $FormQueryDlgStartMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), new Form$21($GetConnection(this$static), this$static, onSuccess, onError));
}

function $GetHTMLSignature(this$static, lang2, onSuccess, onError, executeNow){
  var ret;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In GetHTMLSignature: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , GetHTMLSignature_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(lang2), onSuccess, onError])), executeNow))
    return;
  if (this$static.curTab.ishtml_0 == 0) {
    InvokeCallback(this$static, null, null, 'Not an Html form.', 'noHtml', onSuccess, onError);
    return;
  }
  ret = $GetHTMLSignature_0(this$static.curTab, lang2 == 1);
  onSrvSuccess(this$static, ret, onSuccess);
}

function $GetRows(this$static, fromRow, onSuccess, onError, executeNow){
  var filter, retObj, jo;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In GetRows: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , GetRows_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(fromRow), onSuccess, onError])), executeNow))
    return;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  filter = this$static.curTab.filter;
  this$static.curTab.ishtml_0 == 1?(retObj = new JSONObject , $AddHtmlToResponseObject(this$static, retObj, true) , jo = {} , InvokeCallback(this$static, jo, retObj, null, null, onSuccess, onError) , undefined):this$static.curTab.level_0 == 0?$FormQuery(this$static, filter, fromRow, onSuccess, onError):$SubFormQuery(this$static, filter, fromRow, onSuccess, onError);
}

function $GetRowsData(table, fromRow, retObj, that){
  var gform = that.GetJsTableObject(table);
  if (gform == null)
    return false;
  var global_forms_rows = that.global_forms_rows;
  if (!global_forms_rows || !global_forms_rows[table] || global_forms_rows[table].length <= 0) {
    retObj.RowsData = {};
    retObj.RowsData[gform.name] = {};
    return true;
  }
  var offset = that.getRowOffset(table);
  var currow = fromRow - offset;
  var lines = that.getTableLines(table);
  var tab = global_forms_rows[table];
  var hasRows = false;
  var curlines = lines - offset;
  var rowcount = that.getTableRowCount(table);
  curlines > rowcount && (curlines = rowcount);
  if (that.getIsAppend()) {
    retObj.RowsData = {};
    retObj.RowsData[gform.name] = {};
    return true;
  }
  retObj.RowsData = {};
  retObj.RowsData[gform.name] = {};
  for (var i = currow; i <= curlines; i++) {
    for (var field in tab[i].data) {
      var colName = that.getColNameById(table, field);
      if (colName != null && colName.length > 0 && gform.columns[colName] != null) {
        !retObj.RowsData[gform.name][i + offset] && (retObj.RowsData[gform.name][i + offset] = {});
        var value_0 = tab[i].data[field];
        var color_0 = tab[i].color;
        gform.columns[colName].type == 'date' && (value_0 = DateToISO(value_0));
        retObj.RowsData[gform.name][i + offset][colName] = value_0;
        retObj.RowsData[gform.name][i + offset]['metadata'] = {};
        retObj.RowsData[gform.name][i + offset]['metadata'].color = color_0;
        hasRows = true;
      }
    }
  }
  return hasRows;
}

function $GotoSubForm(this$static, formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, executeNow, params){
  var ft, hiddenFields, memento, rsp;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In GotoSubForm: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , StartSubForm), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, params])), executeNow))
    return;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  ft = this$static.curTab;
  if (!$hasStringValue(ft.SubForms, formName)) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), "Before InvokeCallback, GotoSubForm can't find subform (error)");
    InvokeCallback(this$static, null, null, "Can't find Sub Form: " + formName, 'noSuchSubForm', onSuccess, onError);
    return;
  }
  hiddenFields = null;
  !!params && (hiddenFields = GetHiddenFields(params));
  memento = $CreateMemento(this$static.curTab);
  rsp = new Form$17(this$static, $GetConnection(this$static), this$static, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError);
  3 <= BuildVersion && hiddenFields != null && hiddenFields.length > 0?$FormSubFormExMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(dynamicCast($getStringValue(ft.SubForms, formName), 55).self_0), hiddenFields, rsp):$FormSubFormMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(dynamicCast($getStringValue(ft.SubForms, formName), 55).self_0), rsp);
}

function $InitDummyFormState(this$static){
  var jop, opTable, opsTable, ses, tableState;
  if (this$static.privateSession == null || !this$static.privateSession.length)
    return;
  tableState = new JSONObject;
  opTable = new JSONArray;
  opsTable = new JSONArray;
  $put(tableState, 'Operations', opsTable);
  $put(tableState, 'Operation', opTable);
  ses = new JSONObject;
  $put(ses, 'session', new JSONString(this$static.privateSession));
  $set(opsTable, opsTable.jsArray.length, ses);
  jop = new JSONObject;
  $put(jop, 'field', new JSONString('0'));
  $put(jop, 'line', new JSONString('0'));
  $put(jop, 'curtab', new JSONString('0'));
  $put(jop, 'value', new JSONString(''));
  $put(jop, 'active', new JSONString('1'));
  $put(jop, 'key', new JSONString('0'));
  $set(opTable, opTable.jsArray.length, jop);
  this$static.dummyFormState = b64encode($toString_0(tableState));
}

function $InvokeErrorIfRowChanged(this$static, onSuccess, onError){
  if (this$static.position_0.changed_0 == 1) {
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, InvokeErrorIfRowChanged');
    InvokeCallback(this$static, null, null, 'Must save/discard changes in current row first.', 'mustSaveOrDiscard', onSuccess, onError);
    return true;
  }
  return false;
}

function $IsAlive(this$static, onSuccess, onError, executeNow){
  var memento;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In IsAlive: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , IsAlive_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  memento = $CreateMemento(this$static.curTab);
  $FormIsAliveMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), new Form$22($GetConnection(this$static), this$static, onSuccess, onError));
}

function $LabelsContinue(this$static, ok, selection, allrecords, clean, print_0, onSuccess, onError, onProgress){
  var memento;
  if (ok == 0) {
    onSrvSuccess_0(this$static, new JSONObject, onSuccess, onError, null, null, 0);
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  $FormGenerateLabelsMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(selection), allrecords, clean, print_0, new Form$9(this$static, $GetConnection(this$static), this$static, print_0, onProgress, onSuccess, onError));
}

function $LabelsStart(this$static, onSuccess, onError, onProgress){
  var con;
  if (LabelsMessages.size_0 > 0) {
    $LabelsStartA(this$static, onSuccess, onError, onProgress);
    return;
  }
  con = $GetConnection(this$static);
  $GeneralExtMessagesRangeMobAsync(con, 'NETMAIN', 'C', {l:1041, m:0, h:0}, {l:1100, m:0, h:0}, new Form$11(this$static, con, onSuccess, onError, onProgress, this$static));
}

function $LabelsStartA(this$static, onSuccess, onError, onProgress){
  var act, activations, memento;
  activations = this$static.curTab.Activations;
  act = dynamicCast($getStringValue(activations, ($clinit_PriCommon() , LabelsPrint) + '.P'), 66);
  if (!act) {
    InvokeCallback(this$static, null, null, 'No such direct activation.', 'noSuchDirectActivation', onSuccess, onError);
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  $FormKeyMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(-($clinit_PriKeys() , SendLabels).intValue), new Form$10($GetConnection(this$static), this$static, act, onProgress, onSuccess, onError));
}

function $NewRow(this$static, onSuccess, onError, executeNow){
  var line;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In NewRow: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , NewRow_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  if ($InvokeErrorIfRowChanged(this$static, onSuccess, onError))
    return;
  line = this$static.curTab.lines_0 + 1;
  this$static.position_0.isappend_0 == 1 && (line -= 1);
  $FormGoto(this$static, line, false, onSuccess, onError);
}

function $SaveCurrentRow(this$static, exit, onSuccess, onError, executeNow){
  var memento;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In SaveCurrentRow: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SaveRow), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(exit), onSuccess, onError])), executeNow))
    return;
  if (exit != 1 && this$static.curTab.ishtml_0 != 1 && $isCurrentRowEmptyNative(this$static.position_0.table_0, this$static.position_0.line_0, this$static)) {
    InvokeCallback(this$static, null, null, "Can't save an empty row.", 'cantSaveEmptyRow', onSuccess, onError);
    return;
  }
  memento = $CreateMemento(this$static.curTab);
  exit == 1 && this$static.curTab.level_0 > 0?$FormKey(this$static, ($clinit_PriKeys() , Tab), onSuccess, onError):$FormKeyMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(($clinit_PriKeys() , SaveRow_0).intValue), new Form$18($GetConnection(this$static), this$static, onSuccess, onError));
}

function $SaveFilter(this$static, id_0, data_0, name_0, isdefault, onSuccess, onError, executeNow){
  var fixed_0, memento, xml;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'SaveFilter: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SaveFilter_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(id_0), data_0, name_0, valueOf(isdefault), onSuccess, onError])), executeNow))
    return;
  fixed_0 = FixFilter_0(data_0, this$static.curTab?this$static.curTab.table_0:0, this$static, onError);
  if (!fixed_0)
    return;
  memento = $CreateMemento(this$static.curTab);
  xml = b64encode(JsonToString(fixed_0));
  $FormQueryDlgSaveMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), fromInt(id_0), xml, name_0, fromInt(isdefault), new Form$19($GetConnection(this$static), this$static, onSuccess, onError));
}

function $SetActiveRow(this$static, row, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In SetActiveRow: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SetActiveRow_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(row), onSuccess, onError])), executeNow))
    return;
  if (row < 1 || row > this$static.curTab.lines_0) {
    InvokeCallback(this$static, null, null, 'Invalid row.', 'mustSaveOrDiscard', onSuccess, onError);
    return;
  }
  $FormGoto(this$static, row, false, onSuccess, onError);
}

function $SetCurFieldValue(this$static){
  var value_0;
  value_0 = $getFieldValue(this$static.position_0.table_0, this$static.position_0.line_0, this$static.position_0.field_0, this$static);
  $SetField(this$static.curTab, this$static.position_0.field_0, value_0);
}

function $SetRowClient(this$static, row){
  var tab;
  tab = this$static.curTab;
  if (tab) {
    this$static.position_0.field_0 = 1;
    this$static.position_0.line_0 = row - tab.line_0 + 1;
    $SetCurRowInData(tab, row - tab.line_0 + 1);
    $SetCurFieldValue(this$static);
  }
}

function $SetSearchFilter(this$static, filter, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In SetSearchFilter: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SetSearchFilter_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [filter, onSuccess, onError])), executeNow))
    return;
  $SetSearchFilter_0(this$static.curTab, filter, onSuccess, onError);
}

function $SetSimpleSearchFilter(this$static, filter, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In SetSimpleSearchFilter: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , SetSimpleSearchFilter_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [filter, onSuccess, onError])), executeNow))
    return;
  $SetSimpleSearchFilter_0(this$static.curTab, filter, onSuccess, onError);
}

function $SubFormQuery(this$static, filter, fromRow, onSuccess, onError){
  var memento, xml;
  if (this$static.curTab.isAdd) {
    $FormGoto(this$static, fromRow, true, onSuccess, onError);
  }
   else {
    memento = $CreateMemento(this$static.curTab);
    xml = null;
    !!filter && (xml = b64encode(JsonToString(filter)));
    $FormQueryDlgExecuteMobAsync($GetConnection(this$static), b64encode($ToStringData(this$static._currentFormState, this$static.privateSession, memento)), false, xml, {l:0, m:0, h:0}, new Form$3(this$static, $GetConnection(this$static), this$static, onSuccess, onError, fromRow));
  }
}

function $Undo(this$static, onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In Undo: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , Undo_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  $FormKey(this$static, ($clinit_PriKeys() , Undo_1), onSuccess, onError);
}

function $UploadDataUrl(this$static, dataUrl, type_0, onProgress, onSuccess, onError, executeNow){
  this$static.isCancelFileUpload = false;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In UploadFile: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , UploadDataUrl_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [dataUrl, type_0, onProgress, onSuccess, onError])), executeNow))
    return;
  if (dataUrl == '') {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, Upload data is empty (error)');
    InvokeCallback(this$static, null, null, 'empty data.', 'exception', onSuccess, onError);
    return;
  }
  $FormSearchSetDirtyMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), new Form$8($GetConnection(this$static), this$static, type_0, dataUrl, onProgress, onSuccess, onError));
}

function $UploadFile_0(this$static, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, userState){
  var fu;
  fu = new Form$FormFileUploader(this$static, this$static);
  $UploadFile(fu, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, userState);
}

function $UploadFile_1(this$static, file, onProgress, onSuccess, onError, executeNow){
  this$static.isCancelFileUpload = false;
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In UploadFile: executeNow=' + executeNow);
  if (!$CanExecuteNow(this$static.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , UploadFile_1), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [file, onProgress, onSuccess, onError])), executeNow))
    return;
  if (!file) {
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, UploadFile file is null (error)');
    InvokeCallback(this$static, null, null, 'file is null.', 'fileIsNull', onSuccess, onError);
    return;
  }
  $FormSearchSetDirtyMobAsync($GetConnection(this$static), ($InitDummyFormState(this$static) , this$static.dummyFormState), new Form$7($GetConnection(this$static), this$static, file, onProgress, onSuccess, onError));
}

function $getFieldValue(table, row, field, that){
  var value_0 = '';
  var global_forms_rows = that.global_forms_rows;
  global_forms_rows[table] && global_forms_rows[table][row] && global_forms_rows[table][row].data && global_forms_rows[table][row].data[field] && (value_0 = global_forms_rows[table][row].data[field]);
  return value_0;
}

function $isCurrentRowEmptyNative(table, row, that){
  var global_forms_rows = that.global_forms_rows;
  if (!global_forms_rows[table][row] || !global_forms_rows[table][row].data)
    return true;
  for (var i = 0; i < global_forms_rows[table][row].data.length; i++) {
    var vl = global_forms_rows[table][row].data[i];
    if (vl && vl != null && vl != '')
      return false;
  }
  return true;
}

function CheckDelOperation(operation){
  if (operation == null) {
    isLastOperationDel_0 = false;
    return 0;
  }
  if ($equals('FormKey_Del', operation)) {
    isLastOperationDel_0 = true;
    return 1;
  }
  if (isLastOperationDel_0 && $equals('FormWarning', operation)) {
    return 1;
  }
  isLastOperationDel_0 = false;
  return 0;
}

function ContainsError(obj){
  $clinit_Form();
  if (obj.Errors != null && obj.Errors.length > 0)
    return true;
  return false;
}

function DateToISO(dateStr){
  $clinit_Form();
  if (dateStr == null || dateStr == '')
    return '';
  if (!/^[0-9\/: ]*$/.test(dateStr))
    return dateStr;
  var lang_0 = ($clinit_PriCommon() , LangFormat);
  var dateParts = dateStr.split(/\/| /);
  var year = dateParts[2];
  var month = lang_0 == '3'?Number(dateParts[0]) - 1:Number(dateParts[1]) - 1;
  var day = lang_0 == '3'?Number(dateParts[1]):Number(dateParts[0]);
  var time = dateParts[3];
  var hours = 0;
  var minutes = 0;
  var date;
  if (time !== undefined) {
    var timeParts = time.split(':');
    hours = timeParts[0];
    minutes = timeParts[1];
    hours = Number(hours);
    minutes = Number(minutes);
  }
  year = Number(year);
  year >= 88 && year <= 99?(year = 1900 + year):year < 88 && (year = 2000 + year);
  if (time === undefined) {
    return year + '-' + (month + 1 < 10?'0':'') + (month + 1) + '-' + (day < 10?'0':'') + day;
  }
  date = new Date(year, month, day, hours, minutes, 0);
  var tzo = -date.getTimezoneOffset(), dif = tzo >= 0?'+':'-', pad = function(num){
    var norm = Math.floor(Math.abs(num));
    return (norm < 10?'0':'') + norm;
  }
  ;
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds()) + dif + pad(tzo / 60) + ':' + pad(tzo % 60);
}

function Form_1(){
  $clinit_Form();
  this.FormTables = new HashMap;
  this.ActiveTables = new HashMap;
  this.RequestsQueue = new FormAPIQueue(this);
  this._currentFormState = new FormTableOperations;
  this.position_0 = new Form$Position;
  this.warningData = new Form$WarningMessageData;
  this.global_forms_rows = [];
  this.prevReplaceText = {};
}

function GetColor(rgb){
  var color_0;
  if ((color_0 = dynamicCastToString($get_1(fieldColors, valueOf(rgb)))) == null) {
    color_0 = '#' + padHex(toUnsignedRadixString(rgb & 255, 16)) + padHex(toUnsignedRadixString((rgb & 65280) >> 8, 16)) + padHex(toUnsignedRadixString((rgb & 16711680) >> 16, 16));
    $put_0(fieldColors, valueOf(rgb), color_0);
  }
  return color_0;
}

function GetDebug(params){
  if (params == null || !params || !params.debug)
    return '';
  return params.debug == 1?true:false;
}

function GetHiddenFields(params){
  if (params == null || !params)
    return null;
  var res = null;
  if (params.hiddenFields && params.hiddenFields != null && params.hiddenFields.length > 0) {
    res = params.hiddenFields[0];
    for (var i = 1; i < params.hiddenFields.length; i++) {
      res += ',' + params.hiddenFields[i];
    }
  }
  return res;
}

function GetZoomName(params){
  if (params == null || !params || !params.zoomName)
    return '';
  return params.zoomName;
}

function GetZoomValue(params){
  if (params == null || !params || !params.zoomValue)
    return '';
  return params.zoomValue;
}

function ISOToDate(colWidth, ISODate){
  $clinit_Form();
  if (ISODate == null || ISODate == '')
    return '';
  var isLongISO = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?([+-][0-2]\d:[0-5]\d|Z)/.test(ISODate);
  var isShortISO = false;
  !isLongISO && (isShortISO = ISODate.length == 10 && /\d{4}-[01]\d-[0-3]\d/.test(ISODate));
  if (colWidth < 14 && isLongISO)
    return 'ERROR_LONGISO';
  if (colWidth >= 14 && isShortISO)
    return 'ERROR_SHORTISO';
  if (!isLongISO && !isShortISO)
    return ISODate;
  if (colWidth >= 14) {
    var date = new Date(ISODate);
    if (isNaN(date.getTime()))
      return '';
    var dateStr = '';
    var month = date.getMonth() + 1 < 10?'0' + (date.getMonth() + 1):date.getMonth() + 1;
    var day = date.getDate();
    day = day < 10?'0' + day:day;
    var year = colWidth != 10?date.getFullYear().toString().substr(2, 2):date.getFullYear();
    ($clinit_PriCommon() , LangFormat) != '3'?(dateStr = day + '/' + month + '/' + year):(dateStr = month + '/' + day + '/' + year);
    if (colWidth >= 14) {
      var hours = date.getHours() < 10?'0' + date.getHours():date.getHours();
      var minutes = date.getMinutes() < 10?'0' + date.getMinutes():date.getMinutes();
      dateStr = dateStr + ' ' + hours + ':' + minutes;
    }
  }
   else {
    var pre = ISODate.split('T');
    var parts = pre[0].split('-');
    var year = colWidth != 10?parts[0].substr(2, 2):parts[0];
    var nummonth = parseInt(parts[1]);
    var month = nummonth < 10?'0' + nummonth:nummonth;
    var numday = parseInt(parts[2]);
    var day = numday < 10?'0' + numday:numday;
    if (isNaN(nummonth) || isNaN(numday))
      return '';
    ($clinit_PriCommon() , LangFormat) != '3'?(dateStr = day + '/' + month + '/' + year):(dateStr = month + '/' + day + '/' + year);
  }
  return dateStr;
}

function ISOToDateErr(value_0){
  $clinit_Form();
  if (value_0 == 'ERROR_LONGISO')
    return 'For date-without-time fields, Date must be in format YYYY-MM-DD';
  if (value_0 == 'ERROR_SHORTISO')
    return 'For date-and-time fields, Date must be in ISO format (for example: 2018-06-10T01:30:00.000Z, 2018-06-10T01:30:00.000-04:00)';
  return null;
}

function ParseJO(jo, retObj, that, operation){
  var zt, ct, ct_0, ct_1, params;
  $clinit_Form();
  operation != 'FormQueryDlgChoose' && operation != 'FormAlertChoose' && that.UpdateStarted();
  var global_forms_rows = that.global_forms_rows;
  var prevReplaceText = that.prevReplaceText;
  lastOperation = operation;
  var isLastOperationDel = CheckDelOperation(operation);
  if (jo.Form[0].FreeTable && jo.Form[0].FreeTable.length > 0) {
    for (i = 0; i < jo.Form[0].FreeTable.length; i++) {
      var table = jo.Form[0].FreeTable[i].table;
      global_forms_rows[table] = [];
    }
  }
  if (jo.Form[0].NewTable && jo.Form[0].NewTable.length > 0) {
    for (var i = 0; i < jo.Form[0].NewTable.length; i++) {
      var maintable = jo.Form[0].NewTable[i];
      var form_0 = parseInt(maintable.form);
      var table = parseInt(maintable.table);
      var self_0 = parseInt(maintable.self);
      var title_0 = maintable.title;
      var name_0 = maintable.name;
      var level = parseInt(maintable.level);
      var rowcount = 0;
      var oneline = parseInt(maintable.oneline);
      var ishtml = parseInt(maintable.ishtml);
      var isquery = parseInt(maintable.query);
      var zoomfield = 0;
      maintable.zoomfield && (zoomfield = parseInt(maintable.zoomfield));
      that.AddTable(form_0, table, title_0, name_0, level, self_0, ishtml, oneline, isquery, zoomfield);
      var gform = that.GetJsTableObject(table);
      if (maintable.NewColumn && maintable.NewColumn.length > 0) {
        for (var j = 0; j < maintable.NewColumn.length; j++) {
          var zoomname = maintable.NewColumn[j].zoomname;
          var field = parseInt(maintable.NewColumn[j].field);
          var decimal = parseInt(maintable.NewColumn[j].decimal);
          var width_0 = parseInt(maintable.NewColumn[j].width);
          var zoom = parseInt(maintable.NewColumn[j].zoom);
          var rowcount = parseInt(maintable.NewColumn[j].height);
          var zoomstr = (zt = ($clinit_ZoomTypes() , dynamicCast($get_1((!mappings_3 && !mappings_3 && (mappings_3 = new HashMap) , mappings_3), valueOf(zoom)), 17)) , zt.name_0 != null?zt.name_0:'' + zt.ordinal);
          var type_0 = parseInt(maintable.NewColumn[j].type);
          var bool = parseInt(maintable.NewColumn[j].bool);
          var typestr = bool == 1?'bool':(ct = ($clinit_ColumnTypes() , dynamicCast($get_1((!mappings && !mappings && (mappings = new HashMap) , mappings), valueOf(type_0)), 16)) , ct.inputType);
          var codestr = (ct_0 = ($clinit_ColumnTypes() , dynamicCast($get_1((!mappings && !mappings && (mappings = new HashMap) , mappings), valueOf(type_0)), 16)) , ct_0.name_0 != null?ct_0.name_0:'' + ct_0.ordinal);
          var format = (ct_1 = dynamicCast($get_1((!mappings && !mappings && (mappings = new HashMap) , mappings), valueOf(type_0)), 16) , $getFormat(ct_1));
          parseInt(maintable.NewColumn[j].height) > rowcount && (rowcount = parseInt(maintable.NewColumn[j].height));
          var attachment = parseInt(maintable.NewColumn[j].attachment);
          var title_0 = maintable.NewColumn[j].title;
          var hidden = parseInt(maintable.NewColumn[j].hidden);
          var multienv = 0;
          maintable.NewColumn[j].multienv && (multienv = parseInt(maintable.NewColumn[j].multienv));
          var readonly = parseInt(maintable.NewColumn[j].readonly);
          var isstatus = 0;
          maintable.NewColumn[j].isstatus && (isstatus = parseInt(maintable.NewColumn[j].isstatus));
          var relcol = '';
          maintable.NewColumn[j].relcol && (relcol = maintable.NewColumn[j].relcol);
          var zoomfname = '';
          maintable.NewColumn[j].zoomfname && (zoomfname = maintable.NewColumn[j].zoomfname);
          that.AddColumn(self_0, zoomname, typestr, width_0, field, hidden, multienv, isstatus);
          if (gform != null) {
            gform.columns[zoomname] = {};
            gform.columns[zoomname].field = field;
            gform.columns[zoomname].zoom = zoomstr;
            gform.columns[zoomname].type = typestr;
            gform.columns[zoomname].code = codestr;
            gform.columns[zoomname].decimal = decimal;
            gform.columns[zoomname].maxLength = width_0;
            gform.columns[zoomname].format = format;
            gform.columns[zoomname].mandatory = maintable.NewColumn[j].mandatory;
            gform.columns[zoomname].readonly = readonly == 1 && multienv == 0?1:0;
            gform.columns[zoomname].attachment = attachment;
            gform.columns[zoomname].title = title_0;
            gform.columns[zoomname].hidden = hidden;
            gform.columns[zoomname].multienv = multienv;
            gform.columns[zoomname].isstatus = isstatus;
            relcol != '' && (gform.columns[zoomname].relcol = relcol);
            zoomfname != '' && (gform.columns[zoomname].zoomfname = zoomfname);
            gform.columns[zoomname].iskey = maintable.NewColumn[j].iskey;
          }
        }
      }
      if (maintable.SubForm && maintable.SubForm.length > 0) {
        for (j = 0; j < maintable.SubForm.length; j++) {
          var istext = -1;
          maintable.SubForm[j].hasOwnProperty('text') && (istext = maintable.SubForm[j].text);
          that.AddSubForm(self_0, maintable.SubForm[j].ename, maintable.SubForm[j].exec, maintable.SubForm[j].form, maintable.SubForm[j].self, maintable.SubForm[j].table, maintable.SubForm[j].title, istext);
        }
      }
      if (maintable.Activation && maintable.Activation.length > 0) {
        for (j = 0; j < maintable.Activation.length; j++) {
          that.AddActivation(self_0, maintable.Activation[j].ename, maintable.Activation[j].exec, maintable.Activation[j].form, maintable.Activation[j].table, maintable.Activation[j].title, maintable.Activation[j].background, maintable.Activation[j].confirm, maintable.Activation[j].etype, maintable.Activation[j].type);
        }
      }
      that.SetTableRowCount(table, rowcount);
      gform != null && (gform.windowSize = rowcount);
      if (maintable.Statuses && maintable.Statuses.length > 0 && maintable.Statuses[0].Status && maintable.Statuses[0].Status.length > 0) {
        var statusarr = maintable.Statuses[0].Status;
        gform.statuses = [];
        for (j = 0; j < statusarr.length; j++) {
          gform.statuses[j] = {};
          gform.statuses[j].statdes = statusarr[j].statdes;
          gform.statuses[j].color = statusarr[j].color;
        }
      }
    }
  }
  if (jo.Form[0].Position && jo.Form[0].Position.length > 0) {
    if (jo.Form[0].Position[0].TableLines && jo.Form[0].Position[0].TableLines.length > 0) {
      var tableLines = jo.Form[0].Position[0].TableLines;
      for (i = 0; i < tableLines.length; i++) {
        that.SetTableLines(parseInt(tableLines[i].table), parseInt(tableLines[i].lines), parseInt(tableLines[i].line), parseInt(tableLines[i].curline));
      }
    }
    that.SetPosition(jo.Form[0].Position[0].session, jo.Form[0].Position[0].table, jo.Form[0].Position[0].field, jo.Form[0].Position[0].line, jo.Form[0].Position[0].lines, jo.Form[0].Position[0].curline, jo.Form[0].Position[0].changed, jo.Form[0].Position[0].isappend);
    if (isLastOperationDel == 1 && jo.Form[0].Position[0].isappend == 1) {
      var table = jo.Form[0].Position[0].table;
      var gform = that.GetJsTableObject(table);
      if (gform) {
        var addline = that.getRowOffset(table);
        retObj.ClearLine = {};
        retObj.ClearLine.rowindex = jo.Form[0].Position[0].line + addline;
      }
    }
  }
  var isFirstLine = true;
  if (jo.Form[0].ClearLine && jo.Form[0].ClearLine.length > 0) {
    for (i = 0; i < jo.Form[0].ClearLine.length; i++) {
      var table = jo.Form[0].ClearLine[i].table;
      var line = jo.Form[0].ClearLine[i].line;
      global_forms_rows[table] && (global_forms_rows[table][line] = {});
      var gform = that.GetJsTableObject(table);
      if (table == jo.Form[0].Position[0].table && isFirstLine && gform && isLastOperationDel == 1) {
        isFirstLine = false;
        var addline = that.getRowOffset(table);
        retObj.ClearLine = {};
        retObj.ClearLine.rowindex = line + addline;
      }
    }
  }
  var savedReplaceText = false;
  var rows_0 = [];
  if (jo.Form[0].RT && jo.Form[0].RT.length > 0) {
    for (i = 0; i < jo.Form[0].RT.length; i++) {
      var rt = jo.Form[0].RT[i].FV;
      var tabId = [];
      var colIdx = [];
      var line = [];
      var value_0 = [];
      var rgb = [];
      tabId[0] = colIdx[0] = line[0] = rgb[0] = 0;
      params = $split(rt, '\t', 0);
      tabId[0] = params.length > 0?__parseAndValidateInt(params[0]):0;
      tabId[0] < 0 && (tabId[0] = -tabId[0]);
      colIdx[0] = params.length > 1?__parseAndValidateInt(params[1]):0;
      colIdx[0] < 0 && (colIdx[0] = -colIdx[0]);
      line[0] = params.length > 2?__parseAndValidateInt(params[2]):0;
      line[0] < 0 && (line[0] = -line[0]);
      rgb[0] = params.length > 3?__parseAndValidateInt(params[3]):0;
      rgb[0] < 0 && (rgb[0] = -rgb[0]);
      value_0[0] = params.length > 5?params[5]:'';
      var color_0;
      !rows_0[tabId[0]] && (rows_0[tabId[0]] = []);
      if (rows_0[tabId[0]][line[0]] && rows_0[tabId[0]][line[0]] != null) {
        color_0 = rows_0[tabId[0]][line[0]];
      }
       else {
        color_0 = GetColor(rgb[0]);
        rows_0[tabId[0]][line[0]] = color_0;
      }
      !global_forms_rows[tabId[0]] && (global_forms_rows[tabId[0]] = []);
      !global_forms_rows[tabId[0]][line[0]] && (global_forms_rows[tabId[0]][line[0]] = {});
      !global_forms_rows[tabId[0]][line[0]].data && (global_forms_rows[tabId[0]][line[0]].data = []);
      global_forms_rows[tabId[0]][line[0]].color = color_0;
      global_forms_rows[tabId[0]][line[0]].data[colIdx[0]] = value_0[0];
      if (operation == 'FormKey_Return' || operation == 'FormWarning' || operation == 'FormKey_Tab' || operation == 'FormKey_SaveRow' || operation == 'FormKey_Undo' || operation == 'FormKey_Del' || operation == 'FormActivate' || operation == 'FormAutomaticActivate' || operation == 'FormSubForm' || operation == 'FormStart') {
        var gform = that.GetJsTableObject(tabId[0]);
        if (gform != null) {
          var colName = that.getColNameById(tabId[0], colIdx[0]);
          if (colName != null && colName.length > 0 && gform != null && gform.columns[colName] != null) {
            !retObj.ReplaceText && (retObj.ReplaceText = {});
            !retObj.ReplaceText[gform.name] && (retObj.ReplaceText[gform.name] = {});
            var addline = that.getRowOffset(tabId[0]);
            !retObj.ReplaceText[gform.name][line[0] + addline] && (retObj.ReplaceText[gform.name][line[0] + addline] = {});
            gform.columns[colName].type == 'date' && (value_0[0] = DateToISO(value_0[0]));
            retObj.ReplaceText[gform.name][line[0] + addline][colName] = value_0[0];
            retObj.ReplaceText[gform.name][line[0] + addline]['metadata'] = {};
            retObj.ReplaceText[gform.name][line[0] + addline]['metadata'].color = color_0;
          }
        }
      }
    }
    if ((operation == 'FormSubForm' || operation == 'FormStart') && jo.Form[0].Position[0].isappend == 1) {
      savedReplaceText = true;
      prevReplaceText.ReplaceText = retObj.ReplaceText;
      retObj.ReplaceText = null;
    }
     else if (prevReplaceText && prevReplaceText.ReplaceText) {
      for (var formName in prevReplaceText.ReplaceText) {
        !retObj.ReplaceText && (retObj.ReplaceText = {});
        !retObj.ReplaceText[formName] && (retObj.ReplaceText[formName] = {});
        for (var formLine in prevReplaceText.ReplaceText[formName]) {
          !retObj.ReplaceText[formName][formLine] && (retObj.ReplaceText[formName][formLine] = {});
          for (var formCol in prevReplaceText.ReplaceText[formName][formLine]) {
            !retObj.ReplaceText[formName][formLine][formCol] && (retObj.ReplaceText[formName][formLine][formCol] = prevReplaceText.ReplaceText[formName][formLine][formCol]);
          }
        }
      }
    }
  }
  !savedReplaceText && (prevReplaceText.ReplaceText = null);
  if (jo.Form[0].ReplaceTextHtml && jo.Form[0].ReplaceTextHtml.length > 0) {
    var rth = jo.Form[0].ReplaceTextHtml[0];
    that.SetTableHtml(rth.table, rth.edit, rth.tsline, rth.tstext, rth.text);
    var gform = that.GetJsTableObject(rth.table);
    gform && gform != null && (gform.ishtmleditable = rth.edit);
    for (var k = 0; k < 2; k++) {
      var signature = k == 0?jo.Form[0].ReplaceTextHtml[0].Signature:jo.Form[0].ReplaceTextHtml[0].SignatureEng;
      if (signature && signature.length > 0) {
        var s = signature[0];
        that.SetTableSignature(rth.table, k, s.date, s.name, s.hr, s.begin, s.position, s.email, s.phone, s.message, s.fontsize, s.cellphone, s.branch, s.dept, s.company);
      }
    }
  }
  jo.Form[0].Position && jo.Form[0].Position.length > 0 && that.SetCurFieldValue();
  (jo.Form[0].fatalerror == 1 || jo.Form[0].fatalerror == 2) && (retObj.fatalerror = 1);
  var ipwrn = jo.ipwarning && jo.ipwarning != null?jo.ipwarning:null;
  that.SetIPMessage(ipwrn);
  if (jo.Form[0].Error && jo.Form[0].Error.length > 0) {
    var msg = '';
    retObj.Errors = [];
    for (var j = 0; j < jo.Form[0].Error.length; j++) {
      var err = jo.Form[0].Error[j];
      var msg = '';
      err.HyperLinkedText != null && err.HyperLinkedText.length > 0 && (msg = err.HyperLinkedText[0].text);
      msg == '' && (msg = err.message);
      retObj.Errors[j] = {};
      retObj.Errors[j].message = msg;
      err.messagetype && (retObj.Errors[j].messagetype = err.messagetype);
    }
  }
  if (jo.Form[0].Warning && jo.Form[0].Warning.length > 0) {
    var msg = '';
    var wrn = jo.Form[0].Warning[0];
    wrn.HyperLinkedText != null && wrn.HyperLinkedText.length > 0 && (msg = wrn.HyperLinkedText[0].text);
    msg == '' && (msg = wrn.message);
    var readWrite = 0;
    jo.Form[0].Warning[0].messagetype && jo.Form[0].Warning[0].messagetype == 'information' && that.IsHtmlForm(jo.Form[0].Position[0].table) && (readWrite = 1);
    that.SetWarningData(wrn.warningsql, parseInt(wrn.warningvalue), parseInt(wrn.warningline), parseInt(wrn.warningkey), parseInt(wrn.warningstep), readWrite);
    retObj.Warning = {};
    retObj.Warning.message = msg;
    jo.Form[0].Warning[0].messagetype && (readWrite?(retObj.Warning.messagetype = 'readWrite'):(retObj.Warning.messagetype = jo.Form[0].Warning[0].messagetype));
  }
  if (jo.Form[0].Choose && jo.Form[0].Choose.length > 0) {
    var coltype;
    operation == 'FormQueryDlgChoose' || operation == 'FormAlertSearch'?(coltype = that.getColTypeById(jo.Form[0].Position[0].table, that.formFilterChooseLastField)):(coltype = that.getColTypeById(jo.Form[0].Position[0].table, jo.Form[0].Position[0].field));
    if (coltype == 'date') {
      var chooseobj = jo.Form[0].Choose[0];
      if (chooseobj && chooseobj.ChooseLine && chooseobj.ChooseLine.length > 0) {
        for (var k = 0; k < chooseobj.ChooseLine.length; k++) {
          if (chooseobj.ChooseLine[k].retval && chooseobj.ChooseLine[k].retval.length > 0) {
            var iso = DateToISO(chooseobj.ChooseLine[k].retval);
            chooseobj.ChooseLine[k].retval = iso;
          }
        }
      }
    }
    retObj.Choose = jo.Form[0].Choose.length > 0?jo.Form[0].Choose[0]:null;
    if (retObj.Choose && jo.Form[0].QueryDates && jo.Form[0].QueryDates[0] && jo.Form[0].QueryDates[0].Date && retObj.Choose.ChooseLine && retObj.Choose.ChooseLine.length == jo.Form[0].QueryDates[0].Date.length) {
      for (var i = 0; i < retObj.Choose.ChooseLine.length; i++) {
        jo.Form[0].QueryDates[0].Date[i].date && (retObj.Choose.ChooseLine[i].date = DateToISO(jo.Form[0].QueryDates[0].Date[i].date));
      }
    }
  }
  if (jo.Form[0].Search && jo.Form[0].Search.length > 0) {
    var coltype;
    operation == 'FormQueryDlgChoose' || operation == 'FormAlertSearch'?(coltype = that.getColTypeById(jo.Form[0].Position[0].table, that.formFilterChooseLastField)):(coltype = that.getColTypeById(jo.Form[0].Position[0].table, jo.Form[0].Position[0].field));
    if (coltype == 'date') {
      var searchobj = jo.Form[0].Search[0];
      if (searchobj && searchobj.SearchLine && searchobj.SearchLine.length > 0) {
        for (var k = 0; k < searchobj.SearchLine.length; k++) {
          if (searchobj.SearchLine[k].retval && searchobj.SearchLine[k].retval.length > 0) {
            var iso = DateToISO(searchobj.SearchLine[k].retval);
            searchobj.SearchLine[k].retval = iso;
          }
        }
      }
    }
    retObj.Search = jo.Form[0].Search.length > 0?jo.Form[0].Search[0]:null;
  }
  if (jo.Form[0].Activate && jo.Form[0].Activate.length > 0) {
    retObj.ActivationLink = {};
    retObj.ActivationLink.table = jo.Form[0].Activate[0].table;
    retObj.ActivationLink.link = jo.Form[0].Activate[0].link;
    retObj.ActivationLink.linkid = jo.Form[0].Activate[0].linkid;
  }
  if (jo.Form[0].UploadFile && jo.Form[0].UploadFile.length > 0) {
    retObj.UploadFile = {};
    retObj.UploadFile.file = jo.Form[0].UploadFile[0].file;
  }
  if (jo.Form[0].QueryFilters && jo.Form[0].QueryFilters.length > 0 && jo.Form[0].QueryFilters[0].QueryValues && jo.Form[0].QueryFilters[0].QueryValues.length > 0) {
    var qf = jo.Form[0].QueryFilters[0];
    var gform = that.GetJsTableObject(qf.table);
    if (gform) {
      gform.queryFilters = {};
      that.AddQueryFilter(qf, qf.table, gform, gform.queryFilters);
    }
  }
  jo.Form[0].Labels && jo.Form[0].Labels.length > 0 && (retObj.labels = jo.Form[0].Labels);
}

function PrepareRetObj(retObj, progress, isLast, fileName){
  retObj.progress = progress;
  isLast && (retObj.file = fileName);
}

function ReadFile(that, file, onProgress, onSuccess, onError){
  $clinit_Form();
  var reader = new FileReader;
  reader.onload = function(event_0){
    var res = event_0.target.result;
    that.UploadFile_0(0, 'c:/' + file.name, res, onProgress, onSuccess, onError);
  }
  ;
  reader.readAsDataURL(file);
}

function padHex(in_$){
  if (in_$.length == 0) {
    return '00';
  }
  if (in_$.length == 1) {
    return '0' + in_$;
  }
  return in_$;
}

defineClass(54, 1, {54:1}, Form_1);
_.ActivateEnd = function ActivateEnd(onSuccess, onError, executeNow){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'In ActivateEnd: executeNow=' + executeNow);
  if (!$CanExecuteNow(this.RequestsQueue, new FormAPIRequest(($clinit_FormAPIRequest$RequestTypes() , ActivateEnd_0), initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [onSuccess, onError])), executeNow))
    return;
  $Activate(this, false, onSuccess, onError, null, null, null);
}
;
_.ActivateStart = function ActivateStart(onSuccess, onError, ename, type_0, onProgress, executeNow){
  $ActivateStart(this, onSuccess, onError, ename, type_0, onProgress, executeNow);
}
;
_.AddActivation = function AddActivation(tabself, ename, exec_0, form_0, table, title_0, background, confirm_0, etype, type_0){
  var ft, da;
  ft = dynamicCast($get_1(this.FormTables, valueOf(tabself)), 21);
  !!ft && (da = new DirectAct(title_0, ($clinit_EntityTypes() , dynamicCast($get_1((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(etype)), 14) , dynamicCast($get_1((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(type_0)), 14))) , $putStringValue(ft.Activations, ename + '.' + charToString(getEntChar(dynamicCast($get_1((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(etype)), 14))), da) , $AddActivationJS(ft.jsTableObject, ename, title_0, getEntChar(dynamicCast($get_1((!mappings_0 && !mappings_0 && (mappings_0 = new HashMap) , mappings_0), valueOf(etype)), 14)), background, confirm_0) , undefined);
}
;
_.AddColumn = function AddColumn(form_0, name_0, type_0, width_0, field, hidden, multienv, isstatus){
  var ft, fc;
  ft = dynamicCast($get_1(this.FormTables, valueOf(form_0)), 21);
  !!ft && (fc = new FormColumn(name_0, type_0, width_0, field, hidden, multienv) , $putStringValue(ft.FormColumns, name_0, fc) , $put_0(ft.FormColumnsI, valueOf(field), fc) , undefined);
}
;
_.AddQueryFilter = function AddQueryFilter(qf, table, gform, retobj){
  $clinit_Form();
  retobj.query = qf.query;
  retobj.queryname = qf.queryname;
  retobj.ignorecase = qf.ignorecase;
  qf.isdefault && (retobj.isdefault = qf.isdefault);
  retobj.saved = qf.saved;
  retobj.queryValues = [];
  if (qf.QueryValues != null) {
    for (var k = 0; k < qf.QueryValues.length; k++) {
      var colName = this.getColNameById(table, qf.QueryValues[k].field);
      if (colName != null && colName.length > 0 && gform.columns[colName] != null) {
        retobj.queryValues[k] = {};
        retobj.queryValues[k].field = colName;
        if (qf.QueryValues[k].FromValues && qf.QueryValues[k].FromValues.length > 0 && qf.QueryValues[k].FromValues[0].Value && qf.QueryValues[k].FromValues[0].Value.length > 0) {
          retobj.queryValues[k].fromval = [];
          for (var l = 0; l < qf.QueryValues[k].FromValues[0].Value.length; l++) {
            var value_0 = qf.QueryValues[k].FromValues[0].Value[l].value;
            gform.columns[colName].type == 'date' && (value_0 = DateToISO(value_0));
            retobj.queryValues[k].fromval[l] = value_0;
          }
        }
         else {
          var value_0 = qf.QueryValues[k].fromval;
          gform.columns[colName].type == 'date' && (value_0 = DateToISO(value_0));
          retobj.queryValues[k].fromval = value_0;
        }
        retobj.queryValues[k].isdesc = qf.QueryValues[k].isdesc;
        retobj.queryValues[k].op = qf.QueryValues[k].op;
        retobj.queryValues[k].sort = qf.QueryValues[k].sort;
        var value_0 = qf.QueryValues[k].toval;
        gform.columns[colName].type == 'date' && (value_0 = DateToISO(value_0));
        retobj.queryValues[k].toval = value_0;
      }
    }
  }
}
;
_.AddSubForm = function AddSubForm(tabself, ename, exec_0, form_0, self_0, table, title_0, istext){
  var ft, sb;
  ft = dynamicCast($get_1(this.FormTables, valueOf(tabself)), 21);
  !!ft && (sb = new SubForm(self_0) , $putStringValue(ft.SubForms, ename, sb) , $AddSubFormJS(ft.jsTableObject, ename, title_0, istext) , undefined);
}
;
_.AddTable = function AddTable(form_0, table, title_0, name_0, level, self_0, ishtml, oneline, isquery, zoomfield){
  var ft;
  ft = new FormTable(this, table, title_0, name_0, level, self_0, ishtml, oneline, isquery, zoomfield);
  $put_0(this.FormTables, valueOf(self_0), ft);
  $put_0(this.ActiveTables, valueOf(table), ft);
}
;
_.AddText = function AddText(text_0, addFlag, commentFlag, lang2Flag, onSuccess, onError, executeNow){
  $AddText(this, text_0, addFlag, commentFlag, lang2Flag, onSuccess, onError, executeNow);
}
;
_.ClearRows = function ClearRows(onSuccess, onError, executeNow){
  $ClearRows(this, onSuccess, onError, executeNow);
}
;
_.ClearSearchFilter = function ClearSearchFilter(onSuccess, onError, executeNow){
  $ClearSearchFilter(this, onSuccess, onError, executeNow);
}
;
_.DelRow = function DelRow(onSuccess, onError, executeNow){
  $DelRow(this, onSuccess, onError, executeNow);
}
;
_.DeleteFilter = function DeleteFilter(filterNum, onSuccess, onError, executeNow){
  $DeleteFilter(this, filterNum, onSuccess, onError, executeNow);
}
;
_.EndCurrentForm = function EndCurrentForm(returnJustThisRow, onSuccess, onError, executeNow){
  $EndCurrentForm(this, returnJustThisRow, onSuccess, onError, executeNow);
}
;
_.ExecuteNextRequest = function ExecuteNextRequest(){
  $ExecuteNextRequest(this.RequestsQueue);
}
;
_.FormCheckSupported = function FormCheckSupported(funcname, onError){
  return $FormCheckSupported(this, funcname, onError);
}
;
_.FormChoose = function FormChoose(fieldName, fieldValue, mode, onSuccess, onError, executeNow){
  $FormChoose(this, fieldName, fieldValue, mode, onSuccess, onError, executeNow);
}
;
_.FormFieldUpdate = function FormFieldUpdate(fieldName, value_0, onSuccess, onError, executeNow){
  $FormFieldUpdate(this, fieldName, value_0, onSuccess, onError, executeNow);
}
;
_.FormFilterChoose = function FormFilterChoose(fieldName, fieldValue, onSuccess, onError, executeNow){
  $FormFilterChoose(this, fieldName, fieldValue, onSuccess, onError, executeNow);
}
;
_.FormFilterSearchAction = function FormFilterSearchAction(action, searchText, onSuccess, onError, executeNow){
  $FormFilterSearchAction(this, action, searchText, onSuccess, onError, executeNow);
}
;
_.FormSearchAction = function FormSearchAction(action, searchText, onSuccess, onError, executeNow){
  $FormSearchAction(this, action, searchText, onSuccess, onError, executeNow);
}
;
_.FormWarning = function FormWarning(ok, executeNow){
  $FormWarning(this, ok, executeNow);
}
;
_.GetFileContent = function GetFileContent(filename, onSuccess, onError, executeNow){
  $GetFileContent(this, filename, onSuccess, onError, executeNow);
}
;
_.GetFileUrl = function GetFileUrl(file){
  return SetMailDirPath(file);
}
;
_.GetFilters = function GetFilters(onSuccess, onError, executeNow){
  $GetFilters(this, onSuccess, onError, executeNow);
}
;
_.GetHTMLSignature = function GetHTMLSignature(lang2, onSuccess, onError, executeNow){
  $GetHTMLSignature(this, lang2, onSuccess, onError, executeNow);
}
;
_.GetJsTableObject = function GetJsTableObject(table){
  $clinit_Form();
  var ft;
  ft = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  if (ft)
    return ft.jsTableObject;
  return null;
}
;
_.GetRows = function GetRows(fromRow, onSuccess, onError, executeNow){
  $GetRows(this, fromRow, onSuccess, onError, executeNow);
}
;
_.GotoSubForm = function GotoSubForm(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, executeNow, params){
  $GotoSubForm(this, formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, executeNow, params);
}
;
_.HandleError = function HandleError(){
  $HandleError(this.RequestsQueue);
}
;
_.IsAlive = function IsAlive(onSuccess, onError, executeNow){
  $IsAlive(this, onSuccess, onError, executeNow);
}
;
_.IsHtmlForm = function IsHtmlForm(table){
  var tab;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  if (!!tab && tab.ishtml_0 == 1)
    return true;
  return false;
}
;
_.NewRow_0 = function NewRow(onSuccess, onError, executeNow){
  $NewRow(this, onSuccess, onError, executeNow);
}
;
_.SaveCurrentRow = function SaveCurrentRow(exit, onSuccess, onError, executeNow){
  $SaveCurrentRow(this, exit, onSuccess, onError, executeNow);
}
;
_.SaveFilter = function SaveFilter(id_0, data_0, name_0, isdefault, onSuccess, onError, executeNow){
  $SaveFilter(this, id_0, data_0, name_0, isdefault, onSuccess, onError, executeNow);
}
;
_.ServerTripCompleted = function ServerTripCompleted(sender, e){
  this.isOnServer = false;
}
;
_.SetActiveRow = function SetActiveRow(row, onSuccess, onError, executeNow){
  $SetActiveRow(this, row, onSuccess, onError, executeNow);
}
;
_.SetCurFieldValue = function SetCurFieldValue(){
  $SetCurFieldValue(this);
}
;
_.SetIPMessage = function SetIPMessage(message){
  message == null?(this.ipmessage = null):(this.ipmessage = GetIPMessage(message));
}
;
_.SetIsGoneToServer = function SetIsGoneToServer(userState){
  if (this.isOnServer)
    return false;
  this.isOnServer = true;
  return true;
}
;
_.SetPosition = function SetPosition(session, table, field, line, lines, curline, changed, isappend){
  var tab;
  this.position_0.table_0 = table;
  this.position_0.field_0 = field;
  this.position_0.line_0 = line;
  this.position_0.changed_0 = changed;
  this.position_0.isappend_0 = isappend;
  this.privateSession = session;
  this.prevTab = this.curTab;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  if (tab) {
    this.curTab = tab;
    $SetCurRowInData(tab, this.position_0.line_0);
  }
}
;
_.SetSearchFilter = function SetSearchFilter(filter, onSuccess, onError, executeNow){
  $SetSearchFilter(this, filter, onSuccess, onError, executeNow);
}
;
_.SetSimpleSearchFilter = function SetSimpleSearchFilter(filter, onSuccess, onError, executeNow){
  $SetSimpleSearchFilter(this, filter, onSuccess, onError, executeNow);
}
;
_.SetTableHtml = function SetTableHtml(table, edit, tsline, tstext, url_0){
  var ft;
  ft = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!ft && (ft.isEdit = edit , ft.tsline_0 = tsline , ft.tstext_0 = tstext , ft.htmltext = url_0);
}
;
_.SetTableLines = function SetTableLines(table, lines, line, curline){
  var ft;
  ft = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!ft && (ft.lines_0 = lines , ft.line_0 = line);
}
;
_.SetTableRowCount = function SetTableRowCount(table, rowcount){
  var ft;
  ft = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!ft && (ft.rowcount = rowcount);
}
;
_.SetTableSignature = function SetTableSignature(table, eng, date, name_0, hr, begin, position, email, phone, message, fontsize, cellphone, branch, dept, company){
  var ft;
  ft = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!ft && (eng == 1?(ft.EngSignature = new FormTable$Signature(date, name_0, hr, begin, position, email, phone, message, cellphone, branch, dept, company)):(ft.HebSignature = new FormTable$Signature(date, name_0, hr, begin, position, email, phone, message, cellphone, branch, dept, company)));
}
;
_.SetWarningData = function SetWarningData(wsql, wval, wline, wkey, wstep, readWrite){
  $SetData(this.warningData, wsql, fromInt(wval), fromInt(wline), fromInt(wkey), fromInt(wstep), readWrite);
}
;
_.Undo = function Undo(onSuccess, onError, executeNow){
  $Undo(this, onSuccess, onError, executeNow);
}
;
_.UpdateStarted = function UpdateStarted(){
  this.started == 0?(this.started = 1):this.started == 1 && (this.started = 2);
}
;
_.UploadDataUrl = function UploadDataUrl(dataUrl, type_0, onProgress, onSuccess, onError, executeNow){
  $UploadDataUrl(this, dataUrl, type_0, onProgress, onSuccess, onError, executeNow);
}
;
_.UploadFile_0 = function UploadFile(uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, userState){
  $UploadFile_0(this, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, userState);
}
;
_.UploadFile_1 = function UploadFile_0(file, onProgress, onSuccess, onError, executeNow){
  $UploadFile_1(this, file, onProgress, onSuccess, onError, executeNow);
}
;
_.WaitForInfoApprove = function WaitForInfoApprove(){
  this.RequestsQueue.isWaitingForWarningApprove = true;
  this.isWaitingInfoApprove = true;
}
;
_.WaitForWarningApprove = function WaitForWarningApprove(){
  this.RequestsQueue.isWaitingForWarningApprove = true;
}
;
_.getColNameById = function getColNameById(table, colId){
  var col, ret, tab;
  ret = null;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  if (tab) {
    col = dynamicCast($get_1(tab.FormColumnsI, valueOf(colId)), 41);
    !!col && (ret = col.zoomname_0);
  }
  return ret;
}
;
_.getColTypeById = function getColTypeById(table, colId){
  var col, ret, tab;
  ret = null;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  if (tab) {
    col = dynamicCast($get_1(tab.FormColumnsI, valueOf(colId)), 41);
    !!col && (ret = col.type_0);
  }
  return ret;
}
;
_.getCurrentTable = function getCurrentTable(){
  return this.curTab?this.curTab.table_0:0;
}
;
_.getDname = function getDname(){
  return this.dname;
}
;
_.getIsAppend = function getIsAppend(){
  return this.position_0.isappend_0;
}
;
_.getRowOffset = function getRowOffset(table){
  var offset, tab;
  offset = 0;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!tab && (offset = tab.line_0 - 1);
  return offset;
}
;
_.getSession = function getSession(){
  return this.privateSession;
}
;
_.getTableLines = function getTableLines(table){
  var lines, tab;
  lines = 0;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!tab && (lines = tab.lines_0);
  return lines;
}
;
_.getTableMessageFunc = function getTableMessageFunc(){
  if (!!this.prevTab && ($equals('FormExitForm', lastOperation) || $equals('FormKey_Tab', lastOperation)))
    return this.prevTab.onShowMessage;
  if (!this.curTab)
    return null;
  return this.curTab.onShowMessage;
}
;
_.getTableRowCount = function getTableRowCount(table){
  var rowcount, tab;
  rowcount = 0;
  tab = dynamicCast($get_1(this.ActiveTables, valueOf(table)), 21);
  !!tab && (rowcount = tab.rowcount);
  return rowcount;
}
;
_.getTableUpdateFieldsFunc = function getTableUpdateFieldsFunc(){
  if (!!this.prevTab && ($equals('FormExitForm', lastOperation) || $equals('FormKey_Tab', lastOperation)))
    return this.prevTab.updateFieldsFunc;
  if (!this.curTab)
    return null;
  return this.curTab.updateFieldsFunc;
}
;
_.isCancelFileUpload_0 = function isCancelFileUpload(){
  return this.isCancelFileUpload;
}
;
_.setCancelFileUpload = function setCancelFileUpload(cancel){
  this.isCancelFileUpload = cancel;
}
;
_.SearchLastPage = 0;
_.con = null;
_.dname = null;
_.formFilterChooseLastField = 0;
_.fromStartForm = 0;
_.ipmessage = null;
_.isCancelFileUpload = false;
_.isOnServer = false;
_.isWaitingInfoApprove = false;
_.lastRetObj = null;
_.onError = null;
_.onShowMessage = null;
_.onSuccess = null;
_.started = 0;
_.updateFieldsFunc = null;
var LabelsMessages, fieldColors, isLastOperationDel_0 = false, lastOperation;
var Lcom_priority_app_form_Form_2_classLit = createForClass('com.priority.app.form', 'Form', 54);
function Form$1(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(154, 8, {}, Form$1);
_.OnPriError = function OnPriError_0(error, isOnServer){
  InvokeFormStartCallback(null, 0, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_0(response){
  var e, ftable, jo, retObj, table;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormStart');
    table = this.this$01.curTab?this.this$01.curTab.table_0:0;
    InvokeFormStartCallback(this.val$thisForm3, table, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      ftable = this.this$01.curTab?this.this$01.curTab.table_0:0;
      InvokeFormStartCallback(this.val$thisForm3, ftable, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$1_2_classLit = createForClass('com.priority.app.form', 'Form/1', 154);
function Form$10($anonymous0, val$thisForm, val$actf, val$onProgress, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$actf4 = val$actf;
  this.val$onProgress5 = val$onProgress;
  this.val$onSuccess6 = val$onSuccess;
  this.val$onError7 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(163, 8, {}, Form$10);
_.OnPriError = function OnPriError_1(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SendLabels (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess6, this.val$onError7);
}
;
_.OnPriResponse = function OnPriResponse_1(response){
  var e, jo, p, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormKey_SendLabels');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SendLabels (success)');
    p = new Proc;
    $SetForm(p, this.val$thisForm3);
    p.privateSession = 'nosession';
    $SetEname(p, LabelsPrint);
    $SetTitle(p, this.val$actf4.title_0);
    p.LastLabelsObject = retObj;
    p.progressFunc = this.val$onProgress5;
    InvokeLabels(p, retObj, this.val$onSuccess6, dynamicCastToString($get_1(($clinit_Form() , LabelsMessages), valueOf(1100))));
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SendLabels (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess6, this.val$onError7);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$10_2_classLit = createForClass('com.priority.app.form', 'Form/10', 163);
function Form$11(this$0, $anonymous0, val$onSuccess, val$onError, val$onProgress, val$thisForm){
  this.this$01 = this$0;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  this.val$onProgress5 = val$onProgress;
  this.val$thisForm6 = val$thisForm;
  WCFResponse.call(this, $anonymous0);
}

defineClass(164, 8, {}, Form$11);
_.OnPriError = function OnPriError_2(error, isOnServer){
  InvokeCallback(this.val$thisForm6, null, null, error, 'exception', this.val$onSuccess3, this.val$onError4);
}
;
_.OnPriResponse = function OnPriResponse_2(response){
  var e, extMessage, i, j, jo, messages, msgnum, pa, text_0;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    extMessage = dynamicCast($get(pa, 0), 5);
    messages = dynamicCast($get_0(extMessage, 'ExtMessage'), 7);
    if (messages) {
      for (i = 0; i < messages.jsArray.length; i++) {
        j = $get(messages, i).isObject();
        text_0 = getHyperLinkedText(j, 'message');
        msgnum = round_int($get_0(dynamicCast($get(messages, i), 5), 'num').isNumber().value_0);
        (msgnum == 1041 || msgnum == 1094 || msgnum == 1099 || msgnum == 1100) && $put_0(($clinit_Form() , LabelsMessages), valueOf(msgnum), text_0);
      }
    }
    $LabelsStartA(this.this$01, this.val$onSuccess3, this.val$onError4, this.val$onProgress5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeCallback(this.val$thisForm6, null, null, e.getMessage(), 'exception', this.val$onSuccess3, this.val$onError4);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$11_2_classLit = createForClass('com.priority.app.form', 'Form/11', 164);
function Form$12(this$0, $anonymous0, val$thisForm, val$start, val$ename, val$type, val$onProgress, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$start4 = val$start;
  this.val$ename5 = val$ename;
  this.val$type6 = val$type;
  this.val$onProgress7 = val$onProgress;
  this.val$onSuccess8 = val$onSuccess;
  this.val$onError9 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(165, 8, {}, Form$12);
_.OnPriError = function OnPriError_3(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormActivate (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess8, this.val$onError9);
}
;
_.OnPriResponse = function OnPriResponse_3(response){
  var activationLink, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormActivate');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormActivate (success)');
    if (this.val$start4) {
      activationLink = retObj.ActivationLink;
      ProcStartActivate(this.val$ename5, this.val$type6, activationLink, this.val$onProgress7, this.this$01.jsDname, this.val$onSuccess8, this.val$onError9);
      $ExecuteNextRequest(this.this$01.RequestsQueue);
    }
     else {
      InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess8, this.val$onError9);
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (!instanceOf($e0, 6))
      throw unwrap_5($e0);
  }
}
;
_.val$start4 = false;
var Lcom_priority_app_form_Form$12_2_classLit = createForClass('com.priority.app.form', 'Form/12', 165);
function $OnPriError(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
  InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$13($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(166, 8, {}, Form$13);
_.OnPriError = function OnPriError_4(error, isOnServer){
  $OnPriError(this, error);
}
;
_.OnPriResponse = function OnPriResponse_4(response){
  var e, jo, retObj, zoom;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormExitForm');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (success)');
    zoom = this.val$thisForm3.formzoom;
    zoom?$ProcParamZoomValue(zoom.proc_0, zoom, this.val$onSuccess4, this.val$onError5):InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$13_2_classLit = createForClass('com.priority.app.form', 'Form/13', 166);
function Form$14($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(167, 8, {}, Form$14);
_.OnPriError = function OnPriError_5(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_5(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormExitForm');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (success)');
    InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$14_2_classLit = createForClass('com.priority.app.form', 'Form/14', 167);
function Form$15(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(168, 8, {}, Form$15);
_.OnPriError = function OnPriError_6(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_6(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormExitForm');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (success)');
    $FormExitForm(this.this$01, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormExitForm (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$15_2_classLit = createForClass('com.priority.app.form', 'Form/15', 168);
function $OnPriError_0(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormJumpLine (error)');
  InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess6, this$static.val$onError7);
}

function Form$16($anonymous0, val$thisForm, val$getData, val$row, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$getData4 = val$getData;
  this.val$row5 = val$row;
  this.val$onSuccess6 = val$onSuccess;
  this.val$onError7 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(169, 8, {}, Form$16);
_.OnPriError = function OnPriError_7(error, isOnServer){
  $OnPriError_0(this, error);
}
;
_.OnPriResponse = function OnPriResponse_7(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormJumpLine');
    if (this.val$getData4) {
      retObj = new JSONObject;
      $GetRowsData(this.val$thisForm3.curTab.table_0, this.val$row5, retObj, this.val$thisForm3);
    }
     else {
      $AddCurrentRow(this.val$row5, retObj);
    }
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormJumpLine (success)');
    InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess6, this.val$onError7);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormJumpLine (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess6, this.val$onError7);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$getData4 = false;
_.val$row5 = 0;
var Lcom_priority_app_form_Form$16_2_classLit = createForClass('com.priority.app.form', 'Form/16', 169);
function $OnPriError_1(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSubForm (error)');
  InvokeSubFormStartCallback(null, 0, null, null, error, 'exception', this$static.val$onSuccess6, this$static.val$onError7);
}

function Form$17(this$0, $anonymous0, val$thisForm, val$onMessageFunc, val$onUpdateFieldsFunc, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onMessageFunc4 = val$onMessageFunc;
  this.val$onUpdateFieldsFunc5 = val$onUpdateFieldsFunc;
  this.val$onSuccess6 = val$onSuccess;
  this.val$onError7 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(170, 8, {}, Form$17);
_.OnPriError = function OnPriError_8(error, isOnServer){
  $OnPriError_1(this, error);
}
;
_.OnPriResponse = function OnPriResponse_8(response){
  var e, jo, retObj, table;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormSubForm');
    table = 0;
    if (this.this$01.curTab) {
      table = this.this$01.curTab.table_0;
      $setAdd(this.this$01.curTab, true);
      this.this$01.curTab.onShowMessage = this.val$onMessageFunc4;
      this.this$01.curTab.updateFieldsFunc = this.val$onUpdateFieldsFunc5;
    }
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSubForm (success)');
    InvokeSubFormStartCallback(this.val$thisForm3, table, jo, retObj, null, null, this.val$onSuccess6, this.val$onError7);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSubForm (error)');
      InvokeSubFormStartCallback(null, 0, null, null, e.getMessage(), 'exception', this.val$onSuccess6, this.val$onError7);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$17_2_classLit = createForClass('com.priority.app.form', 'Form/17', 170);
function Form$18($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(171, 8, {}, Form$18);
_.OnPriError = function OnPriError_9(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SaveRow (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_9(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormKey_SaveRow');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SaveRow (success)');
    InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormKey_SaveRow (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$18_2_classLit = createForClass('com.priority.app.form', 'Form/18', 171);
function $OnPriError_2(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, SaveFilter (error)');
  InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$19($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(172, 8, {}, Form$19);
_.OnPriError = function OnPriError_10(error, isOnServer){
  $OnPriError_2(this, error);
}
;
_.OnPriResponse = function OnPriResponse_10(response){
  var e;
  try {
    safeEval(response);
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, SaveFilter');
    InvokeSaveFilterCallback(this.val$thisForm3, this.val$onSuccess4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, SaveFilter (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$19_2_classLit = createForClass('com.priority.app.form', 'Form/19', 172);
function $OnPriError_3(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormWarning (error)');
  this$static.val$thisForm3.fromStartForm == 1?InvokeSubFormStartCallback(this$static.val$thisForm3, 0, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5):InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$2(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(155, 8, {}, Form$2);
_.OnPriError = function OnPriError_11(error, isOnServer){
  $OnPriError_3(this, error);
}
;
_.OnPriResponse = function OnPriResponse_11(response){
  var e, jo, retObj, table;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormWarning');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormWarning (success)');
    if (this.val$thisForm3.fromStartForm == 1) {
      table = this.this$01.curTab?this.this$01.curTab.table_0:0;
      InvokeSubFormStartCallback(this.val$thisForm3, table, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
    }
     else {
      InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormWarning (error)');
      this.val$thisForm3.fromStartForm == 1?InvokeSubFormStartCallback(this.val$thisForm3, 0, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5):InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$2_2_classLit = createForClass('com.priority.app.form', 'Form/2', 155);
function $OnPriError_4(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, DeleteFilter (error)');
  InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$20($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(173, 8, {}, Form$20);
_.OnPriError = function OnPriError_12(error, isOnServer){
  $OnPriError_4(this, error);
}
;
_.OnPriResponse = function OnPriResponse_12(response){
  var e;
  try {
    safeEval(response);
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, DeleteFilter');
    InvokeDeleteFilterCallback(this.val$thisForm3, this.val$onSuccess4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, DeleteFilter (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$20_2_classLit = createForClass('com.priority.app.form', 'Form/20', 173);
function $OnPriError_5(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, GetFilters (error)');
  InvokeCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$21($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(174, 8, {}, Form$21);
_.OnPriError = function OnPriError_13(error, isOnServer){
  $OnPriError_5(this, error);
}
;
_.OnPriResponse = function OnPriResponse_13(response){
  var e, jo;
  try {
    jo = safeEval(response);
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, GetFilters');
    InvokeGetFiltersCallback(this.val$thisForm3, jo, this.val$onSuccess4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, GetFilters (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$21_2_classLit = createForClass('com.priority.app.form', 'Form/21', 174);
function Form$22($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(175, 8, {}, Form$22);
_.OnPriError = function OnPriError_14(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, IsAlive (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_14(response){
  var e, jo;
  try {
    jo = safeEval(response);
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, IsAlive');
    InvokeIsAliveCallback(this.val$thisForm3, jo, this.val$onSuccess4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, IsAlive (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$22_2_classLit = createForClass('com.priority.app.form', 'Form/22', 175);
function Form$23(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(176, 8, {}, Form$23);
_.OnPriError = function OnPriError_15(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormHtml (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_15(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormHtml');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormHtml (success)');
    $AddHtmlToResponseObject(this.this$01, retObj, false);
    InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$23_2_classLit = createForClass('com.priority.app.form', 'Form/23', 176);
function Form$24($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(177, 8, {}, Form$24);
_.OnPriError = function OnPriError_16(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (error)');
  InvokeFormSearchActionCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_16(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormAlertSearch');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (success)');
    InvokeFormSearchActionCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (error)');
      InvokeFormSearchActionCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$24_2_classLit = createForClass('com.priority.app.form', 'Form/24', 177);
function $OnPriError_6(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (error)');
  InvokeFormSearchActionCallback(this$static.val$thisForm3, null, null, error, 'exception', this$static.val$onSuccess4, this$static.val$onError5);
}

function Form$25($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(178, 8, {}, Form$25);
_.OnPriError = function OnPriError_17(error, isOnServer){
  $OnPriError_6(this, error);
}
;
_.OnPriResponse = function OnPriResponse_17(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormSearch');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (success)');
    InvokeFormSearchActionCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormSearch (error)');
      InvokeFormSearchActionCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$25_2_classLit = createForClass('com.priority.app.form', 'Form/25', 178);
function $OnPriError_7(this$static, error){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormAlertChoose (error)');
  InvokeFormChooseCallback(this$static.val$thisForm4, null, null, error, 'exception', this$static.val$onSuccess5, this$static.val$onError6);
}

function Form$26(this$0, $anonymous0, val$col, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$col3 = val$col;
  this.val$thisForm4 = val$thisForm;
  this.val$onSuccess5 = val$onSuccess;
  this.val$onError6 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(179, 8, {}, Form$26);
_.OnPriError = function OnPriError_18(error, isOnServer){
  $OnPriError_7(this, error);
}
;
_.OnPriResponse = function OnPriResponse_18(response){
  var e, jo, retObj;
  try {
    this.this$01.formFilterChooseLastField = this.val$col3.field_0;
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm4, 'FormAlertChoose');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormAlertChoose (success)');
    InvokeFormChooseCallback(this.val$thisForm4, jo, retObj, null, null, this.val$onSuccess5, this.val$onError6);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormAlertChoose (error)');
      InvokeFormChooseCallback(this.val$thisForm4, null, null, e.getMessage(), 'exception', this.val$onSuccess5, this.val$onError6);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$26_2_classLit = createForClass('com.priority.app.form', 'Form/26', 179);
function Form$27(this$0, $anonymous0, val$col, val$thisForm, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$col3 = val$col;
  this.val$thisForm4 = val$thisForm;
  this.val$onSuccess5 = val$onSuccess;
  this.val$onError6 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(180, 8, {}, Form$27);
_.OnPriError = function OnPriError_19(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgChoose (error)');
  InvokeFormChooseCallback(this.val$thisForm4, null, null, error, 'exception', this.val$onSuccess5, this.val$onError6);
}
;
_.OnPriResponse = function OnPriResponse_19(response){
  var e, jo, retObj;
  try {
    this.this$01.formFilterChooseLastField = this.val$col3.field_0;
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm4, 'FormQueryDlgChoose');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgChoose (success)');
    InvokeFormChooseCallback(this.val$thisForm4, jo, retObj, null, null, this.val$onSuccess5, this.val$onError6);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgChoose (error)');
      InvokeFormChooseCallback(this.val$thisForm4, null, null, e.getMessage(), 'exception', this.val$onSuccess5, this.val$onError6);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$27_2_classLit = createForClass('com.priority.app.form', 'Form/27', 180);
function Form$28($anonymous0, val$thisForm, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(181, 8, {}, Form$28);
_.OnPriError = function OnPriError_20(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormChoose (error)');
  InvokeFormChooseCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_20(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormKey_Normal');
    $clinit_PriCommon();
    isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormChoose (success)');
    InvokeFormChooseCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormChoose (error)');
      InvokeFormChooseCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$28_2_classLit = createForClass('com.priority.app.form', 'Form/28', 181);
function Form$3(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError, val$fromRow){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  this.val$fromRow6 = val$fromRow;
  WCFResponse.call(this, $anonymous0);
}

defineClass(156, 8, {}, Form$3);
_.OnPriError = function OnPriError_21(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgExecute (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_21(response){
  var e, jo, retObj;
  try {
    $setAdd(this.val$thisForm3.curTab, true);
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormQueryDlgExecute');
    ContainsError(retObj)?InvokeCallback(this.val$thisForm3, jo, retObj, '', null, this.val$onSuccess4, this.val$onError5):$FormGoto(this.this$01, this.val$fromRow6, true, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgExecute (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$fromRow6 = 0;
var Lcom_priority_app_form_Form$3_2_classLit = createForClass('com.priority.app.form', 'Form/3', 156);
function Form$4(this$0, $anonymous0, val$thisForm, val$onSuccess, val$onError, val$fromRow){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  this.val$fromRow6 = val$fromRow;
  WCFResponse.call(this, $anonymous0);
}

defineClass(157, 8, {}, Form$4);
_.OnPriError = function OnPriError_22(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgExecute (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_22(response){
  var e, jo, retObj;
  try {
    $setAdd(this.val$thisForm3.curTab, true);
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormQueryDlgExecute');
    ContainsError(retObj)?InvokeCallback(this.val$thisForm3, jo, retObj, '', null, this.val$onSuccess4, this.val$onError5):$FormGoto(this.this$01, this.val$fromRow6, true, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormQueryDlgExecute (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$fromRow6 = 0;
var Lcom_priority_app_form_Form$4_2_classLit = createForClass('com.priority.app.form', 'Form/4', 157);
function Form$5($anonymous0, val$thisForm, val$key, val$onSuccess, val$onError){
  this.val$thisForm3 = val$thisForm;
  this.val$key4 = val$key;
  this.val$onSuccess5 = val$onSuccess;
  this.val$onError6 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(158, 8, {}, Form$5);
_.OnPriError = function OnPriError_23(error, isOnServer){
  Printlog('Before InvokeCallback, FormKey_' + $name(this.val$key4) + ' (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess5, this.val$onError6);
}
;
_.OnPriResponse = function OnPriResponse_23(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormKey_' + $name(this.val$key4));
    Printlog('Before InvokeCallback, FormKey_' + $name(this.val$key4) + ' (success)');
    InvokeCallback(this.val$thisForm3, jo, retObj, null, null, this.val$onSuccess5, this.val$onError6);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      Printlog('Before InvokeCallback, FormKey_' + $name(this.val$key4) + ' (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess5, this.val$onError6);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$5_2_classLit = createForClass('com.priority.app.form', 'Form/5', 158);
function Form$6($anonymous0, val$that, val$onSuccess, val$onError){
  this.val$that3 = val$that;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(159, 8, {}, Form$6);
_.OnPriError = function OnPriError_24(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, GetFileContent (error)');
  InvokeCallback(this.val$that3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_24(response){
  var jo;
  jo = safeEval(response);
  InvokeGetFileContentCallback(this.val$that3, jo, this.val$onSuccess4, this.val$onError5);
}
;
var Lcom_priority_app_form_Form$6_2_classLit = createForClass('com.priority.app.form', 'Form/6', 159);
function Form$7($anonymous0, val$that, val$file, val$onProgress, val$onSuccess, val$onError){
  this.val$that3 = val$that;
  this.val$file4 = val$file;
  this.val$onProgress5 = val$onProgress;
  this.val$onSuccess6 = val$onSuccess;
  this.val$onError7 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(160, 8, {}, Form$7);
_.OnPriError = function OnPriError_25(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, UploadFile (error)');
  InvokeCallback(this.val$that3, null, null, error, 'exception', this.val$onSuccess6, this.val$onError7);
}
;
_.OnPriResponse = function OnPriResponse_25(response){
  var e;
  try {
    ReadFile(this.val$that3, this.val$file4, this.val$onProgress5, this.val$onSuccess6, this.val$onError7);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, UploadFile (error)');
      InvokeCallback(this.val$that3, null, null, e.getMessage(), 'exception', this.val$onSuccess6, this.val$onError7);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$7_2_classLit = createForClass('com.priority.app.form', 'Form/7', 160);
function Form$8($anonymous0, val$that, val$type, val$dataUrl, val$onProgress, val$onSuccess, val$onError){
  this.val$that3 = val$that;
  this.val$type4 = val$type;
  this.val$dataUrl5 = val$dataUrl;
  this.val$onProgress6 = val$onProgress;
  this.val$onSuccess7 = val$onSuccess;
  this.val$onError8 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(161, 8, {}, Form$8);
_.OnPriError = function OnPriError_26(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, UploadFile (error)');
  InvokeCallback(this.val$that3, null, null, error, 'exception', this.val$onSuccess7, this.val$onError8);
}
;
_.OnPriResponse = function OnPriResponse_26(response){
  var e;
  try {
    $UploadFile_0(this.val$that3, 0, '.' + this.val$type4, this.val$dataUrl5, this.val$onProgress6, this.val$onSuccess7, this.val$onError8, null);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, UploadFile (error)');
      InvokeCallback(this.val$that3, null, null, e.getMessage(), 'exception', this.val$onSuccess7, this.val$onError8);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_form_Form$8_2_classLit = createForClass('com.priority.app.form', 'Form/8', 161);
function Form$9(this$0, $anonymous0, val$thisForm, val$print, val$onProgress, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisForm3 = val$thisForm;
  this.val$print4 = val$print;
  this.val$onProgress5 = val$onProgress;
  this.val$onSuccess6 = val$onSuccess;
  this.val$onError7 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(162, 8, {}, Form$9);
_.OnPriError = function OnPriError_27(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormGenerateLabelsMobAsync (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess6, this.val$onError7);
}
;
_.OnPriResponse = function OnPriResponse_27(response){
  var e, jo, labels, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormGenerateLabelsMobAsync');
    if (this.val$print4) {
      labels = new Proc;
      labels.progressFunc = this.val$onProgress5;
      $SetDName(labels, this.this$01.jsDname);
      $ProcStart(labels, 'LABELS', 'P', this.val$onSuccess6, this.val$onError7);
    }
     else {
      onSrvSuccess_0(this, new JSONObject, this.val$onSuccess6, this.val$onError7, null, null, 0);
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormGenerateLabelsMobAsync (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess6, this.val$onError7);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$print4 = false;
var Lcom_priority_app_form_Form$9_2_classLit = createForClass('com.priority.app.form', 'Form/9', 162);
function Form$FormFileUploader(this$0, holder){
  this.this$01 = this$0;
  FileUploader.call(this, holder);
}

defineClass(149, 77, {}, Form$FormFileUploader);
_.ServerUpload = function ServerUpload(uploadmode, finished, segment, fileName, fileSection, last, fileContents, onProgress, onSuccess, onError, userState){
  var memento, thisForm;
  memento = $CreateMemento(this.this$01.curTab);
  thisForm = dynamicCast(this.holder, 54);
  finished?$FormUploadFileAsyncMob($GetConnection(this.this$01), b64encode($ToStringData(this.this$01._currentFormState, this.this$01.privateSession, memento)), {l:2, m:0, h:0}, fileName, b64encode(''), new Form$FormFileUploader$2(this, $GetConnection(this.this$01), thisForm, onSuccess, onError, fileName, userState, fileSection, fileContents, onProgress)):$FormUploadFileAsyncMob($GetConnection(this.this$01), b64encode($ToStringData(this.this$01._currentFormState, this.this$01.privateSession, memento)), fromInt(uploadmode), fileName, segment, new Form$FormFileUploader$1(this, $GetConnection(this.this$01), thisForm, onSuccess, onError, fileName, userState, fileSection, fileContents, onProgress));
}
;
_.UploadCancel = function UploadCancel(onSuccess, onError){
  var form_0;
  form_0 = dynamicCast(this.holder, 54);
  InvokeCallback(form_0, null, null, 'File upload was cancelled.', 'uploadCancelled', onSuccess, onError);
  return;
}
;
var Lcom_priority_app_form_Form$FormFileUploader_2_classLit = createForClass('com.priority.app.form', 'Form/FormFileUploader', 149);
function Form$FormFileUploader$1(this$1, $anonymous0, val$thisForm, val$onSuccess, val$onError, val$fileName, val$userState, val$fileSection, val$contents, val$onProgress){
  this.this$11 = this$1;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  this.val$fileName7 = val$fileName;
  this.val$userState8 = val$userState;
  this.val$fileSection9 = val$fileSection;
  this.val$contents10 = val$contents;
  this.val$onProgress11 = val$onProgress;
  WCFResponse.call(this, $anonymous0);
}

defineClass(152, 8, {}, Form$FormFileUploader$1);
_.OnPriError = function OnPriError_28(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormUploadFile (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_28(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormUploadFile');
    ContainsError(retObj)?InvokeCallback(this.val$thisForm3, jo, retObj, '', null, this.val$onSuccess4, this.val$onError5):$Con_FormUploadFileCompleted(this.this$11.this$01, jo, retObj, this.val$fileName7, this.val$userState8, this.val$fileSection9, false, this.val$contents10, this.val$onProgress11, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormUploadFile (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$fileSection9 = 0;
var Lcom_priority_app_form_Form$FormFileUploader$1_2_classLit = createForClass('com.priority.app.form', 'Form/FormFileUploader/1', 152);
function Form$FormFileUploader$2(this$1, $anonymous0, val$thisForm, val$onSuccess, val$onError, val$fileName, val$userState, val$fileSection, val$contents, val$onProgress){
  this.this$11 = this$1;
  this.val$thisForm3 = val$thisForm;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  this.val$fileName7 = val$fileName;
  this.val$userState8 = val$userState;
  this.val$fileSection9 = val$fileSection;
  this.val$contents10 = val$contents;
  this.val$onProgress11 = val$onProgress;
  WCFResponse.call(this, $anonymous0);
}

defineClass(153, 8, {}, Form$FormFileUploader$2);
_.OnPriError = function OnPriError_29(error, isOnServer){
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormUploadFile2 (error)');
  InvokeCallback(this.val$thisForm3, null, null, error, 'exception', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_29(response){
  var e, jo, retObj;
  try {
    jo = safeEval(response);
    retObj = new JSONObject;
    ParseJO(jo, retObj, this.val$thisForm3, 'FormUploadFile');
    ContainsError(retObj)?InvokeCallback(this.val$thisForm3, jo, retObj, '', null, this.val$onSuccess4, this.val$onError5):$Con_FormUploadFileCompleted(this.this$11.this$01, jo, retObj, this.val$fileName7, this.val$userState8, this.val$fileSection9, true, this.val$contents10, this.val$onProgress11, this.val$onSuccess4, this.val$onError5);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      $clinit_PriCommon();
      isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'Before InvokeCallback, FormUploadFile2 (error)');
      InvokeCallback(this.val$thisForm3, null, null, e.getMessage(), 'exception', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.val$fileSection9 = 0;
var Lcom_priority_app_form_Form$FormFileUploader$2_2_classLit = createForClass('com.priority.app.form', 'Form/FormFileUploader/2', 153);
function Form$Position(){
}

defineClass(150, 1, {}, Form$Position);
_.changed_0 = 0;
_.field_0 = 0;
_.isappend_0 = 0;
_.line_0 = 0;
_.table_0 = 0;
var Lcom_priority_app_form_Form$Position_2_classLit = createForClass('com.priority.app.form', 'Form/Position', 150);
function $SetData(this$static, wsql, wval, wline, wkey, wstep, readWrite){
  this$static.wsql = wsql;
  this$static.wval = wval;
  this$static.wline = wline;
  this$static.wkey = wkey;
  this$static.wstep = wstep;
  this$static.readWrite = readWrite;
}

function Form$WarningMessageData(){
}

defineClass(151, 1, {}, Form$WarningMessageData);
_.readWrite = 0;
_.wkey = {l:0, m:0, h:0};
_.wline = {l:0, m:0, h:0};
_.wstep = {l:0, m:0, h:0};
_.wval = {l:0, m:0, h:0};
var Lcom_priority_app_form_Form$WarningMessageData_2_classLit = createForClass('com.priority.app.form', 'Form/WarningMessageData', 151);
function FormStart(name_0, onShowMessageFunc, updateFieldsFunc, onSuccess, onError, autoRetrieveFirstRows, dn, params){
  FormStartZoom(name_0, onShowMessageFunc, updateFieldsFunc, onSuccess, onError, autoRetrieveFirstRows, dn, params, null);
}

function FormStartZoom(name_0, onShowMessageFunc, updateFieldsFunc, onSuccess, onError, autoRetrieveFirstRows, dn, params, zoom){
  var dname, f;
  if (loginResult <= 0) {
    InvokeFormStartCallback(null, 0, null, null, "Can't start form/procedure because login wasn't successful", 'loginFailed', onSuccess, onError);
    return;
  }
  f = new Form_1;
  f.jsDname = dn;
  dname = GetDName(dn);
  dname != null && dname.length > 0 && (f.dname = dname);
  f.onShowMessage = onShowMessageFunc;
  f.updateFieldsFunc = updateFieldsFunc;
  f.formzoom = zoom;
  $FormStartZoom(f, name_0, autoRetrieveFirstRows, onSuccess, onError, params, zoom);
}

function InvokeCallback(form_0, jo, retObj, errorMsg, errType, onSuccess, onError){
  if (jo == null || retObj == null) {
    onSrvError(form_0, onError, errorMsg, 0, errType);
    return;
  }
  retObj.fatalerror && retObj.fatalerror == 1?onSrvError(form_0, onError, getErrMsg(retObj), 1, errType):onSrvSuccess_0(form_0, retObj, onSuccess, onError, null, null, 0);
}

function InvokeDeleteFilterCallback(form_0, onSuccess){
  onSuccess();
  form_0.ExecuteNextRequest();
}

function InvokeError(form_0, onError, message, errType, fatal){
  onSrvError(form_0, onError, message, fatal, errType);
}

function InvokeErrorNow(form_0, onError, message, fatal, errType){
  sendMessage(form_0, onError, message, 'apiError', errType, fatal, 1, 1, 1);
}

function InvokeFormChooseCallback(form_0, jo, retObj, error, errType, onSuccess, onError){
  if (jo == null || retObj == null) {
    onSrvError(form_0, onError, error, 0, errType);
    return;
  }
  if (retObj.fatalerror && retObj.fatalerror == 1)
    onSrvError(form_0, onError, getErrMsg(retObj), 1, errType);
  else {
    var type_0 = 'None';
    retObj.Search != null?(type_0 = 'Search'):retObj.Choose != null && (type_0 = 'Choose');
    onSrvSuccess_0(form_0, retObj, onSuccess, onError, type_0, null, 0);
  }
}

function InvokeFormSearchActionCallback(form_0, jo, retObj, error, errType, onSuccess, onError){
  if (jo == null || retObj == null) {
    onSrvError(form_0, onError, error, 0, errType);
    return;
  }
  retObj.fatalerror && retObj.fatalerror == 1?onSrvError(form_0, onError, getErrMsg(retObj), 1, errType):onSrvSuccess_0(form_0, retObj, onSuccess, onError, null, null, 0);
}

function InvokeFormStartCallback(form_0, table, jo, retObj, errorMsg, errType, onSuccess, onError){
  if (jo == null || retObj == null) {
    onSrvError(form_0, onError, errorMsg, 0, errType);
    return;
  }
  if (retObj.fatalerror && retObj.fatalerror == 1) {
    onSrvError(form_0, onError, getErrMsg(retObj), 1, errType);
  }
   else {
    var gform = form_0.GetJsTableObject(table);
    gform.session = form_0.getSession();
    var ipmessage = form_0.ipmessage;
    ipmessage && ipmessage != null && sendMessage(form_0, onError, ipmessage, 'error', 'ipwarning', 0, 1, 0, 1);
    onSuccess(gform);
  }
}

function InvokeGetFileContentCallback(form_0, jo, onSuccess, onError){
  var ret = '';
  if (jo.General[0] && jo.General[0].DataUri && jo.General[0].DataUri[0] && jo.General[0].DataUri[0].datauri) {
    ret = jo.General[0].DataUri[0].datauri;
    onSuccess != null && onSuccess(ret);
  }
   else {
    if (onError != null) {
      var table = form_0?form_0.getCurrentTable():0;
      var gform = form_0?form_0.GetJsTableObject(table):null;
      var msg = {};
      msg.type = 'error';
      msg.code = 'fileDownloadFailed';
      msg.message = '';
      msg.form = gform;
      msg.fatal = false;
      onError(msg);
    }
  }
  form_0.ExecuteNextRequest();
}

function InvokeGetFiltersCallback(form_0, jo, onSuccess){
  var resp = {};
  resp.queryFilters = [];
  if (jo && jo.Form && jo.Form[0] && jo.Form[0].QueryDlg) {
    var table = jo.Form[0].Position[0].table;
    var gform = form_0.GetJsTableObject(table);
    for (var i = 0; i < jo.Form[0].QueryDlg.length; i++) {
      resp.queryFilters[i] = {};
      form_0.AddQueryFilter(jo.Form[0].QueryDlg[i], table, gform, resp.queryFilters[i]);
    }
  }
  onSuccess(resp);
  form_0.ExecuteNextRequest();
}

function InvokeIsAliveCallback(form_0, jo, onSuccess){
  var isalive = 0;
  jo.Form && jo.Form.length > 0 && jo.Form[0] && jo.Form[0].isalive == 1 && (isalive = 1);
  onSuccess(isalive);
  form_0.ExecuteNextRequest();
}

function InvokeSaveFilterCallback(form_0, onSuccess){
  onSuccess();
  form_0.ExecuteNextRequest();
}

function InvokeSubFormStartCallback(form_0, table, jo, retObj, errorMsg, errType, onSuccess, onError){
  if (jo == null || retObj == null) {
    onSrvError(form_0, onError, errorMsg, 0, errType);
    return;
  }
  if (retObj.fatalerror && retObj.fatalerror == 1)
    onSrvError(form_0, onError, getErrMsg(retObj), 1, errType);
  else {
    var gform = form_0.GetJsTableObject(table);
    retObj.Warning || retObj.Errors && retObj.Errors.length > 0?onSrvSuccess_0(form_0, retObj, onSuccess, onError, null, null, 1):onSrvSuccess(form_0, gform, onSuccess);
  }
}

function InvokeSuccess(form_0, onSuccess){
  onSrvSuccess(form_0, null, onSuccess);
}

function createJsHelperFunc(){
  $wnd.GMTTime = function(dt){
    var mon = 1 + dt.getUTCMonth();
    mon < 10 && (mon = '0' + mon);
    var day = dt.getUTCDate();
    day < 10 && (day = '0' + day);
    var hours = dt.getUTCHours();
    hours < 10 && (hours = '0' + hours);
    var minutes = dt.getUTCMinutes();
    minutes < 10 && (minutes = '0' + minutes);
    var sec = dt.getUTCSeconds();
    sec < 10 && (sec = '0' + sec);
    var msec = dt.getUTCMilliseconds();
    msec < 10?(msec = '00' + msec):msec < 100 && (msec = '0' + msec);
    var year = dt.getUTCFullYear();
    year < 1900 && (year += 1900);
    return year + '-' + mon + '-' + day + 'T' + hours + ':' + minutes + ':' + sec + '.' + msec + 'Z';
  }
  ;
  $wnd.GMTDates = function(){
    var cr = new Date;
    var exp_0 = new Date(cr);
    exp_0.setMinutes(cr.getMinutes() + 6);
    return '<u:Created>' + $wnd.GMTTime(cr) + '<\/u:Created><u:Expires>' + $wnd.GMTTime(exp_0) + '<\/u:Expires>';
  }
  ;
}

function getErrMsg(retObj){
  return retObj.Errors != null && retObj.Errors.length > 0 && retObj.Errors[0].message != null && retObj.Errors[0].message.length > 0?retObj.Errors[0].message:null;
}

function onSrvError(form_0, onError, message, fatal, errType){
  sendMessage(form_0, onError, message, 'apiError', errType, fatal, 1, 1, 1);
  form_0 && form_0.HandleError();
}

function onSrvSuccess(form_0, gform, onSuccess){
  onSuccess != null && (gform && gform != null?onSuccess(gform):onSuccess());
  form_0.ExecuteNextRequest();
}

function onSrvSuccess_0(form_0, resultObj, onSuccess, onError, par1, par2, fromStartForm){
  var responseVal = resultObj;
  var showMessage = form_0.onShowMessage;
  var updateFieldsFunc;
  form_0.onSuccess = onSuccess;
  form_0.onError = onError;
  form_0.fromStartForm = fromStartForm;
  form_0.lastRetObj = resultObj;
  form_0.lastPar1 = par1;
  form_0.lastPar2 = par2;
  var ipmessage = form_0.ipmessage;
  var table = form_0.getCurrentTable();
  var gform = form_0.GetJsTableObject(table);
  var tableShowMessage = form_0.getTableMessageFunc();
  var tableUpdateFields = form_0.getTableUpdateFieldsFunc();
  tableUpdateFields != null?(updateFieldsFunc = tableUpdateFields):(updateFieldsFunc = form_0.updateFieldsFunc);
  if (resultObj == null) {
    onSuccess != null && onSuccess();
    form_0.ExecuteNextRequest();
    return;
  }
  ipmessage && ipmessage != null && sendMessage(form_0, onError, ipmessage, 'error', 'ipwarning', 0, 1, 0, 1);
  if (resultObj.Errors != null && resultObj.Errors.length > 0) {
    var infoMsg = resultObj.Errors[0].messagetype == 'information';
    !infoMsg && form_0.HandleError();
    var isLast = 0;
    var msg = resultObj.Errors[0].message;
    var msgtype = resultObj.Errors[0].messagetype;
    if (resultObj.Errors.length > 1)
      resultObj.Errors.splice(0, 1);
    else {
      delete responseVal.Errors;
      isLast = 1;
    }
    infoMsg && form_0.WaitForInfoApprove();
    sendMessage(form_0, onError, msg, infoMsg?'information':'error', msgtype, 0, 1, infoMsg?0:1, isLast);
    !infoMsg && resultObj.ReplaceText != null && updateFieldsFunc != null && updateFieldsFunc(resultObj.ReplaceText, gform);
    return;
  }
   else if (resultObj.Warning != null) {
    form_0.WaitForWarningApprove();
    sendMessage(form_0, onError, resultObj.Warning.message, 'warning', resultObj.Warning.messagetype, 0, 1, 0, 1);
    resultObj.ReplaceText != null && updateFieldsFunc != null && updateFieldsFunc(resultObj.ReplaceText, gform);
    return;
  }
   else if (resultObj.ReplaceText != null) {
    updateFieldsFunc != null && updateFieldsFunc(resultObj.ReplaceText, gform);
    delete responseVal.ReplaceText;
  }
   else 
    resultObj.RowsData != null?(responseVal = resultObj.RowsData):resultObj.Choose != null?(responseVal = resultObj.Choose):resultObj.Search != null && (responseVal = resultObj.Search);
  resultObj.ClearLine != null?(responseVal = resultObj.ClearLine):resultObj.NewRow != null && (responseVal = resultObj.NewRow);
  onSuccess != null && onSuccess(responseVal, par1, par2);
  form_0.ExecuteNextRequest();
}

function publishAPIfuncForm(){
  $wnd.formStart = function(formName, onShowMessge, afterMessageShownFunc, dname, autoRetrieveFirstRows, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      FormStart(formName, onShowMessge, afterMessageShownFunc, onSuccess_0, onError_0, autoRetrieveFirstRows, dname, null);
    else 
      return new Promise(function(onSuccess, onError){
        FormStart(formName, onShowMessge, afterMessageShownFunc, onSuccess, onError, autoRetrieveFirstRows, dname, null);
      }
      );
  }
  ;
  $wnd.formStartEx = function(formName, onShowMessge, afterMessageShownFunc, dname, autoRetrieveFirstRows, exParams, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      FormStart(formName, onShowMessge, afterMessageShownFunc, onSuccess_0, onError_0, autoRetrieveFirstRows, dname, exParams, '', '');
    else 
      return new Promise(function(onSuccess, onError){
        FormStart(formName, onShowMessge, afterMessageShownFunc, onSuccess, onError, autoRetrieveFirstRows, dname, exParams, '', '');
      }
      );
  }
  ;
}

function sendMessage(form_0, onError, message, type_0, iconType, fatal, invokeMessage, invokeError, isLast){
  var table = form_0?form_0.getCurrentTable():0;
  var gform = form_0?form_0.GetJsTableObject(table):null;
  var showMessage = form_0?form_0.onShowMessage:null;
  var tableShowMessage = form_0?form_0.getTableMessageFunc():null;
  var msg = {};
  msg.type = type_0;
  msg.code = iconType;
  msg.message = message;
  msg.form = gform;
  msg.fatal = fatal == 1;
  msg.isLast = isLast;
  invokeMessage == 1 && (tableShowMessage != null?tableShowMessage(msg):showMessage != null && showMessage(msg));
  invokeError == 1 && onError(msg);
}

function $CanExecuteNow(this$static, req, executeNow){
  if (executeNow == 1) {
    this$static.isExecutingNow = true;
    return true;
  }
  if (this$static.isExecutingNow && req.type_0 == ($clinit_FormAPIRequest$RequestTypes() , WarningApproved)) {
    if (this$static.isWaitingForWarningApprove) {
      this$static.isWaitingForWarningApprove = false;
      return true;
    }
    $addFirst(this$static.RequestsQueue, req);
    return false;
  }
  if (this$static.RequestsQueue.size_0 > 0 || this$static.isExecutingNow) {
    $offerLast(this$static.RequestsQueue, req);
    return false;
  }
  this$static.isExecutingNow = true;
  return true;
}

function $ExecuteNextRequest(this$static){
  var req;
  this$static.isExecutingNow = false;
  if (this$static.RequestsQueue.size_0 <= 0)
    return;
  req = dynamicCast($pollFirst(this$static.RequestsQueue), 13);
  Printlog('In ExecuteNextRequest: Executing:' + $toString_1(req.type_0));
  switch (req.type_0.ordinal) {
    case 0:
      $SetActiveRow(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 1:
      $FormChoose(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastToString(req.params[1]), dynamicCast(req.params[1], 15).value_0, dynamicCastJso(req.params[3]), dynamicCastJso(req.params[4]), 1);
      break;
    case 23:
      $FormFilterChoose(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastToString(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), 1);
      break;
    case 2:
      $FormSearchAction(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastToString(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), 1);
      break;
    case 24:
      $FormFilterSearchAction(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastToString(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), 1);
      break;
    case 3:
      $FormFieldUpdate(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastToString(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), 1);
      break;
    case 4:
      $FormWarning(this$static.form_0, dynamicCast(req.params[0], 15).value_0, 1);
      break;
    case 5:
      $SaveCurrentRow(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 6:
      $GotoSubForm(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), dynamicCastJso(req.params[4]), 1, dynamicCastJso(req.params[5]));
      break;
    case 7:
      $GetRows(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 8:
      $NewRow(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 9:
      $EndCurrentForm(this$static.form_0, dynamicCast(req.params[0], 38).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 10:
      $Undo(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 11:
      $DelRow(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 12:
      $ClearRows(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 13:
      $SetSearchFilter(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 14:
      $SetSimpleSearchFilter(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 15:
      $ClearSearchFilter(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 16:
      $ActivateStart(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastToString(req.params[2]), dynamicCastToString(req.params[3]), dynamicCastJso(req.params[4]), 1);
      break;
    case 17:
      $ActivateStart(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), null, null, null, 1);
      break;
    case 18:
      $UploadFile_1(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), 1);
      break;
    case 25:
      $UploadDataUrl(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastToString(req.params[1]), dynamicCastJso(req.params[2]), dynamicCastJso(req.params[3]), dynamicCastJso(req.params[4]), 1);
      break;
    case 21:
      $AddText(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCast(req.params[1], 15).value_0, dynamicCast(req.params[2], 15).value_0, dynamicCast(req.params[3], 15).value_0, dynamicCastJso(req.params[4]), dynamicCastJso(req.params[5]), 1);
    case 22:
      $IsAlive(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 26:
      $GetFileContent(this$static.form_0, dynamicCastToString(req.params[0]), dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 27:
      $GetFilters(this$static.form_0, dynamicCastJso(req.params[0]), dynamicCastJso(req.params[1]), 1);
      break;
    case 28:
      $SaveFilter(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastToString(req.params[2]), dynamicCast(req.params[3], 15).value_0, dynamicCastJso(req.params[4]), dynamicCastJso(req.params[5]), 1);
      break;
    case 29:
      $DeleteFilter(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
      break;
    case 30:
      $GetHTMLSignature(this$static.form_0, dynamicCast(req.params[0], 15).value_0, dynamicCastJso(req.params[1]), dynamicCastJso(req.params[2]), 1);
  }
}

function $HandleError(this$static){
  var onError, req;
  this$static.isExecutingNow = false;
  while (this$static.RequestsQueue.size_0 > 0) {
    req = dynamicCast($pollFirst(this$static.RequestsQueue), 13);
    onError = null;
    Printlog('In HandleError: Sending error to request:' + $toString_1(req.type_0));
    switch (req.type_0.ordinal) {
      case 5:
      case 7:
      case 9:
      case 13:
      case 14:
      case 18:
      case 26:
      case 29:
      case 0:
        onError = dynamicCastJso(req.params[2]);
        break;
      case 6:
      case 21:
      case 1:
        onError = dynamicCastJso(req.params[4]);
        break;
      case 2:
      case 24:
      case 3:
      case 23:
        onError = dynamicCastJso(req.params[3]);
        break;
      case 8:
      case 10:
      case 11:
      case 12:
      case 15:
      case 16:
      case 17:
      case 22:
      case 27:
      case 4:
        onError = dynamicCastJso(req.params[1]);
        break;
      case 28:
        onError = dynamicCastJso(req.params[5]);
        break;
      case 30:
        onError = dynamicCastJso(req.params[2]);
    }
    !!onError && InvokeErrorNow(this$static.form_0, onError, 'A previous request has failed, causing all subsequent requests to fail', 0, 'failedPreviousRequest');
  }
}

function FormAPIQueue(form_0){
  this.RequestsQueue = new LinkedList;
  this.form_0 = form_0;
}

defineClass(185, 1, {}, FormAPIQueue);
_.isExecutingNow = false;
_.isWaitingForWarningApprove = false;
var Lcom_priority_app_form_FormAPIQueue_2_classLit = createForClass('com.priority.app.form', 'FormAPIQueue', 185);
function FormAPIRequest(type_0, params){
  this.type_0 = type_0;
  this.params = params;
}

defineClass(13, 1, {13:1}, FormAPIRequest);
var Lcom_priority_app_form_FormAPIRequest_2_classLit = createForClass('com.priority.app.form', 'FormAPIRequest', 13);
function $clinit_FormAPIRequest$RequestTypes(){
  $clinit_FormAPIRequest$RequestTypes = emptyMethod;
  SetActiveRow_0 = new FormAPIRequest$RequestTypes('SetActiveRow', 0, 1);
  Choose_0 = new FormAPIRequest$RequestTypes('Choose', 1, 2);
  SearchAction = new FormAPIRequest$RequestTypes('SearchAction', 2, 3);
  FieldUpdate = new FormAPIRequest$RequestTypes('FieldUpdate', 3, 4);
  WarningApproved = new FormAPIRequest$RequestTypes('WarningApproved', 4, 5);
  SaveRow = new FormAPIRequest$RequestTypes('SaveRow', 5, 6);
  StartSubForm = new FormAPIRequest$RequestTypes('StartSubForm', 6, 7);
  GetRows_0 = new FormAPIRequest$RequestTypes('GetRows', 7, 8);
  NewRow_0 = new FormAPIRequest$RequestTypes('NewRow', 8, 9);
  EndCurrentForm_0 = new FormAPIRequest$RequestTypes('EndCurrentForm', 9, 10);
  Undo_0 = new FormAPIRequest$RequestTypes('Undo', 10, 11);
  DelRow_0 = new FormAPIRequest$RequestTypes('DelRow', 11, 12);
  ClearRows_0 = new FormAPIRequest$RequestTypes('ClearRows', 12, 13);
  SetSearchFilter_0 = new FormAPIRequest$RequestTypes('SetSearchFilter', 13, 14);
  SetSimpleSearchFilter_0 = new FormAPIRequest$RequestTypes('SetSimpleSearchFilter', 14, 15);
  ClearSearchFilter_0 = new FormAPIRequest$RequestTypes('ClearSearchFilter', 15, 16);
  ActivateStart_0 = new FormAPIRequest$RequestTypes('ActivateStart', 16, 17);
  ActivateEnd_0 = new FormAPIRequest$RequestTypes('ActivateEnd', 17, 18);
  UploadFile_1 = new FormAPIRequest$RequestTypes('UploadFile', 18, 19);
  CancelFileUpload = new FormAPIRequest$RequestTypes('CancelFileUpload', 19, 20);
  GetFileUrl_0 = new FormAPIRequest$RequestTypes('GetFileUrl', 20, 21);
  AddText_0 = new FormAPIRequest$RequestTypes('AddText', 21, 22);
  IsAlive_0 = new FormAPIRequest$RequestTypes('IsAlive', 22, 23);
  FilterChoose = new FormAPIRequest$RequestTypes('FilterChoose', 23, 24);
  FilterSearchAction = new FormAPIRequest$RequestTypes('FilterSearchAction', 24, 25);
  UploadDataUrl_0 = new FormAPIRequest$RequestTypes('UploadDataUrl', 25, 26);
  GetFileContent_0 = new FormAPIRequest$RequestTypes('GetFileContent', 26, 27);
  GetFilters_0 = new FormAPIRequest$RequestTypes('GetFilters', 27, 28);
  SaveFilter_0 = new FormAPIRequest$RequestTypes('SaveFilter', 28, 29);
  DeleteFilter_0 = new FormAPIRequest$RequestTypes('DeleteFilter', 29, 30);
  GetHTMLSignature_0 = new FormAPIRequest$RequestTypes('GetHTMLSignature', 30, 31);
}

function FormAPIRequest$RequestTypes(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  $put_0((!mappings_4 && !mappings_4 && (mappings_4 = new HashMap) , mappings_4), valueOf(value_0), this);
}

function values_6(){
  $clinit_FormAPIRequest$RequestTypes();
  return initValues(getClassLiteralForArray(Lcom_priority_app_form_FormAPIRequest$RequestTypes_2_classLit, 1), $intern_5, 12, 0, [SetActiveRow_0, Choose_0, SearchAction, FieldUpdate, WarningApproved, SaveRow, StartSubForm, GetRows_0, NewRow_0, EndCurrentForm_0, Undo_0, DelRow_0, ClearRows_0, SetSearchFilter_0, SetSimpleSearchFilter_0, ClearSearchFilter_0, ActivateStart_0, ActivateEnd_0, UploadFile_1, CancelFileUpload, GetFileUrl_0, AddText_0, IsAlive_0, FilterChoose, FilterSearchAction, UploadDataUrl_0, GetFileContent_0, GetFilters_0, SaveFilter_0, DeleteFilter_0, GetHTMLSignature_0]);
}

defineClass(12, 20, {12:1, 4:1, 25:1, 20:1}, FormAPIRequest$RequestTypes);
var ActivateEnd_0, ActivateStart_0, AddText_0, CancelFileUpload, Choose_0, ClearRows_0, ClearSearchFilter_0, DelRow_0, DeleteFilter_0, EndCurrentForm_0, FieldUpdate, FilterChoose, FilterSearchAction, GetFileContent_0, GetFileUrl_0, GetFilters_0, GetHTMLSignature_0, GetRows_0, IsAlive_0, NewRow_0, SaveFilter_0, SaveRow, SearchAction, SetActiveRow_0, SetSearchFilter_0, SetSimpleSearchFilter_0, StartSubForm, Undo_0, UploadDataUrl_0, UploadFile_1, WarningApproved, mappings_4;
var Lcom_priority_app_form_FormAPIRequest$RequestTypes_2_classLit = createForEnum('com.priority.app.form', 'FormAPIRequest/RequestTypes', 12, values_6);
function FormColumn(zoomname, type_0, width_0, field, hidden, multienv){
  this.field_0 = field;
  this.zoomname_0 = zoomname;
  this.type_0 = type_0;
  this.width_0 = width_0;
  this.hidden_0 = hidden;
  this.multienv_0 = multienv;
  this.isstatus_0 = this.isstatus_0;
}

defineClass(41, 1, {41:1}, FormColumn);
_.field_0 = 0;
_.hidden_0 = 0;
_.isstatus_0 = 0;
_.multienv_0 = 0;
_.width_0 = 0;
var Lcom_priority_app_form_FormColumn_2_classLit = createForClass('com.priority.app.form', 'FormColumn', 41);
function $AddActivationJS(gform, name_0, title_0, etype, background, confirm_0){
  var key = name_0 + '.' + String.fromCharCode(etype);
  gform.activations[key] = {};
  gform.activations[key].title = title_0;
  gform.activations[key].background = background;
  gform.activations[key].confirm = confirm_0;
}

function $AddSubFormJS(gform, name_0, title_0, istext){
  gform.subForms[name_0] = {};
  gform.subForms[name_0].title = title_0;
  istext >= 0 && (gform.subForms[name_0].text = istext);
}

function $AddTableJS(form_0, table, oneline, isquery, ishtml, name_0, title_0, zoomfield){
  var gform = {};
  gform.name = name_0;
  gform.title = title_0;
  gform.subForms = {};
  gform.activations = {};
  gform.columns = {};
  gform.oneline = oneline;
  gform.isquery = isquery;
  gform.ishtml = ishtml;
  gform.zoomfield = zoomfield;
  gform.setActiveRow = function(row, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.SetActiveRow(row, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.SetActiveRow(row, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.chooseModes = {};
  gform.chooseModes.normal = 0;
  gform.chooseModes.full = 1;
  gform.chooseEx = function(fieldName, fieldValue, mode, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormChoose(fieldName, fieldValue, mode, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormChoose(fieldName, fieldValue, mode, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.choose = function(fieldName, fieldValue, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormChoose(fieldName, fieldValue, 0, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormChoose(fieldName, fieldValue, 0, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.filterChoose = function(fieldName, fieldValue, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormFilterChoose(fieldName, fieldValue, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormFilterChoose(fieldName, fieldValue, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.searchAction = function(action, searchText, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormSearchAction(action, searchText, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormSearchAction(action, searchText, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.filterSearchAction = function(action, searchText, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormFilterSearchAction(action, searchText, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormFilterSearchAction(action, searchText, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.fieldUpdate = function(fieldName, fieldValue, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.FormFieldUpdate(fieldName, fieldValue, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.FormFieldUpdate(fieldName, fieldValue, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.warningConfirm = function(ok){
    form_0.FormWarning(ok, 0);
  }
  ;
  gform.infoMsgConfirm = function(){
    form_0.FormWarning(1, 0);
  }
  ;
  gform.saveRow = function(backToParentForm, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.SaveCurrentRow(backToParentForm, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.SaveCurrentRow(backToParentForm, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.startSubForm = function(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.GotoSubForm(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess_0, onError_0, 0, null);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.GotoSubForm(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, 0, null);
      }
      );
    }
  }
  ;
  gform.startSubFormEx = function(formName, onMessageFunc, onUpdateFieldsFunc, exParams, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.GotoSubForm(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess_0, onError_0, 0, exParams);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.GotoSubForm(formName, onMessageFunc, onUpdateFieldsFunc, onSuccess, onError, 0, exParams);
      }
      );
    }
  }
  ;
  gform.getRows = function(fromRow, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.GetRows(fromRow, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.GetRows(fromRow, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.newRow = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.NewRow_0(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.NewRow_0(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.endCurrentForm = function(returnJustThisRow, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.EndCurrentForm(returnJustThisRow, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.EndCurrentForm(returnJustThisRow, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.undo = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.Undo(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.Undo(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.delRow = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.DelRow(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.DelRow(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.clearRows = function(onSuccess_0, onError_0, userState){
    if (onSuccess_0 || onError_0)
      form_0.ClearRows(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.ClearRows(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.setSearchFilter = function(filter, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.SetSearchFilter(filter, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.SetSearchFilter(filter, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.setSimpleSearchFilter = function(filter, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.SetSimpleSearchFilter(filter, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.SetSimpleSearchFilter(filter, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.clearSearchFilter = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.ClearSearchFilter(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.ClearSearchFilter(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.activateStart = function(ename, type_0, onProgress, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.ActivateStart(onSuccess_0, onError_0, ename, type_0, onProgress, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.ActivateStart(onSuccess, onError, ename, type_0, onProgress, 0);
      }
      );
    }
  }
  ;
  gform.activateEnd = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.ActivateEnd(onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.ActivateEnd(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.uploadFile = function(file, onProgress, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.UploadFile_1(file, onProgress, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.UploadFile_1(file, onProgress, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.uploadDataUrl = function(dataUrl, type_0, onProgress, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      form_0.UploadDataUrl(dataUrl, type_0, onProgress, onSuccess_0, onError_0, 0);
    else {
      return new Promise(function(onSuccess, onError){
        form_0.UploadDataUrl(dataUrl, type_0, onProgress, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.cancelFileUpload = function(){
    form_0.isCancelFileUpload = true;
  }
  ;
  gform.getFileUrl = function(file){
    return form_0.GetFileUrl(file);
  }
  ;
  gform.getFileDataUri = function(file, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.GetFileContent(file, onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.GetFileContent(file, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.saveText = function(text_0, addFlag, commentFlag, lang2Flag, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.AddText(text_0, addFlag, commentFlag, lang2Flag, onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.AddText(text_0, addFlag, commentFlag, lang2Flag, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.isAlive = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.IsAlive(onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.IsAlive(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.isSupported = function(funcname){
    return form_0.FormCheckSupported(funcname, null);
  }
  ;
  gform.getFilters = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.GetFilters(onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.GetFilters(onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.saveFilter = function(query, data_0, queryname, isdefault, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.SaveFilter(query, data_0, queryname, isdefault, onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.SaveFilter(query, data_0, queryname, isdefault, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.deleteFilter = function(id_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.DeleteFilter(id_0, onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.DeleteFilter(id_0, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  gform.getHTMLSignature = function(lang2, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      form_0.GetHTMLSignature(lang2, onSuccess_0, onError_0, 0);
    }
     else {
      return new Promise(function(onSuccess, onError){
        form_0.GetHTMLSignature(lang2, onSuccess, onError, 0);
      }
      );
    }
  }
  ;
  table.SetJsTableObject(gform);
}

function $ClearSearchFilter_0(this$static, onSuccess){
  this$static.isAdd = false;
  this$static.filter = null;
  InvokeSuccess(this$static.mainform, onSuccess);
}

function $ComposeText(this$static, curText, textToAdd, addFlag, addSignature, lang2){
  var end, hr, ret, sig, start_0;
  sig = lang2?this$static.EngSignature:this$static.HebSignature;
  start_0 = '';
  end = '';
  if (addSignature) {
    if (!IsNullOrEmpty(sig.date_0)) {
      start_0 += $pGet('<!--pdt-->' + fixtime(sig.date_0, Lang == 3) + '<!--edt-->', lang2);
      start_0 += ($clinit_PriCommon() , '<p dir=' + (Lang == 1 && !lang2?'rtl':'ltr') + '>' + '&nbsp;' + '<\/p>\n');
    }
    end += ($clinit_PriCommon() , '<p dir=' + (Lang == 1 && !lang2?'rtl':'ltr') + '>' + '&nbsp;' + '<\/p>\n' + $pGet('<!--psi-->' + (IsNullOrEmpty(sig.message_0)?'':sig.message_0), lang2) + $pGet(sig.name_0, lang2) + $pGet(sig.position_0, lang2) + $pGet(sig.email_0, lang2) + $pGet(sig.phone_0, lang2) + $pGet(sig.cellphone_0, lang2) + $pGet(sig.dept_0, lang2) + $pGet(sig.branch_0, lang2) + $pGet((IsNullOrEmpty(sig.company_0)?'':sig.company_0) + '<!--esi-->', lang2));
  }
  hr = addSignature && sig.hr_0 == 1?'<hr id="newcomment"/>':'';
  sig.begin_0 == 1?(ret = start_0 + ($clinit_PriCommon() , textToAdd == null || textToAdd.length == 0?'':'<p dir=' + (Lang == 1 && !lang2?'rtl':'ltr') + '>' + textToAdd + '<\/p>\n') + end + hr + (addFlag?curText:'')):(ret = (addFlag?curText:'') + hr + start_0 + ($clinit_PriCommon() , textToAdd == null || textToAdd.length == 0?'':'<p dir=' + (Lang == 1 && !lang2?'rtl':'ltr') + '>' + textToAdd + '<\/p>\n') + end);
  return ret;
}

function $CreateMemento(this$static){
  return $CreateMemento_0(this$static, ($clinit_PriKeys() , None_4), this$static.curfield, this$static.rowInData, $CurFieldVal(this$static));
}

function $CreateMemento_0(this$static, key, field, row, value_0){
  return new FormTableMemento(field, row, value_0, this$static._isQueryMode?-1:1, key);
}

function $CurFieldVal(this$static){
  var fc;
  fc = $getCol(this$static, this$static.curfield);
  if (!!fc && fc.type_0 == 'date')
    return ISOToDate(fc.width_0, this$static.curfieldval);
  return this$static.curfieldval;
}

function $GetHTMLSignature_0(this$static, lang2){
  var sig = {};
  sig.html = this$static.ComposeText('', '', false, true, lang2);
  sig.top = this$static.IsSignatureOnTop(lang2);
  return sig;
}

function $SetCurRowInData(this$static, row){
  this$static.rowInData = row;
}

function $SetField(this$static, field, value_0){
  this$static.curfield = field;
  this$static.curfieldval = value_0;
}

function $SetSearchFilter_0(this$static, filter, onSuccess, onError){
  var fixed_0;
  this$static.isAdd = false;
  fixed_0 = FixFilter_0(filter, this$static.table_0, this$static.mainform, onError);
  this$static.filter = fixed_0;
  InvokeSuccess(this$static.mainform, onSuccess);
}

function $SetSimpleSearchFilter_0(this$static, filter, onSuccess, onError){
  var jfilter;
  this$static.isAdd = false;
  if (filter == null || filter.length <= 0) {
    InvokeError(this$static.mainform, onError, 'Invalid filter.', 'invalidFilter', false);
    return;
  }
  if (filter == null || filter.length <= 0) {
    InvokeError(this$static.mainform, onError, 'Invalid filter.', 'invalidFilter', false);
    return;
  }
  jfilter = BuildFilter(filter, this$static.table_0, this$static.mainform);
  if (!jfilter) {
    InvokeError(this$static.mainform, onError, 'Invalud filter.', 'invalidFilter', false);
    return;
  }
  this$static.filter = jfilter;
  InvokeSuccess(this$static.mainform, onSuccess);
}

function $getCol(this$static, field){
  return dynamicCast($get_1(this$static.FormColumnsI, valueOf(field)), 41);
}

function $getCol_0(this$static, fieldName){
  return dynamicCast($getStringValue(this$static.FormColumns, fieldName), 41);
}

function $pGet(str, lang2){
  return $clinit_PriCommon() , str == null || str.length == 0?'':'<p dir=' + (Lang == 1 && !lang2?'rtl':'ltr') + '>' + str + '<\/p>\n';
}

function $setAdd(this$static, add_0){
  this$static.isAdd = add_0;
}

function BuildFilter(filter, table, form_0){
  var gform = form_0.GetJsTableObject(table);
  if (!gform)
    return null;
  var filt = {};
  filt.or = 1;
  filt.ignorecase = 1;
  filt.QueryValues = [];
  var col = 0;
  for (var colname in gform.columns) {
    if (colname) {
      if (gform.columns[colname].searchfield == 1 && gform.columns[colname].field > 0) {
        filt.QueryValues[col] = {};
        filt.QueryValues[col].field = gform.columns[colname].field;
        filt.QueryValues[col].fromval = filter + '*';
        filt.QueryValues[col].toval = '';
        filt.QueryValues[col].op = '=';
        filt.QueryValues[col].sort = 0;
        filt.QueryValues[col].isdesc = 0;
        col++;
      }
    }
  }
  if (filt.QueryValues.length <= 0)
    return null;
  return filt;
}

function FixFilter(filter, table, form_0){
  var gform = form_0.GetJsTableObject(table);
  if (!gform || filter == null)
    return null;
  if (!filter.QueryValues || filter.QueryValues.length <= 0)
    return null;
  for (var i = 0; i < filter.QueryValues.length; i++) {
    var colname = filter.QueryValues[i].field;
    var val = filter.QueryValues[i].fromval;
    if (val && val.length > 0) {
      if (!colname || !gform.columns[colname] || !gform.columns[colname].field || gform.columns[colname].field <= 0) {
        return null;
      }
      var fixedval = FixFilterValues(val, gform.columns[colname]);
      if (!fixedval || fixedval.length <= 0)
        return null;
      if (gform.columns[colname].type == 'date') {
        var err = ISOToDateErr(fixedval);
        if (err != null) {
          filter.errorVal = val;
          filter.errorDes = err;
          return null;
        }
      }
      filter.QueryValues[i].fromval = fixedval;
    }
    var toval = filter.QueryValues[i].toval;
    if (toval && toval.length > 0) {
      fixedval = FixFilterValues(toval, gform.columns[colname]);
      if (gform.columns[colname].type == 'date') {
        var err = ISOToDateErr(fixedval);
        if (err != null) {
          filter.errorVal = toval;
          filter.errorDes = err;
          return null;
        }
      }
      if (!fixedval || fixedval.length <= 0)
        return null;
      filter.QueryValues[i].toval = fixedval;
    }
    filter.QueryValues[i].field = gform.columns[colname].field;
  }
  if (filter.QueryValues.length <= 0)
    return null;
  return filter;
}

function FixFilter_0(filter, table, form_0, onError){
  var fixed_0;
  fixed_0 = FixFilter(filter, table, form_0);
  !!filter && !fixed_0 && (GetErrFilterField(filter) != null?InvokeError(form_0, onError, GetErrFilterField(filter), 'badDateFormat', false):InvokeError(form_0, onError, 'Invalid filter.', 'invalidFilter', false));
  return fixed_0;
}

function FixFilterValue(value_0, col){
  var dtval = value_0;
  col.type == 'date' && (dtval = ISOToDate(col.maxLength, value_0));
  return dtval;
}

function FixFilterValues(value_0, col){
  var ret = '';
  if (!value_0 || value_0 == null || value_0.length <= 0)
    return null;
  if (typeof value_0 === 'string' || value_0 instanceof String)
    ret = FixFilterValue(value_0, col);
  else {
    for (var j = 0; j < value_0.length; j++) {
      var curval = FixFilterValue(value_0[j], col);
      if (col.type == 'date' && ISOToDateErr(curval) != null)
        return curval;
      if (curval) {
        j > 0 && (ret += '\n');
        ret += curval;
      }
    }
  }
  return ret;
}

function FormTable(mainform, table, title_0, name_0, level, self_0, ishtml, oneline, isquery, zoomfield){
  this.FormColumns = new HashMap;
  this.FormColumnsI = new HashMap;
  this.SubForms = new HashMap;
  this.Activations = new HashMap;
  this.mainform = mainform;
  this.table_0 = table;
  this.level_0 = level;
  this.self_0 = self_0;
  this.ishtml_0 = ishtml;
  $AddTableJS(mainform, this, oneline, isquery, ishtml, name_0, title_0, zoomfield);
}

function GetErrFilterField(obj){
  if (obj.errorVal)
    return obj.errorDes + ' (' + obj.errorVal + ')';
  return null;
}

function fixtime(str, ampm){
  var time = new Date;
  var hour = time.getHours();
  var ampms;
  var hm;
  if (ampm) {
    ampms = hour >= 12?'PM':'AM';
    hour == 0?(hour = 12):hour > 12 && (hour -= 12);
  }
  hour < 10 && (hour = '0' + hour);
  var minu = time.getMinutes();
  minu < 10 && (minu = '0' + minu);
  hm = hour + ':' + minu + (ampm?' ' + ampms:'');
  return str.replace('HH:MM', hm);
}

defineClass(21, 1, {21:1}, FormTable);
_.ComposeText = function ComposeText(curText, textToAdd, addFlag, addSignature, lang2){
  return $ComposeText(this, curText, textToAdd, addFlag, addSignature, lang2);
}
;
_.IsSignatureOnTop = function IsSignatureOnTop(lang2){
  var sig;
  sig = lang2?this.EngSignature:this.HebSignature;
  return sig.begin_0;
}
;
_.SetJsTableObject = function SetJsTableObject(jsTableObject){
  this.jsTableObject = jsTableObject;
}
;
_._isQueryMode = false;
_.curfield = 0;
_.filter = null;
_.isAdd = false;
_.isEdit = 0;
_.ishtml_0 = 0;
_.jsTableObject = null;
_.level_0 = 0;
_.line_0 = 0;
_.lines_0 = 0;
_.onShowMessage = null;
_.rowInData = 0;
_.rowcount = 0;
_.self_0 = 0;
_.table_0 = 0;
_.tsline_0 = 0;
_.updateFieldsFunc = null;
var Lcom_priority_app_form_FormTable_2_classLit = createForClass('com.priority.app.form', 'FormTable', 21);
function FormTable$Signature(date, name_0, hr, begin, position, email, phone, message, cellphone, branch, dept, company){
  this.date_0 = removeQuote(date);
  this.name_0 = removeQuote(name_0);
  this.hr_0 = hr;
  this.begin_0 = begin;
  this.position_0 = removeQuote(position);
  this.email_0 = removeQuote(email);
  this.phone_0 = removeQuote(phone);
  this.message_0 = removeQuote(message);
  this.cellphone_0 = removeQuote(cellphone);
  this.branch_0 = removeQuote(branch);
  this.dept_0 = removeQuote(dept);
  this.company_0 = removeQuote(company);
}

function removeQuote(str){
  if (str == null)
    return str;
  return str.replace(/\\'/g, "'");
}

defineClass(79, 1, {}, FormTable$Signature);
_.begin_0 = 0;
_.hr_0 = 0;
var Lcom_priority_app_form_FormTable$Signature_2_classLit = createForClass('com.priority.app.form', 'FormTable/Signature', 79);
function FormTableMemento(currentFieldNum, currentLine, currentFieldValue, isActive, key){
  this.m_key = values_7()[0];
  $clinit_PriCommon();
  isDebugging && $log_1(logger_0, ($clinit_Level() , ALL), 'FormTableMemento. currentFieldNum: ' + currentFieldNum + '\ncurrentLine: ' + currentLine + '\ncurrentTab: ' + '0' + '\ncurrentFieldValue: ' + currentFieldValue + '\nisActive: ' + isActive + '\nkey: ' + key);
  this.m_currentFieldNum = currentFieldNum;
  this.m_currentLine = currentLine;
  this.m_currentTab = {l:0, m:0, h:0};
  this.m_currentFieldValue = currentFieldValue;
  this.m_isActive = isActive;
  this.m_key = key;
}

defineClass(63, 1, {63:1}, FormTableMemento);
_.m_currentFieldNum = 0;
_.m_currentLine = 0;
_.m_currentTab = {l:0, m:0, h:0};
_.m_isActive = 0;
var Lcom_priority_app_form_FormTableMemento_2_classLit = createForClass('com.priority.app.form', 'FormTableMemento', 63);
function $ToStringData(this$static, session, currState){
  var jop, op, op$iterator, opTable, opsTable, retData, ses, tableState;
  tableState = new JSONObject;
  opTable = new JSONArray;
  opsTable = new JSONArray;
  $put(tableState, 'Operations', opsTable);
  $put(tableState, 'Operation', opTable);
  ses = new JSONObject;
  $put(ses, 'session', new JSONString(session));
  $set(opsTable, opsTable.jsArray.length, ses);
  $add(this$static.operations, currState);
  if (this$static.operations.array.length > 0) {
    for (op$iterator = new AbstractList$IteratorImpl(this$static.operations); op$iterator.i < op$iterator.this$01.size_1();) {
      op = (checkCriticalElement(op$iterator.i < op$iterator.this$01.size_1()) , dynamicCast(op$iterator.this$01.get_1(op$iterator.i++), 63));
      jop = new JSONObject;
      $put(jop, 'field', new JSONString('' + op.m_currentFieldNum));
      $put(jop, 'line', new JSONString('' + op.m_currentLine));
      $put(jop, 'curtab', new JSONString('' + toString_9(op.m_currentTab)));
      $put(jop, 'value', new JSONString(op.m_currentFieldValue));
      $put(jop, 'active', new JSONString('' + op.m_isActive));
      $put(jop, 'key', new JSONString('' + toString_9(fromInt(-op.m_key.intValue))));
      $set(opTable, opTable.jsArray.length, jop);
    }
  }
   else {
    jop = new JSONObject;
    $put(jop, 'field', new JSONString('0'));
    $put(jop, 'line', new JSONString('0'));
    $put(jop, 'curtab', new JSONString('0'));
    $put(jop, 'value', new JSONString(''));
    $put(jop, 'active', new JSONString('1'));
    $put(jop, 'key', new JSONString('0'));
    $set(opTable, opTable.jsArray.length, jop);
  }
  retData = $toString_0(tableState);
  this$static.operations.array = initDim(Ljava_lang_Object_2_classLit, $intern_5, 1, 0, 3, 1);
  return retData;
}

function FormTableOperations(){
  this.operations = new ArrayList;
}

defineClass(186, 1, {}, FormTableOperations);
var Lcom_priority_app_form_FormTableOperations_2_classLit = createForClass('com.priority.app.form', 'FormTableOperations', 186);
function $clinit_PriKeys(){
  $clinit_PriKeys = emptyMethod;
  QueryIncr = new PriKeys('QueryIncr', 0, -5);
  QueryDecr = new PriKeys('QueryDecr', 1, -6);
  QueryEnd = new PriKeys('QueryEnd', 2, -7);
  FormBrother = new PriKeys('FormBrother', 3, -8);
  SaveHtml = new PriKeys('SaveHtml', 4, -10);
  FormZoom = new PriKeys('FormZoom', 5, -18);
  FormNavigateBack = new PriKeys('FormNavigateBack', 6, -27);
  PrevReturn = new PriKeys('PrevReturn', 7, -29);
  DebugMode = new PriKeys('DebugMode', 8, -32);
  SendLink = new PriKeys('SendLink', 9, -31);
  RestoreColumnWidths = new PriKeys('RestoreColumnWidths', 10, -33);
  FullZoom = new PriKeys('FullZoom', 11, -38);
  NotifyViewChange = new PriKeys('NotifyViewChange', 12, -39);
  CopyRecordLink = new PriKeys('CopyRecordLink', 13, -40);
  SaveChoose = new PriKeys('SaveChoose', 14, -43);
  MailTaskUsers = new PriKeys('MailTaskUsers', 15, -45);
  SendLabels = new PriKeys('SendLabels', 16, -46);
  GoogleMaps = new PriKeys('GoogleMaps', 17, -48);
  RefreshTimer = new PriKeys('RefreshTimer', 18, -51);
  SetFollowup = new PriKeys('SetFollowup', 19, -52);
  UnsetFollowup = new PriKeys('UnsetFollowup', 20, -52);
  SaveRow_0 = new PriKeys('SaveRow', 21, -78);
  DocDetails = new PriKeys('DocDetails', 22, -135);
  None_4 = new PriKeys('None', 23, 0);
  Return = new PriKeys('Return', 24, 4);
  Tab = new PriKeys('Tab', 25, 5);
  Up = new PriKeys('Up', 26, 6);
  Down = new PriKeys('Down', 27, 7);
  Right = new PriKeys('Right', 28, 8);
  Left = new PriKeys('Left', 29, 9);
  Del = new PriKeys('Del', 30, 10);
  Cont = new PriKeys('Cont', 31, 11);
  Srch = new PriKeys('Srch', 32, 12);
  App_0 = new PriKeys('App', 33, 13);
  Blk = new PriKeys('Blk', 34, 14);
  DefaultSubLevel = new PriKeys('DefaultSubLevel', 35, 15);
  Backs = new PriKeys('Backs', 36, 16);
  Allbacks = new PriKeys('Allbacks', 37, 17);
  Do = new PriKeys('Do', 38, 18);
  Hebeng = new PriKeys('Hebeng', 39, 19);
  Ins = new PriKeys('Ins', 40, 20);
  Copyf = new PriKeys('Copyf', 41, 21);
  Copyc = new PriKeys('Copyc', 42, 22);
  Setval = new PriKeys('Setval', 43, 23);
  Getval = new PriKeys('Getval', 44, 24);
  Help = new PriKeys('Help', 45, 25);
  Undo_1 = new PriKeys('Undo', 46, 26);
  Learn = new PriKeys('Learn', 47, 27);
  Autofill = new PriKeys('Autofill', 48, 28);
  Tquery = new PriKeys('Tquery', 49, 29);
  Total = new PriKeys('Total', 50, 30);
  Npage = new PriKeys('Npage', 51, 31);
  Ppage = new PriKeys('Ppage', 52, 32);
  Draw = new PriKeys('Draw', 53, 33);
  Prnt = new PriKeys('Prnt', 54, 34);
  Downfirst = new PriKeys('Downfirst', 55, 35);
  SubLevels = new PriKeys('SubLevels', 56, 36);
  Splitdef = new PriKeys('Splitdef', 57, 37);
  Clnln = new PriKeys('Clnln', 58, 38);
  Clntb = new PriKeys('Clntb', 59, 39);
  Lputscr = new PriKeys('Lputscr', 60, 40);
  Lgetscr = new PriKeys('Lgetscr', 61, 41);
  Hebengs = new PriKeys('Hebengs', 62, 42);
  Repins = new PriKeys('Repins', 63, 43);
  Activations = new PriKeys('Activations', 64, 44);
  Gotolin = new PriKeys('Gotolin', 65, 45);
  Gotolinn = new PriKeys('Gotolinn', 66, 46);
  FullMultiRecord = new PriKeys('FullMultiRecord', 67, 47);
  Element_0 = new PriKeys('Element', 68, 48);
  Begin = new PriKeys('Begin', 69, 49);
  Dolearn = new PriKeys('Dolearn', 70, 50);
  Lstlearn = new PriKeys('Lstlearn', 71, 51);
  Lstval = new PriKeys('Lstval', 72, 52);
  Lstscr = new PriKeys('Lstscr', 73, 53);
  Nframe = new PriKeys('Nframe', 74, 54);
  Pframe = new PriKeys('Pframe', 75, 55);
  Select_0 = new PriKeys('Select', 76, 56);
  Tabhelp = new PriKeys('Tabhelp', 77, 57);
  Refresh = new PriKeys('Refresh', 78, 58);
  Activate = new PriKeys('Activate', 79, 59);
  Gotopos = new PriKeys('Gotopos', 80, 60);
  Home = new PriKeys('Home', 81, 61);
  End = new PriKeys('End', 82, 62);
  Top = new PriKeys('Top', 83, 63);
  Bottom = new PriKeys('Bottom', 84, 64);
  Oneline = new PriKeys('Oneline', 85, 65);
  Printtofile = new PriKeys('Printtofile', 86, 66);
  Execute = new PriKeys('Execute', 87, 67);
  Phone = new PriKeys('Phone', 88, 68);
  Sort = new PriKeys('Sort', 89, 69);
  Wdel = new PriKeys('Wdel', 90, 70);
  Enlarge = new PriKeys('Enlarge', 91, 71);
  Mailinter = new PriKeys('Mailinter', 92, 72);
  Movetab = new PriKeys('Movetab', 93, 73);
  Splitempty = new PriKeys('Splitempty', 94, 74);
  DlgQuery = new PriKeys('DlgQuery', 95, 75);
  Execform = new PriKeys('Execform', 96, 76);
  Scroll = new PriKeys('Scroll', 97, 77);
  SelectAll = new PriKeys('SelectAll', 98, 78);
  StoreRecords = new PriKeys('StoreRecords', 99, 79);
  RetrieveRecords = new PriKeys('RetrieveRecords', 100, 80);
  IncrDecrValue = new PriKeys('IncrDecrValue', 101, 81);
  Macro = new PriKeys('Macro', 102, 82);
  ExecuteQuery = new PriKeys('ExecuteQuery', 103, 83);
  DlgBusiness = new PriKeys('DlgBusiness', 104, 84);
  DlgData = new PriKeys('DlgData', 105, 85);
  DlgFields = new PriKeys('DlgFields', 106, 86);
  DlgDirectActivations = new PriKeys('DlgDirectActivations', 107, 87);
  DlgSubLevels = new PriKeys('DlgSubLevels', 108, 88);
  RowColors = new PriKeys('RowColors', 109, 89);
  MacroList = new PriKeys('MacroList', 110, 90);
  DlgMultiComp = new PriKeys('DlgMultiComp', 111, 91);
  AttachActivateApp = new PriKeys('AttachActivateApp', 112, 92);
  AttachBrowse = new PriKeys('AttachBrowse', 113, 93);
  AttachImport = new PriKeys('AttachImport', 114, 94);
  AttachPasteImport = new PriKeys('AttachPasteImport', 115, 95);
  AttachClear = new PriKeys('AttachClear', 116, 96);
  AttachDelete = new PriKeys('AttachDelete', 117, 97);
  AttachSaveAs = new PriKeys('AttachSaveAs', 118, 98);
  AttachHelp = new PriKeys('AttachHelp', 119, 99);
  ShiftDo = new PriKeys('ShiftDo', 120, 100);
  ExecuteDirectAct = new PriKeys('ExecuteDirectAct', 121, 101);
  GotoSubForm_0 = new PriKeys('GotoSubForm', 122, 102);
  Navigate = new PriKeys('Navigate', 123, 103);
  SendExcel = new PriKeys('SendExcel', 124, 104);
  DesignExcel = new PriKeys('DesignExcel', 125, 105);
  SaveExcel = new PriKeys('SaveExcel', 126, 106);
  FormFontSize = new PriKeys('FormFontSize', 127, 107);
  CopyColumn = new PriKeys('CopyColumn', 128, 108);
  PasteColumn = new PriKeys('PasteColumn', 129, 109);
  Skype = new PriKeys('Skype', 130, 110);
  Messenger = new PriKeys('Messenger', 131, 111);
  Dialer = new PriKeys('Dialer', 132, 112);
  Calculator = new PriKeys('Calculator', 133, 113);
  MacroRecStart = new PriKeys('MacroRecStart', 134, 114);
  MacroRecStop = new PriKeys('MacroRecStop', 135, 115);
  RunApp = new PriKeys('RunApp', 136, 116);
  Browse = new PriKeys('Browse', 137, 117);
  Clnfld = new PriKeys('Clnfld', 138, 118);
  Pastec = new PriKeys('Pastec', 139, 119);
  SendWord = new PriKeys('SendWord', 140, 120);
  DesignWord = new PriKeys('DesignWord', 141, 121);
  SubLevelsQuery = new PriKeys('SubLevelsQuery', 142, 122);
  DefaultSubLevelQuery = new PriKeys('DefaultSubLevelQuery', 143, 123);
  MailInterface = new PriKeys('MailInterface', 144, 124);
  PasteOnServer = new PriKeys('PasteOnServer', 145, 125);
  AttachDuplicate = new PriKeys('AttachDuplicate', 146, 126);
  AutoSaveHtml = new PriKeys('AutoSaveHtml', 147, 127);
  Enter = new PriKeys('Enter', 148, 128);
  DynamicKeyboard = new PriKeys('DynamicKeyboard', 149, 129);
}

function PriKeys(enum$name, enum$ordinal, value_0){
  Enum.call(this, enum$name, enum$ordinal);
  this.intValue = value_0;
  $put_0((!mappings_5 && !mappings_5 && (mappings_5 = new HashMap) , mappings_5), valueOf(value_0), this);
}

function values_7(){
  $clinit_PriKeys();
  return initValues(getClassLiteralForArray(Lcom_priority_app_form_PriKeys_2_classLit, 1), $intern_5, 3, 0, [QueryIncr, QueryDecr, QueryEnd, FormBrother, SaveHtml, FormZoom, FormNavigateBack, PrevReturn, DebugMode, SendLink, RestoreColumnWidths, FullZoom, NotifyViewChange, CopyRecordLink, SaveChoose, MailTaskUsers, SendLabels, GoogleMaps, RefreshTimer, SetFollowup, UnsetFollowup, SaveRow_0, DocDetails, None_4, Return, Tab, Up, Down, Right, Left, Del, Cont, Srch, App_0, Blk, DefaultSubLevel, Backs, Allbacks, Do, Hebeng, Ins, Copyf, Copyc, Setval, Getval, Help, Undo_1, Learn, Autofill, Tquery, Total, Npage, Ppage, Draw, Prnt, Downfirst, SubLevels, Splitdef, Clnln, Clntb, Lputscr, Lgetscr, Hebengs, Repins, Activations, Gotolin, Gotolinn, FullMultiRecord, Element_0, Begin, Dolearn, Lstlearn, Lstval, Lstscr, Nframe, Pframe, Select_0, Tabhelp, Refresh, Activate, Gotopos, Home, End, Top, Bottom, Oneline, Printtofile, Execute, Phone, Sort, Wdel, Enlarge, Mailinter, Movetab, Splitempty, DlgQuery, Execform, Scroll, SelectAll, StoreRecords, RetrieveRecords, IncrDecrValue, Macro, ExecuteQuery, DlgBusiness, DlgData, DlgFields, DlgDirectActivations, DlgSubLevels, RowColors, MacroList, DlgMultiComp, AttachActivateApp, AttachBrowse, AttachImport, AttachPasteImport, AttachClear, AttachDelete, AttachSaveAs, AttachHelp, ShiftDo, ExecuteDirectAct, GotoSubForm_0, Navigate, SendExcel, DesignExcel, SaveExcel, FormFontSize, CopyColumn, PasteColumn, Skype, Messenger, Dialer, Calculator, MacroRecStart, MacroRecStop, RunApp, Browse, Clnfld, Pastec, SendWord, DesignWord, SubLevelsQuery, DefaultSubLevelQuery, MailInterface, PasteOnServer, AttachDuplicate, AutoSaveHtml, Enter, DynamicKeyboard]);
}

defineClass(3, 20, {3:1, 4:1, 25:1, 20:1}, PriKeys);
_.intValue = 0;
var Activate, Activations, Allbacks, App_0, AttachActivateApp, AttachBrowse, AttachClear, AttachDelete, AttachDuplicate, AttachHelp, AttachImport, AttachPasteImport, AttachSaveAs, AutoSaveHtml, Autofill, Backs, Begin, Blk, Bottom, Browse, Calculator, Clnfld, Clnln, Clntb, Cont, CopyColumn, CopyRecordLink, Copyc, Copyf, DebugMode, DefaultSubLevel, DefaultSubLevelQuery, Del, DesignExcel, DesignWord, Dialer, DlgBusiness, DlgData, DlgDirectActivations, DlgFields, DlgMultiComp, DlgQuery, DlgSubLevels, Do, DocDetails, Dolearn, Down, Downfirst, Draw, DynamicKeyboard, Element_0, End, Enlarge, Enter, Execform, Execute, ExecuteDirectAct, ExecuteQuery, FormBrother, FormFontSize, FormNavigateBack, FormZoom, FullMultiRecord, FullZoom, Getval, GoogleMaps, GotoSubForm_0, Gotolin, Gotolinn, Gotopos, Hebeng, Hebengs, Help, Home, IncrDecrValue, Ins, Learn, Left, Lgetscr, Lputscr, Lstlearn, Lstscr, Lstval, Macro, MacroList, MacroRecStart, MacroRecStop, MailInterface, MailTaskUsers, Mailinter, Messenger, Movetab, Navigate, Nframe, None_4, NotifyViewChange, Npage, Oneline, PasteColumn, PasteOnServer, Pastec, Pframe, Phone, Ppage, PrevReturn, Printtofile, Prnt, QueryDecr, QueryEnd, QueryIncr, Refresh, RefreshTimer, Repins, RestoreColumnWidths, RetrieveRecords, Return, Right, RowColors, RunApp, SaveChoose, SaveExcel, SaveHtml, SaveRow_0, Scroll, Select_0, SelectAll, SendExcel, SendLabels, SendLink, SendWord, SetFollowup, Setval, ShiftDo, Skype, Sort, Splitdef, Splitempty, Srch, StoreRecords, SubLevels, SubLevelsQuery, Tab, Tabhelp, Top, Total, Tquery, Undo_1, UnsetFollowup, Up, Wdel, mappings_5;
var Lcom_priority_app_form_PriKeys_2_classLit = createForEnum('com.priority.app.form', 'PriKeys', 3, values_7);
function SubForm(self_0){
  this.self_0 = self_0;
}

defineClass(55, 1, {55:1}, SubForm);
_.self_0 = 0;
var Lcom_priority_app_form_SubForm_2_classLit = createForClass('com.priority.app.form', 'SubForm', 55);
function $$init(this$static){
}

function $ExtMessagesAdd(retObj, num, message){
  var msg = {};
  msg.num = num;
  msg.message = message;
  retObj.entMessages.push(msg);
}

function $ExtMessagesStart(){
  var retObj = {};
  retObj.entMessages = [];
  return retObj;
}

function $GetConnection_0(this$static){
  this$static.con = GetWCFServiceClient(this$static);
  return this$static.con;
}

function $LoginB(this$static, username, pwd, accessToken, computerName, windowsUserName, authAudience, onSuccess, onError){
  var con;
  SetWCFServiceClientParams(username, pwd, accessToken, computerName, windowsUserName, authAudience);
  ($clinit_PriCommon() , AppMain).con = null;
  con = (this$static.con = GetWCFServiceClient(this$static) , this$static.con);
  $GetFileVersion(con, new PriorityApp$1(this$static, con, onSuccess, onError));
}

function $LoginC(this$static, onSuccess, onError){
  var con;
  con = (this$static.con = GetWCFServiceClient(this$static) , this$static.con);
  $GeneralValidPasswordMobAsync(con, Pwd, new PriorityApp$2(this$static, con, this$static, onSuccess, onError));
}

function $MainCheckSupported(funcname, onError){
  var ver;
  ver = FuncSupportedFromVersion(1, funcname);
  if (ver == 0)
    return true;
  !!onError && InvokeError_0(($clinit_PriCommon() , 'This feature is supported from web-sdk patch version ' + ver), onError, 'notSupportedInThisPriorityVersion', 'apiError');
  return false;
}

function $getConstantInt(name_0, defaultValue){
  var num, val;
  if (!cachedConstants)
    return defaultValue;
  val = $get_0(cachedConstants, name_0);
  if (!val)
    return defaultValue;
  num = val.isNumber();
  if (!num)
    return defaultValue;
  return round_int(num.value_0);
}

function $getConstantString(name_0, defaultValue){
  var str, val;
  if (!cachedConstants)
    return defaultValue;
  val = $get_0(cachedConstants, name_0);
  if (!val)
    return defaultValue;
  str = val.isString();
  if (!str)
    return defaultValue;
  return str.value_0;
}

function $onModuleLoad_1(this$static){
  $clinit_PriCommon();
  AppMain = this$static;
  createJsHelperFunc();
  publishAPIfuncForm();
  publishAPIfuncProc();
  publishAPIfuncMain(this$static);
}

function ChangePasswordNative(newPwd, confirmNewPwd, oldPwd, mainApp, resolve, reject){
  function onSuccess_3(result_3){
    var messages = result_3.entMessages;
    function onSuccess_2(result_2){
      var Input_0 = {};
      Input_0.EditFields = [];
      Input_0.EditFields[0] = {};
      Input_0.EditFields[0].field = 1;
      Input_0.EditFields[0].value = newPwd;
      Input_0.EditFields[1] = {};
      Input_0.EditFields[1].field = 2;
      Input_0.EditFields[1].value = confirmNewPwd;
      Input_0.EditFields[2] = {};
      Input_0.EditFields[2].field = 3;
      Input_0.EditFields[2].value = oldPwd;
      function onSuccess_1(result_1){
        function onSuccess_0(result_0){
          function onSuccess(result){
            var main = {};
            main.type = 'apiError';
            main.code = 'changePasswordFailed';
            main.message = msgtext;
            reject(main);
          }

          function onError(error){
            var main = {};
            main.type = 'apiError';
            main.code = 'changePasswordFailed';
            main.message = msgtext;
            reject(main);
          }

          if (result_0.type == 'end') {
            if (msgtext == messages[5].message || msgtext == messages[13].message)
              resolve(msgtext);
            else {
              var main_0 = {};
              main_0.type = 'apiError';
              main_0.code = 'changePasswordFailed';
              main_0.message = msgtext;
              reject(main_0);
            }
          }
           else {
            result_0.proc.inputFields(0, null, onSuccess, onError);
          }
        }

        function onError_0(error){
          var main = {};
          main.type = 'apiError';
          main.code = 'changePasswordFailed';
          main.message = error.text;
          reject(main);
        }

        if (result_1.type == 'message') {
          var msgtext = result_1.message;
          result_1.proc.message(1, onSuccess_0, onError_0);
        }
      }

      function onError_1(error){
        var main = {};
        main.type = 'apiError';
        main.code = 'changePasswordFailed';
        main.message = error.text;
        reject(main);
      }

      result_2.proc.inputFields(1, Input_0, onSuccess_1, onError_1);
    }

    function onError_2(error){
      var main = {};
      main.type = 'apiError';
      main.code = 'changePasswordFailed';
      main.message = error.text;
      reject(main);
    }

    $wnd.procStart('CHPWD2', 'P', null, null, onSuccess_2, onError_2);
  }

  function onError_3(error){
    var main = {};
    main.type = 'apiError';
    main.code = 'changePasswordFailed';
    main.message = 'change password failed';
    reject(main);
  }

  mainApp.EntMessages('CHPWD', 'C', 1, 14, onSuccess_3, onError_3);
}

function GetLoginDName(conf){
  if (conf == null || !conf)
    return null;
  if (conf.profile && conf.profile != null) {
    var dn = conf.profile;
    if (dn.company && dn.company != null) {
      if (dn.group && dn.group != null)
        return dn.company + ':' + dn.group;
      return dn.company;
    }
  }
   else if (conf.company && conf.company != null) {
    return conf.company;
  }
   else {
    return null;
  }
  return null;
}

function InvokeError_0(error, onError, errCode, errType){
  var msg = {};
  msg.type = errType;
  msg.message = error;
  msg.code = errCode;
  onError(msg);
}

function InvokeLoginResult(success, mainApp, error, errType, onSuccess_1, onError_1){
  var main = {};
  if (success) {
    main.constants = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.Constants(onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.Constants(onSuccess, onError);
        }
        );
      }
    }
    ;
    main.companies = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.Companies(onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.Companies(onSuccess, onError);
        }
        );
      }
    }
    ;
    main.languages = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.Languages(onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.Languages(onSuccess, onError);
        }
        );
      }
    }
    ;
    main.userValuesSet = function(json, onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.UserValuesSet(json, onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.UserValuesSet(json, onSuccess, onError);
        }
        );
      }
    }
    ;
    main.userValuesGet = function(json, onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.UserValuesGet(json, onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.UserValuesGet(json, onSuccess, onError);
        }
        );
      }
    }
    ;
    main.entMessages = function(ename, type_0, from, to, onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.EntMessages(ename, type_0, from, to, onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.EntMessages(ename, type_0, from, to, onSuccess, onError);
        }
        );
      }
    }
    ;
    main.priorityVersion = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        onSuccess_0(getPriorityVersion());
      else {
        return new Promise(function(onSuccess, onError){
          onSuccess(getPriorityVersion());
        }
        );
      }
    }
    ;
    main.apiVersion = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        onSuccess_0(($clinit_PriCommon() , APIVersion));
      else {
        return new Promise(function(onSuccess, onError){
          onSuccess(($clinit_PriCommon() , APIVersion));
        }
        );
      }
    }
    ;
    main.isUserConsent = function(onSuccess_0, onError_0){
      if (onSuccess_0 || onError_0)
        mainApp.UserConsent(onSuccess_0, onError_0);
      else {
        return new Promise(function(onSuccess, onError){
          mainApp.UserConsent(onSuccess, onError);
        }
        );
      }
    }
    ;
    main.user = function(){
      var user = {};
      user.user = mainApp.getConstantInt('user', 0);
      user.username = mainApp.getConstantString('username', '');
      return user;
    }
    ;
    main.userConsent = mainApp.getConstantInt('userconsent', 1);
    main.marketgateUrl = mainApp.getConstantString('marketgate', '');
    main.isSupported = function(funcname){
      return mainApp.MainCheckSupported(funcname, null);
    }
    ;
    main.refreshAppKey = function(appkey){
      mainApp.RefreshAppKey(appkey);
    }
    ;
    onSuccess_1(main);
  }
   else {
    main.type = 'apiError';
    main.code = errType;
    main.message = error;
    onError_1(main);
  }
}

function InvokeSuccess_0(par, onSuccess){
  onSuccess(par);
}

function InvokeSuccess_1(par, onSuccess){
  onSuccess(par);
}

function PriorityApp(){
  $$init(this);
}

function publishAPIfuncMain(priApp){
  $wnd.login = function(configuration, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      priApp.Login(configuration, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        priApp.Login(configuration, onSuccess, onError);
      }
      );
  }
  ;
  $wnd.changePassword = function(newPwd, confirmNewPwd, oldPwd, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      priApp.ChangePassword(newPwd, confirmNewPwd, oldPwd, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        priApp.ChangePassword(newPwd, confirmNewPwd, oldPwd, onSuccess, onError);
      }
      );
    }
  }
  ;
  $wnd.setGPSLocation = function(gpsLocation, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      priApp.SetGPSLocation(gpsLocation, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        priApp.SetGPSLocation(gpsLocation, onSuccess, onError);
      }
      );
    }
  }
  ;
  $wnd.updateAccessToken = function(newAccessToken, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      priApp.UpdateAccessToken(newAccessToken, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        priApp.UpdateAccessToken(newAccessToken, onSuccess, onError);
      }
      );
    }
  }
  ;
  !(typeof module !== 'undefined' && typeof module.exports !== 'undefined') && $wnd.priorityReady();
}

defineClass(85, 1, {}, PriorityApp);
_.$init = function $init(){
  $$init(this);
}
;
_.ChangePassword = function ChangePassword(newPwd, confirmNewPwd, oldPwd, onSuccess, onError){
  ChangePasswordNative(newPwd, confirmNewPwd, oldPwd, this, onSuccess, onError);
}
;
_.Companies = function Companies(onSuccess, onError){
  var con;
  if (!$MainCheckSupported('companies', onError))
    return;
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralCompaniesMobAsync(con, new PriorityApp$7(con, onSuccess, onError));
}
;
_.Constants = function Constants(onSuccess, onError){
  cachedConstants?InvokeSuccess_1(cachedConstants.jsObject, onSuccess):InvokeError_0('Constants initilization failed', onError, 'constantsUninitialized', 'apiError');
}
;
_.EntMessages = function EntMessages(ename, type_0, from, to, onSuccess, onError){
  var con;
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralExtMessagesRangeMobAsync(con, ename, type_0, fromInt(from), fromInt(to), new PriorityApp$8(this, con, onSuccess, onError));
}
;
_.ExtMessagesAdd = function ExtMessagesAdd(retObj, num, message){
  $ExtMessagesAdd(retObj, num, message);
}
;
_.ExtMessagesStart = function ExtMessagesStart(){
  return $ExtMessagesStart();
}
;
_.GetConnection = function GetConnection(){
  return $GetConnection_0(this);
}
;
_.Languages = function Languages(onSuccess, onError){
  var con;
  if (!$MainCheckSupported('languages', onError))
    return;
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralLanguagesMobAsync(con, new PriorityApp$6(con, onSuccess, onError));
}
;
_.Login = function Login_0(configuration, onSuccess, onError){
  var conf, dname, url_0;
  conf = configuration;
  dname = GetLoginDName(conf);
  url_0 = conf.url;
  !$endsWith(url_0.toLowerCase(), '.svc') && !$endsWith(url_0.toLowerCase(), '.v3') && (url_0 += '/wcf/wcf/Service.svc');
  SetWCFServiceParams(url_0, conf.tabulaini, conf.language, dname, conf.appname, conf.activeDirectory, conf.appid, conf.appkey, conf.debugserver, conf.timezoneName);
  $LoginB(this, conf.username, conf.password, conf.accessToken, conf.devicename, null, conf.authAudience, onSuccess, onError);
}
;
_.LoginB = function LoginB(username, pwd, accessToken, computerName, windowsUserName, authAudience, onSuccess, onError){
  $LoginB(this, username, pwd, accessToken, computerName, windowsUserName, authAudience, onSuccess, onError);
}
;
_.LoginC = function LoginC(onSuccess, onError){
  $LoginC(this, onSuccess, onError);
}
;
_.MainCheckSupported = function MainCheckSupported(funcname, onError){
  return $MainCheckSupported(funcname, onError);
}
;
_.RefreshAppKey = function RefreshAppKey(appkey){
  AppKey = appkey;
}
;
_.RemoveConnection = function RemoveConnection(){
  this.con = null;
}
;
_.ServerTripCompleted = function ServerTripCompleted_0(sender, e){
}
;
_.SetGPSLocation = function SetGPSLocation(gpsLocation, onSuccess, onError){
  var j;
  GPSLocation = gpsLocation;
  j = new JSONObject;
  InvokeSuccess_1(j.jsObject, onSuccess);
}
;
_.SetIsGoneToServer = function SetIsGoneToServer_0(userState){
  return true;
}
;
_.UpdateAccessToken = function UpdateAccessToken(newAccessToken, onSuccess, onError){
  Pwd = newAccessToken;
}
;
_.UserConsent = function UserConsent(onSuccess, onError){
  var con;
  if (!$MainCheckSupported('isUserConsent', onError))
    return;
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralUserConsentMobAsync(con, new PriorityApp$3(con, onSuccess, onError));
}
;
_.UserValuesGet = function UserValuesGet(json, onSuccess, onError){
  var con, jo, send;
  if (!$MainCheckSupported('userValuesGet', onError))
    return;
  jo = new JSONObject_0(json);
  send = b64encode($toString_0(jo));
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralUserValuesGetMobAsync(con, send, new PriorityApp$4(con, onSuccess, onError));
}
;
_.UserValuesSet = function UserValuesSet(json, onSuccess, onError){
  var con, jo, send;
  if (!$MainCheckSupported('userValuesSet', onError))
    return;
  jo = new JSONObject_0(json);
  send = b64encode($toString_0(jo));
  con = (this.con = GetWCFServiceClient(this) , this.con);
  $GeneralUserValuesSetMobAsync(con, send, new PriorityApp$5(con, onSuccess, onError));
}
;
_.getConstantInt = function getConstantInt(name_0, defaultValue){
  return $getConstantInt(name_0, defaultValue);
}
;
_.getConstantString = function getConstantString(name_0, defaultValue){
  return $getConstantString(name_0, defaultValue);
}
;
_.getDname = function getDname_0(){
  return null;
}
;
_.isCancelFileUpload_0 = function isCancelFileUpload_0(){
  return false;
}
;
_.onModuleLoad = function onModuleLoad(){
  $onModuleLoad_1(this);
}
;
_.setCancelFileUpload = function setCancelFileUpload_0(cancel){
}
;
_.con = null;
var cachedConstants = null, loginResult = 0;
var Lcom_priority_app_main_PriorityApp_2_classLit = createForClass('com.priority.app.main', 'PriorityApp', 85);
function PriorityApp$1(this$0, $anonymous0, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(86, 8, {}, PriorityApp$1);
_.OnPriError = function OnPriError_30(error, isOnServer){
  $LoginC(this.this$01, this.val$onSuccess3, this.val$onError4);
}
;
_.OnPriResponse = function OnPriResponse_30(response){
  SetWCFVersion(response);
  $LoginC(this.this$01, this.val$onSuccess3, this.val$onError4);
}
;
var Lcom_priority_app_main_PriorityApp$1_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/1', 86);
function PriorityApp$2(this$0, $anonymous0, val$priApp, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$priApp3 = val$priApp;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(87, 8, {}, PriorityApp$2);
_.OnPriError = function OnPriError_31(error, isOnServer){
  var response;
  response = "Can't connect to server.";
  error.indexOf('InvalidSecurityToken') != -1 && (response = 'Authorization failed. \nPlease check the username and password.');
  InvokeLoginResult(false, this.val$priApp3, response, 'loginFailed', this.val$onSuccess4, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_31(response){
  var cons, e, ja, jo, jval, message, pa, ret;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    cons = $get(pa, 0).isObject();
    cachedConstants = cons;
    ret = 0;
    message = null;
    jval = $get_0(cons, 'ValidPassword');
    if (jval) {
      ja = jval.isArray_0();
      !!ja && ja.jsArray.length > 0 && (ret = round_int($get_0($get(ja, 0).isObject(), 'valid').isNumber().value_0));
    }
    jval = $get_0(cons, 'Message');
    if (jval) {
      ja = jval.isArray_0();
      !!ja && ja.jsArray.length > 0 && (message = $get_0($get(ja, 0).isObject(), 'message').isString().value_0);
    }
    loginResult = ret;
    if (ret == 1) {
      $clinit_PriCommon();
      SystemMailDir = $getConstantString('systemmail', '');
      SystemImagesDir = $getConstantString('systemimages', '');
      MajorVersion = $getConstantInt('latupg', 0);
      MinorVersion = $getConstantInt('servicepack', 0);
      BuildVersion = $getConstantInt('lastfix', 0);
      LangFormat = $getConstantInt('format', 0);
      IPMessage = $getConstantString('ipmessage', '');
      TenantID = $getConstantString('tenantid', '');
      MGCookie = $getConstantString('mgcookie', '');
      HtmlSvcCookie = $getConstantString('htmlsvccookie', '');
      HasUserValuesFeature = ($clinit_Boolean() , $getConstantInt('hasuservalues', 0) == 1?TRUE_0:FALSE_0);
      MGCookie != null && MGCookie.length > 0 && setCookie('PriUser', MGCookie, tenYearsFromNow, '/');
      DName != null && setCookie('Environment', DName, tenYearsFromNow, '/');
      if (HtmlSvcCookie != null && HtmlSvcCookie.length > 0) {
        setCookie('PriUserV2', HtmlSvcCookie, tenYearsFromNow, '/');
        setCookie('PriUserV2', HtmlSvcCookie, tenYearsFromNow, '/html/priority/primail/' + App);
        setCookie('PriUserV2', HtmlSvcCookie, tenYearsFromNow, '/html/priority/netfiles/' + App);
        setCookie('PriUserV2', HtmlSvcCookie, tenYearsFromNow, '/html/priority/apps/' + App);
      }
      $getConstantInt('has_filters_feature', 0) == 1 && (HasFiltersFeature = (null , TRUE_0));
      $getConstantInt('has_form_alert_choose_feature', 0) == 1 && (HasFormAlertChooseFeature = (null , TRUE_0));
      InvokeLoginResult(true, this.val$priApp3, null, null, this.val$onSuccess4, this.val$onError5);
    }
     else if (ret == -1) {
      InvokeLoginResult(false, this.val$priApp3, message, 'loginExpired', this.val$onSuccess4, this.val$onError5);
    }
     else {
      (message == null || message.length <= 0) && (message = "Can't connect to server.");
      InvokeLoginResult(false, this.val$priApp3, message, 'loginFailed', this.val$onSuccess4, this.val$onError5);
    }
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeLoginResult(false, this.val$priApp3, e.getMessage(), 'loginFailed', this.val$onSuccess4, this.val$onError5);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$2_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/2', 87);
function PriorityApp$3($anonymous0, val$onSuccess, val$onError){
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(88, 8, {}, PriorityApp$3);
_.OnPriError = function OnPriError_32(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_32(response){
  var consent, e, jo, obj, pa;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    obj = $get(pa, 0).isObject();
    consent = 1;
    !!obj && 'userconsent' in obj.jsObject && (consent = round_int(getJSONNumberProperty(obj, 'userconsent')));
    InvokeSuccess_0(consent, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$3_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/3', 88);
function PriorityApp$4($anonymous0, val$onSuccess, val$onError){
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(89, 8, {}, PriorityApp$4);
_.OnPriError = function OnPriError_33(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_33(response){
  var e, jo, js, obj, pa;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    obj = $get(pa, 0).isObject();
    js = null;
    !!obj && (js = obj.jsObject);
    InvokeSuccess_1(js, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$4_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/4', 89);
function PriorityApp$5($anonymous0, val$onSuccess, val$onError){
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(90, 8, {}, PriorityApp$5);
_.OnPriError = function OnPriError_34(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_34(response){
  var e, jo, js, obj, pa;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    obj = $get(pa, 0).isObject();
    js = null;
    !!obj && (js = obj.jsObject);
    InvokeSuccess_1(js, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$5_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/5', 90);
function PriorityApp$6($anonymous0, val$onSuccess, val$onError){
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(91, 8, {}, PriorityApp$6);
_.OnPriError = function OnPriError_35(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_35(response){
  var e, jo, js, obj, pa;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    obj = $get(pa, 0).isObject();
    js = null;
    !!obj && (js = obj.jsObject);
    InvokeSuccess_1(js, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$6_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/6', 91);
function PriorityApp$7($anonymous0, val$onSuccess, val$onError){
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(92, 8, {}, PriorityApp$7);
_.OnPriError = function OnPriError_36(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_36(response){
  var e, jo, js, obj, pa;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    obj = $get(pa, 0).isObject();
    js = null;
    !!obj && (js = obj.jsObject);
    InvokeSuccess_1(js, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$7_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/7', 92);
function PriorityApp$8(this$0, $anonymous0, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(93, 8, {}, PriorityApp$8);
_.OnPriError = function OnPriError_37(error, isOnServer){
  InvokeError_0(error, this.val$onError4, 'exception', 'apiError');
}
;
_.OnPriResponse = function OnPriResponse_37(response){
  var e, extMessage, i, j, jo, messages, pa, retObj, text_0;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    pa = dynamicCast($get_0(dynamicCast(jo, 5), 'General'), 7);
    extMessage = dynamicCast($get(pa, 0), 5);
    messages = dynamicCast($get_0(extMessage, 'ExtMessage'), 7);
    retObj = $ExtMessagesStart();
    if (messages) {
      for (i = 0; i < messages.jsArray.length; i++) {
        j = $get(messages, i).isObject();
        text_0 = getHyperLinkedText(j, 'message');
        $ExtMessagesAdd(retObj, round_int($get_0(dynamicCast($get(messages, i), 5), 'num').isNumber().value_0), text_0);
      }
    }
    InvokeSuccess_1(retObj, this.val$onSuccess3);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_0(e.getMessage(), this.val$onError4, 'exception', 'apiError');
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_main_PriorityApp$8_2_classLit = createForClass('com.priority.app.main', 'PriorityApp/8', 93);
function FormZoom_0(formZoomNative, proc, fieldID){
  this.proc_0 = proc;
  this.nativeZoom = formZoomNative;
  this.fieldID = fieldID;
}

defineClass(134, 1, {}, FormZoom_0);
_.fieldID = 0;
var Lcom_priority_app_proc_FormZoom_2_classLit = createForClass('com.priority.app.proc', 'FormZoom', 134);
function $AskPrint(this$static, proc, onSuccess){
  var askprint, formats, hasAutoMail, par, pdfVal, wantsPdf, wordTemplates;
  askprint = dynamicCast($get_0(proc, 'AskPrint'), 7);
  formats = null;
  wordTemplates = null;
  wantsPdf = false;
  hasAutoMail = false;
  if (!!askprint && askprint.jsArray.length > 0) {
    par = dynamicCast($get(askprint, 0), 5);
    formats = dynamicCast($get_0(par, 'Formats'), 7);
    wordTemplates = dynamicCast($get_0(par, 'WordTemplates'), 7);
    pdfVal = round_int(getJSONNumberProperty(par, 'pdf'));
    hasAutoMail = round_int(getJSONNumberProperty(par, 'hasmail')) == 1;
    wantsPdf = pdfVal % 2 != 0;
  }
  InvokeDocumentOptions(this$static, wantsPdf, hasAutoMail, !formats?null:formats.jsArray, !wordTemplates?null:wordTemplates.jsArray, onSuccess);
}

function $CancelContinue(this$static, killFlag, executionFlag, onSuccess, onError){
  if (this$static.isFinished || IsNullOrEmpty(this$static.privateSession)) {
    !!onSuccess && InvokeEnd(this$static, onSuccess);
    return;
  }
  killFlag?executionFlag?$ProcKillExecutionMobAsync($GetConnectionForCancel(this$static), this$static.privateSession, new Proc$CommonResponse($GetConnectionForCancel(this$static), this$static, 'ProcKillExecution', onSuccess, onError)):$ProcKillProcessMobAsync($GetConnectionForCancel(this$static), this$static.privateSession, new Proc$CommonResponse($GetConnectionForCancel(this$static), this$static, 'ProcKillProcess', onSuccess, onError)):$ProcEndMobAsync($GetConnectionForCancel(this$static), this$static.privateSession, new Proc$CommonResponse($GetConnectionForCancel(this$static), this$static, 'ProcEnd', onSuccess, onError));
}

function $CancelProcedure(this$static, killFlag, executionFlag, onSuccess, onError){
  if (this$static.ename_0 == ($clinit_PriCommon() , LabelsPrint)) {
    $LabelsContinue(this$static.form_0, 0, this$static.LastLabelsSelection, false, false, false, onSuccess, onError, this$static.progressFunc);
    return;
  }
  if (this$static.isFinished || IsNullOrEmpty(this$static.privateSession)) {
    !!onSuccess && InvokeEnd(this$static, onSuccess);
    return;
  }
  this$static.isCanceling = true;
  this$static.isOnServer?scheduleFixedDelayImpl(($clinit_SchedulerImpl() , new Proc$7(this$static, onSuccess, killFlag, executionFlag, onError)), 250):$CancelContinue(this$static, killFlag, executionFlag, onSuccess, onError);
}

function $ChooseDatesToISO(ar){
  var i, jv, s, str;
  for (i = 0; i < ar.jsArray.length; i++) {
    jv = dynamicCast($get(ar, i), 5);
    if ('retval' in jv.jsObject) {
      s = $get_0(jv, 'retval').isString();
      if (s) {
        str = new JSONString(DateToISO(s.value_0));
        $put(jv, 'retval', str);
      }
    }
  }
}

function $DatesToISO(this$static, jo, objName){
  var datestr, editFields, err, fi, field, i, jn, jv, ret, s, str;
  ret = new Proc$RetObj;
  ret.success = true;
  editFields = dynamicCast($get_0(jo, objName), 7);
  if (!editFields)
    return ret;
  for (i = 0; i < editFields.jsArray.length; i++) {
    jv = dynamicCast($get(editFields, i), 5);
    jn = $get_0(jv, 'field').isNumber();
    field = round_int(jn.value_0);
    fi = dynamicCast($get_1(this$static.inputFields_0, valueOf(field)), 53);
    if (!!fi && $equals('date', fi.columntype.inputType)) {
      if ('value' in jv.jsObject) {
        s = $get_0(jv, 'value').isString();
        if (s) {
          datestr = ISOToDate(fi.width_0, s.value_0);
          err = ISOToDateErr(datestr);
          if (err != null) {
            ret.success = false;
            ret.errVal = err + ' (' + s.value_0 + ')';
            return ret;
          }
          str = new JSONString(datestr);
          $put(jv, 'value', str);
        }
      }
      if ('value1' in jv.jsObject) {
        s = $get_0(jv, 'value1').isString();
        if (s) {
          datestr = ISOToDate(fi.width_0, s.value_0);
          err = ISOToDateErr(datestr);
          if (err != null) {
            ret.success = false;
            ret.errVal = err + ' (' + s.value_0 + ')';
            return ret;
          }
          str = new JSONString(datestr);
          $put(jv, 'value1', str);
        }
      }
    }
  }
  return ret;
}

function $Download(this$static, proc, onSuccess){
  var filename, par, suffix, url_0, urltab, ret;
  urltab = dynamicCast($get_0(proc, 'URL'), 7);
  suffix = null;
  filename = null;
  url_0 = null;
  if (!!urltab && urltab.jsArray.length > 0) {
    par = dynamicCast($get(urltab, 0), 5);
    suffix = getJSONStringProperty(par, 'suffix');
    filename = getJSONStringProperty(par, 'filename');
    url_0 = getJSONStringProperty(par, 'url');
  }
  ret = {};
  ret.proc = this$static.GetProc();
  ret.type = 'download';
  url_0 != null && (ret.url = url_0);
  filename != null && (ret.filename = filename);
  suffix != null && (ret.suffix = suffix);
  onSuccess(ret);
}

function $GetConnection_1(this$static){
  if (!!this$static.con && $equals(this$static.con.Password, Pwd))
    return this$static.con;
  this$static.con = GetWCFServiceClient(this$static);
  return this$static.con;
}

function $GetConnectionForCancel(this$static){
  if (!!this$static.cancelCon && $equals(this$static.cancelCon.Password, Pwd))
    return this$static.cancelCon;
  this$static.cancelCon = GetWCFServiceClient(this$static);
  return this$static.cancelCon;
}

function $Input(this$static, proc, onSuccess){
  var chooseField, chooseFields, columntype, editField, editFields, field, helpString, i, isboolean, ispassword, mandatory, name_0, op, opId, operator, operators, par, parameters, readonly, ret, selected, simplechoose, text_0, title_0, title0, value_0, value1, width_0, zoom, zoomtype, op_0;
  ret = ($reset(this$static.inputFields_0) , {});
  parameters = dynamicCast($get_0(proc, 'Parameters'), 7);
  if (!!parameters && parameters.jsArray.length > 0) {
    par = dynamicCast($get(parameters, 0), 5);
    editFields = dynamicCast($get_0(par, 'EditField'), 7);
    if (editFields) {
      for (i = 0; i < editFields.jsArray.length; i++) {
        editField = dynamicCast($get(editFields, i), 5);
        field = round_int(getJSONNumberProperty(editField, 'field'));
        helpString = getHyperLinkedText(editField, 'help');
        isboolean = round_int(getJSONNumberProperty(editField, 'isboolean'));
        ispassword = round_int(getJSONNumberProperty(editField, 'ispassword'));
        mandatory = round_int(getJSONNumberProperty(editField, 'mandatory'));
        operator = round_int(getJSONNumberProperty(editField, 'operator'));
        simplechoose = round_int(getJSONNumberProperty(editField, 'simplechoose'));
        readonly = getJSONStringProperty(editField, 'readonly');
        title0 = getJSONStringProperty(editField, 'title');
        columntype = forValue(getJSONStringProperty(editField, 'type').charCodeAt(0));
        value_0 = getJSONStringProperty(editField, 'value');
        value1 = getJSONStringProperty(editField, 'value1');
        width_0 = round_int(getJSONNumberProperty(editField, 'width'));
        zoomtype = forValue_0(round_int(getJSONNumberProperty(editField, 'zoomtype')));
        zoom = round_int(getJSONNumberProperty(editField, 'zoom'));
        $InputFieldAdd(this$static, ret, field, helpString, isboolean, ispassword, mandatory, operator, simplechoose, readonly, title0, columntype, value_0, value1, width_0, zoomtype, zoom);
      }
    }
    operators = dynamicCast($get_0(par, 'Operators'), 7);
    if (operators) {
      for (i = 0; i < operators.jsArray.length; i++) {
        op = dynamicCast($get(operators, i), 5);
        name_0 = getJSONStringProperty(op, 'name');
        opId = round_int(getJSONNumberProperty(op, 'op'));
        title0 = getJSONStringProperty(op, 'title');
        op_0 = {};
        op_0.name = name_0;
        op_0.op = opId;
        op_0.title = title0;
        !ret.Operators && (ret.Operators = []);
        ret.Operators.push(op_0);
      }
    }
    chooseFields = dynamicCast($get_0(par, 'ChooseField'), 7);
    if (chooseFields) {
      for (i = 0; i < chooseFields.jsArray.length; i++) {
        chooseField = dynamicCast($get(chooseFields, i), 5);
        field = round_int(getJSONNumberProperty(chooseField, 'field'));
        helpString = getHyperLinkedText(chooseField, 'help');
        name_0 = getJSONStringProperty(chooseField, 'name');
        selected = round_int(getJSONNumberProperty(chooseField, 'selected'));
        title0 = getJSONStringProperty(chooseField, 'title');
        $InputChooseAdd(ret, field, helpString, name_0, selected, title0);
      }
    }
    text_0 = getHyperLinkedText(par, 'text');
    title_0 = getJSONStringProperty(par, 'title');
    ret.text = text_0;
    ret.title = title_0;
  }
  InvokeInput(this$static, ret, onSuccess);
}

function $InputChooseAdd(retObj, fieldId, helpString, name_0, selected, title_0){
  var field = {};
  field.field = fieldId;
  field.helpstring = helpString;
  field.name = name_0;
  field.selected = selected;
  field.title = title_0;
  !retObj.Options && (retObj.Options = []);
  retObj.Options.push(field);
}

function $InputFieldAdd(this$static, retObj, fieldId, helpstring, isboolean, ispassword, mandatory, operator, simplechoose, readonly, title_0, columntype, value_0, value1, width_0, zoomtype, zoom){
  var codestr, format, typestr;
  $put_0(this$static.inputFields_0, valueOf(fieldId), new Proc$InputField(columntype, zoomtype, width_0));
  if ($equals('date', columntype.inputType)) {
    value_0 = DateToISO(value_0);
    value1 = DateToISO(value1);
  }
  format = $getFormat(columntype);
  typestr = columntype.inputType;
  codestr = columntype.name_0 != null?columntype.name_0:'' + columntype.ordinal;
  $InputFieldAddNative(retObj, fieldId, helpstring, isboolean, ispassword, mandatory, operator, simplechoose, readonly, title_0, value_0, value1, width_0, zoomtype.name_0 != null?zoomtype.name_0:'' + zoomtype.ordinal, format, typestr, codestr, zoom);
}

function $InputFieldAddNative(retObj, fieldId, helpstring, isboolean, ispassword, mandatory, operator, simplechoose, readonly, title_0, value_0, value1, width_0, zoomtype, format, typestr, codestr, zoom){
  var field = {};
  field.field = fieldId;
  field.helpstring = helpstring;
  field.ispassword = ispassword;
  field.mandatory = mandatory;
  field.operator = operator;
  field.readonly = simplechoose;
  field.readonlyoperator = readonly == 'r'?1:0;
  field.title = title_0;
  field.type = isboolean == 1?'bool':typestr;
  field.code = codestr;
  field.value = value_0;
  field.value1 = value1;
  field.maxlength = width_0;
  field.zoom = zoomtype;
  field.haszoom = zoom;
  field.format = format;
  !retObj.EditFields && (retObj.EditFields = []);
  retObj.EditFields.push(field);
}

function $LabelsRun(this$static, data_0, onSuccess, onError){
  var allRecords, clean, ef, field, i, print_0;
  ef = data_0;
  allRecords = false;
  clean = false;
  print_0 = false;
  for (i = 0; i < ef.EditFields.length; i++) {
    field = ef.EditFields[i];
    field.field == 1?(allRecords = $getBool(field.value)):field.field == 2?(clean = $getBool(field.value)):field.field == 3 && (print_0 = $getBool(field.value));
  }
  $LabelsContinue(this$static.form_0, 1, this$static.LastLabelsSelection, allRecords, clean, print_0, onSuccess, onError, this$static.progressFunc);
}

function $NewReport(this$static, proc, onSuccess, onError){
  var excelTemplates, firstFormat, format, formats, i, n, nformat, nselected, oformat, option, selectedFormat, showExcel, str;
  n = dynamicCast($get_0(proc, 'showexcel'), 26);
  showExcel = !n || n.value_0 != 0;
  (this$static.spreadsheet == 1 || !CheckWCFVersion()) && (showExcel = false);
  str = dynamicCast($get_0(proc, 'optionselected'), 10);
  option = null;
  !!str && (option = str.value_0);
  selectedFormat = 0;
  firstFormat = 0;
  formats = dynamicCast($get_0(proc, 'Formats'), 7);
  if (!!formats && formats.jsArray.length > 0) {
    for (i = 0; i < formats.jsArray.length; i++) {
      oformat = dynamicCast($get(formats, i), 5);
      format = 0;
      nformat = dynamicCast($get_0(oformat, 'format'), 26);
      if (nformat) {
        format = round_int(nformat.value_0);
        firstFormat == 0 && (firstFormat = format);
      }
      nselected = dynamicCast($get_0(oformat, 'selected'), 26);
      !!nselected && nselected.value_0 == 1 && (selectedFormat = format);
    }
  }
  excelTemplates = dynamicCast($get_0(proc, 'ExcelTemplates'), 7);
  (!formats || formats.jsArray.length <= 1) && !showExcel?$ReportOptions(this$static, 1, selectedFormat == 0?firstFormat:selectedFormat, null, onSuccess, onError):InvokeReportOptions(this$static, showExcel, ($equals('excel', option) , formats?formats.jsArray:null), excelTemplates?excelTemplates.jsArray:null, onSuccess);
}

function $ProcCheckSupported(this$static, funcname, onError){
  var ver, ret;
  if ($equals('formZoom', funcname)) {
    return CheckWCFVersion();
  }
  ver = FuncSupportedFromVersion(3, funcname);
  if (ver == 0)
    return true;
  !!onError && (ret = {} , ret.proc = this$static.GetProc() , ret.type = 'notSupportedInThisPriorityVersion' , ret.message = ($clinit_PriCommon() , 'This feature is supported from web-sdk patch version ' + ver) , onError(ret) , undefined);
  return false;
}

function $ProcContinue(this$static, onSuccess, onError){
  if (this$static.isFinished) {
    InvokeEnd(this$static, onSuccess);
    return;
  }
  $ProcContinueMobAsync($GetConnection_1(this$static), this$static.privateSession, new Proc$CommonResponse($GetConnection_1(this$static), this$static, 'ProcContinue', onSuccess, onError));
}

function $ProcMessage(this$static, curmsg, onSuccess){
  var HyperLinks, msgtext, mt;
  mt = dynamicCast($get_0(curmsg, 'messagetype'), 10);
  $setLastMessageType(this$static, mt.value_0);
  msgtext = getHyperLinkedText(curmsg, 'message');
  HyperLinks = getHyperLink(curmsg);
  InvokeMessage(this$static, msgtext, mt.value_0, HyperLinks, onSuccess);
}

function $ProcParamZoomValue(this$static, zoom, onSuccess, onError){
  $ProcParamZoomValueMobAsync($GetConnection_1(this$static), this$static.privateSession, fromInt(zoom.fieldID), zoom.nativeZoom.link, new Proc$4($GetConnection_1(this$static), this$static, onSuccess, onError));
}

function $ProcStart(this$static, ename, type_0, onSuccess, onError){
  this$static.ename_0 = ename;
  this$static.etype_0 = type_0;
  $ProcStartMobAsync($GetConnection_1(this$static), type_0, ename, !!ExtMessages && ExtMessages.size_0 != 0, new Proc$1(this$static, $GetConnection_1(this$static), onSuccess, onError, this$static));
}

function $ProcStep(this$static, jo, operation, newStep, onSuccess, onError){
  var curmsg, exmail, messages, msg, msgs, n, pa, proc, s, step, stepobj, ret, ret_0, urls, ret_1, data_0, jurls, jurl, url_0;
  pa = dynamicCast($get_0(dynamicCast(jo, 5), 'Procedure'), 7);
  proc = dynamicCast($get(pa, 0), 5);
  'title' in proc.jsObject && (this$static.title_0 = dynamicCast($get_0(proc, 'title'), 10).value_0);
  step = '';
  stepobj = $get_0(proc, 'step');
  !!stepobj && (step = dynamicCast(stepobj, 10).value_0);
  this$static.CurrentStep = step;
  this$static.lastOperation = operation;
  if (newStep) {
    this$static.MsgCounter = 0;
    this$static.SentIpWarning = false;
  }
  s = dynamicCast($get_0(proc, 'session'), 10);
  !!s && $setSession(this$static, s.value_0);
  n = dynamicCast($get_0(proc, 'finished'), 26);
  !!n && $setFinished(this$static, n.value_0 == 1);
  n = dynamicCast($get_0(proc, 'spreadsheet'), 26);
  !!n && $setSpreadsheet(this$static, round_int(n.value_0));
  if (this$static.isCanceling) {
    if (!$equals('ProcKillExecution', operation) && !$equals('ProcKillProcess', operation) && !$equals('ProcEnd', operation)) {
      ret = {};
      ret.proc = this$static.GetProc();
      ret.type = 'cancelled';
      ret.message = '';
      onError(ret);
      return;
    }
  }
  if (!this$static.SentIpWarning && 'ipwarning' in dynamicCast(jo, 5).jsObject) {
    msg = dynamicCast($get_0(dynamicCast(jo, 5), 'ipwarning'), 10).value_0;
    msg = GetIPMessage(msg);
    this$static.lastResponse = jo;
    this$static.lastMessageType = ($clinit_PriCommon$PriMessageType() , Ok);
    this$static.lastMessageType = IPWarning;
    this$static.SentIpWarning = true;
    ret_0 = {};
    ret_0.proc = this$static.GetProc();
    ret_0.type = 'message';
    ret_0.message = msg;
    ret_0.messagetype = 'ipwarning';
    onSuccess(ret_0);
    return;
  }
  messages = dynamicCast($get_0(proc, 'Message'), 7);
  if (!!messages && messages.jsArray.length > this$static.MsgCounter) {
    curmsg = dynamicCast($get(messages, this$static.MsgCounter), 5);
    this$static.lastResponse = jo;
    $ProcMessage(this$static, curmsg, onSuccess);
    return;
  }
  exmail = $get_0(proc, 'ExternalMail');
  if (exmail) {
    InvokeNotSupported(this$static, 'ExternalMail', onError);
    $CancelProcedure(this$static, false, false, null, null);
    return;
  }
  switch (step) {
    case 'newsaved':
      $NewReport(this$static, proc, onSuccess, onError);
      break;
    case 'input':
      $Input(this$static, proc, onSuccess);
      break;
    case 'displayurl':
      urls = dynamicCast($get_0(proc, 'URL'), 7);
      InvokeDisplayUrl(this$static, urls.jsArray, onSuccess);
      break;
    case 'askprint':
      $AskPrint(this$static, proc, onSuccess);
      break;
    case 'upload':
      ret_1 = {};
      ret_1.proc = this$static.GetProc();
      ret_1.type = 'upload';
      onSuccess(ret_1);
      break;
    case 'download':
      $Download(this$static, proc, onSuccess);
      break;
    case 'CLIENT':
      data_0 = dynamicCast($get_0(proc, 'data'), 7);
      InvokeClient(this$static, !data_0?null:data_0.jsArray, onSuccess);
      break;
    case 'excel':
      jurls = dynamicCast($get_0(proc, 'URL'), 7);
      jurl = dynamicCast($get(jurls, 0), 5);
      url_0 = dynamicCast($get_0(jurl, 'url'), 10).value_0;
      $ProcCreateSpreadsheetMobAsync($GetConnection_1(this$static), this$static.etype_0, this$static.ename_0, fromInt(this$static.excelTemplate_0 == 0?-1:this$static.excelTemplate_0), b64encode(url_0), new Proc$CommonResponse($GetConnection_1(this$static), this$static, 'ProcClientContinue', onSuccess, onError));
      break;
    case 'NETLABELSINIT':
    case 'savefile':
    case 'movie':
    case 'wizard':
    case 'document':
    case 'GANTT':
    case 'WINDBI':
    case 'EXPLORER':
    case 'PRIVTREE':
    case 'BPM':
    case 'form':
    case 'mailurl':
    case 'internalmail':
    case 'procedure':
    case 'passthru':
    case 'labels':
    case 'synccontacts':
    case 'prexfile':
    case 'OLPORTAL':
    case 'SENDMSG':
    case 'PRINTDLG':
    case 'OPENWORD':
    case 'WORDCONV':
    case 'GTOKENS':
    case 'MSPROJ':
    case 'WORDTMPL':
    case 'SHVAEXEC':
    case 'WINFORM':
    case 'WINPROC':
    case 'WINHTMLH':
    case 'STARSHIP':
      InvokeNotSupported(this$static, step, onError);
      $CancelProcedure(this$static, false, false, null, null);
      break;
    case 'warning':
      this$static.lastResponse = null;
      msgs = dynamicCast($get_0(proc, 'Warning'), 7);
      curmsg = dynamicCast($get(msgs, 0), 5);
      $ProcMessage(this$static, curmsg, onSuccess);
      break;
    case 'BACKGROUND':
      $ProcContinue(this$static, onSuccess, onError);
      break;
    case 'waitprocess':
    case 'waitexecution':
      this$static.waitMS = 400;
      $WaitProcess(this$static, $equals('waitexecution', step), onSuccess, onError);
      break;
    default:InvokeEnd(this$static, onSuccess);
  }
}

function $RefreshSearch(this$static, jo){
  var pa, pr, search, searcharr;
  search = null;
  pa = dynamicCast($get_0(jo, 'Procedure'), 7);
  pr = dynamicCast($get(pa, 0), 5);
  searcharr = dynamicCast($get_0(pr, 'Search'), 7);
  if (searcharr) {
    search = dynamicCast($get(searcharr, 0), 5);
    this$static.SearchCursor = fromDouble(getJSONNumberProperty(search, 'stack_cursor'));
    this$static.SearchStart = fromDouble(getJSONNumberProperty(search, 'stack_stack'));
    $add(this$static.SearchLast, getJSONStringProperty(search, 'stack_last'));
  }
  return search;
}

function $ReportOptions(this$static, ok, selectedFormat, options, onSuccess, onError){
  var newrepmode, ro;
  if (ok == 0) {
    $CancelProcedure(this$static, false, false, onSuccess, onError);
  }
   else {
    newrepmode = 'H';
    if (options) {
      ro = options;
      if (!!ro && ro.excel == 1) {
        newrepmode = 'x';
        this$static.excelTemplate_0 = ro.excelTemplate != null?ro.excelTemplate:0;
      }
    }
    $ProcNewReportMobAsync($GetConnection_1(this$static), this$static.etype_0, this$static.ename_0, newrepmode, fromInt(selectedFormat), new Proc$CommonResponse($GetConnection_1(this$static), this$static, 'ProcNewReport', onSuccess, onError));
  }
}

function $SetDName(this$static, dn){
  this$static.jsDname = dn;
  this$static.dname = GetDName(dn);
}

function $SetEname(this$static, ename){
  this$static.ename_0 = ename;
}

function $SetForm(this$static, form_0){
  this$static.form_0 = form_0;
}

function $SetTitle(this$static, title_0){
  this$static.title_0 = title_0;
}

function $UploadFile_2(this$static, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError){
  var fu;
  fu = new Proc$ProcFileUploader(this$static, this$static);
  $UploadFile(fu, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError, null);
}

function $WaitContinue(this$static, jo, onSuccess, onError, operation){
  var pa, proc, step, val;
  this$static.errCount = 0;
  pa = dynamicCast($get_0(dynamicCast(jo, 5), 'Procedure'), 7);
  proc = dynamicCast($get(pa, 0), 5);
  step = dynamicCast($get_0(proc, 'step'), 10).value_0;
  $equals('waitprocess', step) && this$static.waitAutoProgress?(this$static.waitAutoProgress = false):$equals('waitexecution', step) && !this$static.waitAutoProgress && (this$static.waitAutoProgress = true);
  if ($equals('waitprocess', step)) {
    val = dynamicCast($get_0(proc, 'sandglass'), 26).value_0;
    val > 0 && InvokeProgress(this$static, round_int(val), this$static.progressFunc);
  }
   else if (!$equals('waitexecution', step)) {
    $ProcStep(this$static, jo, operation, true, onSuccess, onError);
    return;
  }
  $WaitProcess(this$static, this$static.waitAutoProgress, onSuccess, onError);
}

function $WaitProcess(this$static, autoprogress, onSuccess, onError){
  this$static.waitAutoProgress = autoprogress;
  scheduleFixedDelayImpl(($clinit_SchedulerImpl() , new Proc$8(this$static, this$static, onSuccess, onError)), this$static.waitMS);
  this$static.waitMS = max_0(this$static.waitMS + 200, 5000);
}

function $checkOptions(options){
  if (typeof options === 'boolean')
    return options?1:0;
  if (typeof options === 'number')
    return options == 0?0:1;
  return 2;
}

function $getBool(val){
  return val == 'Y' || val == 'y';
}

function $setFinished(this$static, finished){
  this$static.isFinished = finished;
}

function $setLastMessageType(this$static, type_0){
  this$static.lastMessageType = ($clinit_PriCommon$PriMessageType() , Ok);
  $equals('warning', type_0)?(this$static.lastMessageType = OkCancel):$equals('ipwarning', type_0) && (this$static.lastMessageType = IPWarning);
}

function $setSession(this$static, value_0){
  this$static.privateSession = value_0;
}

function $setSpreadsheet(this$static, spreadsheet){
  this$static.spreadsheet = spreadsheet;
}

function Proc(){
  this.SearchLast = new ArrayList;
  this.inputFields_0 = new HashMap;
  !ExtMessages && (ExtMessages = new HashMap);
}

function ReadFile_0(that, file, onProgress, onSuccess, onError){
  var reader = new FileReader;
  reader.onload = function(event_0){
    var res = event_0.target.result;
    that.UploadFile_2(0, 'c:/' + file.name, res, onProgress, onSuccess, onError);
  }
  ;
  reader.readAsDataURL(file);
}

defineClass(36, 1, {36:1}, Proc);
_.CancelProcedure = function CancelProcedure(onSuccess, onError){
  $CancelProcedure(this, true, this.waitAutoProgress, onSuccess, onError);
}
;
_.ClientContinue = function ClientContinue(data_0, onSuccess, onError){
  var json;
  if (this.isFinished) {
    InvokeEnd(this, onSuccess);
    return;
  }
  json = b64encode(JsonToString(data_0));
  $ProcClientContinueMobAsync($GetConnection_1(this), this.privateSession, json, new Proc$CommonResponse($GetConnection_1(this), this, 'ProcClientContinue', onSuccess, onError));
}
;
_.DocumentOptions = function DocumentOptions(ok, selectedFormat, options, onSuccess, onError){
  var mode, opt, optionsMode, pdf;
  if (ok == 0) {
    $CancelProcedure(this, false, false, onSuccess, onError);
  }
   else {
    mode = 2;
    optionsMode = $checkOptions(options);
    if (optionsMode == 2) {
      opt = options;
      pdf = opt.pdf == 1;
      (opt.mode == 'signature' || opt.signature == 1) && ($clinit_PriCommon() , 6 <= BuildVersion)?(mode = 8):opt.mode == 'automail'?(mode = 5):opt.mode == 'signature_preview' && (mode = 7);
      opt.word == 1 && (mode += 10);
    }
     else {
      pdf = optionsMode == 1;
    }
    $ProcAskPrintOKMobAsync($GetConnection_1(this), this.privateSession, fromInt(mode), fromInt(selectedFormat), pdf, new Proc$CommonResponse($GetConnection_1(this), this, 'ProcNewReport', onSuccess, onError));
  }
}
;
_.FormZoom = function FormZoom_1(fieldId, onShowMessageFunc, updateFieldsFunc, autoRetrieveFirstRows, params, onSuccess, onError){
  var proc;
  proc = this;
  $ProcParamZoomMobAsync($GetConnection_1(this), this.privateSession, fromInt(fieldId), new Proc$3($GetConnection_1(this), proc, fieldId, onSuccess, onShowMessageFunc, updateFieldsFunc, onError, autoRetrieveFirstRows, params));
}
;
_.GetProc = function GetProc(){
  return GetProc_0(this);
}
;
_.InputChoose = function InputChoose(ok, selection, onSuccess, onError){
  var titleMsg, cleanMsg, printMsg, allRecordsMsg;
  if (this.ename_0 == ($clinit_PriCommon() , LabelsPrint)) {
    ok == 0?$LabelsContinue(this.form_0, 0, selection, false, false, false, onSuccess, onError, this.progressFunc):(this.LastLabelsSelection = selection , titleMsg = dynamicCastToString($get_1(($clinit_Form() , $clinit_Form() , LabelsMessages), valueOf(1100))) , cleanMsg = dynamicCastToString($get_1((null , LabelsMessages), valueOf(1099))) , printMsg = dynamicCastToString($get_1((null , LabelsMessages), valueOf(1041))) , allRecordsMsg = dynamicCastToString($get_1((null , LabelsMessages), valueOf(1094))) , InvokeLabelsInput(this, this.LastLabelsObject, titleMsg, cleanMsg, printMsg, allRecordsMsg, onSuccess) , undefined);
    return;
  }
  ok == 0?$CancelProcedure(this, false, false, onSuccess, onError):$ProcChooseFieldsOKMobAsync($GetConnection_1(this), this.privateSession, fromInt(selection), new Proc$CommonResponse($GetConnection_1(this), this, 'ProcChooseFieldsOK', onSuccess, onError));
}
;
_.InputFields = function InputFields(ok, data_0, onSuccess, onError){
  var jo, json, ret;
  if (this.ename_0 == ($clinit_PriCommon() , LabelsPrint)) {
    ok == 0?$LabelsContinue(this.form_0, 0, this.LastLabelsSelection, false, false, false, onSuccess, onError, this.progressFunc):$LabelsRun(this, data_0, onSuccess, onError);
    return;
  }
  if (ok == 0) {
    $CancelProcedure(this, false, false, onSuccess, onError);
  }
   else {
    jo = new JSONObject_0(data_0);
    ret = $DatesToISO(this, jo, 'EditFields');
    if (!ret.success) {
      InvokeError_1(this, ret.errVal, this.isOnServer, onError);
      return;
    }
    json = b64encode($toString_0(jo));
    $ProcEditFieldsOKMobAsync($GetConnection_1(this), this.privateSession, json, new Proc$CommonResponse($GetConnection_1(this), this, 'ProcEditFieldsOK', onSuccess, onError));
  }
}
;
_.InputHelp = function InputHelp(ok, onSuccess, onError){
  ok == 0?$CancelProcedure(this, false, false, onSuccess, onError):$ProcContinueMobAsync($GetConnection_1(this), this.privateSession, new Proc$CommonResponse($GetConnection_1(this), this, 'ProcContinue', onSuccess, onError));
}
;
_.OpenChoose = function OpenChoose(fieldId, value_0, data_0, onSuccess, onError){
  var field, isBefore183, isDate, jo, json, proc, ret;
  field = dynamicCast($get_1(this.inputFields_0, valueOf(fieldId)), 53);
  proc = this;
  if (!field) {
    InvokeError_1(this, 'Field not found: ' + fieldId, false, onError);
  }
   else {
    jo = new JSONObject_0(data_0);
    ret = $DatesToISO(this, jo, 'ChooseFields');
    if (!ret.success) {
      InvokeError_1(this, ret.errVal, this.isOnServer, onError);
      return;
    }
    json = b64encode($toString_0(jo));
    isBefore183 = ($clinit_PriCommon() , MajorVersion) < 18 || MajorVersion == 18 && MinorVersion < 3;
    isDate = field.zoomtype == ($clinit_ZoomTypes() , Date8_0) || field.zoomtype == Date10_0 || field.zoomtype == Date14_0;
    $ProcParamChooseMobAsync($GetConnection_1(this), this.privateSession, fromInt(isBefore183 && isDate?-1:fieldId), json, new Proc$6(this, $GetConnection_1(this), field, proc, onSuccess, fieldId, value_0, json, onError));
  }
}
;
_.ProcCheckSupported = function ProcCheckSupported(funcname, onError){
  return $ProcCheckSupported(this, funcname, onError);
}
;
_.ProcContinue = function ProcContinue(onSuccess, onError){
  $ProcContinue(this, onSuccess, onError);
}
;
_.ProcMessageHidden = function ProcMessageHidden(ok, onSuccess, onError){
  if (this.lastMessageType == ($clinit_PriCommon$PriMessageType() , Ok)) {
    if (this.lastResponse) {
      ++this.MsgCounter;
      $ProcStep(this, this.lastResponse, this.lastOperation, false, onSuccess, onError);
    }
     else {
      $ProcContinue(this, onSuccess, onError);
    }
  }
   else 
    this.lastMessageType == IPWarning?$ProcStep(this, this.lastResponse, this.lastOperation, false, onSuccess, onError):ok == 1?$ProcWarningOKMobAsync($GetConnection_1(this), this.privateSession, new Proc$CommonResponse($GetConnection_1(this), this, 'ProcWarningOK', onSuccess, onError)):$CancelProcedure(this, false, false, onSuccess, onError);
}
;
_.ReportOptions = function ReportOptions(ok, selectedFormat, options, onSuccess, onError){
  $ReportOptions(this, ok, selectedFormat, options, onSuccess, onError);
}
;
_.SearchAction = function SearchAction_0(fieldId, value_0, action, data_0, onSuccess, onError){
  var count, from, i, lastval, proc, resp, to;
  proc = this;
  count = this.SearchLast.array.length;
  lastval = '';
  if (action == ($clinit_SearchActions() , Prev).intValue) {
    action = Next.intValue;
    if (count > 0) {
      from = count - 2;
      to = (2 < count?2:count) + (0 > count - 2?0:count - 2);
      for (i = to - 1; i >= from; i--)
        this.SearchLast.remove(i);
    }
    count -= 2;
  }
  action == Next.intValue && count > 0?(lastval = dynamicCastToString($get_2(this.SearchLast, count - 1))):(this.SearchLast.array = initDim(Ljava_lang_Object_2_classLit, $intern_5, 1, 0, 3, 1));
  resp = new Proc$5(this, $GetConnection_1(this), proc, onSuccess, onError);
  if (action == Next.intValue && ($clinit_PriCommon() , 6 <= BuildVersion)) {
    ++this.SearchLastPage;
    $ProcParamSearchPageMobAsync($GetConnection_1(this), this.privateSession, fromInt(fieldId), fromInt(this.SearchLastPage), this.SearchCursor, this.SearchStart, lastval, value_0, resp);
  }
   else {
    this.SearchLastPage = 0;
    $ProcParamSearchMobAsync($GetConnection_1(this), this.privateSession, fromInt(fieldId), fromInt(action), this.SearchCursor, this.SearchStart, lastval, value_0, null, resp);
  }
}
;
_.ServerTripCompleted = function ServerTripCompleted_1(sender, e){
  this.isOnServer = false;
}
;
_.SetIsGoneToServer = function SetIsGoneToServer_1(userState){
  if (this.isOnServer)
    return false;
  this.isOnServer = true;
  return true;
}
;
_.UploadDataUrl_0 = function UploadDataUrl_1(dataUrl, type_0, onProgress, onSuccess, onError){
  if (!$ProcCheckSupported(this, 'uploadDataUrl', onError))
    return;
  if (dataUrl == '') {
    InvokeError_1(this, 'empty data.', false, onError);
    return;
  }
  this.isCancelFileUpload = false;
  $UploadFile_2(this, 0, 'c:/123456.' + type_0, dataUrl, onProgress, onSuccess, onError);
}
;
_.UploadFile_2 = function UploadFile_2(uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError){
  $UploadFile_2(this, uploadFileSection, fileName, fileContents, onProgress, onSuccess, onError);
}
;
_.UploadFile_3 = function UploadFile_3(file, onProgress, onSuccess, onError){
  if (!$ProcCheckSupported(this, 'uploadFile', onError))
    return;
  if (!file) {
    InvokeError_1(this, 'file is null.', this.isOnServer, onError);
    return;
  }
  this.isCancelFileUpload = false;
  ReadFile_0(this, file, onProgress, onSuccess, onError);
}
;
_.getDname = function getDname_1(){
  return this.dname;
}
;
_.getSession = function getSession_0(){
  return this.privateSession;
}
;
_.isCancelFileUpload_0 = function isCancelFileUpload_1(){
  return this.isCancelFileUpload;
}
;
_.setCancelFileUpload = function setCancelFileUpload_1(cancel){
  this.isCancelFileUpload = cancel;
}
;
_.LastLabelsSelection = 0;
_.MsgCounter = 0;
_.SearchCursor = {l:0, m:0, h:0};
_.SearchLastPage = 0;
_.SearchStart = {l:0, m:0, h:0};
_.SentIpWarning = false;
_.cancelCon = null;
_.con = null;
_.dname = null;
_.errCount = 0;
_.excelTemplate_0 = 0;
_.isCancelFileUpload = false;
_.isCanceling = false;
_.isFinished = false;
_.isOnServer = false;
_.progressFunc = null;
_.spreadsheet = 0;
_.waitAutoProgress = false;
_.waitMS = 0;
var ExtMessages;
var Lcom_priority_app_proc_Proc_2_classLit = createForClass('com.priority.app.proc', 'Proc', 36);
function Proc$1(this$0, $anonymous0, val$onSuccess, val$onError, val$thisProc){
  this.this$01 = this$0;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  this.val$thisProc5 = val$thisProc;
  WCFResponse.call(this, $anonymous0);
}

defineClass(137, 8, {}, Proc$1);
_.OnPriError = function OnPriError_38(error, isOnServer){
  InvokeError_1(this.val$thisProc5, error, isOnServer, this.val$onError4);
}
;
_.OnPriResponse = function OnPriResponse_38(response){
  var e, jo;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    $ProcStep(this.this$01, jo, 'ProcStart', true, this.val$onSuccess3, this.val$onError4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_1(this.val$thisProc5, e.getMessage(), false, this.val$onError4);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_proc_Proc$1_2_classLit = createForClass('com.priority.app.proc', 'Proc/1', 137);
function Proc$2(this$0, $anonymous0, val$onSuccess, val$onError, val$thisProc){
  this.this$01 = this$0;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
  this.val$thisProc5 = val$thisProc;
  WCFResponse.call(this, $anonymous0);
}

defineClass(138, 8, {}, Proc$2);
_.OnPriError = function OnPriError_39(error, isOnServer){
  InvokeError_1(this.val$thisProc5, error, isOnServer, this.val$onError4);
}
;
_.OnPriResponse = function OnPriResponse_39(response){
  var e, jo;
  try {
    jo = ($clinit_JSONParser() , parse_0(response));
    $ProcStep(this.this$01, jo, 'ProcStartActivate', true, this.val$onSuccess3, this.val$onError4);
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 6)) {
      e = $e0;
      InvokeError_1(this.val$thisProc5, e.getMessage(), false, this.val$onError4);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
var Lcom_priority_app_proc_Proc$2_2_classLit = createForClass('com.priority.app.proc', 'Proc/2', 138);
function Proc$3($anonymous0, val$proc, val$fieldId, val$onSuccess, val$onShowMessageFunc, val$updateFieldsFunc, val$onError, val$autoRetrieveFirstRows, val$params){
  this.val$proc3 = val$proc;
  this.val$fieldId4 = val$fieldId;
  this.val$onSuccess5 = val$onSuccess;
  this.val$onShowMessageFunc6 = val$onShowMessageFunc;
  this.val$updateFieldsFunc7 = val$updateFieldsFunc;
  this.val$onError8 = val$onError;
  this.val$autoRetrieveFirstRows9 = val$autoRetrieveFirstRows;
  this.val$params10 = val$params;
  WCFResponse.call(this, $anonymous0);
}

defineClass(139, 8, {}, Proc$3);
_.OnPriError = function OnPriError_40(error, isOnServer){
  InvokeError_1(this.val$proc3, error, isOnServer, this.val$onError8);
}
;
_.OnPriResponse = function OnPriResponse_40(response){
  var formzoom, jo, pa, pr;
  jo = ($clinit_JSONParser() , dynamicCast(parse_0(response), 5));
  pa = dynamicCast($get_0(jo, 'Procedure'), 7);
  pr = dynamicCast($get(pa, 0), 5);
  formzoom = new FormZoom_0(pr.jsObject, this.val$proc3, this.val$fieldId4);
  if (!$equals(formzoom.nativeZoom.step, 'form')) {
    InvokeZoomValue(this.val$proc3, 0, this.val$fieldId4, '', this.val$onSuccess5);
    return;
  }
  FormStartZoom(formzoom.nativeZoom.formname, this.val$onShowMessageFunc6, this.val$updateFieldsFunc7, this.val$onSuccess5, this.val$onError8, this.val$autoRetrieveFirstRows9, this.val$proc3.jsDname, this.val$params10, formzoom);
}
;
_.val$autoRetrieveFirstRows9 = 0;
_.val$fieldId4 = 0;
var Lcom_priority_app_proc_Proc$3_2_classLit = createForClass('com.priority.app.proc', 'Proc/3', 139);
function Proc$4($anonymous0, val$proc, val$onSuccess, val$onError){
  this.val$proc3 = val$proc;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(140, 8, {}, Proc$4);
_.OnPriError = function OnPriError_41(error, isOnServer){
  InvokeError_1(this.val$proc3, error, isOnServer, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_41(response){
  var editField, editFields, field, haszoom, jo, pa, par, parameters, pr, value_0;
  jo = ($clinit_JSONParser() , dynamicCast(parse_0(response), 5));
  pa = dynamicCast($get_0(jo, 'Procedure'), 7);
  pr = dynamicCast($get(pa, 0), 5);
  haszoom = round_int(getJSONNumberProperty(pr, 'haszoom'));
  parameters = dynamicCast($get_0(pr, 'Parameters'), 7);
  field = 0;
  value_0 = '';
  if (!!parameters && parameters.jsArray.length > 0) {
    par = dynamicCast($get(parameters, 0), 5);
    editFields = dynamicCast($get_0(par, 'EditField'), 7);
    if (editFields) {
      editField = dynamicCast($get(editFields, 0), 5);
      field = round_int(getJSONNumberProperty(editField, 'field'));
      value_0 = getJSONStringProperty(editField, 'value');
    }
  }
  InvokeZoomValue(this.val$proc3, haszoom, field, value_0, this.val$onSuccess4);
}
;
var Lcom_priority_app_proc_Proc$4_2_classLit = createForClass('com.priority.app.proc', 'Proc/4', 140);
function Proc$5(this$0, $anonymous0, val$proc, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$proc3 = val$proc;
  this.val$onSuccess4 = val$onSuccess;
  this.val$onError5 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(141, 8, {}, Proc$5);
_.OnPriError = function OnPriError_42(error, isOnServer){
  InvokeError_1(this.val$proc3, error, isOnServer, this.val$onError5);
}
;
_.OnPriResponse = function OnPriResponse_42(response){
  var jo, search;
  jo = ($clinit_JSONParser() , dynamicCast(parse_0(response), 5));
  search = $RefreshSearch(this.this$01, jo);
  search?InvokeSearch(this.val$proc3, search.jsObject, this.val$onSuccess4):InvokeError_1(this.val$proc3, 'Error in choose/search', this.this$01.isOnServer, this.val$onError5);
}
;
var Lcom_priority_app_proc_Proc$5_2_classLit = createForClass('com.priority.app.proc', 'Proc/5', 141);
function Proc$6(this$0, $anonymous0, val$field, val$proc, val$onSuccess, val$fieldId, val$value, val$json, val$onError){
  this.this$01 = this$0;
  this.val$field3 = val$field;
  this.val$proc4 = val$proc;
  this.val$onSuccess5 = val$onSuccess;
  this.val$fieldId6 = val$fieldId;
  this.val$value7 = val$value;
  this.val$json8 = val$json;
  this.val$onError9 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(142, 8, {}, Proc$6);
_.OnPriError = function OnPriError_43(error, isOnServer){
  InvokeError_1(this.val$proc4, error, isOnServer, this.val$onError9);
}
;
_.OnPriResponse = function OnPriResponse_43(response){
  var choose, choosearr, chooselines, jo, pa, pr;
  chooselines = null;
  choose = null;
  jo = ($clinit_JSONParser() , parse_0(response));
  pa = dynamicCast($get_0(dynamicCast(jo, 5), 'Procedure'), 7);
  pr = dynamicCast($get(pa, 0), 5);
  choosearr = dynamicCast($get_0(pr, 'Choose'), 7);
  if (choosearr) {
    choose = dynamicCast($get(choosearr, 0), 5);
    !!choose && (chooselines = dynamicCast($get_0(choose, 'ChooseLine'), 7));
  }
  if (!!chooselines && chooselines.jsArray.length > 0) {
    $equals('date', this.val$field3.columntype.inputType) && $ChooseDatesToISO(chooselines);
    InvokeChoose(this.val$proc4, choose.jsObject, this.val$onSuccess5);
  }
   else {
    this.this$01.SearchLast.array = initDim(Ljava_lang_Object_2_classLit, $intern_5, 1, 0, 3, 1);
    this.this$01.SearchLastPage = 0;
    $ProcParamSearchMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, fromInt(this.val$fieldId6), fromInt(($clinit_SearchActions() , Start).intValue), {l:0, m:0, h:0}, {l:0, m:0, h:0}, '', this.val$value7, this.val$json8, new Proc$6$1(this, $GetConnection_1(this.this$01), this.val$field3, this.val$proc4, this.val$onSuccess5, this.val$onError9));
  }
}
;
_.val$fieldId6 = 0;
var Lcom_priority_app_proc_Proc$6_2_classLit = createForClass('com.priority.app.proc', 'Proc/6', 142);
function Proc$6$1(this$1, $anonymous0, val$field, val$proc, val$onSuccess, val$onError){
  this.this$11 = this$1;
  this.val$field3 = val$field;
  this.val$proc4 = val$proc;
  this.val$onSuccess5 = val$onSuccess;
  this.val$onError6 = val$onError;
  WCFResponse.call(this, $anonymous0);
}

defineClass(143, 8, {}, Proc$6$1);
_.OnPriError = function OnPriError_44(error, isOnServer){
  InvokeError_1(this.val$proc4, error, isOnServer, this.val$onError6);
}
;
_.OnPriResponse = function OnPriResponse_44(response){
  var chooselines, jo, search;
  jo = ($clinit_JSONParser() , dynamicCast(parse_0(response), 5));
  search = $RefreshSearch(this.this$11.this$01, jo);
  if (search) {
    chooselines = dynamicCast($get_0(search, 'SearchLine'), 7);
    $equals('date', this.val$field3.columntype.inputType) && $ChooseDatesToISO(chooselines);
    InvokeSearch(this.val$proc4, search.jsObject, this.val$onSuccess5);
  }
   else {
    InvokeError_1(this.val$proc4, 'Error in choose/search', this.this$11.this$01.isOnServer, this.val$onError6);
  }
}
;
var Lcom_priority_app_proc_Proc$6$1_2_classLit = createForClass('com.priority.app.proc', 'Proc/6/1', 143);
function Proc$7(this$0, val$onSuccess, val$killFlag, val$executionFlag, val$onError){
  this.this$01 = this$0;
  this.val$onSuccess2 = val$onSuccess;
  this.val$killFlag3 = val$killFlag;
  this.val$executionFlag4 = val$executionFlag;
  this.val$onError5 = val$onError;
}

defineClass(144, 1, {}, Proc$7);
_.execute = function execute_0(){
  if (this.this$01.isOnServer)
    return true;
  if (this.this$01.isFinished || IsNullOrEmpty(this.this$01.privateSession)) {
    !!this.val$onSuccess2 && InvokeEnd(this.this$01, this.val$onSuccess2);
    return false;
  }
  $CancelContinue(this.this$01, this.val$killFlag3, this.val$executionFlag4, this.val$onSuccess2, this.val$onError5);
  return false;
}
;
_.val$executionFlag4 = false;
_.val$killFlag3 = false;
var Lcom_priority_app_proc_Proc$7_2_classLit = createForClass('com.priority.app.proc', 'Proc/7', 144);
function Proc$8(this$0, val$thisProc, val$onSuccess, val$onError){
  this.this$01 = this$0;
  this.val$thisProc2 = val$thisProc;
  this.val$onSuccess3 = val$onSuccess;
  this.val$onError4 = val$onError;
}

defineClass(145, 1, {}, Proc$8);
_.execute = function execute_1(){
  this.this$01.waitAutoProgress?$ProcCheckExecutionMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, new Proc$WaitProcessResponse($GetConnection_1(this.this$01), this.val$thisProc2, 'ProcCheckExecution', this.val$onSuccess3, this.val$onError4)):$ProcContinueMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, new Proc$WaitProcessResponse($GetConnection_1(this.this$01), this.val$thisProc2, 'ProcContinue', this.val$onSuccess3, this.val$onError4));
  return false;
}
;
var Lcom_priority_app_proc_Proc$8_2_classLit = createForClass('com.priority.app.proc', 'Proc/8', 145);
function Proc$CommonResponse(con, proc, operation, onSuccess, onError){
  WCFResponse.call(this, con);
  this.proc_0 = proc;
  this.operation = operation;
  this.onSuccess = onSuccess;
  this.onError = onError;
}

defineClass(24, 8, {}, Proc$CommonResponse);
_.OnPriError = function OnPriError_45(error, isOnServer){
  !!this.onError && InvokeError_1(this.proc_0, error, isOnServer, this.onError);
}
;
_.OnPriResponse = function OnPriResponse_45(response){
  var e, jo;
  if (this.onSuccess) {
    try {
      jo = ($clinit_JSONParser() , parse_0(response));
      $ProcStep(this.proc_0, jo, this.operation, true, this.onSuccess, this.onError);
    }
     catch ($e0) {
      $e0 = wrap($e0);
      if (instanceOf($e0, 6)) {
        e = $e0;
        InvokeError_1(this.proc_0, e.getMessage(), false, this.onError);
      }
       else 
        throw unwrap_5($e0);
    }
  }
}
;
var Lcom_priority_app_proc_Proc$CommonResponse_2_classLit = createForClass('com.priority.app.proc', 'Proc/CommonResponse', 24);
function Proc$InputField(columntype, zoomtype, width_0){
  this.columntype = columntype;
  this.zoomtype = zoomtype;
  this.width_0 = width_0;
}

defineClass(53, 1, {53:1}, Proc$InputField);
_.width_0 = 0;
var Lcom_priority_app_proc_Proc$InputField_2_classLit = createForClass('com.priority.app.proc', 'Proc/InputField', 53);
function Proc$ProcFileUploader(this$0, holder){
  this.this$01 = this$0;
  FileUploader.call(this, holder);
}

defineClass(135, 77, {}, Proc$ProcFileUploader);
_.ServerUpload = function ServerUpload_0(uploadmode, finished, segment, fileName, fileSection, last, fileContents, onProgress, onSuccess, onError, userState){
  var proc, uploadStep;
  proc = dynamicCast(this.holder, 36);
  uploadStep = $equals('upload', proc.CurrentStep);
  finished?uploadStep?$ProcUploadFileMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, {l:2, m:0, h:0}, b64encode(''), new Proc$UploadResponse($GetConnection_1(this.this$01), proc, 'ProcUploadFile', '', fileSection, true, fileContents, onProgress, onSuccess, onError)):$ProcUploadFileParamMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, {l:2, m:0, h:0}, b64encode(''), fileName, new Proc$UploadResponse($GetConnection_1(this.this$01), proc, 'ProcUploadFileParam', fileName, fileSection, true, fileContents, onProgress, onSuccess, onError)):uploadStep?$ProcUploadFileMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, fromInt(uploadmode), segment, new Proc$UploadResponse($GetConnection_1(this.this$01), proc, 'ProcUploadFile', '', fileSection, false, fileContents, onProgress, onSuccess, onError)):$ProcUploadFileParamMobAsync($GetConnection_1(this.this$01), this.this$01.privateSession, fromInt(uploadmode), segment, fileName, new Proc$UploadResponse($GetConnection_1(this.this$01), proc, 'ProcUploadFileParam', fileName, fileSection, false, fileContents, onProgress, onSuccess, onError));
}
;
_.UploadCancel = function UploadCancel_0(onSuccess, onError){
  var proc, ret;
  proc = dynamicCast(this.holder, 36);
  ret = {};
  ret.proc = proc.GetProc();
  ret.type = 'uploadCancelled';
  ret.message = 'File upload was cancelled.';
  onError(ret);
}
;
var Lcom_priority_app_proc_Proc$ProcFileUploader_2_classLit = createForClass('com.priority.app.proc', 'Proc/ProcFileUploader', 135);
function Proc$RetObj(){
}

defineClass(136, 1, {}, Proc$RetObj);
_.success = false;
var Lcom_priority_app_proc_Proc$RetObj_2_classLit = createForClass('com.priority.app.proc', 'Proc/RetObj', 136);
function Proc$UploadResponse(con, proc, operation, filename, uploadFileSection, islast, contents, onProgress, onSuccess, onError){
  WCFResponse.call(this, con);
  this.proc_0 = proc;
  this.operation = operation;
  this.onSuccess = onSuccess;
  this.onProgress = onProgress;
  this.onError = onError;
  this.filename_0 = filename;
  this.uploadFileSection = uploadFileSection;
  this.islast = islast;
  this.contents = contents;
}

defineClass(52, 8, {}, Proc$UploadResponse);
_.OnPriError = function OnPriError_46(error, isOnServer){
  !!this.onError && InvokeError_1(this.proc_0, error, isOnServer, this.onError);
}
;
_.OnPriResponse = function OnPriResponse_46(response){
  var e, fn, jo, messages, pa, prc, progress, step, uf, uf0;
  if (this.onSuccess) {
    try {
      jo = ($clinit_JSONParser() , parse_0(response));
      pa = dynamicCast($get_0(dynamicCast(jo, 5), 'Procedure'), 7);
      prc = dynamicCast($get(pa, 0), 5);
      step = null;
      !!$get_0(prc, 'step') && (step = dynamicCast($get_0(prc, 'step'), 10).value_0);
      messages = dynamicCast($get_0(prc, 'Message'), 7);
      if (step != null && !$equals('upload', step) || !!messages)
        $ProcStep(this.proc_0, jo, this.operation, true, this.onSuccess, this.onError);
      else {
        if (this.islast) {
          InvokeUplaod(this.proc_0, 100, true, this.filename_0, this.onSuccess);
        }
         else {
          uf = dynamicCast($get_0(prc, 'File'), 7);
          uf0 = dynamicCast($get(uf, 0), 5);
          fn = dynamicCast($get_0(uf0, 'file'), 10).value_0;
          fn != null && fn.length > 0 && (this.filename_0 = fn);
          progress = $getProgress(this.uploadFileSection, this.contents);
          new JSONObject;
          InvokeUplaod(this.proc_0, progress, false, this.filename_0, this.onProgress);
          $UploadFile_2(this.proc_0, this.uploadFileSection + 1, this.filename_0, this.contents, this.onProgress, this.onSuccess, this.onError);
        }
      }
    }
     catch ($e0) {
      $e0 = wrap($e0);
      if (instanceOf($e0, 6)) {
        e = $e0;
        InvokeError_1(this.proc_0, e.getMessage(), false, this.onError);
      }
       else 
        throw unwrap_5($e0);
    }
  }
}
;
_.islast = false;
_.uploadFileSection = 0;
var Lcom_priority_app_proc_Proc$UploadResponse_2_classLit = createForClass('com.priority.app.proc', 'Proc/UploadResponse', 52);
function Proc$WaitProcessResponse(con, proc, operation, onSuccess, onError){
  WCFResponse.call(this, con);
  this.proc_0 = proc;
  this.operation = operation;
  this.onSuccess = onSuccess;
  this.onError = onError;
}

defineClass(76, 8, {}, Proc$WaitProcessResponse);
_.OnPriError = function OnPriError_47(error, isOnServer){
  if (this.proc_0.errCount >= 100) {
    $CancelProcedure(this.proc_0, true, this.proc_0.waitAutoProgress, this.onSuccess, this.onError);
  }
   else {
    ++this.proc_0.errCount;
    $WaitProcess(this.proc_0, this.proc_0.waitAutoProgress, this.onSuccess, this.onError);
  }
}
;
_.OnPriResponse = function OnPriResponse_47(response){
  var jo;
  if ($equals('ProcContinue', this.operation) || $equals('ProcCheckExecution', this.operation)) {
    jo = ($clinit_JSONParser() , parse_0(response));
    $WaitContinue(this.proc_0, jo, this.onSuccess, this.onError, this.operation);
  }
}
;
var Lcom_priority_app_proc_Proc$WaitProcessResponse_2_classLit = createForClass('com.priority.app.proc', 'Proc/WaitProcessResponse', 76);
function GetProc_0(thisProc){
  var proc = thisProc.proc_0;
  if (proc)
    return proc;
  proc = {};
  proc.title = thisProc.title_0;
  proc.name = thisProc.ename_0;
  proc.session = thisProc.getSession();
  proc.message = function(ok, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.ProcMessageHidden(ok, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        thisProc.ProcMessageHidden(ok, onSuccess, onError);
      }
      );
    }
  }
  ;
  proc.reportOptions = function(ok, selectedFormat, options, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.ReportOptions(ok, selectedFormat, options, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        thisProc.ReportOptions(ok, selectedFormat, options, onSuccess, onError);
      }
      );
    }
  }
  ;
  proc.documentOptions = function(ok, selectedFormat, options, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.DocumentOptions(ok, selectedFormat, options, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.DocumentOptions(ok, selectedFormat, options, onSuccess, onError);
      }
      );
  }
  ;
  proc.inputFields = function(ok, data_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.InputFields(ok, data_0, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.InputFields(ok, data_0, onSuccess, onError);
      }
      );
  }
  ;
  proc.inputOptions = function(ok, data_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.InputChoose(ok, data_0, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.InputChoose(ok, data_0, onSuccess, onError);
      }
      );
  }
  ;
  proc.inputHelp = function(ok, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.InputHelp(ok, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.InputHelp(ok, onSuccess, onError);
      }
      );
  }
  ;
  proc.continueProc = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.ProcContinue(onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.ProcContinue(onSuccess, onError);
      }
      );
  }
  ;
  proc.cancel = function(onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.CancelProcedure(onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.CancelProcedure(onSuccess, onError);
      }
      );
  }
  ;
  proc.choose = function(fieldId, value_0, data_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.OpenChoose(fieldId, value_0, data_0, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.OpenChoose(fieldId, value_0, data_0, onSuccess, onError);
      }
      );
  }
  ;
  proc.searchAction = function(fieldId, value_0, action, data_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.SearchAction(fieldId, value_0, action, data_0, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.SearchAction(fieldId, value_0, action, data_0, onSuccess, onError);
      }
      );
  }
  ;
  proc.uploadFile = function(file, onProgress, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.UploadFile_3(file, onProgress, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        thisProc.UploadFile_3(file, onProgress, onSuccess, onError);
      }
      );
    }
  }
  ;
  proc.uploadDataUrl = function(dataUrl, type_0, onProgress, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.UploadDataUrl_0(dataUrl, type_0, onProgress, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        thisProc.UploadDataUrl_0(dataUrl, type_0, onProgress, onSuccess, onError);
      }
      );
    }
  }
  ;
  proc.clientContinue = function(data_0, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.ClientContinue(data_0, onSuccess_0, onError_0);
    else {
      return new Promise(function(onSuccess, onError){
        thisProc.ClientContinue(data_0, onSuccess, onError);
      }
      );
    }
  }
  ;
  proc.formZoom = function(fieldId, onShowMessge, afterMessageShownFunc, autoRetrieveFirstRows, exParams, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0)
      thisProc.FormZoom(fieldId, onShowMessge, afterMessageShownFunc, autoRetrieveFirstRows, exParams, onSuccess_0, onError_0);
    else 
      return new Promise(function(onSuccess, onError){
        thisProc.FormZoom(fieldId, onShowMessge, afterMessageShownFunc, autoRetrieveFirstRows, exParams, onSuccess, onError);
      }
      );
  }
  ;
  proc.cancelFileUpload = function(){
    thisProc.isCancelFileUpload = true;
  }
  ;
  proc.isSupported = function(funcname){
    return thisProc.ProcCheckSupported(funcname, null);
  }
  ;
  thisProc.proc_0 = proc;
  return proc;
}

function InvokeChoose(thisProc, jo, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'Choose';
  delete jo.chooseid;
  delete jo.sortby;
  ret.Search = jo;
  onSuccess(ret);
}

function InvokeClient(thisProc, data_0, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'client';
  ret.data = data_0;
  onSuccess(ret);
}

function InvokeDisplayUrl(thisProc, urls, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'displayUrl';
  ret.Urls = urls;
  onSuccess(ret);
}

function InvokeDocumentOptions(thisProc, wantsPdf, hasAutoMail, formats, wordTemplates, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'documentOptions';
  ret.formats = formats;
  ret.wordTemplates = wordTemplates;
  ret.pdf = wantsPdf?1:0;
  ret.hasAutoMail = hasAutoMail?1:0;
  onSuccess(ret);
}

function InvokeEnd(thisProc, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'end';
  onSuccess(ret);
}

function InvokeError_1(thisProc, message, isOnServer, onError){
  var ret = {};
  ret.proc = thisProc?thisProc.GetProc():null;
  ret.type = isOnServer?'ServerBusy':'Error';
  ret.message = message;
  onError(ret);
}

function InvokeInput(thisProc, inputObj, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  var type_0 = 'inputHelp';
  inputObj.EditFields?(type_0 = 'inputFields'):(inputObj.ChooseFields || inputObj.Options) && (type_0 = 'inputOptions');
  ret.type = type_0;
  ret.input = inputObj;
  onSuccess(ret);
}

function InvokeLabels(thisProc, labelsObj, onSuccess, title_0){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'inputOptions';
  ret.input = {};
  ret.input.title = title_0;
  ret.input.Options = [];
  for (var i = 0; i < labelsObj.labels.length; i++) {
    ret.input.Options[i] = {};
    ret.input.Options[i].field = labelsObj.labels[i].label;
    ret.input.Options[i].helpstring = '';
    ret.input.Options[i].name = '';
    ret.input.Options[i].selected = i == 0?1:0;
    ret.input.Options[i].title = labelsObj.labels[i].labelname;
  }
  onSuccess(ret);
}

function InvokeLabelsInput(thisProc, labelsObj, titleMsg, cleanMsg, printMsg, allRecordsMsg, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'inputFields';
  ret.input = {};
  ret.input.EditFields = [];
  ret.input.title = titleMsg;
  var mayprint = 0;
  var wantslines = 0;
  var wantsclean = 0;
  var wantsprint = 0;
  if (labelsObj.labels && labelsObj.labels.length > 0) {
    var l = labelsObj.labels[0];
    mayprint = l.mayprint;
    wantslines = l.wantslines;
    wantsclean = l.wantsclean;
    wantsprint = l.wantsprint;
  }
  LabelsAddField(0, allRecordsMsg, wantslines, ret);
  LabelsAddField(1, cleanMsg, wantsclean, ret);
  mayprint && LabelsAddField(2, printMsg, wantsprint, ret);
  ret.input.Operators = [];
  ret.input.Operators[0] = {};
  var op = ret.input.Operators[0];
  op.name = '= ';
  op.op = 0;
  op.title = '';
  onSuccess(ret);
}

function InvokeMessage(thisProc, message, messageType, HyperLinks, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'message';
  ret.message = message;
  ret.hyperlinks = HyperLinks;
  ret.messagetype = messageType;
  onSuccess(ret);
}

function InvokeNotSupported(thisProc, step, onError){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'NotSupported';
  ret.message = 'step ' + step + ' is not supported';
  onError(ret);
}

function InvokeProgress(thisProc, progress, onProgress){
  onProgress && onProgress(thisProc.GetProc(), progress);
}

function InvokeReportOptions(thisProc, showExcel, formats, excelTemplates, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'reportOptions';
  ret.formats = formats;
  ret.hasExcel = showExcel?1:0;
  var sendTemplates = [];
  var j = 0;
  if (excelTemplates != null) {
    for (var i = 0; i < excelTemplates.length; i++) {
      var t = excelTemplates[i];
      if (t.oldtemplate != 1 && t.template) {
        var newt = {};
        newt.selected = t.selected;
        newt.template = t.template;
        newt.title = t.title;
        sendTemplates[j] = newt;
        j++;
      }
    }
  }
  ret.excelTemplates = sendTemplates;
  onSuccess(ret);
}

function InvokeSearch(thisProc, jo, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'Search';
  delete jo.stack_last;
  delete jo.stack_cursor;
  delete jo.stack_start;
  delete jo.start;
  ret.Search = jo;
  onSuccess(ret);
}

function InvokeUplaod(thisProc, progress, isLast, filename, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.progress = progress;
  isLast && filename != null && filename != '' && (ret.file = filename);
  onSuccess(ret);
}

function InvokeZoomValue(thisProc, haszoom, field, value_0, onSuccess){
  var ret = {};
  ret.proc = thisProc.GetProc();
  ret.type = 'zoomvalue';
  ret.haszoom = haszoom;
  ret.field = field;
  ret.value = value_0;
  onSuccess(ret);
}

function LabelsAddField(index_0, title_0, value_0, ret){
  ret.input.EditFields[index_0] = {};
  var field = ret.input.EditFields[index_0];
  field.field = index_0 + 1;
  field.helpstring = '';
  field.ispassword = 0;
  field.mandatory = 0;
  field.operator = 0;
  field.readonly = 0;
  field.readonlyoperator = 1;
  field.title = title_0;
  field.type = 'bool';
  field.code = 'Char';
  field.value = value_0;
  field.value1 = '';
  field.maxlength = 1;
  field.zoom = 'None';
  field.format = '';
}

function ProcStart(ename, type_0, progressFunc, dn, onSuccess, onError){
  var p;
  if (loginResult <= 0 && !$equals('CHPWD2', ename)) {
    InvokeError_1(null, "Can't start form/procedure because login wasn't successful", false, onError);
    return;
  }
  p = new Proc;
  p.progressFunc = progressFunc;
  p.jsDname = dn;
  p.dname = GetDName(dn);
  $ProcStart(p, ename, type_0, onSuccess, onError);
}

function ProcStartActivate(ename, type_0, link_0, progressFunc, dn, onSuccess, onError){
  var p, lnk;
  p = new Proc;
  p.progressFunc = progressFunc;
  p.jsDname = dn;
  p.dname = GetDName(dn);
  lnk = link_0;
  p.ename_0 = ename;
  p.etype_0 = type_0;
  $ProcStartActivateMobAsync($GetConnection_1(p), type_0, ename, lnk.table, lnk.link, lnk.linkid, !!ExtMessages && ExtMessages.size_0 != 0, new Proc$2(p, $GetConnection_1(p), onSuccess, onError, p));
}

function publishAPIfuncProc(){
  $wnd.procStart = function(ename, type_0, onProgress, dname, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      ProcStart(ename, type_0, onProgress, dname, onSuccess_0, onError_0);
    }
     else 
      return new Promise(function(onSuccess, onError){
        ProcStart(ename, type_0, onProgress, dname, onSuccess, onError);
      }
      );
  }
  ;
  $wnd.procStartActivate = function(ename, type_0, link_0, onProgress, dname, onSuccess_0, onError_0){
    if (onSuccess_0 || onError_0) {
      ProcStartActivate(ename, type_0, link_0, onProgress, dname, onSuccess_0, onError_0);
    }
     else 
      return new Promise(function(onSuccess, onError){
        ProcStartActivate(ename, type_0, link_0, onProgress, dname, onSuccess, onError);
      }
      );
  }
  ;
}

function AbstractStringBuilder(string){
  this.string = string;
}

defineClass(69, 1, {});
_.toString$ = function toString_11(){
  return this.string;
}
;
var Ljava_lang_AbstractStringBuilder_2_classLit = createForClass('java.lang', 'AbstractStringBuilder', 69);
function ArithmeticException(){
  RuntimeException_0.call(this, 'divide by zero');
}

defineClass(102, 19, $intern_2, ArithmeticException);
var Ljava_lang_ArithmeticException_2_classLit = createForClass('java.lang', 'ArithmeticException', 102);
function ArrayStoreException(){
  RuntimeException.call(this);
}

defineClass(48, 19, $intern_2, ArrayStoreException);
var Ljava_lang_ArrayStoreException_2_classLit = createForClass('java.lang', 'ArrayStoreException', 48);
function $clinit_Boolean(){
  $clinit_Boolean = emptyMethod;
  FALSE_0 = new Boolean_0(false);
  TRUE_0 = new Boolean_0(true);
}

function Boolean_0(value_0){
  this.value_0 = value_0;
}

defineClass(38, 1, {4:1, 38:1, 25:1}, Boolean_0);
_.equals$ = function equals_5(o){
  return instanceOf(o, 38) && dynamicCast(o, 38).value_0 == this.value_0;
}
;
_.hashCode$ = function hashCode_6(){
  return this.value_0?1231:1237;
}
;
_.toString$ = function toString_12(){
  return '' + this.value_0;
}
;
_.value_0 = false;
var FALSE_0, TRUE_0;
var Ljava_lang_Boolean_2_classLit = createForClass('java.lang', 'Boolean', 38);
function digit(c){
  if (c >= 48 && c < 58) {
    return c - 48;
  }
  if (c >= 97 && c < 97) {
    return c - 97 + 10;
  }
  if (c >= 65 && c < 65) {
    return c - 65 + 10;
  }
  return -1;
}

function ClassCastException(){
  RuntimeException.call(this);
}

defineClass(37, 19, $intern_2, ClassCastException);
var Ljava_lang_ClassCastException_2_classLit = createForClass('java.lang', 'ClassCastException', 37);
function __parseAndValidateInt(s){
  var i, isTooLow, length_0, startIndex, toReturn;
  if (s == null) {
    throw new NumberFormatException('null');
  }
  length_0 = s.length;
  startIndex = length_0 > 0 && (s.charCodeAt(0) == 45 || s.charCodeAt(0) == 43)?1:0;
  for (i = startIndex; i < length_0; i++) {
    if (digit(s.charCodeAt(i)) == -1) {
      throw new NumberFormatException('For input string: "' + s + '"');
    }
  }
  toReturn = parseInt(s, 10);
  isTooLow = toReturn < $intern_12;
  if (isNaN(toReturn)) {
    throw new NumberFormatException('For input string: "' + s + '"');
  }
   else if (isTooLow || toReturn > $intern_0) {
    throw new NumberFormatException('For input string: "' + s + '"');
  }
  return toReturn;
}

defineClass(59, 1, {4:1, 59:1});
var Ljava_lang_Number_2_classLit = createForClass('java.lang', 'Number', 59);
function Double(value_0){
  this.value_0 = value_0;
}

defineClass(49, 59, {4:1, 25:1, 49:1, 59:1}, Double);
_.equals$ = function equals_6(o){
  return instanceOf(o, 49) && dynamicCast(o, 49).value_0 == this.value_0;
}
;
_.hashCode$ = function hashCode_7(){
  return round_int(this.value_0);
}
;
_.toString$ = function toString_14(){
  return '' + this.value_0;
}
;
_.value_0 = 0;
var Ljava_lang_Double_2_classLit = createForClass('java.lang', 'Double', 49);
function IllegalArgumentException(){
  RuntimeException.call(this);
}

function IllegalArgumentException_0(message){
  RuntimeException_0.call(this, message);
}

defineClass(29, 19, $intern_2, IllegalArgumentException, IllegalArgumentException_0);
var Ljava_lang_IllegalArgumentException_2_classLit = createForClass('java.lang', 'IllegalArgumentException', 29);
function IllegalStateException(){
  RuntimeException_0.call(this, "Can't overwrite cause");
}

defineClass(191, 19, $intern_2, IllegalStateException);
var Ljava_lang_IllegalStateException_2_classLit = createForClass('java.lang', 'IllegalStateException', 191);
function IndexOutOfBoundsException(message){
  RuntimeException_0.call(this, message);
}

defineClass(61, 19, $intern_2, IndexOutOfBoundsException);
var Ljava_lang_IndexOutOfBoundsException_2_classLit = createForClass('java.lang', 'IndexOutOfBoundsException', 61);
function Integer(value_0){
  this.value_0 = value_0;
}

function numberOfLeadingZeros_0(i){
  var m, n, y_0;
  if (i < 0) {
    return 0;
  }
   else if (i == 0) {
    return 32;
  }
   else {
    y_0 = -(i >> 16);
    m = y_0 >> 16 & 16;
    n = 16 - m;
    i = i >> m;
    y_0 = i - 256;
    m = y_0 >> 16 & 8;
    n += m;
    i <<= m;
    y_0 = i - 4096;
    m = y_0 >> 16 & 4;
    n += m;
    i <<= m;
    y_0 = i - 16384;
    m = y_0 >> 16 & 2;
    n += m;
    i <<= m;
    y_0 = i >> 14;
    m = y_0 & ~(y_0 >> 1);
    return n + 2 - m;
  }
}

function numberOfTrailingZeros(i){
  var r, rtn;
  if (i == 0) {
    return 32;
  }
   else {
    rtn = 0;
    for (r = 1; (r & i) == 0; r <<= 1) {
      ++rtn;
    }
    return rtn;
  }
}

function toUnsignedRadixString(value_0, radix){
  return (value_0 >>> 0).toString(radix);
}

function valueOf(i){
  var rebase, result;
  if (i > -129 && i < 128) {
    rebase = i + 128;
    result = ($clinit_Integer$BoxedValues() , boxedValues_0)[rebase];
    !result && (result = boxedValues_0[rebase] = new Integer(i));
    return result;
  }
  return new Integer(i);
}

defineClass(15, 59, {4:1, 25:1, 15:1, 59:1}, Integer);
_.equals$ = function equals_7(o){
  return instanceOf(o, 15) && dynamicCast(o, 15).value_0 == this.value_0;
}
;
_.hashCode$ = function hashCode_8(){
  return this.value_0;
}
;
_.toString$ = function toString_15(){
  return '' + this.value_0;
}
;
_.value_0 = 0;
var Ljava_lang_Integer_2_classLit = createForClass('java.lang', 'Integer', 15);
function $clinit_Integer$BoxedValues(){
  $clinit_Integer$BoxedValues = emptyMethod;
  boxedValues_0 = initDim(Ljava_lang_Integer_2_classLit, $intern_5, 15, 256, 0, 1);
}

var boxedValues_0;
function max_0(x_0, y_0){
  return x_0 > y_0?x_0:y_0;
}

function min_0(x_0){
  return x_0 < 5?x_0:5;
}

function NullPointerException(){
  RuntimeException.call(this);
}

function NullPointerException_0(message){
  RuntimeException_0.call(this, message);
}

defineClass(33, 19, $intern_2, NullPointerException, NullPointerException_0);
var Ljava_lang_NullPointerException_2_classLit = createForClass('java.lang', 'NullPointerException', 33);
function NumberFormatException(message){
  IllegalArgumentException_0.call(this, message);
}

defineClass(56, 29, $intern_2, NumberFormatException);
var Ljava_lang_NumberFormatException_2_classLit = createForClass('java.lang', 'NumberFormatException', 56);
function StackTraceElement(methodName, fileName, lineNumber){
  this.className = 'Unknown';
  this.methodName = methodName;
  this.fileName = fileName;
  this.lineNumber = lineNumber;
}

defineClass(32, 1, {4:1, 32:1}, StackTraceElement);
_.equals$ = function equals_8(other){
  var st;
  if (instanceOf(other, 32)) {
    st = dynamicCast(other, 32);
    return this.lineNumber == st.lineNumber && equals_19(this.methodName, st.methodName) && equals_19(this.className, st.className) && equals_19(this.fileName, st.fileName);
  }
  return false;
}
;
_.hashCode$ = function hashCode_9(){
  return hashCode_15(initValues(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_5, 1, 3, [valueOf(this.lineNumber), this.className, this.methodName, this.fileName]));
}
;
_.toString$ = function toString_16(){
  return this.className + '.' + this.methodName + '(' + (this.fileName != null?this.fileName:'Unknown Source') + (this.lineNumber >= 0?':' + this.lineNumber:'') + ')';
}
;
_.lineNumber = 0;
var Ljava_lang_StackTraceElement_2_classLit = createForClass('java.lang', 'StackTraceElement', 32);
function $charAt(this$static, index_0){
  return this$static.charCodeAt(index_0);
}

function $endsWith(this$static, suffix){
  var suffixlength;
  suffixlength = suffix.length;
  return $equals(__substr(this$static, this$static.length - suffixlength, suffixlength), suffix);
}

function $equals(this$static, other){
  return this$static === other;
}

function $indexOf(this$static, str){
  return this$static.indexOf(str);
}

function $lastIndexOf(this$static, str){
  return this$static.lastIndexOf(str);
}

function $lastIndexOf_0(this$static, str, start_0){
  return this$static.lastIndexOf(str, start_0);
}

function $replace(this$static, from, to){
  var hex = toUnsignedRadixString(from, 16);
  var regex = '\\u' + '0000'.substring(hex.length) + hex;
  return this$static.replace(RegExp(regex, 'g'), String.fromCharCode(to));
}

function $split(this$static, regex, maxMatch){
  var compiled = new RegExp(regex, 'g');
  var out = [];
  var count = 0;
  var trail = this$static;
  var lastTrail = null;
  while (true) {
    var matchObj = compiled.exec(trail);
    if (matchObj == null || trail == '' || count == maxMatch - 1 && maxMatch > 0) {
      out[count] = trail;
      break;
    }
     else {
      out[count] = trail.substring(0, matchObj.index);
      trail = trail.substring(matchObj.index + matchObj[0].length, trail.length);
      compiled.lastIndex = 0;
      if (lastTrail == trail) {
        out[count] = trail.substring(0, 1);
        trail = trail.substring(1);
      }
      lastTrail = trail;
      count++;
    }
  }
  if (maxMatch == 0 && this$static.length > 0) {
    var lastNonEmpty = out.length;
    while (lastNonEmpty > 0 && out[lastNonEmpty - 1] == '') {
      --lastNonEmpty;
    }
    lastNonEmpty < out.length && out.splice(lastNonEmpty, out.length - lastNonEmpty);
  }
  var jr = __createArray(out.length);
  for (var i = 0; i < out.length; ++i) {
    jr[i] = out[i];
  }
  return jr;
}

function $startsWith(this$static, prefix){
  return $equals(__substr(this$static, 0, prefix.length), prefix);
}

function $substring(this$static, beginIndex){
  return __substr(this$static, beginIndex, this$static.length - beginIndex);
}

function $substring_0(this$static, beginIndex, endIndex){
  return this$static.substr(beginIndex, endIndex - beginIndex);
}

function $trim(this$static){
  if (this$static.length == 0 || this$static[0] > ' ' && this$static[this$static.length - 1] > ' ') {
    return this$static;
  }
  return this$static.replace(/^[\u0000-\u0020]*|[\u0000-\u0020]*$/g, '');
}

function __createArray(numElements){
  return initDim(Ljava_lang_String_2_classLit, $intern_5, 2, numElements, 4, 1);
}

function __substr(str, beginIndex, len){
  return str.substr(beginIndex, len);
}

function fromCodePoint(codePoint){
  var hiSurrogate, loSurrogate;
  if (codePoint >= 65536) {
    hiSurrogate = 55296 + (codePoint - 65536 >> 10 & 1023) & 65535;
    loSurrogate = 56320 + (codePoint - 65536 & 1023) & 65535;
    return valueOf_0(hiSurrogate) + valueOf_0(loSurrogate);
  }
   else {
    return String.fromCharCode(codePoint & 65535);
  }
}

function valueOf_0(x_0){
  return String.fromCharCode(x_0);
}

var Ljava_lang_String_2_classLit = createForClass('java.lang', 'String', 2);
function $clinit_String$HashCache(){
  $clinit_String$HashCache = emptyMethod;
  back_0 = {};
  front = {};
}

function compute(str){
  var hashCode, i, n, nBatch;
  hashCode = 0;
  n = str.length;
  nBatch = n - 4;
  i = 0;
  while (i < nBatch) {
    hashCode = str.charCodeAt(i + 3) + 31 * (str.charCodeAt(i + 2) + 31 * (str.charCodeAt(i + 1) + 31 * (str.charCodeAt(i) + 31 * hashCode)));
    hashCode = ~~hashCode;
    i += 4;
  }
  while (i < n) {
    hashCode = hashCode * 31 + $charAt(str, i++);
  }
  hashCode = ~~hashCode;
  return hashCode;
}

function getHashCode_0(str){
  $clinit_String$HashCache();
  var key = ':' + str;
  var result = front[key];
  if (result != null) {
    return result;
  }
  result = back_0[key];
  result == null && (result = compute(str));
  increment();
  return front[key] = result;
}

function increment(){
  if (count_0 == 256) {
    back_0 = front;
    front = {};
    count_0 = 0;
  }
  ++count_0;
}

var back_0, count_0 = 0, front;
function $append(this$static, x_0){
  this$static.string += x_0;
  return this$static;
}

function $append_0(this$static, x_0){
  this$static.string += x_0;
  return this$static;
}

function StringBuilder(){
  AbstractStringBuilder.call(this, '');
}

function StringBuilder_0(s){
  AbstractStringBuilder.call(this, s);
}

defineClass(34, 69, {228:1}, StringBuilder, StringBuilder_0);
var Ljava_lang_StringBuilder_2_classLit = createForClass('java.lang', 'StringBuilder', 34);
function UnsupportedOperationException(){
  RuntimeException.call(this);
}

function UnsupportedOperationException_0(message){
  RuntimeException_0.call(this, message);
}

defineClass(44, 19, $intern_2, UnsupportedOperationException, UnsupportedOperationException_0);
var Ljava_lang_UnsupportedOperationException_2_classLit = createForClass('java.lang', 'UnsupportedOperationException', 44);
function $advanceToFind(this$static, o){
  var e, iter;
  for (iter = this$static.iterator(); iter.hasNext();) {
    e = iter.next_0();
    if (maskUndefined(o) === maskUndefined(e) || o != null && equals_Ljava_lang_Object__Z__devirtual$(o, e)) {
      return true;
    }
  }
  return false;
}

function $containsAll(this$static, c){
  var e, e$iterator;
  checkNotNull(c);
  for (e$iterator = c.iterator(); e$iterator.hasNext();) {
    e = e$iterator.next_0();
    if (!this$static.contains(e)) {
      return false;
    }
  }
  return true;
}

defineClass(213, 1, {});
_.contains = function contains(o){
  return $advanceToFind(this, o);
}
;
_.toString$ = function toString_17(){
  var comma, e, e$iterator, sb;
  sb = new StringBuilder_0('[');
  comma = false;
  for (e$iterator = this.iterator(); e$iterator.hasNext();) {
    e = e$iterator.next_0();
    comma?(sb.string += ', ' , sb):(comma = true);
    sb.string += e === this?'(this Collection)':'' + e;
  }
  sb.string += ']';
  return sb.string;
}
;
var Ljava_util_AbstractCollection_2_classLit = createForClass('java.util', 'AbstractCollection', 213);
function $containsEntry(this$static, entry){
  var key, ourValue, value_0;
  key = entry.getKey();
  value_0 = entry.getValue();
  ourValue = isJavaString(key)?$getStringValue(this$static, key):getEntryValueOrNull($getEntry(this$static.hashCodeMap, key));
  if (!(maskUndefined(value_0) === maskUndefined(ourValue) || value_0 != null && equals_Ljava_lang_Object__Z__devirtual$(value_0, ourValue))) {
    return false;
  }
  if (ourValue == null && !(isJavaString(key)?$hasStringValue(this$static, key):!!$getEntry(this$static.hashCodeMap, key))) {
    return false;
  }
  return true;
}

function $implFindEntry(this$static, key){
  var entry, iter, k;
  for (iter = new AbstractHashMap$EntrySetIterator((new AbstractHashMap$EntrySet(this$static)).this$01); $hasNext(iter);) {
    entry = (checkStructuralChange(iter.this$01, iter) , checkCriticalElement($hasNext(iter)) , dynamicCast(iter.current.next_0(), 18));
    k = entry.getKey();
    if (maskUndefined(key) === maskUndefined(k) || key != null && equals_Ljava_lang_Object__Z__devirtual$(key, k)) {
      return entry;
    }
  }
  return null;
}

function $toString_2(this$static, o){
  return o === this$static?'(this Map)':'' + o;
}

function getEntryValueOrNull(entry){
  return !entry?null:entry.getValue();
}

defineClass(212, 1, {57:1});
_.equals$ = function equals_9(obj){
  var entry, entry$iterator, otherMap;
  if (obj === this) {
    return true;
  }
  if (!instanceOf(obj, 57)) {
    return false;
  }
  otherMap = dynamicCast(obj, 57);
  if (this.size_0 != otherMap.size_1()) {
    return false;
  }
  for (entry$iterator = otherMap.entrySet_0().iterator(); entry$iterator.hasNext();) {
    entry = dynamicCast(entry$iterator.next_0(), 18);
    if (!$containsEntry(this, entry)) {
      return false;
    }
  }
  return true;
}
;
_.get_0 = function get_0(key){
  return getEntryValueOrNull($implFindEntry(this, key));
}
;
_.hashCode$ = function hashCode_10(){
  return hashCode_16(new AbstractHashMap$EntrySet(this));
}
;
_.put = function put(key, value_0){
  throw new UnsupportedOperationException_0('Put not supported on this map');
}
;
_.size_1 = function size_1(){
  return (new AbstractHashMap$EntrySet(this)).this$01.size_0;
}
;
_.toString$ = function toString_18(){
  var comma, entry, entry$iterator, sb;
  sb = new StringBuilder_0('{');
  comma = false;
  for (entry$iterator = new AbstractHashMap$EntrySetIterator((new AbstractHashMap$EntrySet(this)).this$01); $hasNext(entry$iterator);) {
    entry = (checkStructuralChange(entry$iterator.this$01, entry$iterator) , checkCriticalElement($hasNext(entry$iterator)) , dynamicCast(entry$iterator.current.next_0(), 18));
    comma?(sb.string += ', ' , sb):(comma = true);
    $append_0(sb, $toString_2(this, entry.getKey()));
    sb.string += '=';
    $append_0(sb, $toString_2(this, entry.getValue()));
  }
  sb.string += '}';
  return sb.string;
}
;
var Ljava_util_AbstractMap_2_classLit = createForClass('java.util', 'AbstractMap', 212);
function $containsKey(this$static, key){
  return isJavaString(key)?$hasStringValue(this$static, key):!!$getEntry(this$static.hashCodeMap, key);
}

function $elementAdded(this$static){
  ++this$static.size_0;
  structureChanged(this$static);
}

function $elementRemoved(this$static){
  --this$static.size_0;
  structureChanged(this$static);
}

function $get_1(this$static, key){
  return isJavaString(key)?$getStringValue(this$static, key):getEntryValueOrNull($getEntry(this$static.hashCodeMap, key));
}

function $getStringValue(this$static, key){
  return key == null?getEntryValueOrNull($getEntry(this$static.hashCodeMap, null)):this$static.stringMap.get_2(key);
}

function $hasStringValue(this$static, key){
  return key == null?!!$getEntry(this$static.hashCodeMap, null):!(this$static.stringMap.get_2(key) === undefined);
}

function $put_0(this$static, key, value_0){
  return $put_1(this$static.hashCodeMap, key, value_0);
}

function $putStringValue(this$static, key, value_0){
  return key == null?$put_1(this$static.hashCodeMap, null, value_0):this$static.stringMap.put_0(key, value_0);
}

function $reset(this$static){
  $clinit_InternalJsMapFactory$BackwardCompatibleJsMapFactory();
  this$static.hashCodeMap = delegate.createJsHashCodeMap();
  this$static.hashCodeMap.host = this$static;
  this$static.stringMap = delegate.createJsStringMap();
  this$static.stringMap.host = this$static;
  this$static.size_0 = 0;
  structureChanged(this$static);
}

defineClass(97, 212, {57:1});
_.entrySet_0 = function entrySet(){
  return new AbstractHashMap$EntrySet(this);
}
;
_.get_0 = function get_1(key){
  return $get_1(this, key);
}
;
_.put = function put_0(key, value_0){
  return $putStringValue(this, key, value_0);
}
;
_.size_1 = function size_2(){
  return this.size_0;
}
;
_.size_0 = 0;
var Ljava_util_AbstractHashMap_2_classLit = createForClass('java.util', 'AbstractHashMap', 97);
defineClass(214, 213, $intern_13);
_.equals$ = function equals_10(o){
  var other;
  if (o === this) {
    return true;
  }
  if (!instanceOf(o, 47)) {
    return false;
  }
  other = dynamicCast(o, 47);
  if (other.size_1() != this.size_1()) {
    return false;
  }
  return $containsAll(this, other);
}
;
_.hashCode$ = function hashCode_11(){
  return hashCode_16(this);
}
;
var Ljava_util_AbstractSet_2_classLit = createForClass('java.util', 'AbstractSet', 214);
function AbstractHashMap$EntrySet(this$0){
  this.this$01 = this$0;
}

defineClass(35, 214, $intern_13, AbstractHashMap$EntrySet);
_.contains = function contains_0(o){
  if (instanceOf(o, 18)) {
    return $containsEntry(this.this$01, dynamicCast(o, 18));
  }
  return false;
}
;
_.iterator = function iterator_0(){
  return new AbstractHashMap$EntrySetIterator(this.this$01);
}
;
_.size_1 = function size_3(){
  return this.this$01.size_0;
}
;
var Ljava_util_AbstractHashMap$EntrySet_2_classLit = createForClass('java.util', 'AbstractHashMap/EntrySet', 35);
function $hasNext(this$static){
  if (this$static.current.hasNext()) {
    return true;
  }
  if (this$static.current != this$static.stringMapEntries) {
    return false;
  }
  this$static.current = this$static.this$01.hashCodeMap.entries();
  return this$static.current.hasNext();
}

function $next(this$static){
  return checkStructuralChange(this$static.this$01, this$static) , checkCriticalElement($hasNext(this$static)) , dynamicCast(this$static.current.next_0(), 18);
}

function AbstractHashMap$EntrySetIterator(this$0){
  this.this$01 = this$0;
  this.stringMapEntries = this.this$01.stringMap.entries();
  this.current = this.stringMapEntries;
  setModCount(this, this$0._gwt_modCount);
}

defineClass(42, 1, {}, AbstractHashMap$EntrySetIterator);
_.hasNext = function hasNext(){
  return $hasNext(this);
}
;
_.next_0 = function next_0(){
  return $next(this);
}
;
var Ljava_util_AbstractHashMap$EntrySetIterator_2_classLit = createForClass('java.util', 'AbstractHashMap/EntrySetIterator', 42);
defineClass(216, 213, {27:1});
_.add_0 = function add_1(index_0, element){
  throw new UnsupportedOperationException_0('Add not supported on this list');
}
;
_.add_1 = function add_2(obj){
  this.add_0(this.size_1(), obj);
  return true;
}
;
_.equals$ = function equals_11(o){
  var elem, elem$iterator, elemOther, iterOther, other;
  if (o === this) {
    return true;
  }
  if (!instanceOf(o, 27)) {
    return false;
  }
  other = dynamicCast(o, 27);
  if (this.size_1() != other.size_1()) {
    return false;
  }
  iterOther = other.iterator();
  for (elem$iterator = this.iterator(); elem$iterator.hasNext();) {
    elem = elem$iterator.next_0();
    elemOther = iterOther.next_0();
    if (!(maskUndefined(elem) === maskUndefined(elemOther) || elem != null && equals_Ljava_lang_Object__Z__devirtual$(elem, elemOther))) {
      return false;
    }
  }
  return true;
}
;
_.hashCode$ = function hashCode_12(){
  return hashCode_17(this);
}
;
_.iterator = function iterator_1(){
  return new AbstractList$IteratorImpl(this);
}
;
var Ljava_util_AbstractList_2_classLit = createForClass('java.util', 'AbstractList', 216);
function AbstractList$IteratorImpl(this$0){
  this.this$01 = this$0;
}

defineClass(73, 1, {}, AbstractList$IteratorImpl);
_.hasNext = function hasNext_0(){
  return this.i < this.this$01.size_1();
}
;
_.next_0 = function next_1(){
  return checkCriticalElement(this.i < this.this$01.size_1()) , this.this$01.get_1(this.i++);
}
;
_.i = 0;
var Ljava_util_AbstractList$IteratorImpl_2_classLit = createForClass('java.util', 'AbstractList/IteratorImpl', 73);
function $iterator(this$static){
  var outerIter;
  outerIter = new AbstractHashMap$EntrySetIterator((new AbstractHashMap$EntrySet(this$static.this$01)).this$01);
  return new AbstractMap$1$1(outerIter);
}

function AbstractMap$1(this$0){
  this.this$01 = this$0;
}

defineClass(100, 214, $intern_13, AbstractMap$1);
_.contains = function contains_1(key){
  return $containsKey(this.this$01, key);
}
;
_.iterator = function iterator_2(){
  return $iterator(this);
}
;
_.size_1 = function size_4(){
  return this.this$01.size_0;
}
;
var Ljava_util_AbstractMap$1_2_classLit = createForClass('java.util', 'AbstractMap/1', 100);
function $next_0(this$static){
  var entry;
  entry = $next(this$static.val$outerIter2);
  return entry.getKey();
}

function AbstractMap$1$1(val$outerIter){
  this.val$outerIter2 = val$outerIter;
}

defineClass(101, 1, {}, AbstractMap$1$1);
_.hasNext = function hasNext_1(){
  return $hasNext(this.val$outerIter2);
}
;
_.next_0 = function next_2(){
  return $next_0(this);
}
;
var Ljava_util_AbstractMap$1$1_2_classLit = createForClass('java.util', 'AbstractMap/1/1', 101);
defineClass(98, 1, $intern_14);
_.equals$ = function equals_12(other){
  var entry;
  if (!instanceOf(other, 18)) {
    return false;
  }
  entry = dynamicCast(other, 18);
  return equals_19(this.key, entry.getKey()) && equals_19(this.value_0, entry.getValue());
}
;
_.getKey = function getKey(){
  return this.key;
}
;
_.getValue = function getValue(){
  return this.value_0;
}
;
_.hashCode$ = function hashCode_13(){
  return hashCode_23(this.key) ^ hashCode_23(this.value_0);
}
;
_.setValue = function setValue(value_0){
  var oldValue;
  oldValue = this.value_0;
  this.value_0 = value_0;
  return oldValue;
}
;
_.toString$ = function toString_19(){
  return this.key + '=' + this.value_0;
}
;
var Ljava_util_AbstractMap$AbstractEntry_2_classLit = createForClass('java.util', 'AbstractMap/AbstractEntry', 98);
function AbstractMap$SimpleEntry(key, value_0){
  this.key = key;
  this.value_0 = value_0;
}

defineClass(99, 98, $intern_14, AbstractMap$SimpleEntry);
var Ljava_util_AbstractMap$SimpleEntry_2_classLit = createForClass('java.util', 'AbstractMap/SimpleEntry', 99);
defineClass(217, 1, $intern_14);
_.equals$ = function equals_13(other){
  var entry;
  if (!instanceOf(other, 18)) {
    return false;
  }
  entry = dynamicCast(other, 18);
  return equals_19(this.getKey(), entry.getKey()) && equals_19(this.getValue(), entry.getValue());
}
;
_.hashCode$ = function hashCode_14(){
  return hashCode_23(this.getKey()) ^ hashCode_23(this.getValue());
}
;
_.toString$ = function toString_20(){
  return this.getKey() + '=' + this.getValue();
}
;
var Ljava_util_AbstractMapEntry_2_classLit = createForClass('java.util', 'AbstractMapEntry', 217);
defineClass(227, 216, {27:1});
_.add_0 = function add_3(index_0, element){
  var iter;
  iter = $listIterator(this, index_0);
  $addNode(iter.this$01, element, iter.currentNode.prev, iter.currentNode);
  ++iter.currentIndex;
  iter.lastNode = null;
}
;
_.get_1 = function get_2(index_0){
  var iter;
  iter = $listIterator(this, index_0);
  try {
    return checkCriticalElement(iter.currentNode != iter.this$01.tail) , iter.lastNode = iter.currentNode , iter.currentNode = iter.currentNode.next , ++iter.currentIndex , iter.lastNode.value_0;
  }
   catch ($e0) {
    $e0 = wrap($e0);
    if (instanceOf($e0, 65)) {
      throw new IndexOutOfBoundsException("Can't get element " + index_0);
    }
     else 
      throw unwrap_5($e0);
  }
}
;
_.iterator = function iterator_3(){
  return $listIterator(this, 0);
}
;
var Ljava_util_AbstractSequentialList_2_classLit = createForClass('java.util', 'AbstractSequentialList', 227);
function $add(this$static, o){
  setCheck(this$static.array, this$static.array.length, o);
  return true;
}

function $get_2(this$static, index_0){
  checkElementIndex(index_0, this$static.array.length);
  return this$static.array[index_0];
}

function $indexOf_0(this$static, o, index_0){
  for (; index_0 < this$static.array.length; ++index_0) {
    if (equals_19(o, this$static.array[index_0])) {
      return index_0;
    }
  }
  return -1;
}

function $remove(this$static, index_0){
  var previous;
  previous = (checkElementIndex(index_0, this$static.array.length) , this$static.array[index_0]);
  splice(this$static.array, index_0, 1);
  return previous;
}

function $toArray(this$static, out){
  var i, size_0, result;
  size_0 = this$static.array.length;
  out.length < size_0 && (out = (result = initializeArrayElementsWithDefaults(0, size_0) , initValues(getClass__Ljava_lang_Class___devirtual$(out), out.castableTypeMap$, out.__elementTypeId$, out.__elementTypeCategory$, result) , result));
  for (i = 0; i < size_0; ++i) {
    setCheck(out, i, this$static.array[i]);
  }
  out.length > size_0 && setCheck(out, size_0, null);
  return out;
}

function ArrayList(){
  this.array = initDim(Ljava_lang_Object_2_classLit, $intern_5, 1, 0, 3, 1);
}

function splice(array, index_0, deleteCount){
  array.splice(index_0, deleteCount);
}

function splice_0(array, index_0, deleteCount, value_0){
  array.splice(index_0, deleteCount, value_0);
}

defineClass(40, 216, $intern_15, ArrayList);
_.add_0 = function add_4(index_0, o){
  checkPositionIndex(index_0, this.array.length);
  splice_0(this.array, index_0, 0, o);
}
;
_.add_1 = function add_5(o){
  return $add(this, o);
}
;
_.contains = function contains_2(o){
  return $indexOf_0(this, o, 0) != -1;
}
;
_.get_1 = function get_3(index_0){
  return $get_2(this, index_0);
}
;
_.remove = function remove(index_0){
  return $remove(this, index_0);
}
;
_.size_1 = function size_5(){
  return this.array.length;
}
;
var Ljava_util_ArrayList_2_classLit = createForClass('java.util', 'ArrayList', 40);
function hashCode_15(a){
  var e, e$index, e$max, hashCode;
  hashCode = 1;
  for (e$index = 0 , e$max = a.length; e$index < e$max; ++e$index) {
    e = a[e$index];
    hashCode = 31 * hashCode + (e != null?hashCode__I__devirtual$(e):0);
    hashCode = ~~hashCode;
  }
  return hashCode;
}

function hashCode_16(collection){
  var e, e$iterator, hashCode;
  hashCode = 0;
  for (e$iterator = collection.iterator(); e$iterator.hasNext();) {
    e = e$iterator.next_0();
    hashCode = hashCode + (e != null?hashCode__I__devirtual$(e):0);
    hashCode = ~~hashCode;
  }
  return hashCode;
}

function hashCode_17(list){
  var e, e$iterator, hashCode;
  hashCode = 1;
  for (e$iterator = list.iterator(); e$iterator.hasNext();) {
    e = e$iterator.next_0();
    hashCode = 31 * hashCode + (e != null?hashCode__I__devirtual$(e):0);
    hashCode = ~~hashCode;
  }
  return hashCode;
}

function unmodifiableList(list){
  return instanceOf(list, 67)?new Collections$UnmodifiableRandomAccessList(list):new Collections$UnmodifiableList(list);
}

function Collections$UnmodifiableCollection(coll){
  this.coll = coll;
}

defineClass(71, 1, {});
_.add_1 = function add_6(o){
  throw new UnsupportedOperationException;
}
;
_.iterator = function iterator_4(){
  return new Collections$UnmodifiableCollectionIterator(this.coll.iterator());
}
;
_.size_1 = function size_6(){
  return this.coll.size_1();
}
;
_.toString$ = function toString_21(){
  return this.coll.toString$();
}
;
var Ljava_util_Collections$UnmodifiableCollection_2_classLit = createForClass('java.util', 'Collections/UnmodifiableCollection', 71);
function Collections$UnmodifiableCollectionIterator(it){
  this.it = it;
}

defineClass(110, 1, {}, Collections$UnmodifiableCollectionIterator);
_.hasNext = function hasNext_2(){
  return this.it.hasNext();
}
;
_.next_0 = function next_3(){
  return this.it.next_0();
}
;
var Ljava_util_Collections$UnmodifiableCollectionIterator_2_classLit = createForClass('java.util', 'Collections/UnmodifiableCollectionIterator', 110);
function Collections$UnmodifiableList(list){
  Collections$UnmodifiableCollection.call(this, list);
  this.list = list;
}

defineClass(72, 71, {27:1}, Collections$UnmodifiableList);
_.equals$ = function equals_14(o){
  return this.list.equals$(o);
}
;
_.get_1 = function get_4(index_0){
  return this.list.get_1(index_0);
}
;
_.hashCode$ = function hashCode_18(){
  return this.list.hashCode$();
}
;
var Ljava_util_Collections$UnmodifiableList_2_classLit = createForClass('java.util', 'Collections/UnmodifiableList', 72);
function Collections$UnmodifiableMap(map_0){
  this.map_0 = map_0;
}

defineClass(105, 1, {57:1}, Collections$UnmodifiableMap);
_.entrySet_0 = function entrySet_0(){
  !this.entrySet && (this.entrySet = new Collections$UnmodifiableMap$UnmodifiableEntrySet(this.map_0.entrySet_0()));
  return this.entrySet;
}
;
_.equals$ = function equals_15(o){
  return this.map_0.equals$(o);
}
;
_.get_0 = function get_5(key){
  return this.map_0.get_0(key);
}
;
_.hashCode$ = function hashCode_19(){
  return this.map_0.hashCode$();
}
;
_.put = function put_1(key, value_0){
  throw new UnsupportedOperationException;
}
;
_.size_1 = function size_7(){
  return this.map_0.size_1();
}
;
_.toString$ = function toString_22(){
  return this.map_0.toString$();
}
;
var Ljava_util_Collections$UnmodifiableMap_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap', 105);
defineClass(106, 71, $intern_13);
_.equals$ = function equals_16(o){
  return this.coll.equals$(o);
}
;
_.hashCode$ = function hashCode_20(){
  return this.coll.hashCode$();
}
;
var Ljava_util_Collections$UnmodifiableSet_2_classLit = createForClass('java.util', 'Collections/UnmodifiableSet', 106);
function Collections$UnmodifiableMap$UnmodifiableEntrySet(s){
  Collections$UnmodifiableCollection.call(this, s);
}

defineClass(107, 106, $intern_13, Collections$UnmodifiableMap$UnmodifiableEntrySet);
_.iterator = function iterator_5(){
  var it;
  it = this.coll.iterator();
  return new Collections$UnmodifiableMap$UnmodifiableEntrySet$1(it);
}
;
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet', 107);
function Collections$UnmodifiableMap$UnmodifiableEntrySet$1(val$it){
  this.val$it2 = val$it;
}

defineClass(111, 1, {}, Collections$UnmodifiableMap$UnmodifiableEntrySet$1);
_.hasNext = function hasNext_3(){
  return this.val$it2.hasNext();
}
;
_.next_0 = function next_4(){
  return new Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry(dynamicCast(this.val$it2.next_0(), 18));
}
;
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet$1_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet/1', 111);
function Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry(entry){
  this.entry = entry;
}

defineClass(108, 1, $intern_14, Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry);
_.equals$ = function equals_17(o){
  return this.entry.equals$(o);
}
;
_.getKey = function getKey_0(){
  return this.entry.getKey();
}
;
_.getValue = function getValue_0(){
  return this.entry.getValue();
}
;
_.hashCode$ = function hashCode_21(){
  return this.entry.hashCode$();
}
;
_.setValue = function setValue_0(value_0){
  throw new UnsupportedOperationException;
}
;
_.toString$ = function toString_23(){
  return this.entry.toString$();
}
;
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry', 108);
function Collections$UnmodifiableRandomAccessList(list){
  Collections$UnmodifiableList.call(this, list);
}

defineClass(109, 72, {27:1, 67:1}, Collections$UnmodifiableRandomAccessList);
var Ljava_util_Collections$UnmodifiableRandomAccessList_2_classLit = createForClass('java.util', 'Collections/UnmodifiableRandomAccessList', 109);
function checkStructuralChange(host, iterator){
  if (iterator._gwt_modCount != host._gwt_modCount) {
    throw new ConcurrentModificationException;
  }
}

function setModCount(o, modCount){
  o._gwt_modCount = modCount;
}

function structureChanged(map_0){
  var modCount;
  modCount = map_0._gwt_modCount | 0;
  setModCount(map_0, modCount + 1);
}

function ConcurrentModificationException(){
  RuntimeException.call(this);
}

defineClass(192, 19, $intern_2, ConcurrentModificationException);
var Ljava_util_ConcurrentModificationException_2_classLit = createForClass('java.util', 'ConcurrentModificationException', 192);
function $fixDaylightSavings(this$static, requestedHours){
  var badHours, copy, day, hours, newTime, originalTimeInMillis, timeDiff, timeDiffHours, timeDiffMinutes;
  hours = this$static.jsdate.getHours();
  if (hours % 24 != requestedHours % 24) {
    copy = create(this$static.jsdate.getTime());
    $setDate(copy, copy.getDate() + 1);
    timeDiff = this$static.jsdate.getTimezoneOffset() - copy.getTimezoneOffset();
    if (timeDiff > 0) {
      timeDiffHours = ~~(timeDiff / 60);
      timeDiffMinutes = timeDiff % 60;
      day = this$static.jsdate.getDate();
      badHours = this$static.jsdate.getHours();
      badHours + timeDiffHours >= 24 && ++day;
      newTime = create_0(this$static.jsdate.getFullYear(), this$static.jsdate.getMonth(), day, requestedHours + timeDiffHours, this$static.jsdate.getMinutes() + timeDiffMinutes, this$static.jsdate.getSeconds(), this$static.jsdate.getMilliseconds());
      $setTime(this$static.jsdate, newTime.getTime());
    }
    return;
  }
  originalTimeInMillis = this$static.jsdate.getTime();
  $setTime(this$static.jsdate, originalTimeInMillis + 3600000);
  hours != this$static.jsdate.getHours() && $setTime(this$static.jsdate, originalTimeInMillis);
}

function $toString_3(this$static){
  var hourOffset, minuteOffset, offset;
  offset = -this$static.jsdate.getTimezoneOffset();
  hourOffset = (offset >= 0?'+':'') + ~~(offset / 60);
  minuteOffset = (offset < 0?-offset:offset) % 60 < 10?'0' + (offset < 0?-offset:offset) % 60:'' + (offset < 0?-offset:offset) % 60;
  return ($clinit_Date$StringData() , DAYS)[this$static.jsdate.getDay()] + ' ' + MONTHS[this$static.jsdate.getMonth()] + ' ' + padTwo(this$static.jsdate.getDate()) + ' ' + padTwo(this$static.jsdate.getHours()) + ':' + padTwo(this$static.jsdate.getMinutes()) + ':' + padTwo(this$static.jsdate.getSeconds()) + ' GMT' + hourOffset + minuteOffset + ' ' + this$static.jsdate.getFullYear();
}

function Date_0(){
  this.jsdate = new Date;
}

function Date_1(date){
  this.jsdate = create(toDouble(date));
}

function padTwo(number){
  return number < 10?'0' + number:'' + number;
}

defineClass(46, 1, {4:1, 25:1, 46:1}, Date_0, Date_1);
_.equals$ = function equals_18(obj){
  return instanceOf(obj, 46) && eq(fromDouble(this.jsdate.getTime()), fromDouble(dynamicCast(obj, 46).jsdate.getTime()));
}
;
_.hashCode$ = function hashCode_22(){
  var time;
  time = fromDouble(this.jsdate.getTime());
  return toInt(xor(time, shru(time, 32)));
}
;
_.toString$ = function toString_24(){
  return $toString_3(this);
}
;
var Ljava_util_Date_2_classLit = createForClass('java.util', 'Date', 46);
function $clinit_Date$StringData(){
  $clinit_Date$StringData = emptyMethod;
  DAYS = initValues(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_5, 2, 4, ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']);
  MONTHS = initValues(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_5, 2, 4, ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
}

var DAYS, MONTHS;
function $equals_0(value1, value2){
  return maskUndefined(value1) === maskUndefined(value2) || value1 != null && equals_Ljava_lang_Object__Z__devirtual$(value1, value2);
}

function $getHashCode(key){
  var hashCode;
  hashCode = hashCode__I__devirtual$(key);
  return ~~hashCode;
}

function HashMap(){
  $reset(this);
}

defineClass(9, 97, {4:1, 9:1, 57:1}, HashMap);
var Ljava_util_HashMap_2_classLit = createForClass('java.util', 'HashMap', 9);
function $ensureChain(this$static, hashCode){
  var map_0 = this$static.backingMap;
  return map_0[hashCode] || (map_0[hashCode] = []);
}

function $getChain(this$static, hashCode){
  return this$static.backingMap[hashCode];
}

function $getChainOrEmpty(this$static, hashCode){
  return this$static.backingMap[hashCode] || [];
}

function $getEntry(this$static, key){
  var entry, entry$array, entry$index, entry$max;
  for (entry$array = $getChainOrEmpty(this$static, key == null?'0':'' + $getHashCode(key)) , entry$index = 0 , entry$max = entry$array.length; entry$index < entry$max; ++entry$index) {
    entry = entry$array[entry$index];
    if ($equals_0(key, entry.getKey())) {
      return entry;
    }
  }
  return null;
}

function $keys(this$static){
  return Object.getOwnPropertyNames(this$static.backingMap);
}

function $put_1(this$static, key, value_0){
  var chain, entry, entry$index, entry$max;
  chain = $ensureChain(this$static, !key?'0':'' + $getHashCode(key));
  for (entry$index = 0 , entry$max = chain.length; entry$index < entry$max; ++entry$index) {
    entry = chain[entry$index];
    if ($equals_0(key, entry.getKey())) {
      return entry.setValue(value_0);
    }
  }
  setCheck(chain, chain.length, new AbstractMap$SimpleEntry(key, value_0));
  $elementAdded(this$static.host);
  return null;
}

function $remove_0(this$static, key){
  var chain, entry, hashCode, i;
  hashCode = key == null?'0':'' + $getHashCode(key);
  chain = $getChainOrEmpty(this$static, hashCode);
  for (i = 0; i < chain.length; i++) {
    entry = chain[i];
    if ($equals_0(key, entry.getKey())) {
      chain.length == 1?(delete this$static.backingMap[hashCode] , undefined):(chain.splice(i, 1) , undefined);
      $elementRemoved(this$static.host);
      return entry.getValue();
    }
  }
  return null;
}

function InternalJsHashCodeMap(){
  this.backingMap = this.createMap();
}

defineClass(75, 1, {}, InternalJsHashCodeMap);
_.createMap = function createMap(){
  return Object.create(null);
}
;
_.entries = function entries(){
  return new InternalJsHashCodeMap$1(this);
}
;
var Ljava_util_InternalJsHashCodeMap_2_classLit = createForClass('java.util', 'InternalJsHashCodeMap', 75);
function $hasNext_0(this$static){
  if (this$static.itemIndex < this$static.chain.length) {
    return true;
  }
  if (this$static.chainIndex < this$static.keys_0.length - 1) {
    this$static.chain = $getChain(this$static.this$01, this$static.keys_0[++this$static.chainIndex]);
    this$static.itemIndex = 0;
    return true;
  }
  return false;
}

function InternalJsHashCodeMap$1(this$0){
  this.this$01 = this$0;
  this.keys_0 = $keys(this.this$01);
  this.chain = initDim(Ljava_util_Map$Entry_2_classLit, $intern_5, 18, 0, 0, 1);
}

defineClass(122, 1, {}, InternalJsHashCodeMap$1);
_.hasNext = function hasNext_4(){
  return $hasNext_0(this);
}
;
_.next_0 = function next_5(){
  return checkCriticalElement($hasNext_0(this)) , this.lastEntry = this.chain[this.itemIndex++] , this.lastEntry;
}
;
_.chainIndex = -1;
_.itemIndex = 0;
_.lastEntry = null;
var Ljava_util_InternalJsHashCodeMap$1_2_classLit = createForClass('java.util', 'InternalJsHashCodeMap/1', 122);
function InternalJsHashCodeMap$InternalJsHashCodeMapLegacy(){
  InternalJsHashCodeMap.call(this);
}

defineClass(120, 75, {}, InternalJsHashCodeMap$InternalJsHashCodeMapLegacy);
_.createMap = function createMap_0(){
  return {};
}
;
_.entries = function entries_0(){
  var list = this.newEntryList();
  var map_0 = this.backingMap;
  for (var hashCode in map_0) {
    if (hashCode == parseInt(hashCode, 10)) {
      var array = map_0[hashCode];
      for (var i = 0, c = array.length; i < c; ++i) {
        list.add_1(array[i]);
      }
    }
  }
  return list.iterator();
}
;
_.newEntryList = function newEntryList(){
  return new InternalJsHashCodeMap$InternalJsHashCodeMapLegacy$1(this);
}
;
var Ljava_util_InternalJsHashCodeMap$InternalJsHashCodeMapLegacy_2_classLit = createForClass('java.util', 'InternalJsHashCodeMap/InternalJsHashCodeMapLegacy', 120);
function InternalJsHashCodeMap$InternalJsHashCodeMapLegacy$1(this$1){
  this.this$11 = this$1;
  ArrayList.call(this);
}

defineClass(121, 40, $intern_15, InternalJsHashCodeMap$InternalJsHashCodeMapLegacy$1);
_.remove = function remove_0(index_0){
  var removed;
  return removed = dynamicCast($remove(this, index_0), 18) , $remove_0(this.this$11, removed.getKey()) , removed;
}
;
var Ljava_util_InternalJsHashCodeMap$InternalJsHashCodeMapLegacy$1_2_classLit = createForClass('java.util', 'InternalJsHashCodeMap/InternalJsHashCodeMapLegacy/1', 121);
function InternalJsMapFactory(){
}

defineClass(117, 1, {}, InternalJsMapFactory);
_.createJsHashCodeMap = function createJsHashCodeMap(){
  return new InternalJsHashCodeMap;
}
;
_.createJsStringMap = function createJsStringMap(){
  return new InternalJsStringMap;
}
;
var Ljava_util_InternalJsMapFactory_2_classLit = createForClass('java.util', 'InternalJsMapFactory', 117);
function $clinit_InternalJsMapFactory$BackwardCompatibleJsMapFactory(){
  $clinit_InternalJsMapFactory$BackwardCompatibleJsMapFactory = emptyMethod;
  delegate = createFactory();
}

function canHandleProto(){
  var protoField = '__proto__';
  var map_0 = Object.create(null);
  if (map_0[protoField] !== undefined) {
    return false;
  }
  var keys_0 = Object.getOwnPropertyNames(map_0);
  if (keys_0.length != 0) {
    return false;
  }
  map_0[protoField] = 42;
  if (map_0[protoField] !== 42) {
    return false;
  }
  return true;
}

function createFactory(){
  var map_0;
  if (Object.create && Object.getOwnPropertyNames && canHandleProto()) {
    return (map_0 = Object.create(null) , map_0['__proto__'] = 42 , Object.getOwnPropertyNames(map_0).length == 0)?new InternalJsMapFactory$KeysWorkaroundJsMapFactory:new InternalJsMapFactory;
  }
  return new InternalJsMapFactory$LegacyInternalJsMapFactory;
}

var delegate;
function InternalJsMapFactory$KeysWorkaroundJsMapFactory(){
}

defineClass(119, 117, {}, InternalJsMapFactory$KeysWorkaroundJsMapFactory);
_.createJsStringMap = function createJsStringMap_0(){
  return new InternalJsStringMap$InternalJsStringMapWithKeysWorkaround;
}
;
var Ljava_util_InternalJsMapFactory$KeysWorkaroundJsMapFactory_2_classLit = createForClass('java.util', 'InternalJsMapFactory/KeysWorkaroundJsMapFactory', 119);
function InternalJsMapFactory$LegacyInternalJsMapFactory(){
}

defineClass(118, 117, {}, InternalJsMapFactory$LegacyInternalJsMapFactory);
_.createJsHashCodeMap = function createJsHashCodeMap_0(){
  return new InternalJsHashCodeMap$InternalJsHashCodeMapLegacy;
}
;
_.createJsStringMap = function createJsStringMap_1(){
  return new InternalJsStringMap$InternalJsStringMapLegacy;
}
;
var Ljava_util_InternalJsMapFactory$LegacyInternalJsMapFactory_2_classLit = createForClass('java.util', 'InternalJsMapFactory/LegacyInternalJsMapFactory', 118);
function $keys_0(this$static){
  return Object.getOwnPropertyNames(this$static.backingMap);
}

function $put_2(this$static, key, value_0){
  var oldValue;
  oldValue = this$static.backingMap[key];
  oldValue === undefined && $elementAdded(this$static.host);
  $set_0(this$static, key, value_0 === undefined?null:value_0);
  return oldValue;
}

function $remove_1(this$static, key){
  var value_0;
  value_0 = this$static.backingMap[key];
  if (!(value_0 === undefined)) {
    delete this$static.backingMap[key];
    $elementRemoved(this$static.host);
  }
  return value_0;
}

function $set_0(this$static, key, value_0){
  this$static.backingMap[key] = value_0;
}

function InternalJsStringMap(){
  this.backingMap = this.createMap_0();
}

defineClass(60, 1, {}, InternalJsStringMap);
_.createMap_0 = function createMap_1(){
  return Object.create(null);
}
;
_.entries = function entries_1(){
  var keys_0;
  keys_0 = this.keys_1();
  return new InternalJsStringMap$1(this, keys_0);
}
;
_.get_2 = function get_6(key){
  return this.backingMap[key];
}
;
_.keys_1 = function keys_1(){
  return $keys_0(this);
}
;
_.newMapEntry = function newMapEntry(key){
  return new InternalJsStringMap$2(this, key);
}
;
_.put_0 = function put_2(key, value_0){
  return $put_2(this, key, value_0);
}
;
var Ljava_util_InternalJsStringMap_2_classLit = createForClass('java.util', 'InternalJsStringMap', 60);
function InternalJsStringMap$1(this$0, val$keys){
  this.this$01 = this$0;
  this.val$keys2 = val$keys;
}

defineClass(115, 1, {}, InternalJsStringMap$1);
_.hasNext = function hasNext_5(){
  return this.i < this.val$keys2.length;
}
;
_.next_0 = function next_6(){
  return checkCriticalElement(this.i < this.val$keys2.length) , new InternalJsStringMap$2(this.this$01, this.val$keys2[this.i++]);
}
;
_.i = 0;
var Ljava_util_InternalJsStringMap$1_2_classLit = createForClass('java.util', 'InternalJsStringMap/1', 115);
function InternalJsStringMap$2(this$0, val$key){
  this.this$01 = this$0;
  this.val$key2 = val$key;
}

defineClass(74, 217, $intern_14, InternalJsStringMap$2);
_.getKey = function getKey_1(){
  return this.val$key2;
}
;
_.getValue = function getValue_1(){
  return this.this$01.get_2(this.val$key2);
}
;
_.setValue = function setValue_1(object){
  return this.this$01.put_0(this.val$key2, object);
}
;
var Ljava_util_InternalJsStringMap$2_2_classLit = createForClass('java.util', 'InternalJsStringMap/2', 74);
function InternalJsStringMap$InternalJsStringMapLegacy(){
  InternalJsStringMap.call(this);
}

defineClass(112, 60, {}, InternalJsStringMap$InternalJsStringMapLegacy);
_.createMap_0 = function createMap_2(){
  return {};
}
;
_.entries = function entries_2(){
  var list = this.newEntryList_0();
  for (var key in this.backingMap) {
    if (key.charCodeAt(0) == 58) {
      var entry = this.newMapEntry(key.substring(1));
      list.add_1(entry);
    }
  }
  return list.iterator();
}
;
_.get_2 = function get_7(key){
  return this.backingMap[':' + key];
}
;
_.newEntryList_0 = function newEntryList_0(){
  return new InternalJsStringMap$InternalJsStringMapLegacy$1(this);
}
;
_.put_0 = function put_3(key, value_0){
  return $put_2(this, ':' + key, value_0);
}
;
var Ljava_util_InternalJsStringMap$InternalJsStringMapLegacy_2_classLit = createForClass('java.util', 'InternalJsStringMap/InternalJsStringMapLegacy', 112);
function InternalJsStringMap$InternalJsStringMapLegacy$1(this$1){
  this.this$11 = this$1;
  ArrayList.call(this);
}

defineClass(114, 40, $intern_15, InternalJsStringMap$InternalJsStringMapLegacy$1);
_.remove = function remove_1(index_0){
  var removed;
  return removed = dynamicCast($remove(this, index_0), 18) , $remove_1(this.this$11, ':' + dynamicCastToString(removed.getKey())) , removed;
}
;
var Ljava_util_InternalJsStringMap$InternalJsStringMapLegacy$1_2_classLit = createForClass('java.util', 'InternalJsStringMap/InternalJsStringMapLegacy/1', 114);
function InternalJsStringMap$InternalJsStringMapWithKeysWorkaround(){
  InternalJsStringMap.call(this);
}

defineClass(113, 60, {}, InternalJsStringMap$InternalJsStringMapWithKeysWorkaround);
_.keys_1 = function keys_2(){
  var keys_0;
  keys_0 = $keys_0(this);
  !(this.backingMap['__proto__'] === undefined) && (keys_0[keys_0.length] = '__proto__');
  return keys_0;
}
;
var Ljava_util_InternalJsStringMap$InternalJsStringMapWithKeysWorkaround_2_classLit = createForClass('java.util', 'InternalJsStringMap/InternalJsStringMapWithKeysWorkaround', 113);
function $addFirst(this$static, o){
  $addNode(this$static, o, this$static.header, this$static.header.next);
}

function $addNode(this$static, o, prev, next){
  var node;
  node = new LinkedList$Node;
  node.value_0 = o;
  node.prev = prev;
  node.next = next;
  next.prev = prev.next = node;
  ++this$static.size_0;
}

function $listIterator(this$static, index_0){
  var i, node;
  checkPositionIndex(index_0, this$static.size_0);
  if (index_0 >= this$static.size_0 >> 1) {
    node = this$static.tail;
    for (i = this$static.size_0; i > index_0; --i) {
      node = node.prev;
    }
  }
   else {
    node = this$static.header.next;
    for (i = 0; i < index_0; ++i) {
      node = node.next;
    }
  }
  return new LinkedList$ListIteratorImpl(this$static, index_0, node);
}

function $offerLast(this$static, e){
  $addNode(this$static, e, this$static.tail.prev, this$static.tail);
  return true;
}

function $pollFirst(this$static){
  return this$static.size_0 == 0?null:(checkCriticalElement(this$static.size_0 != 0) , $removeNode(this$static, this$static.header.next));
}

function $removeNode(this$static, node){
  var oldValue;
  oldValue = node.value_0;
  node.next.prev = node.prev;
  node.prev.next = node.next;
  node.next = node.prev = null;
  node.value_0 = null;
  --this$static.size_0;
  return oldValue;
}

function LinkedList(){
  this.header = new LinkedList$Node;
  this.tail = new LinkedList$Node;
  this.header.next = this.tail;
  this.tail.prev = this.header;
  this.header.prev = this.tail.next = null;
  this.size_0 = 0;
}

defineClass(193, 227, {4:1, 27:1}, LinkedList);
_.add_1 = function add_7(o){
  $addNode(this, o, this.tail.prev, this.tail);
  return true;
}
;
_.size_1 = function size_8(){
  return this.size_0;
}
;
_.size_0 = 0;
var Ljava_util_LinkedList_2_classLit = createForClass('java.util', 'LinkedList', 193);
function LinkedList$ListIteratorImpl(this$0, index_0, startNode){
  this.this$01 = this$0;
  this.currentNode = startNode;
  this.currentIndex = index_0;
}

defineClass(194, 1, {}, LinkedList$ListIteratorImpl);
_.hasNext = function hasNext_6(){
  return this.currentNode != this.this$01.tail;
}
;
_.next_0 = function next_7(){
  return checkCriticalElement(this.currentNode != this.this$01.tail) , this.lastNode = this.currentNode , this.currentNode = this.currentNode.next , ++this.currentIndex , this.lastNode.value_0;
}
;
_.currentIndex = 0;
_.lastNode = null;
var Ljava_util_LinkedList$ListIteratorImpl_2_classLit = createForClass('java.util', 'LinkedList/ListIteratorImpl', 194);
function LinkedList$Node(){
}

defineClass(62, 1, {}, LinkedList$Node);
var Ljava_util_LinkedList$Node_2_classLit = createForClass('java.util', 'LinkedList/Node', 62);
var Ljava_util_Map$Entry_2_classLit = createForInterface('java.util', 'Map/Entry');
function NoSuchElementException(){
  RuntimeException.call(this);
}

defineClass(65, 19, {4:1, 6:1, 11:1, 65:1}, NoSuchElementException);
var Ljava_util_NoSuchElementException_2_classLit = createForClass('java.util', 'NoSuchElementException', 65);
function equals_19(a, b){
  return maskUndefined(a) === maskUndefined(b) || a != null && equals_Ljava_lang_Object__Z__devirtual$(a, b);
}

function hashCode_23(o){
  return o != null?hashCode__I__devirtual$(o):0;
}

function $clinit_Level(){
  $clinit_Level = emptyMethod;
  ALL = new Level$LevelAll;
  CONFIG = new Level$LevelConfig;
  FINE = new Level$LevelFine;
  FINER = new Level$LevelFiner;
  FINEST = new Level$LevelFinest;
  INFO = new Level$LevelInfo;
  OFF = new Level$LevelOff;
  SEVERE = new Level$LevelSevere;
  WARNING = new Level$LevelWarning;
}

defineClass(221, 1, $intern_5);
_.getName = function getName_0(){
  return 'DUMMY';
}
;
_.intValue_0 = function intValue(){
  return -1;
}
;
_.toString$ = function toString_25(){
  return this.getName();
}
;
var ALL, CONFIG, FINE, FINER, FINEST, INFO, OFF, SEVERE, WARNING;
var Ljava_util_logging_Level_2_classLit = createForClass('java.util.logging', 'Level', 221);
function Level$LevelAll(){
}

defineClass(124, 221, $intern_5, Level$LevelAll);
_.getName = function getName_1(){
  return 'ALL';
}
;
_.intValue_0 = function intValue_0(){
  return $intern_12;
}
;
var Ljava_util_logging_Level$LevelAll_2_classLit = createForClass('java.util.logging', 'Level/LevelAll', 124);
function Level$LevelConfig(){
}

defineClass(125, 221, $intern_5, Level$LevelConfig);
_.getName = function getName_2(){
  return 'CONFIG';
}
;
_.intValue_0 = function intValue_1(){
  return 700;
}
;
var Ljava_util_logging_Level$LevelConfig_2_classLit = createForClass('java.util.logging', 'Level/LevelConfig', 125);
function Level$LevelFine(){
}

defineClass(126, 221, $intern_5, Level$LevelFine);
_.getName = function getName_3(){
  return 'FINE';
}
;
_.intValue_0 = function intValue_2(){
  return 500;
}
;
var Ljava_util_logging_Level$LevelFine_2_classLit = createForClass('java.util.logging', 'Level/LevelFine', 126);
function Level$LevelFiner(){
}

defineClass(127, 221, $intern_5, Level$LevelFiner);
_.getName = function getName_4(){
  return 'FINER';
}
;
_.intValue_0 = function intValue_3(){
  return 400;
}
;
var Ljava_util_logging_Level$LevelFiner_2_classLit = createForClass('java.util.logging', 'Level/LevelFiner', 127);
function Level$LevelFinest(){
}

defineClass(128, 221, $intern_5, Level$LevelFinest);
_.getName = function getName_5(){
  return 'FINEST';
}
;
_.intValue_0 = function intValue_4(){
  return 300;
}
;
var Ljava_util_logging_Level$LevelFinest_2_classLit = createForClass('java.util.logging', 'Level/LevelFinest', 128);
function Level$LevelInfo(){
}

defineClass(129, 221, $intern_5, Level$LevelInfo);
_.getName = function getName_6(){
  return 'INFO';
}
;
_.intValue_0 = function intValue_5(){
  return 800;
}
;
var Ljava_util_logging_Level$LevelInfo_2_classLit = createForClass('java.util.logging', 'Level/LevelInfo', 129);
function Level$LevelOff(){
}

defineClass(130, 221, $intern_5, Level$LevelOff);
_.getName = function getName_7(){
  return 'OFF';
}
;
_.intValue_0 = function intValue_6(){
  return $intern_0;
}
;
var Ljava_util_logging_Level$LevelOff_2_classLit = createForClass('java.util.logging', 'Level/LevelOff', 130);
function Level$LevelSevere(){
}

defineClass(131, 221, $intern_5, Level$LevelSevere);
_.getName = function getName_8(){
  return 'SEVERE';
}
;
_.intValue_0 = function intValue_7(){
  return 1000;
}
;
var Ljava_util_logging_Level$LevelSevere_2_classLit = createForClass('java.util.logging', 'Level/LevelSevere', 131);
function Level$LevelWarning(){
}

defineClass(132, 221, $intern_5, Level$LevelWarning);
_.getName = function getName_9(){
  return 'WARNING';
}
;
_.intValue_0 = function intValue_8(){
  return 900;
}
;
var Ljava_util_logging_Level$LevelWarning_2_classLit = createForClass('java.util.logging', 'Level/LevelWarning', 132);
function $addLoggerImpl(this$static, logger){
  $putStringValue(this$static.loggerMap, logger.impl.name_0, logger);
}

function $ensureLogger(this$static, name_0){
  var logger, newLogger, name_1, parentName;
  logger = dynamicCast($getStringValue(this$static.loggerMap, name_0), 50);
  if (!logger) {
    newLogger = new Logger(name_0);
    name_1 = newLogger.impl.name_0;
    parentName = $substring_0(name_1, 0, max_0(0, $lastIndexOf(name_1, fromCodePoint(46))));
    $setParent_0(newLogger, $ensureLogger(this$static, parentName));
    $putStringValue(this$static.loggerMap, newLogger.impl.name_0, newLogger);
    return newLogger;
  }
  return logger;
}

function LogManager(){
  this.loggerMap = new HashMap;
}

function getLogManager(){
  var rootLogger;
  if (!singleton) {
    singleton = new LogManager;
    rootLogger = new Logger('');
    $setLevel_1(rootLogger, ($clinit_Level() , INFO));
    $addLoggerImpl(singleton, rootLogger);
  }
  return singleton;
}

defineClass(116, 1, {}, LogManager);
var singleton;
var Ljava_util_logging_LogManager_2_classLit = createForClass('java.util.logging', 'LogManager', 116);
function $setLoggerName(this$static, newName){
  this$static.loggerName = newName;
}

function LogRecord(level, msg){
  this.level_0 = level;
  this.msg = msg;
  this.millis = fromDouble(now_1());
}

defineClass(182, 1, $intern_5, LogRecord);
_.loggerName = '';
_.millis = {l:0, m:0, h:0};
_.thrown = null;
var Ljava_util_logging_LogRecord_2_classLit = createForClass('java.util.logging', 'LogRecord', 182);
function $log_1(this$static, level, msg){
  $log(this$static.impl, level, msg, null);
}

function $log_2(this$static, level, msg, thrown){
  $log(this$static.impl, level, msg, thrown);
}

function $setLevel_1(this$static, newLevel){
  $setLevel_0(this$static.impl, newLevel);
}

function $setParent_0(this$static, newParent){
  $setParent(this$static.impl, newParent);
}

function Logger(name_0){
  this.impl = new LoggerImplRegular;
  $setName(this.impl, name_0);
}

function getLogger(name_0){
  new LoggerImplRegular;
  return $ensureLogger(getLogManager(), name_0);
}

defineClass(50, 1, {50:1}, Logger);
var Ljava_util_logging_Logger_2_classLit = createForClass('java.util.logging', 'Logger', 50);
var Lcom_google_gwt_lang_CollapsedPropertyHolder_2_classLit = createForClass('com.google.gwt.lang', 'CollapsedPropertyHolder', 201), Lcom_google_gwt_lang_JavaClassHierarchySetupUtil_2_classLit = createForClass('com.google.gwt.lang', 'JavaClassHierarchySetupUtil', 203), Lcom_google_gwt_lang_LongLibBase$LongEmul_2_classLit = createForClass('com.google.gwt.lang', 'LongLibBase/LongEmul', null), Lcom_google_gwt_lang_ModuleUtils_2_classLit = createForClass('com.google.gwt.lang', 'ModuleUtils', 206), Ljava_util_Map$Entry_2_classLit = createForInterface('java.util', 'Map/Entry');
var $entry = registerEntry();
var gwtOnLoad = gwtOnLoad = gwtOnLoad_0;
addInitFunctions(init);
setGwtProperty('permProps', [[['locale', 'default'], ['user.agent', 'safari']]]);
$sendStats('moduleStartup', 'moduleEvalEnd');
gwtOnLoad(__gwtModuleFunction.__errFn, __gwtModuleFunction.__moduleName, __gwtModuleFunction.__moduleBase, __gwtModuleFunction.__softPermutationId,__gwtModuleFunction.__computePropValue);
$sendStats('moduleStartup', 'end');
$gwt && $gwt.permProps && __gwtModuleFunction.__moduleStartupDone($gwt.permProps);
//# sourceURL=priorityapp-0.js

// End GWT code

        var toReturn = {login: $wnd.login, formStart: $wnd.formStart, procStart: $wnd.procStart, procStartActivate: $wnd.procStartActivate, changePassword: $wnd.changePassword, formStartEx: $wnd.formStartEx, setGPSLocation: $wnd.setGPSLocation, updateAccessToken: $wnd.updateAccessToken};   // LEOR - exporting

        toReturn.version = '1.0.0';

        return toReturn;
    }

    var isBrowser, globalEnv, document;

    if (typeof window !== 'undefined') { // usual browser window
        isBrowser = true;
        globalEnv = window;
        document = window.document ? window.document : {};
    } else if (typeof self !== 'undefined') { // Web Worker
        isBrowser = true;
        globalEnv = self;
        document = {};
    } else { // Node.js
        isBrowser = false;
        globalEnv = global;
        document = {};
    }

    var fakeWindow;
    if (isBrowser && !true) {
        fakeWindow = globalEnv;
    } else {
        fakeWindow = {};
        fakeWindow.setTimeout = globalEnv.setTimeout.bind(globalEnv);
        fakeWindow.clearTimeout = globalEnv.clearTimeout.bind(globalEnv);
        fakeWindow.setInterval = globalEnv.setInterval.bind(globalEnv);
        fakeWindow.clearInterval = globalEnv.clearInterval.bind(globalEnv);
        fakeWindow.Array = globalEnv.Array.bind(globalEnv);  // LEOR
    }

    if (!fakeWindow.document) {
        fakeWindow.document = document;
    }

    var syncExports = getExports(fakeWindow);
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = {          
          login: function(configuration, onSuccess, onError) {
            return syncExports.login(configuration, onSuccess, onError);
          },
          formStart: function(formName, onShowMessgeFunc, onUpdateFieldsFunc, dname, autoRetrieveFirstRows, onSuccess, onError) {
            return syncExports.formStart(formName, onShowMessgeFunc, onUpdateFieldsFunc, dname, autoRetrieveFirstRows, onSuccess, onError);
          },
          formStartEx: function(formName, onShowMessgeFunc, onUpdateFieldsFunc, dname, autoRetrieveFirstRows, exParams, onSuccess, onError) {
            return syncExports.formStartEx(formName, onShowMessgeFunc, onUpdateFieldsFunc, dname, autoRetrieveFirstRows, exParams, onSuccess, onError);
          },
          procStart: function(ename, type, progress, dname, onSuccess, onError) {
            return syncExports.procStart(ename, type, progress, dname, onSuccess, onError);
          },
          procStartActivate: function(ename, type, link, progress, dname, onSuccess, onError) {
            return syncExports.procStartActivate(ename, type, link, progress, dname, onSuccess, onError);
          },
          changePassword: function(newPwd, confirmNewPwd, oldPwd, onSuccess, onError) {
            return syncExports.changePassword(newPwd, confirmNewPwd, oldPwd, onSuccess, onError);
          },
          setGPSLocation: function(gpsLocation, onSuccess, onError) {
            return syncExports.setGPSLocation(gpsLocation, onSuccess, onError);
          },
          updateAccessToken: function(accessToken, onSuccess, onError) {
            return syncExports.updateAccessToken(accessToken, onSuccess, onError);
          }
        };
    }
 
})();

